(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define("CashierPaymentsWidget", ["React", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["CashierPaymentsWidget"] = factory(require("React"), require("ReactDOM"));
	else
		root["CashierPaymentsWidget"] = factory(root["React"], root["ReactDOM"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_63__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	__webpack_require__.p = typeof window !== 'undefined' && window.__STATICS_BASE_URL__ || __webpack_require__.p;
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 483);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(114);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  typeof document.createElement -> undefined
 */
function isStandardBrowserEnv() {
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    typeof document.createElement === 'function'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(83)('wks');
var uid = __webpack_require__(84);
var Symbol = __webpack_require__(2).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(15);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dataItem = __webpack_require__(62);

var _dataItem2 = _interopRequireDefault(_dataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents bi events from the "fed monitoring" source:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */
var BiBaseDataItem = function (_DataItem) {
  _inherits(BiBaseDataItem, _DataItem);

  function BiBaseDataItem(evid, sessionId) {
    _classCallCheck(this, BiBaseDataItem);

    return _possibleConstructorReturn(this, (BiBaseDataItem.__proto__ || Object.getPrototypeOf(BiBaseDataItem)).call(this, {
      src: 72,
      evid: evid,
      session_id: sessionId, // eslint-disable-line
      _: new Date().getTime() // cache buster
    }));
  }

  return BiBaseDataItem;
}(_dataItem2.default);

exports.default = BiBaseDataItem;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(4);
var ctx = __webpack_require__(18);
var hide = __webpack_require__(8);
var has = __webpack_require__(20);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(14);
var createDesc = __webpack_require__(76);
module.exports = __webpack_require__(9) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(39)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(132)();
}


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Loader_1 = __webpack_require__(152);
exports.default = Loader_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Translate_1 = __webpack_require__(35);
exports.default = Translate_1.default;
exports.translate = Translate_1.translate;
//# sourceMappingURL=index.js.map

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(5);
var IE8_DOM_DEFINE = __webpack_require__(225);
var toPrimitive = __webpack_require__(226);
var dP = Object.defineProperty;

exports.f = __webpack_require__(9) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(19);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _set = __webpack_require__(286);

var _set2 = _interopRequireDefault(_set);

var _unset = __webpack_require__(321);

var _unset2 = _interopRequireDefault(_unset);

var _forEach = __webpack_require__(327);

var _forEach2 = _interopRequireDefault(_forEach);

var _uniqueId = __webpack_require__(348);

var _uniqueId2 = _interopRequireDefault(_uniqueId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ModuleRegistry = function () {
  function ModuleRegistry() {
    _classCallCheck(this, ModuleRegistry);

    this.registeredComponents = {};
    this.registeredMethods = {};
    this.eventListeners = {};
    this.modules = {};
  }

  _createClass(ModuleRegistry, [{
    key: 'cleanAll',
    value: function cleanAll() {
      this.registeredComponents = {};
      this.registeredMethods = {};
      this.eventListeners = {};
      this.modules = {};
    }
  }, {
    key: 'registerModule',
    value: function registerModule(globalID, ModuleFactory) {
      var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      if (this.modules[globalID]) {
        throw new Error('A module with id "' + globalID + '" is already registered');
      }

      this.modules[globalID] = new (Function.prototype.bind.apply(ModuleFactory, [null].concat(_toConsumableArray(args))))();
    }
  }, {
    key: 'getModule',
    value: function getModule(globalID) {
      return this.modules[globalID];
    }
  }, {
    key: 'getAllModules',
    value: function getAllModules() {
      var _this = this;

      return Object.keys(this.modules).map(function (moduleId) {
        return _this.modules[moduleId];
      });
    }
  }, {
    key: 'registerComponent',
    value: function registerComponent(globalID, generator) {
      this.registeredComponents[globalID] = generator;
    }
  }, {
    key: 'component',
    value: function component(globalID) {
      var generator = this.registeredComponents[globalID];
      if (!generator) {
        console.error('ModuleRegistry.component ' + globalID + ' used but not yet registered');
        return undefined;
      }
      return generator();
    }
  }, {
    key: 'addListener',
    value: function addListener(globalID, callback) {
      var _this2 = this;

      var callbackKey = (0, _uniqueId2.default)('eventListener');
      (0, _set2.default)(this.eventListeners, [globalID, callbackKey], callback);
      return {
        remove: function remove() {
          return (0, _unset2.default)(_this2.eventListeners[globalID], callbackKey);
        }
      };
    }
  }, {
    key: 'notifyListeners',
    value: function notifyListeners(globalID) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var listenerCallbacks = this.eventListeners[globalID];
      if (!listenerCallbacks) {
        return;
      }
      (0, _forEach2.default)(listenerCallbacks, function (callback) {
        return invokeSafely(callback, args);
      });
    }
  }, {
    key: 'registerMethod',
    value: function registerMethod(globalID, generator) {
      this.registeredMethods[globalID] = generator;
    }
  }, {
    key: 'invoke',
    value: function invoke(globalID) {
      var generator = this.registeredMethods[globalID];
      if (!generator) {
        console.error('ModuleRegistry.invoke ' + globalID + ' used but not yet registered');
        return undefined;
      }
      var method = generator();

      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return method.apply(undefined, args);
    }
  }]);

  return ModuleRegistry;
}();

var singleton = void 0;
if (typeof window !== 'undefined') {
  singleton = window.ModuleRegistry || new ModuleRegistry();
  window.ModuleRegistry = singleton;
} else {
  singleton = new ModuleRegistry();
}
exports.default = singleton;


function invokeSafely(callback, args) {
  try {
    callback.apply(undefined, _toConsumableArray(args));
  } catch (err) {
    console.error(err);
  }
}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(49),
    getRawTag = __webpack_require__(289),
    objectToString = __webpack_require__(290);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(101);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 25 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(48);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(51);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(315);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(100),
    isLength = __webpack_require__(104);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHost = setHost;
exports.getHost = getHost;
exports.isWebWorker = isWebWorker;
exports.provideBrowsingContext = provideBrowsingContext;
var host = 'frog.wix.com';

function setHost(_host) {
  host = _host;
}

function getHost() {
  return host;
}

function isWebWorker() {
  /* global WorkerGlobalScope */

  //At the moment, this is the most reliable way of detecting if current code is run in a worker
  //Taken from here: https://stackoverflow.com/a/18002694
  return typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope;
}

/**
 * Provides a window object to the callback iff current window is the topmost one
 * Otherwise returns null
 */
function provideBrowsingContext(cb) {
  if (typeof window !== 'undefined' && window) {
    try {
      return window.top === window.self ? cb ? cb(window) : window : null;
    } catch (e) {
      return null;
    }
  }

  return null;
}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var apiCalls_1 = __webpack_require__(394);
/**
 * Class will contain methods with payment logic
 */
var PaymentsApi = /** @class */ (function () {
    function PaymentsApi() {
        this.charge = function (_a) {
            var request = _a.request, _b = _a.host, host = _b === void 0 ? '' : _b;
            return apiCalls_1.default.charge({ request: request, host: host });
        };
        this.fetchPaymentMethodSettings = function (config, host) { return apiCalls_1.default.fetchPaymentMethodSettings(config, host); };
    }
    return PaymentsApi;
}());
exports.default = new PaymentsApi();
//# sourceMappingURL=paymentsApi.js.map

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHost = setHost;
exports.getHost = getHost;
exports.isWebWorker = isWebWorker;
exports.provideBrowsingContext = provideBrowsingContext;
var host = 'frog.wix.com';

function setHost(_host) {
  host = _host;
}

function getHost() {
  return host;
}

function isWebWorker() {
  /* global WorkerGlobalScope */

  //At the moment, this is the most reliable way of detecting if current code is run in a worker
  //Taken from here: https://stackoverflow.com/a/18002694
  return typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope;
}

/**
 * Provides a window object to the callback iff current window is the topmost one
 * Otherwise returns null
 */
function provideBrowsingContext(cb) {
  if (typeof window !== 'undefined' && window) {
    try {
      return window.top === window.self ? cb ? cb(window) : window : null;
    } catch (e) {
      return null;
    }
  }

  return null;
}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _location = __webpack_require__(127);

var _location2 = _interopRequireDefault(_location);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * window.performance wrappers
 */
exports.default = {
  getNavigation: function getNavigation() {
    return window && window.performance ? window.performance.navigation : {};
  },


  /**
   * get all loaded resources
   */
  getResources: function getResources() {
    var emptyVal = [];
    try {
      return window && window.performance && window.performance.getEntriesByType && window.performance.getEntriesByType('resource') || emptyVal;
    } catch (e) {
      return emptyVal;
    }
  },
  getTiming: function getTiming() {
    return window && window.performance ? window.performance.timing : {};
  },


  /**
   * Duration relative to navigation start (window.performance.timing.navigationStart)
   */
  now: function now() {
    return window && window.performance && window.performance.now ? window.performance.now() : new Date().getTime();
  },


  /**
   * Create a performance timestamp
   */
  mark: function mark(name) {
    if (_location2.default.isFedopsDev()) {
      window && window.performance && window.performance.mark && window.performance.mark(name);
    }
  },


  /**
   * Record a performance measurement
   */
  measure: function measure(name, startMark, endMark) {
    if (_location2.default.isFedopsDev()) {
      window && window.performance && window.performance.measure && window.performance.measure(name, startMark, endMark);
    }
  }
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var i18n_1 = __webpack_require__(36);
var Translate = function (props) {
    return (React.createElement("span", null, exports.translate(props)));
};
exports.translate = function (props) { return i18n_1.default.t(props.forKey, props.overrides) || props.forKey; };
exports.default = Translate;
//# sourceMappingURL=Translate.js.map

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var i18next = __webpack_require__(155);
var i18nextXHRBackend = __webpack_require__(156);
/* TODO we should load languages async */
var SUPPORTED_LANGUAGES = [
    'ar', 'bg', 'cs', 'da', 'de', 'el', 'en',
    'es', 'fi', 'fr', 'he', 'hi', 'hu', 'id',
    'it', 'ja', 'ko', 'ms', 'nl', 'no', 'pl',
    'pt', 'ro', 'ru', 'sv', 'th', 'tl', 'tr',
    'zh',
];
exports.init = function (_a) {
    var locale = _a.locale;
    var resources = {};
    SUPPORTED_LANGUAGES.forEach(function (lng) {
        resources[lng] = {
            translation: __webpack_require__(160)("./messages_" + lng + ".json"),
        };
    });
    return new Promise(function (resolve) {
        return i18next
            .use(i18nextXHRBackend)
            .init({
            resources: resources,
            lng: locale,
            keySeparator: '$',
            fallbackLng: 'en',
            interpolation: {
                escapeValue: false,
            },
        }, resolve);
    });
};
exports.default = i18next;
//# sourceMappingURL=i18n.js.map

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FormsStore_1 = __webpack_require__(194);
exports.default = FormsStore_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PaymentMethodLayout_1 = __webpack_require__(206);
exports.default = PaymentMethodLayout_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(15);
var document = __webpack_require__(2).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(81);
var defined = __webpack_require__(42);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(83)('keys');
var uid = __webpack_require__(84);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(14).f;
var has = __webpack_require__(20);
var TAG = __webpack_require__(3)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(19);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(98),
    eq = __webpack_require__(51);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(288),
    getValue = __webpack_require__(294);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(24);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 51 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(17),
    isKey = __webpack_require__(295),
    stringToPath = __webpack_require__(296),
    toString = __webpack_require__(102);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(23),
    isObjectLike = __webpack_require__(26);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 54 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(53);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function default_1(string, props) {
    if (props === void 0) { props = {}; }
    return string && string.replace(/\{{(\w+)\}}/g, function (match, expr) { return props[expr] || ''; });
}
exports.default = default_1;
//# sourceMappingURL=interpolate.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(395);

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(398);

var PROTECTION_PREFIX = /^\)\]\}',?\n/;
var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(115);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(115);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      data = data.replace(PROTECTION_PREFIX, '');
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(397)))

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = {"paymentMethodsAccountApiUrl":"/_api/payment-services-web/payments/v2/accounts/{{accountId}}/payment-methods","paymentMethodsOrderApiUrl":"/_api/payment-services-web/payments/v2/orders/{{orderId}}/payment-methods","paymentMethodAccountApiUrl":"/_api/payment-services-web/payments/v2/accounts/{{accountId}}/payment-methods/{{paymentMethod}}","paymentMethodOrderApiUrl":"/_api/payment-services-web/payments/v2/orders/{{orderId}}/payment-methods/{{paymentMethod}}","paymentDetailsUrl":"/_api/payment-services-web/payments/v2/payment-details","creditCardsUrl":"/_api/payment-gateway-web/v2/credit-cards","tokenForSavedCard":"/_api/payment-gateway-web/v2/credit-cards/{{creditCardId}}/tokens","orderUrl":"/_api/payment-services-web/payments/v2/orders/{{orderId}}","orderChargesUrl":"/_api/payment-services-web/payments/v2/orders/{{orderId}}/charges","resolveCountryUrl":"/_api/payment-services-web/buyer/country","mandatoryFieldsUrl":"/_api/payment-services-web/payments/v2/orders/{{orderId}}/mandatory-fields","mandatoryFieldsProviderUrl":"/_api/payment-services-web/payments/v2/mandatory-fields"}

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DataItem = function () {
  function DataItem() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    _classCallCheck(this, DataItem);

    this.data = data;
  }

  _createClass(DataItem, [{
    key: 'isActive',
    value: function isActive() {
      return true;
    }
  }, {
    key: 'export',
    value: function _export() {
      return this.data;
    }
  }]);

  return DataItem;
}();

exports.default = DataItem;

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_63__;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Loader = __webpack_require__(131);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Loader).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ../node_modules/i18next/dist/es/logger.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var consoleLogger = {
  type: 'logger',

  log: function log(args) {
    this._output('log', args);
  },
  warn: function warn(args) {
    this._output('warn', args);
  },
  error: function error(args) {
    this._output('error', args);
  },
  _output: function _output(type, args) {
    if (console && console[type]) console[type].apply(console, Array.prototype.slice.call(args));
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  Logger.prototype.init = function init(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug === false ? false : true;
  };

  Logger.prototype.setDebug = function setDebug(bool) {
    this.debug = bool;
  };

  Logger.prototype.log = function log() {
    this.forward(arguments, 'log', '', true);
  };

  Logger.prototype.warn = function warn() {
    this.forward(arguments, 'warn', '', true);
  };

  Logger.prototype.error = function error() {
    this.forward(arguments, 'error', '');
  };

  Logger.prototype.deprecate = function deprecate() {
    this.forward(arguments, 'warn', 'WARNING DEPRECATED: ', true);
  };

  Logger.prototype.forward = function forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return;
    if (typeof args[0] === 'string') args[0] = prefix + this.prefix + ' ' + args[0];
    this.logger[lvl](args);
  };

  Logger.prototype.create = function create(moduleName) {
    var sub = new Logger(this.logger, _extends({ prefix: this.prefix + ':' + moduleName + ':' }, this.options));

    return sub;
  };

  // createInstance(options = {}) {
  //   return new Logger(options, callback);
  // }

  return Logger;
}();

;

/* harmony default export */ var logger = (new Logger());
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/EventEmitter.js
function EventEmitter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventEmitter = function () {
	function EventEmitter() {
		EventEmitter__classCallCheck(this, EventEmitter);

		this.observers = {};
	}

	EventEmitter.prototype.on = function on(events, listener) {
		var _this = this;

		events.split(' ').forEach(function (event) {
			_this.observers[event] = _this.observers[event] || [];
			_this.observers[event].push(listener);
		});
	};

	EventEmitter.prototype.off = function off(event, listener) {
		var _this2 = this;

		if (!this.observers[event]) {
			return;
		}

		this.observers[event].forEach(function () {
			if (!listener) {
				delete _this2.observers[event];
			} else {
				var index = _this2.observers[event].indexOf(listener);
				if (index > -1) {
					_this2.observers[event].splice(index, 1);
				}
			}
		});
	};

	EventEmitter.prototype.emit = function emit(event) {
		for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
			args[_key - 1] = arguments[_key];
		}

		if (this.observers[event]) {
			var cloned = [].concat(this.observers[event]);
			cloned.forEach(function (observer) {
				observer.apply(undefined, args);
			});
		}

		if (this.observers['*']) {
			var _cloned = [].concat(this.observers['*']);
			_cloned.forEach(function (observer) {
				var _ref;

				observer.apply(observer, (_ref = [event]).concat.apply(_ref, args));
			});
		}
	};

	return EventEmitter;
}();

/* harmony default export */ var es_EventEmitter = (EventEmitter);
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/utils.js
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}

function utils_copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};

    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}

function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}

function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}

function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop in target) {
      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }return target;
}

function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

/* eslint-disable */
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': '&quot;',
  "'": '&#39;',
  "/": '&#x2F;'
};
/* eslint-enable */

function utils_escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  } else {
    return data;
  }
}
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/ResourceStore.js
var ResourceStore__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function ResourceStore__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }




var ResourceStore_ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  function ResourceStore() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { ns: ['translation'], defaultNS: 'translation' };

    ResourceStore__classCallCheck(this, ResourceStore);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.data = data;
    _this.options = options;
    return _this;
  }

  ResourceStore.prototype.addNamespaces = function addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  };

  ResourceStore.prototype.removeNamespaces = function removeNamespaces(ns) {
    var index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  };

  ResourceStore.prototype.getResource = function getResource(lng, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var keySeparator = options.keySeparator || this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key && typeof key !== 'string') path = path.concat(key);
    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    }

    return getPath(this.data, path);
  };

  ResourceStore.prototype.addResource = function addResource(lng, ns, key, value) {
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { silent: false };

    var keySeparator = this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    setPath(this.data, path, value);

    if (!options.silent) this.emit('added', lng, ns, key, value);
  };

  ResourceStore.prototype.addResources = function addResources(lng, ns, resources) {
    for (var m in resources) {
      if (typeof resources[m] === 'string') this.addResource(lng, ns, m, resources[m], { silent: true });
    }
    this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.addResourceBundle = function addResourceBundle(lng, ns, resources, deep, overwrite) {
    var path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    var pack = getPath(this.data, path) || {};

    if (deep) {
      deepExtend(pack, resources, overwrite);
    } else {
      pack = ResourceStore__extends({}, pack, resources);
    }

    setPath(this.data, path, pack);

    this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.removeResourceBundle = function removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);

    this.emit('removed', lng, ns);
  };

  ResourceStore.prototype.hasResourceBundle = function hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  };

  ResourceStore.prototype.getResourceBundle = function getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;

    // TODO: COMPATIBILITY remove extend in v2.1.0
    if (this.options.compatibilityAPI === 'v1') return ResourceStore__extends({}, this.getResource(lng, ns));

    return this.getResource(lng, ns);
  };

  ResourceStore.prototype.toJSON = function toJSON() {
    return this.data;
  };

  return ResourceStore;
}(es_EventEmitter);

/* harmony default export */ var es_ResourceStore = (ResourceStore_ResourceStore);
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/postProcessor.js
/* harmony default export */ var postProcessor = ({

  processors: {},

  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });

    return value;
  }
});
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/compatibility/v1.js


function convertInterpolation(options) {

  options.interpolation = {
    unescapeSuffix: 'HTML'
  };

  options.interpolation.prefix = options.interpolationPrefix || '__';
  options.interpolation.suffix = options.interpolationSuffix || '__';
  options.interpolation.escapeValue = options.escapeInterpolation || false;

  options.interpolation.nestingPrefix = options.reusePrefix || '$t(';
  options.interpolation.nestingSuffix = options.reuseSuffix || ')';

  return options;
}

function convertAPIOptions(options) {
  if (options.resStore) options.resources = options.resStore;

  if (options.ns && options.ns.defaultNs) {
    options.defaultNS = options.ns.defaultNs;
    options.ns = options.ns.namespaces;
  } else {
    options.defaultNS = options.ns || 'translation';
  }

  if (options.fallbackToDefaultNS && options.defaultNS) options.fallbackNS = options.defaultNS;

  options.saveMissing = options.sendMissing;
  options.saveMissingTo = options.sendMissingTo || 'current';
  options.returnNull = options.fallbackOnNull ? false : true;
  options.returnEmptyString = options.fallbackOnEmpty ? false : true;
  options.returnObjects = options.returnObjectTrees;
  options.joinArrays = '\n';

  options.returnedObjectHandler = options.objectTreeKeyHandler;
  options.parseMissingKeyHandler = options.parseMissingKey;
  options.appendNamespaceToMissingKey = true;

  options.nsSeparator = options.nsseparator || ':';
  options.keySeparator = options.keyseparator || '.';

  if (options.shortcutFunction === 'sprintf') {
    options.overloadTranslationOptionHandler = function (args) {
      var values = [];

      for (var i = 1; i < args.length; i++) {
        values.push(args[i]);
      }

      return {
        postProcess: 'sprintf',
        sprintf: values
      };
    };
  }

  options.whitelist = options.lngWhitelist;
  options.preload = options.preload;
  if (options.load === 'current') options.load = 'currentOnly';
  if (options.load === 'unspecific') options.load = 'languageOnly';

  // backend
  options.backend = options.backend || {};
  options.backend.loadPath = options.resGetPath || 'locales/__lng__/__ns__.json';
  options.backend.addPath = options.resPostPath || 'locales/add/__lng__/__ns__';
  options.backend.allowMultiLoading = options.dynamicLoad;

  // cache
  options.cache = options.cache || {};
  options.cache.prefix = 'res_';
  options.cache.expirationTime = 7 * 24 * 60 * 60 * 1000;
  options.cache.enabled = options.useLocalStorage ? true : false;

  options = convertInterpolation(options);
  if (options.defaultVariables) options.interpolation.defaultVariables = options.defaultVariables;

  // TODO: deprecation
  // if (options.getAsync === false) throw deprecation error

  return options;
}

function convertJSONOptions(options) {
  options = convertInterpolation(options);
  options.joinArrays = '\n';

  return options;
}

function convertTOptions(options) {
  if (options.interpolationPrefix || options.interpolationSuffix || options.escapeInterpolation) {
    options = convertInterpolation(options);
  }

  options.nsSeparator = options.nsseparator;
  options.keySeparator = options.keyseparator;

  options.returnObjects = options.returnObjectTrees;

  return options;
}

function appendBackwardsAPI(i18n) {
  i18n.lng = function () {
    logger.deprecate('i18next.lng() can be replaced by i18next.language for detected language or i18next.languages for languages ordered by translation lookup.');
    return i18n.services.languageUtils.toResolveHierarchy(i18n.language)[0];
  };

  i18n.preload = function (lngs, cb) {
    logger.deprecate('i18next.preload() can be replaced with i18next.loadLanguages()');
    i18n.loadLanguages(lngs, cb);
  };

  i18n.setLng = function (lng, options, callback) {
    logger.deprecate('i18next.setLng() can be replaced with i18next.changeLanguage() or i18next.getFixedT() to get a translation function with fixed language or namespace.');
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!options) options = {};

    if (options.fixLng === true) {
      if (callback) return callback(null, i18n.getFixedT(lng));
    }

    i18n.changeLanguage(lng, callback);
  };

  i18n.addPostProcessor = function (name, fc) {
    logger.deprecate('i18next.addPostProcessor() can be replaced by i18next.use({ type: \'postProcessor\', name: \'name\', process: fc })');
    i18n.use({
      type: 'postProcessor',
      name: name,
      process: fc
    });
  };
}
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/Translator.js
var Translator__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function Translator__defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function Translator__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Translator__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Translator__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : Translator__defaults(subClass, superClass); }







var Translator_Translator = function (_EventEmitter) {
  Translator__inherits(Translator, _EventEmitter);

  function Translator(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Translator__classCallCheck(this, Translator);

    var _this = Translator__possibleConstructorReturn(this, _EventEmitter.call(this));

    utils_copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector'], services, _this);

    _this.options = options;
    _this.logger = logger.create('translator');
    return _this;
  }

  Translator.prototype.changeLanguage = function changeLanguage(lng) {
    if (lng) this.language = lng;
  };

  Translator.prototype.exists = function exists(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { interpolation: {} };

    if (this.options.compatibilityAPI === 'v1') {
      options = convertTOptions(options);
    }

    return this.resolve(key, options) !== undefined;
  };

  Translator.prototype.extractFromKey = function extractFromKey(key, options) {
    var nsSeparator = options.nsSeparator || this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';
    var keySeparator = options.keySeparator || this.options.keySeparator || '.';

    var namespaces = options.ns || this.options.defaultNS;
    if (nsSeparator && key.indexOf(nsSeparator) > -1) {
      var parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    if (typeof namespaces === 'string') namespaces = [namespaces];

    return {
      key: key,
      namespaces: namespaces
    };
  };

  Translator.prototype.translate = function translate(keys) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
      options = this.options.overloadTranslationOptionHandler(arguments);
    } else if (this.options.compatibilityAPI === 'v1') {
      options = convertTOptions(options);
    }

    // non valid keys handling
    if (keys === undefined || keys === null || keys === '') return '';
    if (typeof keys === 'number') keys = String(keys);
    if (typeof keys === 'string') keys = [keys];

    // separators
    var keySeparator = options.keySeparator || this.options.keySeparator || '.';

    // get namespace(s)

    var _extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
        key = _extractFromKey.key,
        namespaces = _extractFromKey.namespaces;

    var namespace = namespaces[namespaces.length - 1];

    // return key on CIMode
    var lng = options.lng || this.language;
    var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng && lng.toLowerCase() === 'cimode') {
      if (appendNamespaceToCIMode) {
        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
        return namespace + nsSeparator + key;
      }

      return key;
    }

    // resolve from store
    var res = this.resolve(keys, options);

    var resType = Object.prototype.toString.apply(res);
    var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;

    // object
    if (res && typeof res !== 'string' && noObject.indexOf(resType) < 0 && !(joinArrays && resType === '[object Array]')) {
      if (!options.returnObjects && !this.options.returnObjects) {
        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(key, res, options) : 'key \'' + key + ' (' + this.language + ')\' returned an object instead of string.';
      }

      // if we got a separator we loop over children - else we just return object as is
      // as having it set to false means no hierarchy so no lookup for nested values
      if (options.keySeparator || this.options.keySeparator) {
        var copy = resType === '[object Array]' ? [] : {}; // apply child translation on a copy

        for (var m in res) {
          if (res.hasOwnProperty(m)) {
            copy[m] = this.translate('' + key + keySeparator + m, Translator__extends({}, options, { joinArrays: false, ns: namespaces }));
          }
        }
        res = copy;
      }
    }
    // array special treatment
    else if (joinArrays && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, key, options);
      }
      // string, empty or null
      else {
          var usedDefault = false,
              usedKey = false;

          // fallback value
          if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
            usedDefault = true;
            res = options.defaultValue;
          }
          if (!this.isValidLookup(res)) {
            usedKey = true;
            res = key;
          }

          // save missing
          if (usedKey || usedDefault) {
            this.logger.log('missingKey', lng, namespace, key, res);

            var lngs = [];
            var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
            if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
              for (var i = 0; i < fallbackLngs.length; i++) {
                lngs.push(fallbackLngs[i]);
              }
            } else if (this.options.saveMissingTo === 'all') {
              lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
            } else {
              //(this.options.saveMissingTo === 'current' || (this.options.saveMissingTo === 'fallback' && this.options.fallbackLng[0] === false) ) {
              lngs.push(options.lng || this.language);
            }

            if (this.options.saveMissing) {
              if (this.options.missingKeyHandler) {
                this.options.missingKeyHandler(lngs, namespace, key, res);
              } else if (this.backendConnector && this.backendConnector.saveMissing) {
                this.backendConnector.saveMissing(lngs, namespace, key, res);
              }
            }

            this.emit('missingKey', lngs, namespace, key, res);
          }

          // extend
          res = this.extendTranslation(res, key, options);

          // append namespace if still key
          if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = namespace + ':' + key;

          // parseMissingKeyHandler
          if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
        }

    // return
    return res;
  };

  Translator.prototype.extendTranslation = function extendTranslation(res, key, options) {
    var _this2 = this;

    if (options.interpolation) this.interpolator.init(Translator__extends({}, options, { interpolation: Translator__extends({}, this.options.interpolation, options.interpolation) }));

    // interpolate
    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
    if (this.options.interpolation.defaultVariables) data = Translator__extends({}, this.options.interpolation.defaultVariables, data);
    res = this.interpolator.interpolate(res, data, this.language);

    // nesting
    res = this.interpolator.nest(res, function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _this2.translate.apply(_this2, args);
    }, options);

    if (options.interpolation) this.interpolator.reset();

    // post process
    var postProcess = options.postProcess || this.options.postProcess;
    var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

    if (res !== undefined && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
      res = postProcessor.handle(postProcessorNames, res, key, options, this);
    }

    return res;
  };

  Translator.prototype.resolve = function resolve(keys) {
    var _this3 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var found = void 0;

    if (typeof keys === 'string') keys = [keys];

    // forEach possible key
    keys.forEach(function (k) {
      if (_this3.isValidLookup(found)) return;

      var _extractFromKey2 = _this3.extractFromKey(k, options),
          key = _extractFromKey2.key,
          namespaces = _extractFromKey2.namespaces;

      if (_this3.options.fallbackNS) namespaces = namespaces.concat(_this3.options.fallbackNS);

      var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
      var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';

      var codes = options.lngs ? options.lngs : _this3.languageUtils.toResolveHierarchy(options.lng || _this3.language);

      namespaces.forEach(function (ns) {
        if (_this3.isValidLookup(found)) return;

        codes.forEach(function (code) {
          if (_this3.isValidLookup(found)) return;

          var finalKey = key;
          var finalKeys = [finalKey];

          var pluralSuffix = void 0;
          if (needsPluralHandling) pluralSuffix = _this3.pluralResolver.getSuffix(code, options.count);

          // fallback for plural if context not found
          if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);

          // get key for context if needed
          if (needsContextHandling) finalKeys.push(finalKey += '' + _this3.options.contextSeparator + options.context);

          // get key for plural if needed
          if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);

          // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only
          var possibleKey = void 0;
          while (possibleKey = finalKeys.pop()) {
            if (_this3.isValidLookup(found)) continue;
            found = _this3.getResource(code, ns, possibleKey, options);
          }
        });
      });
    });

    return found;
  };

  Translator.prototype.isValidLookup = function isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  };

  Translator.prototype.getResource = function getResource(code, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    return this.resourceStore.getResource(code, ns, key, options);
  };

  return Translator;
}(es_EventEmitter);

/* harmony default export */ var es_Translator = (Translator_Translator);
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/LanguageUtils.js
function LanguageUtils__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtils_LanguageUtil = function () {
  function LanguageUtil(options) {
    LanguageUtils__classCallCheck(this, LanguageUtil);

    this.options = options;

    this.whitelist = this.options.whitelist || false;
    this.logger = logger.create('languageUtils');
  }

  LanguageUtil.prototype.getScriptPartFromCode = function getScriptPartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return null;

    var p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    return this.formatLanguageCode(p.join('-'));
  };

  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return code;

    var p = code.split('-');
    return this.formatLanguageCode(p[0]);
  };

  LanguageUtil.prototype.formatLanguageCode = function formatLanguageCode(code) {
    // http://www.iana.org/assignments/language-tags/language-tags.xhtml
    if (typeof code === 'string' && code.indexOf('-') > -1) {
      var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
      var p = code.split('-');

      if (this.options.lowerCaseLng) {
        p = p.map(function (part) {
          return part.toLowerCase();
        });
      } else if (p.length === 2) {
        p[0] = p[0].toLowerCase();
        p[1] = p[1].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      } else if (p.length === 3) {
        p[0] = p[0].toLowerCase();

        // if lenght 2 guess it's a country
        if (p[1].length === 2) p[1] = p[1].toUpperCase();
        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
      }

      return p.join('-');
    } else {
      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  };

  LanguageUtil.prototype.isWhitelisted = function isWhitelisted(code, exactMatch) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist && !exactMatch) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1 ? true : false;
  };

  LanguageUtil.prototype.getFallbackCodes = function getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;

    if (!code) return fallbacks.default || [];

    // asume we have an object defining fallbacks
    var found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks.default;

    return found || [];
  };

  LanguageUtil.prototype.toResolveHierarchy = function toResolveHierarchy(code, fallbackCode) {
    var _this = this;

    var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);

    var codes = [];
    var addCode = function addCode(code) {
      var exactMatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!code) return;
      if (_this.isWhitelisted(code, exactMatch)) {
        codes.push(code);
      } else {
        _this.logger.warn('rejecting non-whitelisted language code: ' + code);
      }
    };

    if (typeof code === 'string' && code.indexOf('-') > -1) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code), true);
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code), true);
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (typeof code === 'string') {
      addCode(this.formatLanguageCode(code));
    }

    fallbackCodes.forEach(function (fc) {
      if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
    });

    return codes;
  };

  return LanguageUtil;
}();

;

/* harmony default export */ var LanguageUtils = (LanguageUtils_LanguageUtil);
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/PluralResolver.js
var PluralResolver__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function PluralResolver__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// definition http://translate.sourceforge.net/wiki/l10n/pluralforms
/* eslint-disable */
var sets = [{ lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'tg', 'ti', 'tr', 'uz', 'wa'], nr: [1, 2], fc: 1 }, { lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'es_ar', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'he', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt', 'pt_br', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'], nr: [1, 2], fc: 2 }, { lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'], nr: [1], fc: 3 }, { lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'], nr: [1, 2, 5], fc: 4 }, { lngs: ['ar'], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ['cs', 'sk'], nr: [1, 2, 5], fc: 6 }, { lngs: ['csb', 'pl'], nr: [1, 2, 5], fc: 7 }, { lngs: ['cy'], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ['fr'], nr: [1, 2], fc: 9 }, { lngs: ['ga'], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ['gd'], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ['is'], nr: [1, 2], fc: 12 }, { lngs: ['jv'], nr: [0, 1], fc: 13 }, { lngs: ['kw'], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ['lt'], nr: [1, 2, 10], fc: 15 }, { lngs: ['lv'], nr: [1, 2, 0], fc: 16 }, { lngs: ['mk'], nr: [1, 2], fc: 17 }, { lngs: ['mnk'], nr: [0, 1, 2], fc: 18 }, { lngs: ['mt'], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ['or'], nr: [2, 1], fc: 2 }, { lngs: ['ro'], nr: [1, 2, 20], fc: 20 }, { lngs: ['sl'], nr: [5, 1, 2, 3], fc: 21 }];

var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  }
};
/* eslint-enable */

function createRules() {
  var l,
      rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      return rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver_PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    PluralResolver__classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;

    this.logger = logger.create('pluralResolver');

    this.rules = createRules();
  }

  PluralResolver.prototype.addRule = function addRule(lng, obj) {
    this.rules[lng] = obj;
  };

  PluralResolver.prototype.getRule = function getRule(code) {
    return this.rules[this.languageUtils.getLanguagePartFromCode(code)];
  };

  PluralResolver.prototype.needsPlural = function needsPlural(code) {
    var rule = this.getRule(code);

    return rule && rule.numbers.length <= 1 ? false : true;
  };

  PluralResolver.prototype.getSuffix = function getSuffix(code, count) {
    var _this = this;

    var rule = this.getRule(code);

    if (rule) {
      var _ret = function () {
        if (rule.numbers.length === 1) return {
            v: ''
          }; // only singular

        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        var suffix = rule.numbers[idx];

        // special treatment for lngs only having singular and plural
        if (_this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          if (suffix === 2) {
            suffix = 'plural';
          } else if (suffix === 1) {
            suffix = '';
          }
        }

        var returnSuffix = function returnSuffix() {
          return _this.options.prepend && suffix.toString() ? _this.options.prepend + suffix.toString() : suffix.toString();
        };

        // COMPATIBILITY JSON
        // v1
        if (_this.options.compatibilityJSON === 'v1') {
          if (suffix === 1) return {
              v: ''
            };
          if (typeof suffix === 'number') return {
              v: '_plural_' + suffix.toString()
            };
          return {
            v: returnSuffix()
          };
        }
        // v2
        else if (_this.options.compatibilityJSON === 'v2' || rule.numbers.length === 2 && rule.numbers[0] === 1) {
            return {
              v: returnSuffix()
            };
          }
          // v3 - gettext index
          else if (rule.numbers.length === 2 && rule.numbers[0] === 1) {
              return {
                v: returnSuffix()
              };
            }
        return {
          v: _this.options.prepend && idx.toString() ? _this.options.prepend + idx.toString() : idx.toString()
        };
      }();

      if ((typeof _ret === 'undefined' ? 'undefined' : PluralResolver__typeof(_ret)) === "object") return _ret.v;
    } else {
      this.logger.warn('no plural rule found for: ' + code);
      return '';
    }
  };

  return PluralResolver;
}();

;

/* harmony default export */ var es_PluralResolver = (PluralResolver_PluralResolver);
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/Interpolator.js
var Interpolator__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function Interpolator__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Interpolator_Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    Interpolator__classCallCheck(this, Interpolator);

    this.logger = logger.create('interpolator');

    this.init(options, true);
  }

  Interpolator.prototype.init = function init() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var reset = arguments[1];

    if (reset) {
      this.options = options;
      this.format = options.interpolation && options.interpolation.format || function (value) {
        return value;
      };
      this.escape = options.interpolation && options.interpolation.escape || utils_escape;
    }
    if (!options.interpolation) options.interpolation = { escapeValue: true };

    var iOpts = options.interpolation;

    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;

    this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
    this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';

    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';

    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';

    this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
    this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');

    // the regexp
    this.resetRegExp();
  };

  Interpolator.prototype.reset = function reset() {
    if (this.options) this.init(this.options);
  };

  Interpolator.prototype.resetRegExp = function resetRegExp() {
    // the regexp
    var regexpStr = this.prefix + '(.+?)' + this.suffix;
    this.regexp = new RegExp(regexpStr, 'g');

    var regexpUnescapeStr = this.prefix + this.unescapePrefix + '(.+?)' + this.unescapeSuffix + this.suffix;
    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');

    var nestingRegexpStr = this.nestingPrefix + '(.+?)' + this.nestingSuffix;
    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
  };

  Interpolator.prototype.interpolate = function interpolate(str, data, lng) {
    var _this = this;

    var match = void 0,
        value = void 0;

    function regexSafe(val) {
      return val.replace(/\$/g, '$$$$');
    }

    var handleFormat = function handleFormat(key) {
      if (key.indexOf(_this.formatSeparator) < 0) return getPath(data, key);

      var p = key.split(_this.formatSeparator);
      var k = p.shift().trim();
      var f = p.join(_this.formatSeparator).trim();

      return _this.format(getPath(data, k), f, lng);
    };

    this.resetRegExp();

    // unescape if has unescapePrefix/Suffix
    while (match = this.regexpUnescape.exec(str)) {
      var _value = handleFormat(match[1].trim());
      str = str.replace(match[0], _value);
      this.regexpUnescape.lastIndex = 0;
    }

    // regular escape on demand
    while (match = this.regexp.exec(str)) {
      value = handleFormat(match[1].trim());
      if (typeof value !== 'string') value = makeString(value);
      if (!value) {
        this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
        value = '';
      }
      value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  };

  Interpolator.prototype.nest = function nest(str, fc) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var match = void 0,
        value = void 0;

    var clonedOptions = Interpolator__extends({}, options);
    clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup

    function regexSafe(val) {
      return val.replace(/\$/g, '$$$$');
    }

    // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"
    function handleHasOptions(key) {
      if (key.indexOf(',') < 0) return key;

      var p = key.split(',');
      key = p.shift();
      var optionsString = p.join(',');
      optionsString = this.interpolate(optionsString, clonedOptions);
      optionsString = optionsString.replace(/'/g, '"');

      try {
        clonedOptions = JSON.parse(optionsString);
      } catch (e) {
        this.logger.error('failed parsing options string in nesting for key ' + key, e);
      }

      return key;
    }

    // regular escape on demand
    while (match = this.nestingRegexp.exec(str)) {
      value = fc(handleHasOptions.call(this, match[1].trim()), clonedOptions);
      if (typeof value !== 'string') value = makeString(value);
      if (!value) {
        this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
        value = '';
      }
      // Nested keys should not be escaped by default #854
      // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  };

  return Interpolator;
}();

/* harmony default export */ var es_Interpolator = (Interpolator_Interpolator);
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/BackendConnector.js
var BackendConnector__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function BackendConnector__defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function BackendConnector__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BackendConnector__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function BackendConnector__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : BackendConnector__defaults(subClass, superClass); }





function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var BackendConnector_Connector = function (_EventEmitter) {
  BackendConnector__inherits(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    BackendConnector__classCallCheck(this, Connector);

    var _this = BackendConnector__possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.options = options;
    _this.logger = logger.create('backendConnector');

    _this.state = {};
    _this.queue = [];

    _this.backend && _this.backend.init && _this.backend.init(services, options.backend, options);
    return _this;
  }

  Connector.prototype.queueLoad = function queueLoad(languages, namespaces, callback) {
    var _this2 = this;

    // find what needs to be loaded
    var toLoad = [],
        pending = [],
        toLoadLanguages = [],
        toLoadNamespaces = [];

    languages.forEach(function (lng) {
      var hasAllNamespaces = true;

      namespaces.forEach(function (ns) {
        var name = lng + '|' + ns;

        if (_this2.store.hasResourceBundle(lng, ns)) {
          _this2.state[name] = 2; // loaded
        } else if (_this2.state[name] < 0) {
          // nothing to do for err
        } else if (_this2.state[name] === 1) {
          if (pending.indexOf(name) < 0) pending.push(name);
        } else {
          _this2.state[name] = 1; // pending

          hasAllNamespaces = false;

          if (pending.indexOf(name) < 0) pending.push(name);
          if (toLoad.indexOf(name) < 0) toLoad.push(name);
          if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
        }
      });

      if (!hasAllNamespaces) toLoadLanguages.push(lng);
    });

    if (toLoad.length || pending.length) {
      this.queue.push({
        pending: pending,
        loaded: {},
        errors: [],
        callback: callback
      });
    }

    return {
      toLoad: toLoad,
      pending: pending,
      toLoadLanguages: toLoadLanguages,
      toLoadNamespaces: toLoadNamespaces
    };
  };

  Connector.prototype.loaded = function loaded(name, err, data) {
    var _this3 = this;

    var _name$split = name.split('|'),
        _name$split2 = _slicedToArray(_name$split, 2),
        lng = _name$split2[0],
        ns = _name$split2[1];

    if (err) this.emit('failedLoading', lng, ns, err);

    if (data) {
      this.store.addResourceBundle(lng, ns, data);
    }

    // set loaded
    this.state[name] = err ? -1 : 2;
    // callback if ready
    this.queue.forEach(function (q) {
      pushPath(q.loaded, [lng], ns);
      remove(q.pending, name);

      if (err) q.errors.push(err);

      if (q.pending.length === 0 && !q.done) {
        _this3.emit('loaded', q.loaded);
        q.errors.length ? q.callback(q.errors) : q.callback();
        q.done = true;
      }
    });

    // remove done load requests
    this.queue = this.queue.filter(function (q) {
      return !q.done;
    });
  };

  Connector.prototype.read = function read(lng, ns, fcName, tried, wait, callback) {
    var _this4 = this;

    if (!tried) tried = 0;
    if (!wait) wait = 250;

    if (!lng.length) return callback(null, {}); // noting to load

    this.backend[fcName](lng, ns, function (err, data) {
      if (err && data /* = retryFlag */ && tried < 5) {
        setTimeout(function () {
          _this4.read.call(_this4, lng, ns, fcName, ++tried, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    });
  };

  Connector.prototype.load = function load(languages, namespaces, callback) {
    var _this5 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }
    var options = BackendConnector__extends({}, this.backend.options, this.options.backend);

    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    var toLoad = this.queueLoad(languages, namespaces, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now
      return; // pendings will trigger callback
    }

    // load with multi-load
    if (options.allowMultiLoading && this.backend.readMulti) {
      this.read(toLoad.toLoadLanguages, toLoad.toLoadNamespaces, 'readMulti', null, null, function (err, data) {
        if (err) _this5.logger.warn('loading namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading failed', err);
        if (!err && data) _this5.logger.log('loaded namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading', data);

        toLoad.toLoad.forEach(function (name) {
          var _name$split3 = name.split('|'),
              _name$split4 = _slicedToArray(_name$split3, 2),
              l = _name$split4[0],
              n = _name$split4[1];

          var bundle = getPath(data, [l, n]);
          if (bundle) {
            _this5.loaded(name, err, bundle);
          } else {
            var _err = 'loading namespace ' + n + ' for language ' + l + ' via multiloading failed';
            _this5.loaded(name, _err);
            _this5.logger.error(_err);
          }
        });
      });
    }

    // load one by one
    else {
        (function () {
          var readOne = function readOne(name) {
            var _this6 = this;

            var _name$split5 = name.split('|'),
                _name$split6 = _slicedToArray(_name$split5, 2),
                lng = _name$split6[0],
                ns = _name$split6[1];

            this.read(lng, ns, 'read', null, null, function (err, data) {
              if (err) _this6.logger.warn('loading namespace ' + ns + ' for language ' + lng + ' failed', err);
              if (!err && data) _this6.logger.log('loaded namespace ' + ns + ' for language ' + lng, data);

              _this6.loaded(name, err, data);
            });
          };

          ;

          toLoad.toLoad.forEach(function (name) {
            readOne.call(_this5, name);
          });
        })();
      }
  };

  Connector.prototype.reload = function reload(languages, namespaces) {
    var _this7 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
    }
    var options = BackendConnector__extends({}, this.backend.options, this.options.backend);

    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    // load with multi-load
    if (options.allowMultiLoading && this.backend.readMulti) {
      this.read(languages, namespaces, 'readMulti', null, null, function (err, data) {
        if (err) _this7.logger.warn('reloading namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading failed', err);
        if (!err && data) _this7.logger.log('reloaded namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading', data);

        languages.forEach(function (l) {
          namespaces.forEach(function (n) {
            var bundle = getPath(data, [l, n]);
            if (bundle) {
              _this7.loaded(l + '|' + n, err, bundle);
            } else {
              var _err2 = 'reloading namespace ' + n + ' for language ' + l + ' via multiloading failed';
              _this7.loaded(l + '|' + n, _err2);
              _this7.logger.error(_err2);
            }
          });
        });
      });
    }

    // load one by one
    else {
        (function () {
          var readOne = function readOne(name) {
            var _this8 = this;

            var _name$split7 = name.split('|'),
                _name$split8 = _slicedToArray(_name$split7, 2),
                lng = _name$split8[0],
                ns = _name$split8[1];

            this.read(lng, ns, 'read', null, null, function (err, data) {
              if (err) _this8.logger.warn('reloading namespace ' + ns + ' for language ' + lng + ' failed', err);
              if (!err && data) _this8.logger.log('reloaded namespace ' + ns + ' for language ' + lng, data);

              _this8.loaded(name, err, data);
            });
          };

          ;

          languages.forEach(function (l) {
            namespaces.forEach(function (n) {
              readOne.call(_this7, l + '|' + n);
            });
          });
        })();
      }
  };

  Connector.prototype.saveMissing = function saveMissing(languages, namespace, key, fallbackValue) {
    if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue);

    // write to store to avoid resending
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  };

  return Connector;
}(es_EventEmitter);

/* harmony default export */ var BackendConnector = (BackendConnector_Connector);
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/CacheConnector.js
var CacheConnector__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function CacheConnector__defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function CacheConnector__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CacheConnector__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function CacheConnector__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : CacheConnector__defaults(subClass, superClass); }





var CacheConnector_Connector = function (_EventEmitter) {
  CacheConnector__inherits(Connector, _EventEmitter);

  function Connector(cache, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    CacheConnector__classCallCheck(this, Connector);

    var _this = CacheConnector__possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.cache = cache;
    _this.store = store;
    _this.services = services;
    _this.options = options;
    _this.logger = logger.create('cacheConnector');

    _this.cache && _this.cache.init && _this.cache.init(services, options.cache, options);
    return _this;
  }

  Connector.prototype.load = function load(languages, namespaces, callback) {
    var _this2 = this;

    if (!this.cache) return callback && callback();
    var options = CacheConnector__extends({}, this.cache.options, this.options.cache);

    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    if (options.enabled) {
      this.cache.load(languages, function (err, data) {
        if (err) _this2.logger.error('loading languages ' + languages.join(', ') + ' from cache failed', err);
        if (data) {
          for (var l in data) {
            for (var n in data[l]) {
              if (n === 'i18nStamp') continue;
              var bundle = data[l][n];
              if (bundle) _this2.store.addResourceBundle(l, n, bundle);
            }
          }
        }
        if (callback) callback();
      });
    } else {
      if (callback) callback();
    }
  };

  Connector.prototype.save = function save() {
    if (this.cache && this.options.cache && this.options.cache.enabled) this.cache.save(this.store.data);
  };

  return Connector;
}(es_EventEmitter);

/* harmony default export */ var CacheConnector = (CacheConnector_Connector);
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/defaults.js
function get() {
  return {
    debug: false,
    initImmediate: true,

    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false, // string or array of namespaces

    whitelist: false, // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all', // | currentOnly | languageOnly
    preload: false, // array with preload languages

    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',

    saveMissing: false, // enable to send missing values
    saveMissingTo: 'fallback', // 'current' || 'all'
    missingKeyHandler: false, // function(lng, ns, key, fallbackValue) -> override if prefer on handling

    postProcess: false, // string or array of postProcessor names
    returnNull: true, // allows null value as valid translation
    returnEmptyString: true, // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false, // or string to join array
    returnedObjectHandler: function returnedObjectHandler() {}, // function(key, value, options) triggered if key returns object but returnObjects is set to false
    parseMissingKeyHandler: false, // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function overloadTranslationOptionHandler(args) {
      return { defaultValue: args[1] };
    },

    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',

      nestingPrefix: '$t(',
      nestingSuffix: ')',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',
      defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
    }
  };
}

function transformOptions(options) {
  // create namespace object if namespace is passed in as string
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  // extend whitelist with cimode
  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) options.whitelist.push('cimode');

  return options;
}
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/i18next.js
var i18next__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var i18next__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function i18next__defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function i18next__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function i18next__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function i18next__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : i18next__defaults(subClass, superClass); }















function noop() {};

var i18next_I18n = function (_EventEmitter) {
  i18next__inherits(I18n, _EventEmitter);

  function I18n() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    i18next__classCallCheck(this, I18n);

    var _this = i18next__possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = logger;
    _this.modules = { external: [] };

    if (callback && !_this.isInitialized && !options.isClone) {
      var _ret;

      // https://github.com/i18next/i18next/issues/879
      if (!_this.options.initImmediate) return _ret = _this.init(options, callback), i18next__possibleConstructorReturn(_this, _ret);
      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }

  I18n.prototype.init = function init(options, callback) {
    var _this2 = this;

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!options) options = {};

    if (options.compatibilityAPI === 'v1') {
      this.options = i18next__extends({}, get(), transformOptions(convertAPIOptions(options)), {});
    } else if (options.compatibilityJSON === 'v1') {
      this.options = i18next__extends({}, get(), transformOptions(convertJSONOptions(options)), {});
    } else {
      this.options = i18next__extends({}, get(), this.options, transformOptions(options));
    }
    if (!callback) callback = noop;

    function createClassOnDemand(ClassOrObject) {
      if (!ClassOrObject) return;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    }

    // init services
    if (!this.options.isClone) {
      if (this.modules.logger) {
        logger.init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        logger.init(null, this.options);
      }

      var lu = new LanguageUtils(this.options);
      this.store = new es_ResourceStore(this.options.resources, this.options);

      var s = this.services;
      s.logger = logger;
      s.resourceStore = this.store;
      s.resourceStore.on('added removed', function (lng, ns) {
        s.cacheConnector.save();
      });
      s.languageUtils = lu;
      s.pluralResolver = new es_PluralResolver(lu, { prepend: this.options.pluralSeparator, compatibilityJSON: this.options.compatibilityJSON, simplifyPluralSuffix: this.options.simplifyPluralSuffix });
      s.interpolator = new es_Interpolator(this.options);

      s.backendConnector = new BackendConnector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.backendConnector.on('*', function (event) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      s.backendConnector.on('loaded', function (loaded) {
        s.cacheConnector.save();
      });

      s.cacheConnector = new CacheConnector(createClassOnDemand(this.modules.cache), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.cacheConnector.on('*', function (event) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        s.languageDetector.init(s, this.options.detection, this.options);
      }

      this.translator = new es_Translator(this.services, this.options);
      // pipe events from translator
      this.translator.on('*', function (event) {
        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      this.modules.external.forEach(function (m) {
        if (m.init) m.init(_this2);
      });
    }

    // append api
    var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle'];
    storeApi.forEach(function (fcName) {
      _this2[fcName] = function () {
        return this.store[fcName].apply(this.store, arguments);
      };
    });

    // TODO: COMPATIBILITY remove this
    if (this.options.compatibilityAPI === 'v1') appendBackwardsAPI(this);

    var load = function load() {
      _this2.changeLanguage(_this2.options.lng, function (err, t) {
        _this2.isInitialized = true;
        _this2.logger.log('initialized', _this2.options);
        _this2.emit('initialized', _this2.options);

        callback(err, t);
      });
    };

    if (this.options.resources || !this.options.initImmediate) {
      load();
    } else {
      setTimeout(load, 0);
    }

    return this;
  };

  I18n.prototype.loadResources = function loadResources() {
    var _this3 = this;

    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

    if (!this.options.resources) {
      var _ret2 = function () {
        if (_this3.language && _this3.language.toLowerCase() === 'cimode') return {
            v: callback()
          }; // avoid loading resources for cimode

        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;
          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!_this3.language) {
          // at least load fallbacks in this case
          var fallbacks = _this3.services.languageUtils.getFallbackCodes(_this3.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(_this3.language);
        }

        if (_this3.options.preload) {
          _this3.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        _this3.services.cacheConnector.load(toLoad, _this3.options.ns, function () {
          _this3.services.backendConnector.load(toLoad, _this3.options.ns, callback);
        });
      }();

      if ((typeof _ret2 === 'undefined' ? 'undefined' : i18next__typeof(_ret2)) === "object") return _ret2.v;
    } else {
      callback(null);
    }
  };

  I18n.prototype.reloadResources = function reloadResources(lngs, ns) {
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    this.services.backendConnector.reload(lngs, ns);
  };

  I18n.prototype.use = function use(module) {
    if (module.type === 'backend') {
      this.modules.backend = module;
    }

    if (module.type === 'cache') {
      this.modules.cache = module;
    }

    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }

    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }

    if (module.type === 'postProcessor') {
      postProcessor.addPostProcessor(module);
    }

    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }

    return this;
  };

  I18n.prototype.changeLanguage = function changeLanguage(lng, callback) {
    var _this4 = this;

    var done = function done(err) {
      if (lng) {
        _this4.emit('languageChanged', lng);
        _this4.logger.log('languageChanged', lng);
      }

      if (callback) callback(err, function () {
        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        return _this4.t.apply(_this4, args);
      });
    };

    if (!lng && this.services.languageDetector) lng = this.services.languageDetector.detect();

    if (lng) {
      this.language = lng;
      this.languages = this.services.languageUtils.toResolveHierarchy(lng);

      this.translator.changeLanguage(lng);

      if (this.services.languageDetector) this.services.languageDetector.cacheUserLanguage(lng);
    }

    this.loadResources(function (err) {
      done(err);
    });
  };

  I18n.prototype.getFixedT = function getFixedT(lng, ns) {
    var _this5 = this;

    var fixedT = function fixedT(key) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var options = i18next__extends({}, opts);
      options.lng = options.lng || fixedT.lng;
      options.ns = options.ns || fixedT.ns;
      return _this5.t(key, options);
    };
    fixedT.lng = lng;
    fixedT.ns = ns;
    return fixedT;
  };

  I18n.prototype.t = function t() {
    return this.translator && this.translator.translate.apply(this.translator, arguments);
  };

  I18n.prototype.exists = function exists() {
    return this.translator && this.translator.exists.apply(this.translator, arguments);
  };

  I18n.prototype.setDefaultNamespace = function setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  };

  I18n.prototype.loadNamespaces = function loadNamespaces(ns, callback) {
    var _this6 = this;

    if (!this.options.ns) return callback && callback();
    if (typeof ns === 'string') ns = [ns];

    ns.forEach(function (n) {
      if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
    });

    this.loadResources(callback);
  };

  I18n.prototype.loadLanguages = function loadLanguages(lngs, callback) {
    if (typeof lngs === 'string') lngs = [lngs];
    var preloaded = this.options.preload || [];

    var newLngs = lngs.filter(function (lng) {
      return preloaded.indexOf(lng) < 0;
    });
    // Exit early if all given languages are already preloaded
    if (!newLngs.length) return callback();

    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(callback);
  };

  I18n.prototype.dir = function dir(lng) {
    if (!lng) lng = this.language;
    if (!lng) return 'rtl';

    var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];

    return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
  };

  I18n.prototype.createInstance = function createInstance() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    return new I18n(options, callback);
  };

  I18n.prototype.cloneInstance = function cloneInstance() {
    var _this7 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

    var mergedOptions = i18next__extends({}, options, this.options, { isClone: true });
    var clone = new I18n(mergedOptions, callback);
    var membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(function (m) {
      clone[m] = _this7[m];
    });
    clone.translator = new es_Translator(clone.services, clone.options);
    clone.translator.on('*', function (event) {
      for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      clone.emit.apply(clone, [event].concat(args));
    });
    clone.init(mergedOptions, callback);

    return clone;
  };

  return I18n;
}(es_EventEmitter);

/* harmony default export */ var i18next = (new i18next_I18n());
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeLanguage", function() { return changeLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneInstance", function() { return es_cloneInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createInstance", function() { return createInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dir", function() { return dir; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exists", function() { return es_exists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFixedT", function() { return getFixedT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return es_init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadLanguages", function() { return loadLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadNamespaces", function() { return loadNamespaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadResources", function() { return loadResources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "off", function() { return off; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "on", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDefaultNamespace", function() { return setDefaultNamespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return t; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "use", function() { return es_use; });


/* harmony default export */ var es = __webpack_exports__["default"] = (i18next);

var changeLanguage = i18next.changeLanguage.bind(i18next);
var es_cloneInstance = i18next.cloneInstance.bind(i18next);
var createInstance = i18next.createInstance.bind(i18next);
var dir = i18next.dir.bind(i18next);
var es_exists = i18next.exists.bind(i18next);
var getFixedT = i18next.getFixedT.bind(i18next);
var es_init = i18next.init.bind(i18next);
var loadLanguages = i18next.loadLanguages.bind(i18next);
var loadNamespaces = i18next.loadNamespaces.bind(i18next);
var loadResources = i18next.loadResources.bind(i18next);
var off = i18next.off.bind(i18next);
var on = i18next.on.bind(i18next);
var setDefaultNamespace = i18next.setDefaultNamespace.bind(i18next);
var t = i18next.t.bind(i18next);
var es_use = i18next.use.bind(i18next);

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(63);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MOUSE_EVENTS_SUPPORTED = ['click'];

var WixComponent = function (_React$PureComponent) {
  _inherits(WixComponent, _React$PureComponent);

  function WixComponent(params) {
    _classCallCheck(this, WixComponent);

    var _this = _possibleConstructorReturn(this, (WixComponent.__proto__ || Object.getPrototypeOf(WixComponent)).call(this, params));

    _this._addDataHook = _this._addDataHook.bind(_this);
    _this._supportOnClickOutside = _this._supportOnClickOutside.bind(_this);
    _this._onMouseEventsHandler = _this._onMouseEventsHandler.bind(_this);
    return _this;
  }

  _createClass(WixComponent, [{
    key: 'checkIfEventOnElements',
    value: function checkIfEventOnElements(e, elem) {
      var current = e.target;
      while (current.parentNode) {
        if (elem.indexOf(current) > -1) {
          return true;
        }
        current = current.parentNode;
      }

      return current !== document;
    }
  }, {
    key: 'componentElements',
    value: function componentElements() {
      return [_reactDom2.default.findDOMNode(this)];
    }
  }, {
    key: 'setStyles',
    value: function setStyles(styles) {
      var typography = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.props.styles) {
        this.styles = this.props.styles;
      } else {
        this.styles = styles;
      }
      this.typography = this.props.styles || typography;
    }
  }, {
    key: '_onMouseEventsHandler',
    value: function _onMouseEventsHandler(e) {
      if (!this.checkIfEventOnElements(e, this.componentElements())) {
        this.onClickOutside(e);
      }
    }
  }, {
    key: '_addDataHook',
    value: function _addDataHook(dataHook) {
      var domNode = _reactDom2.default.findDOMNode(this);
      if (domNode) {
        domNode.setAttribute('data-hook', dataHook);
      }
    }
  }, {
    key: '_supportOnClickOutside',
    value: function _supportOnClickOutside() {
      var _this2 = this;

      MOUSE_EVENTS_SUPPORTED.forEach(function (eventName) {
        document.addEventListener(eventName, _this2._onMouseEventsHandler, true);
      });

      this._boundEvents = MOUSE_EVENTS_SUPPORTED;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dataHook = this.props.dataHook;

      if (dataHook) {
        this._addDataHook(dataHook);
      }

      if (typeof this.onClickOutside === 'function') {
        this._supportOnClickOutside();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      if (this._boundEvents && typeof document !== 'undefined') {
        this._boundEvents.forEach(function (eventName) {
          document.removeEventListener(eventName, _this3._onMouseEventsHandler, true);
        });
      }
    }
  }]);

  return WixComponent;
}(_react2.default.PureComponent);

WixComponent.propTypes = {
  dataHook: _propTypes2.default.string,
  styles: _propTypes2.default.string
};

exports.default = WixComponent;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Installments_1 = __webpack_require__(150);
exports.Installments = Installments_1.default;
var Field_1 = __webpack_require__(192);
exports.Field = Field_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__(11);
var React = __webpack_require__(0);
var Loader_1 = __webpack_require__(12);
var s = __webpack_require__(154);
var Dropdown = (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.currentOptionIndex = -1;
        _this.setDropdownRef = function (ref) { return _this.node = ref; };
        _this.hideDropdownMenu = function () {
            _this.setState({
                isOptionsListOpened: false,
            });
        };
        _this.handleClickOutside = function (event) {
            /* istanbul ignore next */
            if (_this.node && !_this.node.contains(event.target)) {
                _this.hideDropdownMenu();
            }
        };
        _this.showDropdownMenu = function () { return !_this.props.disabled && _this.setState({ isOptionsListOpened: true }); };
        _this.handleKeyDown = function (e) {
            e.stopPropagation();
            var options = _this.props.options;
            switch (e.key) {
                case 'ArrowUp': {
                    e.preventDefault();
                    if (_this.currentOptionIndex <= 0) {
                        _this.currentOptionIndex = options.length;
                    }
                    _this.currentOptionIndex--;
                    if (options[_this.currentOptionIndex]) {
                        _this.setState({ selectedOptionId: options[_this.currentOptionIndex].value });
                        var node = document.getElementById("dropdown-option-" + options[_this.currentOptionIndex].id);
                        /* istanbul ignore next */
                        if (node.offsetTop - _this.dropdownMenuNode.scrollTop <= 0) {
                            _this.dropdownMenuNode.scrollTop = node.offsetTop;
                        }
                        /* istanbul ignore next */
                        if (_this.dropdownMenuNode.scrollTop <= 0) {
                            _this.dropdownMenuNode.scrollTop = node.offsetTop;
                        }
                    }
                    break;
                }
                case 'ArrowDown': {
                    e.preventDefault();
                    if (!_this.state.isOptionsListOpened) {
                        _this.showDropdownMenu();
                    }
                    if (_this.currentOptionIndex >= options.length - 1) {
                        _this.currentOptionIndex = -1;
                    }
                    _this.currentOptionIndex++;
                    if (options[_this.currentOptionIndex]) {
                        _this.setState({ selectedOptionId: options[_this.currentOptionIndex].value });
                        var node = document.getElementById("dropdown-option-" + options[_this.currentOptionIndex].id);
                        if (_this.dropdownMenuNode.offsetHeight <= node.offsetTop) {
                            _this.dropdownMenuNode.scrollTop = node.offsetTop;
                        }
                        if (_this.dropdownMenuNode.scrollTop >= node.offsetTop) {
                            _this.dropdownMenuNode.scrollTop = 0;
                        }
                    }
                    break;
                }
                case 'ArrowRight':
                case 'Enter':
                case 'Tab': {
                    if (options[_this.currentOptionIndex]) {
                        _this.onOptionClick(options[_this.currentOptionIndex])();
                    }
                    break;
                }
                default: {
                    break;
                }
            }
        };
        _this.handleTextChange = function (e) {
            if (!_this.state.isOptionsListOpened) {
                _this.showDropdownMenu();
            }
            if (_this.props.onChange) {
                _this.props.onChange(e);
            }
        };
        _this.loadSymbolPolyfillIfRequired();
        return _this;
    }
    Dropdown.prototype.loadSymbolPolyfillIfRequired = function () {
        var symbolLoader = document.createElement('script');
        symbolLoader.src = 'https://static.parastorage.com/polyfill/v2/polyfill.js?features=Symbol';
        symbolLoader.async = true;
        document.head.appendChild(symbolLoader);
    };
    Dropdown.prototype.componentWillMount = function () {
        this.setState({
            isOptionsListOpened: false,
            selectedOptionId: this.props.defaultOptionId,
        });
    };
    Dropdown.prototype.onOptionSelection = function (option) {
        this.setState({
            isOptionsListOpened: false,
            selectedOptionId: option.id,
        });
        this.props.onSelect(option);
    };
    Dropdown.prototype.onOptionClick = function (option) {
        var _this = this;
        return (function () { return _this.onOptionSelection(option); });
    };
    Dropdown.prototype.componentDidMount = function () {
        document.addEventListener('click', this.handleClickOutside);
    };
    Dropdown.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.handleClickOutside);
    };
    Dropdown.prototype.renderDropdownInput = function () {
        var _this = this;
        var selectedOption = this.props.options.find(function (option) { return option.id === _this.state.selectedOptionId; });
        if (this.props.autocomplete) {
            return (React.createElement("div", { onClick: this.showDropdownMenu, "data-hook": "cashier-payments-method-dropdown" },
                React.createElement("input", { onKeyDown: this.handleKeyDown, disabled: this.props.disabled, className: s.input, value: this.props.autocompleteInputValue, onChange: this.handleTextChange, onFocus: this.props.onFocus, onBlur: this.props.onBlur }),
                React.createElement("div", { className: s.dropdownArrow })));
        }
        return (React.createElement("div", { className: classNames(s.option, (_a = {}, _a[s.selectedOptionNonActiveState] = !this.state.isOptionsListOpened, _a)), onClick: this.showDropdownMenu, "data-hook": "cashier-payments-method-dropdown" },
            React.createElement("span", { className: s.optionLabel }, selectedOption ? selectedOption.label : null),
            React.createElement("div", { className: s.dropdownArrow })));
        var _a;
    };
    Dropdown.prototype.renderDropdownMenu = function () {
        var _this = this;
        if (!this.state.isOptionsListOpened) {
            return null;
        }
        return (React.createElement("div", { "data-hook": "cashier-payments-method-dropdown-menu", className: s.dropdownOptions, ref: function (node) { return _this.dropdownMenuNode = node; } },
            this.props.isLoadingOptions
                ? React.createElement("div", { "data-hook": "cashier-payments-method-dropdown-spinner", className: s.loader },
                    React.createElement(Loader_1.default, { size: "small" }))
                : null,
            this.props.options.map(function (option) {
                return (React.createElement("div", { "data-hook": "cashier-payments-method-dropdown-option-" + option.id, key: option.id, id: "dropdown-option-" + option.id, className: classNames(s.option, s.selectableOption, (_a = {}, _a[s.currentSelection] = option.id === _this.state.selectedOptionId, _a)), onClick: _this.onOptionClick(option) },
                    React.createElement("span", { className: s.optionLabel }, option.label)));
                var _a;
            })));
    };
    Dropdown.prototype.render = function () {
        return (React.createElement("div", { ref: this.setDropdownRef, className: s.dropdownContainer },
            this.renderDropdownInput(),
            this.renderDropdownMenu()));
    };
    return Dropdown;
}(React.Component));
exports.default = Dropdown;
//# sourceMappingURL=Dropdown.js.map

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(64);


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AutoComplete_1 = __webpack_require__(197);
exports.default = AutoComplete_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PaymentDetails_1 = __webpack_require__(215);
exports.default = PaymentDetails_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PayButton_1 = __webpack_require__(217);
exports.default = PayButton_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PaymentsStore_1 = __webpack_require__(219);
exports.default = PaymentsStore_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(222);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = __webpack_require__(227);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(230);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(260);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(267);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(268);

var _createClass3 = _interopRequireDefault(_createClass2);

var _promise = __webpack_require__(77);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function httpRequest(url) {
  return new _promise2.default(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'text';
    xhr.withCredentials = true;
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 400) {
        resolve(xhr.responseText);
      } else {
        reject('Failed to load ' + url + ', status ' + xhr.status);
      }
    };
    xhr.onerror = function () {
      return reject('Failed to load ' + url);
    };
    xhr.send();
  });
}

function tryParse(data) {
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (e) {/* Ignore */}
  }
  return data;
}

var Experiments = function () {
  function Experiments() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, Experiments);

    this.experiments = obj.experiments || {};
    this.loaders = [];
    this.baseUrl = obj.baseUrl || '';
    if (obj.scope) {
      this.load(obj.scope);
    }
  }

  (0, _createClass3.default)(Experiments, [{
    key: 'add',
    value: function add(obj) {
      this.experiments = (0, _extends3.default)({}, this.experiments, obj);
    }
  }, {
    key: 'get',
    value: function get(key) {
      return this.experiments[key];
    }
  }, {
    key: 'enabled',
    value: function enabled(key) {
      return this.get(key) === 'true';
    }
  }, {
    key: 'all',
    value: function all() {
      return this.experiments;
    }
  }, {
    key: '_addLoader',
    value: function _addLoader(promise) {
      var _this = this;

      this.loaders.push(promise);
      promise.then(function () {
        _this.loaders = _this.loaders.filter(function (x) {
          return x !== promise;
        });
      });
      return promise;
    }
  }, {
    key: '_getUrlWithFallback',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(url, fallback) {
        var response;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return httpRequest(url);

              case 3:
                response = _context.sent;
                return _context.abrupt('return', tryParse(response));

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);
                return _context.abrupt('return', fallback);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function _getUrlWithFallback(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return _getUrlWithFallback;
    }()
  }, {
    key: 'load',
    value: function load(scope) {
      var _this2 = this;

      var url = this.baseUrl + '/_api/wix-laboratory-server/laboratory/conductAllInScope?scope=' + scope;
      var result = this._getUrlWithFallback(url, {}).then(function (obj) {
        return _this2.add(obj);
      });
      return this._addLoader(result);
    }
  }, {
    key: 'conduct',
    value: function conduct(spec, fallback) {
      var _this3 = this;

      var url = this.baseUrl + '/_api/wix-laboratory-server/laboratory/conductExperiment?key=' + spec + '&fallback=' + fallback;
      var result = this._getUrlWithFallback(url, fallback).then(function (value) {
        _this3.add((0, _defineProperty3.default)({}, spec, value));
        return value;
      });
      return this._addLoader(result);
    }
  }, {
    key: 'pending',
    value: function pending() {
      return !!this.loaders.length;
    }
  }, {
    key: 'ready',
    value: function ready() {
      return _promise2.default.all(this.loaders);
    }
  }]);
  return Experiments;
}();

exports.default = Experiments;
//# sourceMappingURL=index.js.map


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(223), __esModule: true };

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(231), __esModule: true };

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(79);
var $export = __webpack_require__(7);
var redefine = __webpack_require__(235);
var hide = __webpack_require__(8);
var Iterators = __webpack_require__(16);
var $iterCreate = __webpack_require__(236);
var setToStringTag = __webpack_require__(45);
var getPrototypeOf = __webpack_require__(242);
var ITERATOR = __webpack_require__(3)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(239);
var enumBugKeys = __webpack_require__(85);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(21);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(41);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(2).document;
module.exports = document && document.documentElement;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(42);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(21);
var TAG = __webpack_require__(3)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(5);
var aFunction = __webpack_require__(19);
var SPECIES = __webpack_require__(3)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(18);
var invoke = __webpack_require__(253);
var html = __webpack_require__(86);
var cel = __webpack_require__(40);
var global = __webpack_require__(2);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(21)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(5);
var isObject = __webpack_require__(15);
var newPromiseCapability = __webpack_require__(46);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(273);
var subBlocks = new Array(4);
exports.default = (function (props) { return (React.createElement("div", { className: styles.creditCardIcon, "data-hook": "wcn-credit-card-icon" },
    React.createElement("img", { src: "https://www.wix.com/_partials/third-party/cashier-settings/cashier-payments/creditCard.svg" }))); });


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(274);
exports.default = (function (props) { return (React.createElement("img", { className: styles.paypalLogo, src: "https://www.wix.com/_partials/third-party/cashier-settings/cashier-payments/payPal.svg", style: props.style })); });


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(275);
exports.default = (function (props) { return (React.createElement("img", { className: styles.mercadoPagoLogo, src: "https://www.wix.com/_partials/third-party/cashier-settings/methods-new/method-icon-mercadoPago-new.svg", style: props.style })); });


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(276);
exports.default = (function (props) { return (React.createElement("img", { className: styles.pagSeguroLogo, src: "https://www.wix.com/_partials/third-party/cashier-settings/methods-new/method-icon-pagSeguro-new.svg", style: props.style })); });


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(277);
exports.default = (function (props) { return (React.createElement("img", { className: styles.yandexLogo, src: "https://www.wix.com/_partials/third-party/cashier-settings/methods-new/method-icon-yandex-new.svg", style: props.style })); });


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(99);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(48);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(23),
    isObject = __webpack_require__(25);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50)))

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(319);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(333),
    baseKeys = __webpack_require__(343),
    isArrayLike = __webpack_require__(30);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 104 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 105 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moduleRegistry = __webpack_require__(22);

var _moduleRegistry2 = _interopRequireDefault(_moduleRegistry);

var _tagAppender = __webpack_require__(107);

var _assign = __webpack_require__(350);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseLazyComponent = function (_React$Component) {
  _inherits(BaseLazyComponent, _React$Component);

  function BaseLazyComponent(props, manifest) {
    _classCallCheck(this, BaseLazyComponent);

    var _this = _possibleConstructorReturn(this, (BaseLazyComponent.__proto__ || Object.getPrototypeOf(BaseLazyComponent)).call(this, props));

    _this.manifest = manifest;
    return _this;
  }

  _createClass(BaseLazyComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      _moduleRegistry2.default.notifyListeners('reactModuleContainer.componentStartLoading', this.manifest.component);
      var prepare = this.manifest.prepare ? function () {
        return _this2.manifest.prepare();
      } : function () {
        return undefined;
      };
      var filesAppenderPromise = (0, _tagAppender.filesAppender)(this.manifest.files, this.manifest.crossorigin).then(prepare, function (err) {
        return console.error(err);
      });
      var resolvePromise = this.manifest.resolve ? this.manifest.resolve() : Promise.resolve({});
      this.resourceLoader = Promise.all([resolvePromise, filesAppenderPromise]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
            resolvedData = _ref2[0];

        _this2.resolvedData = resolvedData;
        _moduleRegistry2.default.notifyListeners('reactModuleContainer.componentReady', _this2.manifest.component);
      }).catch(function (err) {
        return console.error(err);
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _moduleRegistry2.default.notifyListeners('reactModuleContainer.componentWillUnmount', this.manifest.component);
    }
  }, {
    key: 'mergedProps',
    get: function get() {
      return (0, _assign2.default)({}, this.props, this.resolvedData);
    }
  }]);

  return BaseLazyComponent;
}(_react2.default.Component);

exports.default = BaseLazyComponent;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createLinkElement = createLinkElement;
exports.createScriptElement = createScriptElement;
exports.tagAppender = tagAppender;
exports.filesAppender = filesAppender;
exports.unloadStyles = unloadStyles;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var requireCache = {};

function noprotocol(url) {
  return url.replace(/^.*:\/\//, '//');
}

function createLinkElement(url) {
  var fileref = document.createElement('LINK');
  fileref.setAttribute('rel', 'stylesheet');
  fileref.setAttribute('type', 'text/css');
  fileref.setAttribute('href', url);
  return fileref;
}

function createScriptElement(url, crossorigin) {
  var fileref = document.createElement('SCRIPT');
  fileref.setAttribute('type', 'text/javascript');
  fileref.setAttribute('src', url);
  if (crossorigin) {
    fileref.setAttribute('crossorigin', 'anonymous');
  }
  return fileref;
}

function tagAppender(url, filetype, crossorigin) {
  var styleSheets = document.styleSheets;
  return requireCache[url] = new Promise(function (resolve, reject) {
    if (window.requirejs && filetype === 'js') {
      window.requirejs([url], resolve, reject);
      return;
    } else if (url in requireCache) {
      // requireCache[url].then(resolve, reject);
      // return;
    }

    var fileref = filetype === 'css' ? createLinkElement(url) : createScriptElement(url, crossorigin);

    var done = false;
    document.getElementsByTagName('head')[0].appendChild(fileref);
    fileref.onerror = function () {
      fileref.onerror = fileref.onload = fileref.onreadystatechange = null;
      delete requireCache[url];
      reject();
    };
    fileref.onload = fileref.onreadystatechange = function () {
      if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
        done = true;
        fileref.onerror = fileref.onload = fileref.onreadystatechange = null;
        resolve();
      }
    };
    if (filetype === 'css' && navigator.userAgent.match(' Safari/') && !navigator.userAgent.match(' Chrom') && navigator.userAgent.match(' Version/5.')) {
      var attempts = 20;
      var interval = setInterval(function () {
        for (var i = 0; i < styleSheets.length; i++) {
          if (noprotocol('' + styleSheets[i].href) === noprotocol(url)) {
            clearInterval(interval);
            fileref.onload();
            return;
          }
        }
        if (--attempts === 0) {
          clearInterval(interval);
          fileref.onerror();
        }
      }, 50);
    }
  });
}

function append(file, crossorigin) {
  return tagAppender(file, file.split('.').pop(), crossorigin);
}

function filesAppender(files, crossorigin) {
  return Promise.all(files.map(function (file) {
    if (Array.isArray(file)) {
      return file.reduce(function (promise, next) {
        return promise.then(function () {
          return append(next, crossorigin);
        }, function (err) {
          return console.log(err);
        });
      }, Promise.resolve());
    } else {
      return append(file, crossorigin);
    }
  }));
}

var getStyleSheetLinks = function getStyleSheetLinks(document) {
  return [].concat(_toConsumableArray(document.querySelectorAll('link'))).filter(function (link) {
    return link.rel === 'stylesheet' && link.href;
  }).reduceRight(function (acc, curr) {
    return _extends({}, acc, _defineProperty({}, noprotocol(curr.href), curr));
  }, {});
};

var getStyleSheetUrls = function getStyleSheetUrls(files) {
  var _ref;

  return (_ref = []).concat.apply(_ref, _toConsumableArray(files)).filter(function (file) {
    return file.endsWith('.css');
  }).map(function (file) {
    return noprotocol(file);
  });
};

function unloadStyles(document, files) {
  var links = getStyleSheetLinks(document);
  getStyleSheetUrls(files).forEach(function (file) {
    var link = links[file];
    if (link) {
      link.parentNode.removeChild(link);
    }
  });
}

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var i18next = __webpack_require__(65);
exports.init = function (lng, resources, onReady) {
    return i18next.init({
        lng: lng,
        keySeparator: '$',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        },
        resources: resources
    }, function (err, t) {
        onReady && onReady(t);
    });
};
exports.default = i18next;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assert = __webpack_require__(110);
var BiLogger = __webpack_require__(370);

var BiLoggerFactory = function () {
  function BiLoggerFactory() {
    _classCallCheck(this, BiLoggerFactory);

    this._publishers = [];
    this._validators = [];
    this._defaults = {};
    this._events = {};
  }

  _createClass(BiLoggerFactory, [{
    key: 'addPublisher',
    value: function addPublisher(publisher) {
      assert.defined(publisher, 'Publisher must be provided');
      assert.ok(typeof publisher === 'function', 'Expected a publisher function');
      this._publishers.push(publisher);
      return this;
    }
  }, {
    key: 'addValidator',
    value: function addValidator(validator) {
      assert.defined(validator, 'Validator must be provided');
      assert.ok((typeof validator === 'undefined' ? 'undefined' : _typeof(validator)) === 'object' && validator, 'Expected a validator object');
      assert.ok(validator.execute && validator.match, 'Provided validator does not match the interface');
      this._validators.push(validator);
      return this;
    }
  }, {
    key: 'setDefaults',
    value: function setDefaults(defaults) {
      assert.defined(defaults, 'Defaults must be provided');
      assert.object(defaults, 'Defaults must be an object');
      this._defaults = defaults;
      return this;
    }
  }, {
    key: 'updateDefaults',
    value: function updateDefaults(defaults) {
      assert.defined(defaults, 'Defaults must be provided');
      assert.object(defaults, 'Defaults must be an object');
      Object.assign(this._defaults, defaults);
      return this;
    }
  }, {
    key: 'setEvents',
    value: function setEvents(events) {
      assert.defined(events, 'Events must be provided');
      assert.object(events, 'Events must be an object');
      this._events = events;
      return this;
    }
  }, {
    key: 'setDefaultValueTimeout',
    value: function setDefaultValueTimeout(defaultValueTimeout) {
      assert.defined(defaultValueTimeout, 'Default Value Timeout must be provided');
      this._defaultValueTimeout = defaultValueTimeout;
      return this;
    }
  }, {
    key: 'setDefaultContinueOnFail',
    value: function setDefaultContinueOnFail(defaultContinueOnFail) {
      assert.defined(defaultContinueOnFail, 'Default Continue On Fail must be provided');
      this._defaultContinueOnFail = defaultContinueOnFail;
      return this;
    }
  }, {
    key: 'logger',
    value: function logger(context) {
      return new BiLogger({
        publishers: this._publishers,
        validators: this._validators,
        defaults: this._defaults,
        events: this._events,
        defaultValueTimeout: this._defaultValueTimeout,
        defaultContinueOnFail: this._defaultContinueOnFail
      }, context);
    }
  }]);

  return BiLoggerFactory;
}();

module.exports = BiLoggerFactory;
//# sourceMappingURL=bi-logger-factory.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssertionError = function (_Error) {
  _inherits(AssertionError, _Error);

  function AssertionError(message) {
    _classCallCheck(this, AssertionError);

    var _this = _possibleConstructorReturn(this, (AssertionError.__proto__ || Object.getPrototypeOf(AssertionError)).call(this, message));

    _this.name = _this.constructor.name;
    return _this;
  }

  return AssertionError;
}(Error);

function assertDefined(target, message) {
  if (target === undefined) {
    throw new AssertionError(message);
  }
}

function assertObject(target, message) {
  if (target !== undefined && ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) !== 'object' || Array.isArray(target) || target === null)) {
    throw new AssertionError(message);
  }
}

function assertOk(target, message) {
  if (!target) {
    throw new AssertionError(message);
  }
}

module.exports.defined = assertDefined;
module.exports.object = assertObject;
module.exports.ok = assertOk;
module.exports.AssertionError = AssertionError;
//# sourceMappingURL=assert.js.map

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildUrl = buildUrl;
exports.guid = guid;

var _performance = __webpack_require__(375);

var _env = __webpack_require__(31);

var DEFAULT_ENDPOINT = '';

var cacheKillerCounter = 0;

function addParam(url, key, value) {
  var separator = url.indexOf('?') === -1 ? '?' : '&';
  return '' + url + separator + encodeURIComponent(key) + '=' + encodeURIComponent(value);
}

function buildUrl(_ref, params) {
  var host = _ref.host,
      _ref$endpoint = _ref.endpoint,
      endpoint = _ref$endpoint === undefined ? DEFAULT_ENDPOINT : _ref$endpoint;

  host = host || (0, _env.getHost)();

  params._ = '' + new Date().getTime() + cacheKillerCounter++;
  params.ms = Math.round((0, _performance.now)());

  var prefix = '//' + host + '/' + endpoint;
  return Object.keys(params).reduce(function (url, key) {
    return addParam(url, key, params[key]);
  }, prefix);
}

function guid() {
  /*eslint-disable */
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
  /*eslint-enable */
}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listen = listen;
exports.sendBeacon = sendBeacon;

var _env = __webpack_require__(31);

function hook(obj, fnName, hook) {
  if (!obj || !obj[fnName]) {
    return;
  }

  var original = obj[fnName];
  obj[fnName] = function () {
    hook.apply(null, arguments);
    return original.apply(obj, arguments);
  };
}

function onLoad(cb) {
  setTimeout(function () {
    return (0, _env.provideBrowsingContext)(function (window) {
      return cb(window.location.href);
    });
  });
}

function onPushState(cb) {
  (0, _env.provideBrowsingContext)(function (_ref) {
    var history = _ref.history;
    return ['pushState', 'replaceState'].forEach(function (fnName) {
      hook(history, fnName, function (_, __, url) {
        return cb(url);
      });
    });
  });
}

function onPopState(cb) {
  (0, _env.provideBrowsingContext)(function (window) {
    return window.addEventListener('popstate', function () {
      return cb(window.location.href);
    });
  });
}

function listen(cb) {
  (0, _env.provideBrowsingContext)(function (window) {
    var fromUrl = window.document.referrer;

    [onLoad, onPushState, onPopState].forEach(function (event) {
      return event(function (toUrl) {
        cb(fromUrl, toUrl);
        fromUrl = toUrl;
      });
    });
  });
}

function sendBeacon(url) {
  if (typeof navigator === 'undefined' || !navigator || !navigator.sendBeacon) {
    return false;
  }

  return navigator.sendBeacon(url);
}

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var i18n_1 = __webpack_require__(108);
var Translate = function (_a) {
    var forKey = _a.forKey, _b = _a.data, data = _b === void 0 ? {} : _b;
    var translation = i18n_1.default.t(forKey, data);
    return (React.createElement("span", null, translation));
};
exports.translate = function (_a) {
    var forKey = _a.forKey, _b = _a.data, data = _b === void 0 ? {} : _b;
    return i18n_1.default.t(forKey, data);
};
exports.default = Translate;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(399);
var buildURL = __webpack_require__(401);
var parseHeaders = __webpack_require__(402);
var isURLSameOrigin = __webpack_require__(403);
var createError = __webpack_require__(116);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(404);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(405);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        if (request.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(400);

/**
 * Create an Error with the specified message, config, error code, and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 @ @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, response);
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var web_bi_logger_1 = __webpack_require__(425);
var mandatoryFieldsMapping = {
    cardNumber: 'number',
    expire: 'expiration',
    cvc: 'additional_information.cvv',
    cardHolderName: 'additional_information.holder_name',
    holderId: 'additional_information.holder_id',
};
var BiLogger = /** @class */ (function () {
    function BiLogger() {
        var _this = this;
        this.init = function (_a) {
            var appId = _a.appId, appInstanceId = _a.appInstanceId, orderSnapshotId = _a.orderSnapshotId, visitorId = _a.visitorId, msid = _a.msid, host = _a.host, type = _a.type;
            var factoryConfig = host ? { host: host, endpoint: 'cashier-ugc' } : { endpoint: 'cashier-ugc' };
            if (type === 'mobile') {
                // TODO we need to implement bi for mobile
                _this.logger = {
                    log: function () { return null; }
                };
            }
            else {
                _this.logger = web_bi_logger_1.default.factory(factoryConfig).setDefaults({
                    src: 64,
                    appId: appId,
                    appInstanceId: appInstanceId,
                    msid: msid,
                    orderSnapshotId: orderSnapshotId,
                    visitorId: visitorId,
                }).logger();
            }
        };
        this.log = function (_a) {
            var evid = _a.evid, rest = __rest(_a, ["evid"]);
            return _this.logger && _this.logger.log(__assign({ evid: evid }, rest));
        };
        this.mandatoryFieldsLoaded = function (_a) {
            var mandatoryFieldsList = _a.mandatoryFieldsList, orderId = _a.orderId, paymentMethod = _a.paymentMethod, appId = _a.appId, appInstanceId = _a.appInstanceId;
            // List of mandatory fields to be fulfilled by buyer
            var evid = 164;
            mandatoryFieldsList = _this.stringifyMandatoryFields(mandatoryFieldsList);
            _this.log({ evid: evid, mandatoryFieldsList: mandatoryFieldsList, orderId: orderId, paymentMethod: paymentMethod, appId: appId, appInstanceId: appInstanceId });
        };
        this.mandatoryFieldsValidation = function (_a) {
            var status = _a.status, invalidFields = _a.invalidFields, paymentMethod = _a.paymentMethod, orderId = _a.orderId, paymentProvider = _a.paymentProvider;
            // The result of Payment Method Validation
            var evid = 165;
            var reason = _this.stringifyMandatoryFields(invalidFields);
            _this.log({ evid: evid, status: status, paymentMethod: paymentMethod, orderId: orderId, reason: reason, paymentProvider: paymentProvider });
        };
        /**
         * Convert fields loaded from server and from validation to same format
         *
         * @param {Array<string>} fields
         * @returns {string}
         */
        this.stringifyMandatoryFields = function (fields) {
            var mappedFields = Object.keys(mandatoryFieldsMapping).map(function (field) { return mandatoryFieldsMapping[field]; });
            fields = fields.map(function (field) {
                if (mappedFields.indexOf(field) !== -1) {
                    return field;
                }
                else {
                    field = field.split('.').pop();
                    return mandatoryFieldsMapping[field] || "description.billingAddress." + field;
                }
            });
            return fields.join(',');
        };
    }
    return BiLogger;
}());
exports.default = (new BiLogger());
//# sourceMappingURL=biLogger.js.map

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildUrl = buildUrl;
exports.guid = guid;

var _performance = __webpack_require__(427);

var _env = __webpack_require__(33);

var DEFAULT_ENDPOINT = '';

var cacheKillerCounter = 0;

function addParam(url, key, value) {
  var separator = url.indexOf('?') === -1 ? '?' : '&';
  return '' + url + separator + encodeURIComponent(key) + '=' + encodeURIComponent(value);
}

function buildUrl(_ref, params) {
  var host = _ref.host,
      _ref$endpoint = _ref.endpoint,
      endpoint = _ref$endpoint === undefined ? DEFAULT_ENDPOINT : _ref$endpoint;

  host = host || (0, _env.getHost)();

  params._ = '' + new Date().getTime() + cacheKillerCounter++;
  params.ms = Math.round((0, _performance.now)());

  var prefix = '//' + host + '/' + endpoint;
  return Object.keys(params).reduce(function (url, key) {
    return addParam(url, key, params[key]);
  }, prefix);
}

function guid() {
  /*eslint-disable */
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
  /*eslint-enable */
}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listen = listen;
exports.sendBeacon = sendBeacon;

var _env = __webpack_require__(33);

function hook(obj, fnName, hook) {
  if (!obj || !obj[fnName]) {
    return;
  }

  var original = obj[fnName];
  obj[fnName] = function () {
    hook.apply(null, arguments);
    return original.apply(obj, arguments);
  };
}

function onLoad(cb) {
  setTimeout(function () {
    return (0, _env.provideBrowsingContext)(function (window) {
      return cb(window.location.href);
    });
  });
}

function onPushState(cb) {
  (0, _env.provideBrowsingContext)(function (_ref) {
    var history = _ref.history;
    return ['pushState', 'replaceState'].forEach(function (fnName) {
      hook(history, fnName, function (_, __, url) {
        return cb(url);
      });
    });
  });
}

function onPopState(cb) {
  (0, _env.provideBrowsingContext)(function (window) {
    return window.addEventListener('popstate', function () {
      return cb(window.location.href);
    });
  });
}

function listen(cb) {
  (0, _env.provideBrowsingContext)(function (window) {
    var fromUrl = window.document.referrer;

    [onLoad, onPushState, onPopState].forEach(function (event) {
      return event(function (toUrl) {
        cb(fromUrl, toUrl);
        fromUrl = toUrl;
      });
    });
  });
}

function sendBeacon(url) {
  if (typeof navigator === 'undefined' || !navigator || !navigator.sendBeacon) {
    return false;
  }

  return navigator.sendBeacon(url);
}

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Converts object to query string
 *
 * @param   {Object} data   a map to convert
 * @returns {String}        query string
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
function mapToQuery(data) {
  var res = [];

  for (var key in data) {
    if (data.hasOwnProperty(key)) {
      // eslint-disable-line
      res.push(key + '=' + encodeURIComponent(data[key]));
    }
  }

  return res.join('&');
}

/**
 * Generates a valid GUID
 *
 * @returns {String}  GUID
 */
function generateGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c === 'x' ? r : r & 0x3 | 0x8; // eslint-disable-line
    return v.toString(16);
  });
}

exports.default = {
  mapToQuery: mapToQuery,
  generateGuid: generateGuid
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dataSource = __webpack_require__(438);

var _dataSource2 = _interopRequireDefault(_dataSource);

var _biLoadPhaseItem = __webpack_require__(439);

var _biLoadPhaseItem2 = _interopRequireDefault(_biLoadPhaseItem);

var _durationItem = __webpack_require__(124);

var _durationItem2 = _interopRequireDefault(_durationItem);

var _biErrorItem = __webpack_require__(128);

var _biErrorItem2 = _interopRequireDefault(_biErrorItem);

var _performance = __webpack_require__(34);

var _performance2 = _interopRequireDefault(_performance);

var _resourceItem = __webpack_require__(440);

var _resourceItem2 = _interopRequireDefault(_resourceItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Base Logger
 *
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */
var BaseLogger = function () {
  function BaseLogger(appName, appVersion, reporter, _ref) {
    var sessionId = _ref.sessionId,
        errorHandlerToggle = _ref.errorHandlerToggle,
        disableAutoLoadFinish = _ref.disableAutoLoadFinish;

    _classCallCheck(this, BaseLogger);

    this.appName = appName;
    this.appVersion = appVersion;
    this.reporter = reporter;
    this.params = { sessionId: sessionId };
    this.errorHandlerToggle = errorHandlerToggle;
    this.disableAutoLoadFinish = disableAutoLoadFinish;
    this.dataSource = new _dataSource2.default({ appName: appName });
    if (errorHandlerToggle) {
      window.fedopsLoggerErrorHandler.subscribeListener(appName, this.reportError.bind(this));
    }
  }

  _createClass(BaseLogger, [{
    key: 'reportNetworkAnalysis',
    value: function reportNetworkAnalysis() {
      var _this = this;

      var resources = _performance2.default.getResources();
      setTimeout(function () {
        try {
          var resourceDataItem = new _resourceItem2.default(_this.sessionId);
          var analysis = resourceDataItem.performNetworkAnalysis(resources);
          if (!analysis) {
            return;
          }
          var dataSource = _this.dataSource.clone().addItem(resourceDataItem).addItem(analysis);
          _this._report(dataSource);
        } catch (e) {
          console.error('[fedops] Failed to report resource metrics', e);
        }
      }, 1000);
    }
  }, {
    key: 'reportError',
    value: function reportError(error, errorType, errorInfo) {
      var interactionName = void 0;

      if (!this._appLoadedCalled) {
        interactionName = '[APP LOAD]';
      } else {
        interactionName = Object.keys(this._outgoingInteractions)[0];
      }

      var dataSource = this.dataSource.clone().addItem({ interactionName: interactionName }).addItem({ errorType: errorType }).addItem({ errorInfo: errorInfo }).addItem(new _biErrorItem2.default(this.sessionId));

      // const stackTrace = error.stack;

      if (interactionName) {
        this._report(dataSource);
      }
    }
  }, {
    key: '_report',
    value: function _report(dataSource) {
      return this.reporter.report(dataSource.mergeItems());
    }
  }, {
    key: 'getAppName',
    value: function getAppName() {
      return this.appName;
    }
  }, {
    key: 'getAppVersion',
    value: function getAppVersion() {
      return this.appVersion;
    }
  }, {
    key: 'getReporter',
    value: function getReporter() {
      return this.reporter;
    }
  }, {
    key: 'getParam',
    value: function getParam(paramName) {
      return this.params[paramName];
    }
  }, {
    key: '_isDisableAutoLoadFinish',
    value: function _isDisableAutoLoadFinish() {
      return this.disableAutoLoadFinish;
    }
  }, {
    key: 'appLoadingPhase',


    /**
     * Custom phase (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/13)
     * Call this method to report custom phases during initial application load.
     *
     * @param {String} phaseName  phase name
     */
    value: function appLoadingPhase(phaseName) {
      var dataSource = this.dataSource.clone().addItem({ name: phaseName }).addItem(new _biLoadPhaseItem2.default(this.sessionId)).addItem(new _durationItem2.default());

      return this._report(dataSource);
    }
  }, {
    key: 'sessionId',
    get: function get() {
      return this.getParam('sessionId');
    }
  }]);

  return BaseLogger;
}();

exports.default = BaseLogger;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _time = __webpack_require__(125);

var _time2 = _interopRequireDefault(_time);

var _dataItem = __webpack_require__(62);

var _dataItem2 = _interopRequireDefault(_dataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DurationDataItem = function (_DataItem) {
  _inherits(DurationDataItem, _DataItem);

  function DurationDataItem(appName) {
    _classCallCheck(this, DurationDataItem);

    var _this = _possibleConstructorReturn(this, (DurationDataItem.__proto__ || Object.getPrototypeOf(DurationDataItem)).call(this, {
      duration: Math.floor(_time2.default.appLoadTime(appName))
    }));

    _this.appName = appName;
    return _this;
  }

  _createClass(DurationDataItem, [{
    key: 'setFirstRequestDuration',
    value: function setFirstRequestDuration() {
      this.data.frd = Math.floor(_time2.default.firstRequestDuration(this.appName));
      return this;
    }
  }]);

  return DurationDataItem;
}(_dataItem2.default);

exports.default = DurationDataItem;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _appData = __webpack_require__(126);

var _appData2 = _interopRequireDefault(_appData);

var _performance = __webpack_require__(34);

var _performance2 = _interopRequireDefault(_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function startLoadTime(appName) {
  return _appData2.default.getStartLoadTime(appName) || 0;
}

function endLoadTime() {
  return _performance2.default.now();
}

/**
 * calculates the app load time
 */
exports.default = {
  appLoadTime: function appLoadTime(appName) {
    return endLoadTime() - startLoadTime(appName);
  },
  loadStarted: function loadStarted(appName) {
    _appData2.default.setStartLoadTime(appName, _performance2.default.now());
  },
  firstRequestDuration: function firstRequestDuration(appName) {
    return startLoadTime(appName);
  }
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * window.fedops.apps wrapper (for tests mainly)
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
function getAppData(appName) {
  return window.fedops.apps[appName];
}

exports.default = {
  init: function init(appName) {
    window.fedops.apps[appName] = window.fedops.apps[appName] || {};
  },
  getStartLoadTime: function getStartLoadTime(appName) {
    var appData = getAppData(appName);
    if (!appData) {
      return null;
    }
    return appData.startLoadTime;
  },
  setStartLoadTime: function setStartLoadTime(appName, startLoadTime) {
    return getAppData(appName).startLoadTime = startLoadTime;
  }
};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var location = function location() {
  return typeof window !== 'undefined' && window.location;
};

exports.default = {
  getHost: function getHost() {
    return location() && window.location.host;
  },
  isFedopsDev: function isFedopsDev() {
    var q = (location() || {}).search || '';
    return q.indexOf('fedops=dev') > -1;
  }
};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVID = undefined;

var _biBaseItem = __webpack_require__(6);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EVID = exports.EVID = 17;
/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */

var BiErrorItem = function (_BiBaseDataItem) {
  _inherits(BiErrorItem, _BiBaseDataItem);

  function BiErrorItem(sessionId) {
    _classCallCheck(this, BiErrorItem);

    return _possibleConstructorReturn(this, (BiErrorItem.__proto__ || Object.getPrototypeOf(BiErrorItem)).call(this, EVID, sessionId));
  }

  return BiErrorItem;
}(_biBaseItem2.default);

exports.default = BiErrorItem;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getParameterByName(name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&'); // eslint-disable-line
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
exports.getParameterByName = getParameterByName;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var sdk_1 = __webpack_require__(382);
var resources = {};
var cashierPayments = (function () {
    var instance = new sdk_1.default(resources);
    return {
        init: instance.init,
        on: instance.on,
        off: instance.off,
        reload: instance.reload,
        remove: instance.remove,
        render: instance.render,
        addMethod: instance.addMethod,
        getPaymentMethodMetadata: instance.getPaymentMethodMetadata,
        fetchPaymentMethodSettings: instance.fetchPaymentMethodSettings,
        setActivePaymentMethod: instance.setActivePaymentMethod,
        fetchSettings: instance.fetchSettings,
        fetchMandatoryFields: instance.fetchMandatoryFields,
        fetchPaymentMethodsByConfiguration: instance.fetchPaymentMethodsByConfiguration,
        logMandatoryFieldsValidationStatus: instance.logMandatoryFieldsValidationStatus,
        setMandatoryField: instance.setMandatoryField,
        getMandatoryFieldsMap: instance.getMandatoryFieldsMap,
        isRTLLocale: instance.isRTLLocale,
        tokenize: instance.tokenize,
        localizeError: instance.localizeError,
        continuePayment: instance.continuePayment,
        pay: instance.pay,
        initializePayment: instance.initializePayment,
        getCreditCardPublicData: instance.getCreditCardPublicData,
        launchPaymentPopup: instance.launchPaymentPopup,
        cancelPaymentPopup: instance.cancelPaymentPopup,
        resolveCountry: instance.resolveCountry,
        setCountry: instance.setCountry,
        setInstallments: instance.setInstallments,
        saveCreditCard: instance.saveCreditCard,
        updateSavedCreditCard: instance.updateSavedCreditCard,
        fetchSavedCreditCards: instance.fetchSavedCreditCards,
        fetchTokenForSavedCreditCard: instance.fetchTokenForSavedCreditCard,
        fetchSavedCreditCard: instance.fetchSavedCreditCard,
        deleteSavedCreditCard: instance.deleteSavedCreditCard,
        saveBillingAddress: instance.saveBillingAddress,
        updateSavedBillingAddress: instance.updateSavedBillingAddress,
        makeCreditCardPrimary: instance.makeCreditCardPrimary,
        charge: instance.charge,
        getOrder: instance.getOrder,
        submit: instance.submit,
        validate: instance.validate,
        collapse: instance.collapse,
        expand: instance.expand,
    };
})();
if (cashierPayments && typeof window === 'object') {
    window.cashierPayments = cashierPayments;
}
exports.default = cashierPayments;
//# sourceMappingURL=index.js.map

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _WixComponent2 = __webpack_require__(66);

var _WixComponent3 = _interopRequireDefault(_WixComponent2);

var _Arc = __webpack_require__(136);

var _Arc2 = _interopRequireDefault(_Arc);

var _Loader = __webpack_require__(137);

var _Loader2 = _interopRequireDefault(_Loader);

var _Text = __webpack_require__(138);

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var arcsAngles = {
  small: {
    light: 216,
    dark: 144
  },
  medium: {
    light: 108,
    dark: 108
  },
  large: {
    light: 180,
    dark: 180
  }
};
var strokeWidth = 4;
var sizesInPx = {
  small: 30,
  medium: 54,
  large: 102
};

var Loader = function (_WixComponent) {
  _inherits(Loader, _WixComponent);

  function Loader() {
    _classCallCheck(this, Loader);

    return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).apply(this, arguments));
  }

  _createClass(Loader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          color = _props.color,
          text = _props.text;

      var sizeInPx = sizesInPx[size];
      var lightArcAngle = arcsAngles[size].light;
      var darkArcAngle = arcsAngles[size].dark;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_Loader2.default.loaderContainer, _Loader2.default[size], _Loader2.default[color]) },
        _react2.default.createElement(
          'div',
          {
            className: _Loader2.default.arcsContainer,
            style: {
              width: sizeInPx + 'px',
              height: sizeInPx + 'px' }
          },
          _react2.default.createElement(_Arc2.default, {
            angle: lightArcAngle,
            className: _Loader2.default.lightArc,
            strokeWidth: strokeWidth,
            viewBoxSize: sizeInPx
          }),
          _react2.default.createElement(_Arc2.default, {
            angle: darkArcAngle,
            className: _Loader2.default.darkArc,
            strokeWidth: strokeWidth,
            viewBoxSize: sizeInPx
          })
        ),
        text && _react2.default.createElement(
          'div',
          { className: _Loader2.default.text },
          _react2.default.createElement(
            _Text2.default,
            { appearance: 'T5', dataHook: 'loader-text' },
            this.props.text
          )
        )
      );
    }
  }]);

  return Loader;
}(_WixComponent3.default);

Loader.displayName = 'Loader';
Loader.propTypes = {
  /** The size of the loader */
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),

  /** The color of the loader */
  color: _propTypes2.default.oneOf(['blue', 'white']),

  /** Text to be shown below the loader */
  text: _propTypes2.default.string
};
Loader.defaultProps = {
  size: 'medium',
  color: 'blue'
};
exports.default = Loader;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(133);
var invariant = __webpack_require__(134);
var ReactPropTypesSecret = __webpack_require__(135);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// taken from https://stackoverflow.com/a/18473154
function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  };
}

/* eslint-disable max-params */
function describeArc(x, y, radius, startAngle, endAngle) {

  var start = polarToCartesian(x, y, radius, endAngle);
  var end = polarToCartesian(x, y, radius, startAngle);

  var largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

  var d = ['M', start.x, start.y, 'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y].join(' ');

  return d;
}
/* eslint-enable */

var Arc = function Arc(_ref) {
  var className = _ref.className,
      strokeWidth = _ref.strokeWidth,
      viewBoxSize = _ref.viewBoxSize,
      angle = _ref.angle;

  var d = describeArc(0, 0, (viewBoxSize - strokeWidth) / 2, 0, angle);
  var viewBox = '-' + viewBoxSize / 2 + ' -' + viewBoxSize / 2 + ' ' + viewBoxSize + ' ' + viewBoxSize;
  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: viewBox,
      className: className
    },
    _react2.default.createElement('path', {
      strokeWidth: strokeWidth,
      d: d
    })
  );
};

Arc.propTypes = {
  angle: _propTypes2.default.number,
  className: _propTypes2.default.string,
  strokeWidth: _propTypes2.default.number,
  viewBoxSize: _propTypes2.default.number
};

Arc.displayName = 'Arc';

exports.default = Arc;

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loaderContainer":"_3djMk","arcsContainer":"_2WLvm","darkArc":"PxmiM","lightArc":"_3oXGn","text":"ZdUjb","small":"_1tv_t","rotation":"_10GqU","medium":"KOeB4","large":"_3fIwl","staggered-rotation":"GTqNK","staggeredRotation":"GTqNK","blue":"_3HCSv","white":"_1drU-"};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WixComponent2 = __webpack_require__(66);

var _WixComponent3 = _interopRequireDefault(_WixComponent2);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Typography = __webpack_require__(139);

var _Typography2 = _interopRequireDefault(_Typography);

var _styles = __webpack_require__(142);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
  * General all purpose text component with Wix styling.
  *
  * Adds correct styling so you don't have to.
  *
  * Renders correct element (either `span` or `h1` - `h5`) depending on `appearance` (defaults to `span`)
  */
var _class = function (_WixComponent) {
  _inherits(_class, _WixComponent);

  function _class() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, _class);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.getTitle = function () {
      var _this$props = _this.props,
          forceHideTitle = _this$props.forceHideTitle,
          ellipsis = _this$props.ellipsis,
          children = _this$props.children;


      return typeof children === 'string' && ellipsis && !forceHideTitle ? children : null;
    }, _this.getType = function (appearance) {
      return [{ type: 'h1', candidates: ['H0'] }, { type: 'h2', candidates: ['H1', 'H1.1'] }, { type: 'h3', candidates: ['H2', 'H2.1'] }, { type: 'h4', candidates: ['H3'] }, { type: 'h5', candidates: ['H4'] }].filter(function (_ref2) {
        var candidates = _ref2.candidates;
        return candidates.indexOf(appearance) !== -1;
      }).reduceRight(function (acc, _ref3) {
        var type = _ref3.type;
        return type;
      }, 'span');
    }, _this.getClassNames = function (appearance) {
      return [{ className: _styles2.default.headingDefaults, candidates: ['H0', 'H1', 'H1.1', 'H2', 'H2.1', 'H3', 'H4'] }].filter(function (_ref4) {
        var candidates = _ref4.candidates;
        return candidates.indexOf(appearance) !== -1;
      }).reduce(function (acc, _ref5) {
        var className = _ref5.className;
        return acc.concat(className);
      }, [_Typography2.default[(0, _Typography.convertFromUxLangToCss)(appearance)]]).join(' ');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          appearance = _props.appearance,
          ellipsis = _props.ellipsis,
          children = _props.children;


      return _react2.default.createElement(this.getType(appearance), {
        title: this.getTitle(),
        className: (0, _classnames2.default)(this.getClassNames(appearance), _defineProperty({}, _styles2.default.ellipsis, ellipsis))
      }, children);
    }
  }]);

  return _class;
}(_WixComponent3.default);

_class.displayName = 'Text';
_class.propTypes = {
  /** a name of appearance to apply */
  appearance: _propTypes2.default.oneOf(['H0', 'H1', 'H1.1', 'H2', 'H2.1', 'H3', 'H4', 'T1', 'T1.1', 'T1.2', 'T1.3', 'T1.4', 'T2', 'T2.1', 'T2.2', 'T2.3', 'T3', 'T3.1', 'T3.2', 'T3.3', 'T3.4', 'T4', 'T4.1', 'T4.2', 'T4.3', 'T5', 'T5.1']),

  /** should the text be ellipsed or not */
  ellipsis: _propTypes2.default.bool,

  /** should hide the title tooltip that is shown on mouse hover when using the ellipsis prop */
  forceHideTitle: _propTypes2.default.bool,

  /** any nodes to be rendered (usually text nodes) */
  children: _propTypes2.default.node
};
_class.defaultProps = {
  appearance: 'T1.1'
};
exports.default = _class;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Utils = __webpack_require__(140);

Object.keys(_Utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Utils[key];
    }
  });
});

var _Typography = __webpack_require__(141);

var _Typography2 = _interopRequireDefault(_Typography);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Typography2.default;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var convertFromUxLangToCss = exports.convertFromUxLangToCss = function convertFromUxLangToCss() {
  var ux = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return ux.toLowerCase().replace('.', '_');
};

var convertFromCssToUxLang = exports.convertFromCssToUxLang = function convertFromCssToUxLang() {
  var css = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return css.toUpperCase().replace('_', '.');
};

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"h0":"_3wUw6","h1":"_1SA9z","h1_1":"kc9mL","h11":"kc9mL","h2":"_3wLnA","h2_1":"_7sgvH","h21":"_7sgvH","h3":"PwwZu","h4":"_1woe7","t1":"_2KQcY","t1_1":"rpEZd","t11":"rpEZd","t1_2":"_2qFNj","t12":"_2qFNj","t1_3":"_1TMdX","t13":"_1TMdX","t1_4":"_38rt6","t14":"_38rt6","t1_5":"XQ5OX","t15":"XQ5OX","t1_6":"_3sS1w","t16":"_3sS1w","t2":"_3eDj6","t2_1":"_1dPFH","t21":"_1dPFH","t2_2":"eWazg","t22":"eWazg","t2_3":"V6o7k","t23":"V6o7k","t3":"s7hKA","t3_1":"qNcmk","t31":"qNcmk","t3_2":"_3uy2c","t32":"_3uy2c","t3_3":"_2fGq8","t33":"_2fGq8","t3_4":"_2UxaH","t34":"_2UxaH","t3_5":"_38CGS","t35":"_38CGS","t3_6":"_17uQM","t36":"_17uQM","t4":"_3Op-z","t4_1":"fH6mf","t41":"fH6mf","t4_2":"-MzIS","t42":"-MzIS","t4_3":"_5INKy","t43":"_5INKy","t5":"FLBvd","t5_1":"_2BPLg","t51":"_2BPLg","t6":"_3v69c","t6_1":"_2-Quv","t61":"_2-Quv"};

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"headingDefaults":"_1y9lJ","ellipsis":"_3jjq8"};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var i18next = __webpack_require__(65);
var cashier_payments_method_component_1 = __webpack_require__(144);
var Loader_1 = __webpack_require__(64);
var styles = __webpack_require__(269);
var locationUtils_1 = __webpack_require__(129);
var PaymentMethodList_1 = __webpack_require__(270);
var react_module_container_1 = __webpack_require__(285);
var CollapsedPayment_1 = __webpack_require__(362);
var i18n_1 = __webpack_require__(108);
var biLogger_1 = __webpack_require__(368);
var domUtils_1 = __webpack_require__(379);
var Translate_1 = __webpack_require__(113);
var TermsAndSubmit_1 = __webpack_require__(380);
var src_1 = __webpack_require__(130);
var logger_1 = __webpack_require__(431);
var VisibilityWrapper_1 = __webpack_require__(448);
var wix_experiments_1 = __webpack_require__(74);
var SUPPORTED_LANGUAGES = [
    'ar', 'bg', 'cs', 'da', 'de', 'el', 'en',
    'es', 'fi', 'fr', 'he', 'hi', 'hu', 'id',
    'it', 'ja', 'ko', 'ms', 'nl', 'no', 'pl',
    'pt', 'ro', 'ru', 'sv', 'th', 'tl', 'tr',
    'zh'
];
var resources = {};
SUPPORTED_LANGUAGES.forEach(function (lng) {
    resources[lng] = {
        translation: __webpack_require__(451)("./messages_" + lng + ".json")
    };
});
var CashierPaymentsWidget = /** @class */ (function (_super) {
    __extends(CashierPaymentsWidget, _super);
    function CashierPaymentsWidget(props) {
        var _this = _super.call(this, props) || this;
        _this._isComponentMounted = true; // TODO this is trick to resolve warning with fetchSettings request, we need to improve sdk
        _this.experimentsExistAtWindow = function () {
            return typeof window !== 'undefined' && !!window['__EXPERIMENTS__'];
        };
        _this.mandatoryFieldsExperimentEnabled = function () {
            return window['__EXPERIMENTS__']['specs.cashier.MandatoryFields'] === 'true';
        };
        _this.mandatoryFieldsForCheckoutExperimentEnabled = function () {
            return window['__EXPERIMENTS__']['specs.payments.MandatoryFields'] === 'true';
        };
        _this.fetchPaymentMethods = function (country) {
            return src_1.default.fetchPaymentMethodsByConfiguration(_this.props.configuration, country);
        };
        _this.updateCountry = function (country) {
            src_1.default.setCountry(country);
            _this.setState({ isLoading: true });
            _this.fetchSettingsPromise = src_1.default.fetchSettings(_this.props.configuration).then(function (settings) {
                _this.setState({ isLoading: false });
                if (_this._isComponentMounted) {
                    _this.setPaymentsMethods(settings.paymentMethods, settings.offlineText);
                }
            });
        };
        _this.handleCountryChange = function (country) {
            _this.setState({
                countryCode: country && country.value
            });
        };
        _this.handleMessageFromSdk = function (method, message) {
            if (message.type === 'PING' && message.status === 'INITED' && _this._isComponentMounted) {
                var cc = _this.state.methods.find(function (it) { return it.value === 'creditCard'; });
                biLogger_1.default.creditCardLoaded({
                    duration: Date.now() - _this.creditCardLoadDate,
                    paymentCategory: 'CreditCard',
                    paymentProvider: cc && cc.connectedProviderId,
                    source: null,
                });
            }
            else if (message.type === 'LOAD_STARTED' && method === 'creditCard') {
                _this.creditCardLoadDate = Date.now();
            }
            if (message.type === 'CLIENT_FORM_SUBMIT') {
                if (message.status !== 'OK' && message.status !== 'CLIENT_OK' && message.status !== 'IN_PROGRESS' && _this.state.isPaymentInProgress) {
                    _this.setState({
                        isPaymentInProgress: false
                    });
                }
            }
            if (_this.props.paymentResult) {
                _this.props.paymentResult(__assign({}, message, { method: method }));
            }
        };
        _this._getAdditionalInfo = function (pm) {
            switch (pm.paymentMethod) {
                case 'offline':
                    return _this.tryParseCustomOfflineText(pm.additionalInfo);
                case 'creditCard':
                    return __assign({}, pm.addtionalInfo, { installments: pm.installments });
                default:
                    return pm.additionalInfo;
            }
        };
        _this._getUniqueMandatoryFields = function (paymentMethods) {
            var methods = paymentMethods || _this.state.methods;
            var allMandatoryFields = methods
                // Gets only methods with mandatory fields provided
                .filter(function (m) { return !!m.mandatoryFields; })
                // Gets mandatory fields of every payment method
                .map(function (m) { return m.mandatoryFields; });
            return []
                // Array flattening: [[{fieldName: 'first'}, {fieldName: 'last'}], [{fieldName: 'email'}]]
                // => [{fieldName: 'first'}, {fieldName: 'last'}, {fieldName: 'email'}]
                .concat.apply([], allMandatoryFields)
                // Mapping to fieldName and its last part after the dot: 'billing.info.address' => 'address'
                .map(function (m) { return m.fieldName.split('.').pop(); })
                // Get unique fields
                .filter(function (value, index, self) { return self.indexOf(value) === index; });
        };
        _this.fetchMandatoryFields = function (country) {
            return _this.fetchPaymentMethods(country).then(function (paymentMethodsResult) {
                return _this._getUniqueMandatoryFields(paymentMethodsResult.paymentMethods);
            });
        };
        _this.getAllMandatoryFields = function () {
            return new Promise(function (resolve, reject) {
                _this.fetchSettingsPromise.then(function (settingsResponse) {
                    resolve(_this._getUniqueMandatoryFields(settingsResponse.paymentMethods));
                }).catch(function () {
                    reject();
                });
            });
        };
        _this.setMandatoryFields = function (mandatoryFields) {
            _this.setState({
                mandatoryFields: mandatoryFields
            });
        };
        _this.setPaymentsMethods = function (paymentMethods, offlineText) {
            _this.setState({
                methods: (paymentMethods || []).map(function (pm) {
                    var additionalInfo = _this._getAdditionalInfo(pm);
                    var translateKey = pm.paymentMethod;
                    if (pm.paymentMethod === 'offline') {
                        translateKey = (offlineText && offlineText.titleId) || (additionalInfo && additionalInfo.titleId) || 'settings.offlineTitleOptionDefault';
                    }
                    return {
                        icon: pm.icon,
                        connectedProviderId: pm.connectedProviderId,
                        value: pm.paymentMethod,
                        additionalInfo: additionalInfo,
                        label: Translate_1.translate({ forKey: translateKey }) || pm.paymentMethod,
                        mandatoryFields: pm.mandatoryFields
                    };
                }),
                offlineText: offlineText
            }, function () {
                var activeMethod = _this.props.configuration.defaultPaymentMethod || (_this.state.methods[0] && _this.state.methods[0].value);
                if (paymentMethods && paymentMethods.find(function (pm) { return pm.paymentMethod === _this.state.selectedMethod; })) {
                    activeMethod = _this.state.selectedMethod;
                }
                return src_1.default.setActivePaymentMethod(activeMethod);
            });
        };
        _this.handleTermsStatusChange = function (e) { return _this.setState({ isTermsAccepted: e.target.checked }); };
        _this.arrowKeysFunctions = {
            ArrowDown: domUtils_1.focusNextEl,
            ArrowUp: domUtils_1.focusPrevEl
        };
        _this.handleArrowKeys = function (e) {
            if (_this.arrowKeysFunctions[e.key]) {
                _this.arrowKeysFunctions[e.key](e.target);
                e.preventDefault();
            }
        };
        _this.getActivePaymentMethod = function () {
            var paymentMethod = _this.state.methods.find(function (method) { return method.value === _this.state.selectedMethod; });
            if (!paymentMethod) {
                return null;
            }
            return {
                paymentMethod: paymentMethod.value,
                name: paymentMethod.label,
                connectedProviderId: paymentMethod.connectedProviderId,
                additionalInfo: __assign({ installments: paymentMethod.installments }, (paymentMethod.additionalInfo || {}))
            };
        };
        _this.onPaymentMethodChanged = function (pmId) {
            _this.setCurrentStep('paymentDetails');
            src_1.default.setActivePaymentMethod(pmId);
        };
        _this.changeActivePaymentMethod = function (pmId) {
            biLogger_1.default.buyerChoosedPaymentMethod({ paymentMethod: pmId });
            _this.setState({
                selectedMethod: pmId,
                isMethodCollapsed: false,
                collapsedMessage: '',
                generalErrorMessage: '',
                isCreditCardIframeLoading: false,
                isCreditCardIframeError: false
            });
        };
        _this.collapseCurrentMethod = function () { return _this.setState({ isMethodCollapsed: true }); };
        _this.expandCurrentMethod = function () { return _this.setState({ isMethodCollapsed: false }); };
        _this.handleSubmitResult = function (result) {
            var generalErrorMessage = result.errorCode ? result.translatedError || Translate_1.translate({ forKey: 'payment.submitError' }) : '';
            _this.setState({ generalErrorMessage: generalErrorMessage });
            return true;
        };
        _this.handleCollapseResult = function (result) {
            _this.setState({
                collapsedMessage: result.message,
                collapsedIcon: result.icon
            });
            return true;
        };
        _this.tokenize = function () { return src_1.default.tokenize(_this.state.selectedMethod); };
        _this.continuePayment = function (chargeResponse, _a) {
            var inNewTab = (_a === void 0 ? { inNewTab: _this.props.walletPaymentInNewTab } : _a).inNewTab;
            return src_1.default.continuePayment(_this.state.selectedMethod, { chargeResponse: chargeResponse, inNewTab: inNewTab });
        };
        _this.launchPaymentPopup = function (chargeResponse) {
            return src_1.default.launchPaymentPopup(_this.state.selectedMethod, { chargeResponse: chargeResponse });
        };
        _this.cancelPaymentPopup = function () {
            return src_1.default.cancelPaymentPopup(_this.state.selectedMethod);
        };
        _this.localizeError = function (errorCode, locale) { return src_1.default.localizeError(errorCode, locale || _this.getLocale()); };
        _this.submit = function () {
            _this.setState({
                generalErrorMessage: ''
            });
            src_1.default.submit();
            return Promise.resolve(true);
        };
        _this.pay = function () {
            _this.setState({
                generalErrorMessage: ''
            });
            return src_1.default.pay(_this.state.selectedMethod);
        };
        _this.validate = function () {
            if (_this.paymentDetailsInstance) {
                return _this.paymentDetailsInstance.validate();
            }
            return src_1.default.validate();
        };
        _this.expand = function () {
            _this.expandCurrentMethod();
            return src_1.default.expand();
        };
        _this.collapse = function () { return new Promise(function (resolve, reject) {
            _this.validate()
                .then(function (validationResult) {
                if (validationResult.isValid) {
                    src_1.default.collapse().then(function (data) {
                        if (_this.state.selectedMethod === 'creditCard') {
                            _this.handleCollapseResult(__assign({}, data, { message: "\u25CF\u25CF\u25CF\u25CF \u25CF\u25CF\u25CF\u25CF \u25CF\u25CF\u25CF\u25CF " + data.lastFourDigits, icon: data.type }));
                        }
                        else if (_this.state.selectedMethod === 'offline') {
                            _this.handleCollapseResult(__assign({}, data, { message: _this.renderPaymentComponent() }));
                        }
                        else {
                            var method = _this.getActivePaymentMethod();
                            _this.handleCollapseResult(__assign({}, data, { message: React.createElement("span", null,
                                    i18next.t('payments.collapsedMode.label', { paymentMethodLabel: method.name }),
                                    " "), icon: method.paymentMethod }));
                        }
                        _this.collapseCurrentMethod();
                        resolve(data);
                    }).catch(function (e) { return reject(e); });
                }
                else {
                    reject();
                }
            })
                .catch(function (e) {
                reject(e);
            });
        }); };
        _this.initializePayment = function () {
            return src_1.default.initializePayment(_this.state.selectedMethod);
        };
        var i18n = i18n_1.init(_this.getLocale(), resources, function () { return ({}); });
        _this.logger = props.logger || new logger_1.default();
        _this.state = {
            currentStep: 'paymentMethod',
            isLoading: true,
            methods: [],
            isPaymentSuccess: false,
            isTermsAccepted: false,
            isPaymentInProgress: false,
            selectedMethod: '',
            isCreditCardIframeLoading: false,
            mandatoryFieldExperimentEnabled: false,
            mandatoryFieldForCheckoutEnabled: false,
            mandatoryFields: {},
        };
        biLogger_1.default.init({
            appId: props.configuration.appId,
            appInstanceId: props.configuration.appInstanceId,
            visitorId: props.configuration.visitorId,
            orderSnapshotId: props.configuration.snapshotId,
            msid: props.configuration.msid,
        });
        biLogger_1.default.buyerLoadStart({ duration: 0 });
        _this.buyerLoadStartTime = Date.now();
        if (props.initApi) {
            props.initApi(_this);
        }
        var href = window.location.href;
        src_1.default.init({
            type: 'RAW',
            noPrefetchOnInit: true,
            host: props.host,
            walletExpressCheckoutAPIUrl: props.configuration.walletExpressCheckoutAPIUrl,
            walletPaymentInNewTab: props.walletPaymentInNewTab,
            appId: _this.props.configuration && _this.props.configuration.appId,
            appInstanceId: _this.props.configuration && _this.props.configuration.appInstanceId,
            visitorId: _this.props.configuration && _this.props.configuration.visitorId,
            msid: _this.props.configuration && _this.props.configuration.msid,
            snapshotId: _this.props.configuration && _this.props.configuration.snapshotId,
            query: {
                providerId: locationUtils_1.getParameterByName('providerId', href),
                submitType: locationUtils_1.getParameterByName('submitType', href) || 'external',
                creditCardMinInstallments: locationUtils_1.getParameterByName('creditCardMinInstallments', href),
                creditCardMaxInstallments: locationUtils_1.getParameterByName('creditCardMaxInstallments', href),
                isInstallmentsSupported: locationUtils_1.getParameterByName('isInstallmentsSupported', href),
                country: (_this.props.configuration && _this.props.configuration.country) || locationUtils_1.getParameterByName('country', href),
                amount: props.configuration.amount,
                orderId: props.configuration.snapshotId,
                locale: _this.getLocale(),
            },
            onError: function (method, data) {
                if (props.onError) {
                    props.onError(method, data);
                }
                _this.setState({
                    isPaymentInProgress: false
                });
            },
            creditCardFormUrl: props.configuration.cashierPCIUrl,
            onMessage: _this.handleMessageFromSdk,
            onPaymentMethodChanged: function (method) {
                var metadata = src_1.default.getPaymentMethodMetadata(method);
                props.paymentMethodChanged(method, metadata);
                _this.changeActivePaymentMethod(method);
            },
            onPaymentStart: function (method) {
                if (method !== 'offline' && method !== 'creditCard' && !props.walletPaymentInNewTab) {
                    // because we will lose all our js, so we log start and end in same time
                    _this.logger.interactionStarted("pay-with-" + method);
                    _this.logger.interactionEnded("pay-with-" + method);
                }
                else {
                    _this.logger.interactionStarted("pay-with-" + method);
                }
                var methodObj = _this.state.methods.find(function (it) { return it.value === method; });
                biLogger_1.default.submitOrder({
                    errorDesc: null,
                    paymentMethodType: method,
                    paymentProvider: methodObj && methodObj.connectedProviderId,
                    status: 1
                });
                if (props.onPaymentStart) {
                    props.onPaymentStart(method);
                }
                if (!_this.state.isPaymentInProgress) {
                    _this.setState({
                        isPaymentInProgress: true
                    });
                }
            },
            onPaymentComplete: function (method, result) {
                _this.logger.interactionEnded("pay-with-" + method);
                if (method !== 'offline' && method !== 'creditCard') {
                    if (props.onWalletPaymentComplete) {
                        props.onWalletPaymentComplete(result);
                    }
                }
                if (result && result.type === 'SERVER_FORM_SUBMIT') {
                    var cc = _this.state.methods.find(function (it) { return it.value === 'creditCard'; });
                    biLogger_1.default.submitOrder({
                        errorDesc: result.status === 'FAILURE' ? result.message : null,
                        paymentMethodType: method,
                        paymentProvider: cc && cc.connectedProviderId,
                        status: 1
                    });
                    biLogger_1.default.transactionStatus({
                        paymentMethodType: method,
                        paymentProvider: cc && cc.connectedProviderId,
                        transactionId: '',
                        transactionStatus: result.status === 'FAILURE' ? 'Failure' : 'Success',
                    });
                }
                if (result && result.type === 'CLIENT_FORM_SUBMIT') {
                    var cc = _this.state.methods.find(function (it) { return it.value === 'creditCard'; });
                    biLogger_1.default.submitOrder({
                        errorDesc: result.status === 'FAILURE' ? result.message : null,
                        paymentMethodType: method,
                        paymentProvider: cc && cc.connectedProviderId,
                        status: Boolean(result.status)
                    });
                }
                var pendingMethods = ['PENDING_MERCHANT', 'PENDING_BUYER', 'INITIALIZED', 'OFFLINE'];
                var successMethods = ['APPROVED', 'OK'];
                var okMethods = successMethods.concat(pendingMethods);
                var doneMethods = okMethods.slice();
                var publicResult = __assign({}, result, { status: doneMethods.indexOf(result.status) !== -1 ? 'OK' : result.status, isPending: pendingMethods.indexOf(result.status) !== -1 });
                if (props.paymentResult) {
                    props.paymentResult(__assign({}, publicResult, { method: method }));
                    _this.handleSubmitResult(result);
                }
                if (result && okMethods.indexOf(result.status) > -1) {
                    _this.setState({
                        isPaymentSuccess: true
                    });
                }
                if (_this.state.isPaymentInProgress) {
                    _this.setState({
                        isPaymentInProgress: false
                    });
                }
                if (props.onPaymentComplete) {
                    props.onPaymentComplete(method, publicResult);
                }
            }
        });
        return _this;
    }
    CashierPaymentsWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.logger.appLoaded();
        this.settingsLoadTimer = setTimeout(function () {
            _this.setState({
                generalErrorMessage: 'Sorry, but something went wrong!'
            });
        }, 8000);
        this.fetchSettingsPromise = src_1.default.fetchSettings(this.props.configuration).then(function (settings) {
            clearTimeout(_this.settingsLoadTimer);
            _this.setState({ isLoading: false, error: false, countryCode: settings.countryCode || '' });
            if (_this._isComponentMounted) {
                biLogger_1.default.buyerLoadCompleted({
                    duration: Date.now() - _this.buyerLoadStartTime,
                    status: true
                });
                _this.setPaymentsMethods(settings.paymentMethods, settings.offlineText);
            }
            return settings;
        });
        // We support mandatory fields just with our submit button
        if (this.experimentsExistAtWindow() && this.mandatoryFieldsExperimentEnabled()) {
            var state = {
                mandatoryFieldExperimentEnabled: true,
                mandatoryFieldForCheckoutEnabled: false,
            };
            if (this.mandatoryFieldsForCheckoutExperimentEnabled()) {
                state.mandatoryFieldForCheckoutEnabled = true;
            }
            this.setState(state);
        }
        else {
            var experiments_1 = this.props.experimentsInstance || new wix_experiments_1.default({ baseUrl: 'https://www.wix.com' });
            experiments_1.load('cashier').then(function () { return _this.setState({
                mandatoryFieldExperimentEnabled: experiments_1.enabled('specs.cashier.MandatoryFields'),
                mandatoryFieldForCheckoutEnabled: experiments_1.enabled('specs.payments.MandatoryFields'),
            }); });
        }
        // We should use `mandatoryFields` as a state to update PaymentDetails component
        // after `setMandatoryFields` method called
        if (this.props.mandatoryFields && Object.keys(this.props.mandatoryFields).length) {
            this.setState({
                mandatoryFields: this.props.mandatoryFields
            });
        }
    };
    CashierPaymentsWidget.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (!this.props.configuration.country && prevState.countryCode && prevState.countryCode && prevState.countryCode !== this.state.countryCode) {
            this.updateCountry(this.state.countryCode);
        }
    };
    CashierPaymentsWidget.prototype.componentWillReceiveProps = function (nextProps, nextState) {
        if (this.props.configuration.country !== nextProps.configuration.country) {
            this.updateCountry(nextProps.configuration.country);
        }
    };
    CashierPaymentsWidget.prototype.componentWillUnmount = function () {
        this._isComponentMounted = false;
    };
    CashierPaymentsWidget.prototype.tryParseCustomOfflineText = function (additionalInfo) {
        if (additionalInfo && additionalInfo.merchantInstructions) {
            var parsedText = null;
            try {
                parsedText = JSON.parse(additionalInfo.merchantInstructions);
            }
            catch (ex) {
                parsedText = null;
            }
            return parsedText;
        }
        return additionalInfo;
    };
    CashierPaymentsWidget.prototype.getLocale = function () {
        return this.props.configuration.locale
            || this.props.locale
            || locationUtils_1.getParameterByName('locale', window.location.href)
            || 'en';
    };
    CashierPaymentsWidget.prototype.isStepVisible = function (step) {
        return this.props.showOnlyCurrentStep === false || this.state.currentStep === step;
    };
    CashierPaymentsWidget.prototype.setCurrentStep = function (currentStep) {
        this.setState({ currentStep: currentStep });
    };
    CashierPaymentsWidget.prototype.renderGeneralError = function () {
        var generalErrorMessage = this.state.generalErrorMessage;
        if (!generalErrorMessage) {
            return null;
        }
        return (React.createElement("div", { "data-hook": "general-error-message", role: "alert", className: styles.generalError },
            React.createElement("div", { className: styles.generalErrorContent },
                React.createElement("img", { className: styles.circleIcon, src: __webpack_require__(482) }),
                React.createElement("span", { className: styles.generalErrorText, title: generalErrorMessage }, generalErrorMessage))));
    };
    CashierPaymentsWidget.prototype.renderPaymentComponent = function () {
        if (!this.getActivePaymentMethod()) {
            return null;
        }
        return (React.createElement("div", null,
            React.createElement(VisibilityWrapper_1.default, { display: this.state.isMethodCollapsed },
                React.createElement(CollapsedPayment_1.default, { iconName: this.state.collapsedIcon, title: this.state.collapsedMessage || '●●●● ●●●● ●●●● ●●●●' })),
            React.createElement(VisibilityWrapper_1.default, { visible: !this.state.isMethodCollapsed },
                React.createElement(cashier_payments_method_component_1.CashierPaymentsMethod, { locale: this.getLocale(), orderId: this.props.configuration.snapshotId, paymentsSDK: src_1.default, paymentMethod: this.getActivePaymentMethod(), payButtonLabel: this.props.externalSubmitButton ? 'button.pay.placeOrder' : 'button.pay.buyNow', externalPayButton: this.props.externalSubmitButton, isMobileApplication: false }))));
    };
    CashierPaymentsWidget.prototype.renderPaymentDetails = function () {
        var _this = this;
        // Payment details & Mandatory fields should be shown only with internal button and if active payment method exists
        if (!this.state.mandatoryFieldExperimentEnabled || !this.getActivePaymentMethod()) {
            return null;
        }
        if (this.props.externalSubmitButton && !this.state.mandatoryFieldForCheckoutEnabled) {
            return null;
        }
        return (React.createElement(cashier_payments_method_component_1.PaymentDetails, { ref: function (paymentDetails) {
                _this.paymentDetailsInstance = paymentDetails;
            }, countryCode: this.state.countryCode, onCountryChange: this.handleCountryChange, locale: this.getLocale(), orderId: this.props.configuration.snapshotId, paymentsSDK: src_1.default, paymentMethod: this.getActivePaymentMethod(), isMandatoryFieldsEnabled: this.state.mandatoryFieldExperimentEnabled, mandatoryFields: this.state.mandatoryFields, isMethodCollapsed: this.state.isMethodCollapsed }));
    };
    CashierPaymentsWidget.prototype.renderSubmitArea = function () {
        if (this.state.isMethodCollapsed) {
            return null;
        }
        return (React.createElement(VisibilityWrapper_1.default, { display: !this.props.externalSubmitButton },
            React.createElement("div", null,
                React.createElement(VisibilityWrapper_1.default, { display: this.props.useTermsAndConditions },
                    React.createElement(TermsAndSubmit_1.default, { termsAndConditionsLink: this.props.termsAndConditionsLink, handleTermsStatusChange: this.handleTermsStatusChange })),
                React.createElement("div", { style: { marginTop: 24 } },
                    React.createElement(cashier_payments_method_component_1.PayButton, { locale: this.getLocale(), withMandatoryFields: this.state.mandatoryFieldExperimentEnabled, text: this.props.externalSubmitButton ? 'button.pay.placeOrder' : 'button.pay.buyNow', orderId: this.props.configuration.snapshotId, paymentsSDK: src_1.default, paymentMethod: this.getActivePaymentMethod() })))));
    };
    CashierPaymentsWidget.prototype.renderStepNavigation = function () {
        var _this = this;
        if (!this.props.showOnlyCurrentStep) {
            return null;
        }
        if (this.isStepVisible('paymentDetails')) {
            return (React.createElement("button", { "data-hook": "wcn-back-button", onClick: function () { return _this.setCurrentStep('paymentMethod'); } }, i18next.t('payments.steps.back')));
        }
    };
    CashierPaymentsWidget.prototype.renderStepTitle = function () {
        if (!this.props.showOnlyCurrentStep) {
            return null;
        }
        var titleKey = "payments.steps." + this.state.currentStep + ".label";
        return (titleKey ? React.createElement("h2", { "data-hook": "wcn-step-title" }, i18next.t(titleKey)) : null);
    };
    CashierPaymentsWidget.prototype.renderPaymentMethodStep = function () {
        if (!this.isStepVisible('paymentMethod')) {
            return null;
        }
        if (this.state.isMethodCollapsed || this.state.methods.length <= 1) {
            return null;
        }
        return (React.createElement(PaymentMethodList_1.default, { radioButtonClassName: this.props.radioButtonClassName, activePaymentComponentNode: this.props.theme === 'accordion' && this.renderPaymentComponent(), paymentMethods: this.state.methods, selectedMethod: this.state.selectedMethod, onPaymentMethodChanged: this.onPaymentMethodChanged }));
    };
    CashierPaymentsWidget.prototype.renderPaymentDetailsStep = function () {
        if (!this.isStepVisible('paymentDetails')) {
            return null;
        }
        return (React.createElement("div", { "data-hook": "wcn-step-paymentDetails" },
            this.props.theme !== 'accordion' || this.state.isMethodCollapsed || (this.props.theme === 'accordion' && this.state.methods.length === 1) ? this.renderPaymentComponent() : null,
            this.renderPaymentDetails(),
            this.renderSubmitArea()));
    };
    CashierPaymentsWidget.prototype.render = function () {
        var rtlClassName = src_1.default.isRTLLocale(this.getLocale())
            ? 'cashier-payments-widget-rtl'
            : 'cashier-payments-widget-ltr';
        if (this.state.isLoading) {
            if (this.state.generalErrorMessage) {
                return this.renderGeneralError();
            }
            return (React.createElement("div", { className: styles.paymentsWidget + " " + rtlClassName, style: { maxWidth: this.props.maxWidth }, "data-hook": "wcn-payment-widget" },
                React.createElement("div", { "data-hook": "cc-spinner-main", className: styles.loaderWrap },
                    React.createElement(Loader_1.default, { size: "medium" }))));
        }
        return (React.createElement("div", { className: styles.paymentsWidget + " " + rtlClassName, style: { maxWidth: this.props.maxWidth }, "data-hook": "wcn-payment-widget", onKeyDown: this.handleArrowKeys },
            !this.state.isMethodCollapsed && this.renderGeneralError(),
            this.renderStepNavigation(),
            this.renderStepTitle(),
            this.renderPaymentMethodStep(),
            this.renderPaymentDetailsStep()));
    };
    CashierPaymentsWidget.defaultProps = {
        walletPaymentInNewTab: true,
        externalSubmitButton: false,
        termsAndConditionsLink: '',
        useTermsAndConditions: false,
        theme: 'accordion',
        showOnlyCurrentStep: false
    };
    return CashierPaymentsWidget;
}(React.Component));
exports.default = CashierPaymentsWidget;
react_module_container_1.ModuleRegistry.registerComponent('CashierPaymentsWidget', function () { return CashierPaymentsWidget; });


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CashierPaymentsMethod_1 = __webpack_require__(145);
exports.CashierPaymentsMethod = CashierPaymentsMethod_1.default;
var PaymentDetails_1 = __webpack_require__(71);
exports.PaymentDetails = PaymentDetails_1.default;
var PayButton_1 = __webpack_require__(72);
exports.PayButton = PayButton_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CashierPaymentsMethod_1 = __webpack_require__(146);
exports.default = CashierPaymentsMethod_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var s = __webpack_require__(147);
var CreditCard_1 = __webpack_require__(148);
var Loader_1 = __webpack_require__(12);
var Offline_1 = __webpack_require__(209);
var Wallet_1 = __webpack_require__(212);
var PaymentDetails_1 = __webpack_require__(71);
var PaymentsStore_1 = __webpack_require__(73);
var CashierPaymentsMethod = (function (_super) {
    __extends(CashierPaymentsMethod, _super);
    function CashierPaymentsMethod() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isComponentMounted = false;
        _this.state = {
            isLoadingLanguage: true,
            installments: null,
        };
        _this.safeSetState = function (state) {
            if (_this.isComponentMounted) {
                _this.setState(state);
            }
        };
        _this.handleCountryChange = function (country) { return __awaiter(_this, void 0, void 0, function () {
            var paymentMethodData, installments;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(country && this.props.countryCode !== country.value)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.paymentsSDK.fetchPaymentMethodSettings(this.props.paymentMethod.paymentMethod, { orderId: this.props.orderId }, 'https://cashier-services.wix.com')];
                    case 1:
                        paymentMethodData = _a.sent();
                        if (paymentMethodData && paymentMethodData.paymentMethod) {
                            installments = paymentMethodData.paymentMethod.installments;
                            this.setState({ installments: installments });
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.isPaymentsDetailsEnabled = function () {
            // TODO in future here should be always true
            return _this.props.paymentDetails;
        };
        _this.renderPaymentMethod = function (name, node) {
            return PaymentsStore_1.default.renderPaymentMethod(name, node);
        };
        _this.renderPaymentMethodComponentByType = function () {
            if (_this.state.isLoadingLanguage || !PaymentsStore_1.default) {
                return React.createElement(Loader_1.default, null);
            }
            var _a = _this.props.paymentMethod, paymentMethod = _a.paymentMethod, name = _a.name, additionalInfo = _a.additionalInfo;
            switch (paymentMethod) {
                case 'creditCard': {
                    var installmentsFromMandatoryFields = _this.state.installments;
                    var info = Object.assign({}, additionalInfo, { installments: (additionalInfo && additionalInfo.installments) || installmentsFromMandatoryFields });
                    return (React.createElement(CreditCard_1.default, { setInstallments: _this.props.paymentsSDK.setInstallments, info: info, renderPaymentMethod: _this.renderPaymentMethod }));
                }
                case 'offline': {
                    return (React.createElement(Offline_1.default, { info: additionalInfo }));
                }
                default: {
                    return (React.createElement(Wallet_1.default, { payButtonLabel: _this.props.payButtonLabel, paymentMethodName: paymentMethod, paymentMethodLabel: name }));
                }
            }
        };
        return _this;
    }
    CashierPaymentsMethod.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isComponentMounted = true;
                        return [4 /*yield*/, PaymentsStore_1.default.initPayments({
                                locale: this.props.locale,
                                paymentsSDK: this.props.paymentsSDK,
                                paymentMethod: this.props.paymentMethod,
                                orderId: this.props.orderId,
                            })];
                    case 1:
                        _a.sent();
                        this.safeSetState({ isLoadingLanguage: false });
                        return [2 /*return*/];
                }
            });
        });
    };
    CashierPaymentsMethod.prototype.componentWillUnmount = function () {
        this.isComponentMounted = false;
    };
    CashierPaymentsMethod.prototype.render = function () {
        return (React.createElement("div", { "data-hook": "cashier-payments-method", className: s.root },
            this.renderPaymentMethodComponentByType(),
            this.isPaymentsDetailsEnabled()
                ? (React.createElement(PaymentDetails_1.default, { countryCode: this.props.countryCode, locale: this.props.locale, externalPayButton: this.props.externalPayButton, isMobileApplication: this.props.isMobileApplication, paymentsSDK: this.props.paymentsSDK, paymentMethod: this.props.paymentMethod, orderId: this.props.orderId, onCountryChange: this.handleCountryChange, isMandatoryFieldsEnabled: this.props.isMandatoryFieldsEnabled }))
                : null));
    };
    return CashierPaymentsMethod;
}(React.Component));
exports.default = CashierPaymentsMethod;
//# sourceMappingURL=CashierPaymentsMethod.js.map

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_1vigz"};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CreditCard_1 = __webpack_require__(149);
exports.default = CreditCard_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Fields_1 = __webpack_require__(67);
var Loader_1 = __webpack_require__(12);
var PaymentMethodLayout_1 = __webpack_require__(38);
var Translate_1 = __webpack_require__(13);
var s = __webpack_require__(208);
var CreditCard = (function (_super) {
    __extends(CreditCard, _super);
    function CreditCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.creditCardNode = null;
        _this.state = {
            error: false,
            loading: true,
        };
        _this.isSpinnerVisible = function () { return _this.state.loading && !_this.state.error; };
        _this.handleInstallmentsSelect = function (selectedOption) {
            if (_this.props.setInstallments) {
                _this.props.setInstallments('creditCard', String(selectedOption.id));
            }
        };
        return _this;
    }
    CreditCard.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.props.renderPaymentMethod('creditCard', this.creditCardNode)];
                    case 1:
                        _a.sent();
                        this.setState({ error: false, loading: false });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error(e_1);
                        this.setState({ error: true, loading: false });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CreditCard.prototype.renderInstallmentsIfSupported = function () {
        var installments = this.props.info.installments;
        if (!installments) {
            return null;
        }
        return (React.createElement("div", { className: s.installmentsWrap },
            React.createElement(Fields_1.Installments, { installments: installments, onInstallmentsSelect: this.handleInstallmentsSelect })));
    };
    CreditCard.prototype.renderSpinner = function () {
        if (!this.isSpinnerVisible()) {
            return null;
        }
        return React.createElement(Loader_1.default, null);
    };
    CreditCard.prototype.renderError = function () {
        if (!this.state.error) {
            return null;
        }
        return (React.createElement("div", { key: "error", "data-hook": "cc-error", className: s.creditCardPayment, style: { minHeight: 'auto' } },
            React.createElement(Translate_1.default, { forKey: "cc.load.error" })));
    };
    CreditCard.prototype.renderCreditCardForm = function () {
        var _this = this;
        if (this.state.error) {
            return null;
        }
        return (React.createElement("div", { className: s.creditCardPayment },
            React.createElement("div", { key: "form", "data-hook": "cc-form", id: "cashier-payments-method-creditCard-iframe-parent", ref: function (node) { return _this.creditCardNode = node; } }),
            this.renderInstallmentsIfSupported()));
    };
    CreditCard.prototype.render = function () {
        return (React.createElement(PaymentMethodLayout_1.default, { noPadding: !this.state.error, dataHook: "cashier-payments-method-creditCard" },
            this.renderCreditCardForm(),
            this.renderError(),
            this.renderSpinner()));
    };
    CreditCard.defaultProps = {
        info: {},
    };
    return CreditCard;
}(React.Component));
exports.default = CreditCard;
//# sourceMappingURL=CreditCard.js.map

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Installments_1 = __webpack_require__(151);
exports.default = Installments_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Dropdown_1 = __webpack_require__(68);
var Translate_1 = __webpack_require__(35);
var s = __webpack_require__(191);
var getInstallmentsOptions = function (min, max) {
    var options = [
        {
            id: 1,
            label: Translate_1.translate({ forKey: 'cc.installments.singlePayment' }),
            value: 1,
        },
    ];
    for (var i = Math.max(min, 2); i <= max; i++) {
        options.push({ id: i, value: i, label: i });
    }
    return options;
};
var Installments = function (_a) {
    var installments = _a.installments, onInstallmentsSelect = _a.onInstallmentsSelect;
    return (React.createElement("div", { "data-hook": "cashier-payments-method-installments-dropdown" },
        React.createElement("div", { className: s.installmentsTitle }, Translate_1.translate({ forKey: 'cc.installments.title' })),
        React.createElement(Dropdown_1.default, { defaultOptionId: 1, options: getInstallmentsOptions(installments.minInstallments, installments.maxInstallments), onSelect: onInstallmentsSelect })));
};
exports.default = Installments;
//# sourceMappingURL=Installments.js.map

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var s = __webpack_require__(153);
var Loader_1 = __webpack_require__(69);
var LoaderWrap = (function (_super) {
    __extends(LoaderWrap, _super);
    function LoaderWrap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoaderWrap.prototype.render = function () {
        return (React.createElement("div", { "data-hook": "cc-spinner", className: this.props.size === 'medium' ? s.loaderWrap : s.small },
            React.createElement(Loader_1.default, { size: this.props.size })));
    };
    LoaderWrap.defaultProps = {
        size: 'medium',
    };
    return LoaderWrap;
}(React.Component));
exports.default = LoaderWrap;
//# sourceMappingURL=Loader.js.map

/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loaderWrap":"_1UDHG","small":"_1Fvgq"};

/***/ }),
/* 154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dropdownContainer":"_17AVT","loader":"_1fjur","dropdownOptions":"_22q5b","option":"_3tCqn","optionLabel":"_3X0Mp","selectableOption":"_3HPdL","selectedOptionNonActiveState":"_3Lslc","currentSelection":"DBaup","dropdownArrow":"_2j0hK","input":"dIr4M","errorInput":"_3eLzi","errorLabel":"NBMt0"};

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ../node_modules/cashier-payments-method-component/node_modules/i18next/dist/es/logger.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var consoleLogger = {
  type: 'logger',

  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    var _console;

    /* eslint no-console: 0 */
    if (console && console[type]) (_console = console)[type].apply(_console, _toConsumableArray(args));
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  Logger.prototype.init = function init(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug;
  };

  Logger.prototype.setDebug = function setDebug(bool) {
    this.debug = bool;
  };

  Logger.prototype.log = function log() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return this.forward(args, 'log', '', true);
  };

  Logger.prototype.warn = function warn() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return this.forward(args, 'warn', '', true);
  };

  Logger.prototype.error = function error() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return this.forward(args, 'error', '');
  };

  Logger.prototype.deprecate = function deprecate() {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
  };

  Logger.prototype.forward = function forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return null;
    if (typeof args[0] === 'string') args[0] = '' + prefix + this.prefix + ' ' + args[0];
    return this.logger[lvl](args);
  };

  Logger.prototype.create = function create(moduleName) {
    return new Logger(this.logger, _extends({ prefix: this.prefix + ':' + moduleName + ':' }, this.options));
  };

  return Logger;
}();

/* harmony default export */ var logger = (new Logger());
// CONCATENATED MODULE: ../node_modules/cashier-payments-method-component/node_modules/i18next/dist/es/EventEmitter.js
function EventEmitter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventEmitter = function () {
  function EventEmitter() {
    EventEmitter__classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  EventEmitter.prototype.on = function on(events, listener) {
    var _this = this;

    events.split(' ').forEach(function (event) {
      _this.observers[event] = _this.observers[event] || [];
      _this.observers[event].push(listener);
    });
  };

  EventEmitter.prototype.off = function off(event, listener) {
    var _this2 = this;

    if (!this.observers[event]) {
      return;
    }

    this.observers[event].forEach(function () {
      if (!listener) {
        delete _this2.observers[event];
      } else {
        var index = _this2.observers[event].indexOf(listener);
        if (index > -1) {
          _this2.observers[event].splice(index, 1);
        }
      }
    });
  };

  EventEmitter.prototype.emit = function emit(event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (this.observers[event]) {
      var cloned = [].concat(this.observers[event]);
      cloned.forEach(function (observer) {
        observer.apply(undefined, args);
      });
    }

    if (this.observers['*']) {
      var _cloned = [].concat(this.observers['*']);
      _cloned.forEach(function (observer) {
        var _ref;

        observer.apply(observer, (_ref = [event]).concat.apply(_ref, args));
      });
    }
  };

  return EventEmitter;
}();

/* harmony default export */ var es_EventEmitter = (EventEmitter);
// CONCATENATED MODULE: ../node_modules/cashier-payments-method-component/node_modules/i18next/dist/es/utils.js
function makeString(object) {
  if (object == null) return '';
  /* eslint prefer-template: 0 */
  return '' + object;
}

function utils_copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};

    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}

function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}

function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}

function deepExtend(target, source, overwrite) {
  /* eslint no-restricted-syntax: 0 */
  for (var prop in source) {
    if (prop in target) {
      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }
  return target;
}

function regexEscape(str) {
  /* eslint no-useless-escape: 0 */
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

/* eslint-disable */
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': '&quot;',
  "'": '&#39;',
  "/": '&#x2F;'
};
/* eslint-enable */

function utils_escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
// CONCATENATED MODULE: ../node_modules/cashier-payments-method-component/node_modules/i18next/dist/es/ResourceStore.js
var ResourceStore__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function ResourceStore__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }




var ResourceStore_ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  function ResourceStore() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { ns: ['translation'], defaultNS: 'translation' };

    ResourceStore__classCallCheck(this, ResourceStore);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.data = data;
    _this.options = options;
    return _this;
  }

  ResourceStore.prototype.addNamespaces = function addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  };

  ResourceStore.prototype.removeNamespaces = function removeNamespaces(ns) {
    var index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  };

  ResourceStore.prototype.getResource = function getResource(lng, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var keySeparator = options.keySeparator || this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key && typeof key !== 'string') path = path.concat(key);
    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    }

    return getPath(this.data, path);
  };

  ResourceStore.prototype.addResource = function addResource(lng, ns, key, value) {
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { silent: false };

    var keySeparator = this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    setPath(this.data, path, value);

    if (!options.silent) this.emit('added', lng, ns, key, value);
  };

  ResourceStore.prototype.addResources = function addResources(lng, ns, resources) {
    /* eslint no-restricted-syntax: 0 */
    for (var m in resources) {
      if (typeof resources[m] === 'string') this.addResource(lng, ns, m, resources[m], { silent: true });
    }
    this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.addResourceBundle = function addResourceBundle(lng, ns, resources, deep, overwrite) {
    var path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    var pack = getPath(this.data, path) || {};

    if (deep) {
      deepExtend(pack, resources, overwrite);
    } else {
      pack = ResourceStore__extends({}, pack, resources);
    }

    setPath(this.data, path, pack);

    this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.removeResourceBundle = function removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);

    this.emit('removed', lng, ns);
  };

  ResourceStore.prototype.hasResourceBundle = function hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  };

  ResourceStore.prototype.getResourceBundle = function getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;

    // COMPATIBILITY: remove extend in v2.1.0
    if (this.options.compatibilityAPI === 'v1') return ResourceStore__extends({}, this.getResource(lng, ns));

    return this.getResource(lng, ns);
  };

  ResourceStore.prototype.toJSON = function toJSON() {
    return this.data;
  };

  return ResourceStore;
}(es_EventEmitter);

/* harmony default export */ var es_ResourceStore = (ResourceStore_ResourceStore);
// CONCATENATED MODULE: ../node_modules/cashier-payments-method-component/node_modules/i18next/dist/es/postProcessor.js
/* harmony default export */ var postProcessor = ({

  processors: {},

  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });

    return value;
  }
});
// CONCATENATED MODULE: ../node_modules/cashier-payments-method-component/node_modules/i18next/dist/es/compatibility/v1.js
/* eslint no-param-reassign: 0 */


function convertInterpolation(options) {

  options.interpolation = {
    unescapeSuffix: 'HTML'
  };

  options.interpolation.prefix = options.interpolationPrefix || '__';
  options.interpolation.suffix = options.interpolationSuffix || '__';
  options.interpolation.escapeValue = options.escapeInterpolation || false;

  options.interpolation.nestingPrefix = options.reusePrefix || '$t(';
  options.interpolation.nestingSuffix = options.reuseSuffix || ')';

  return options;
}

function convertAPIOptions(options) {
  if (options.resStore) options.resources = options.resStore;

  if (options.ns && options.ns.defaultNs) {
    options.defaultNS = options.ns.defaultNs;
    options.ns = options.ns.namespaces;
  } else {
    options.defaultNS = options.ns || 'translation';
  }

  if (options.fallbackToDefaultNS && options.defaultNS) options.fallbackNS = options.defaultNS;

  options.saveMissing = options.sendMissing;
  options.saveMissingTo = options.sendMissingTo || 'current';
  options.returnNull = !options.fallbackOnNull;
  options.returnEmptyString = !options.fallbackOnEmpty;
  options.returnObjects = options.returnObjectTrees;
  options.joinArrays = '\n';

  options.returnedObjectHandler = options.objectTreeKeyHandler;
  options.parseMissingKeyHandler = options.parseMissingKey;
  options.appendNamespaceToMissingKey = true;

  options.nsSeparator = options.nsseparator || ':';
  options.keySeparator = options.keyseparator || '.';

  if (options.shortcutFunction === 'sprintf') {
    options.overloadTranslationOptionHandler = function handle(args) {
      var values = [];

      for (var i = 1; i < args.length; i++) {
        values.push(args[i]);
      }

      return {
        postProcess: 'sprintf',
        sprintf: values
      };
    };
  }

  options.whitelist = options.lngWhitelist;
  options.preload = options.preload;
  if (options.load === 'current') options.load = 'currentOnly';
  if (options.load === 'unspecific') options.load = 'languageOnly';

  // backend
  options.backend = options.backend || {};
  options.backend.loadPath = options.resGetPath || 'locales/__lng__/__ns__.json';
  options.backend.addPath = options.resPostPath || 'locales/add/__lng__/__ns__';
  options.backend.allowMultiLoading = options.dynamicLoad;

  // cache
  options.cache = options.cache || {};
  options.cache.prefix = 'res_';
  options.cache.expirationTime = 7 * 24 * 60 * 60 * 1000;
  options.cache.enabled = options.useLocalStorage;

  options = convertInterpolation(options);
  if (options.defaultVariables) options.interpolation.defaultVariables = options.defaultVariables;

  // COMPATIBILITY: deprecation
  // if (options.getAsync === false) throw deprecation error

  return options;
}

function convertJSONOptions(options) {
  options = convertInterpolation(options);
  options.joinArrays = '\n';

  return options;
}

function convertTOptions(options) {
  if (options.interpolationPrefix || options.interpolationSuffix || options.escapeInterpolation !== undefined) {
    options = convertInterpolation(options);
  }

  options.nsSeparator = options.nsseparator;
  options.keySeparator = options.keyseparator;

  options.returnObjects = options.returnObjectTrees;

  return options;
}

function appendBackwardsAPI(i18n) {
  i18n.lng = function () {
    logger.deprecate('i18next.lng() can be replaced by i18next.language for detected language or i18next.languages for languages ordered by translation lookup.');
    return i18n.services.languageUtils.toResolveHierarchy(i18n.language)[0];
  };

  i18n.preload = function (lngs, cb) {
    logger.deprecate('i18next.preload() can be replaced with i18next.loadLanguages()');
    i18n.loadLanguages(lngs, cb);
  };

  i18n.setLng = function (lng, options, callback) {
    logger.deprecate('i18next.setLng() can be replaced with i18next.changeLanguage() or i18next.getFixedT() to get a translation function with fixed language or namespace.');
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!options) options = {};

    if (options.fixLng === true) {
      if (callback) return callback(null, i18n.getFixedT(lng));
    }

    return i18n.changeLanguage(lng, callback);
  };

  i18n.addPostProcessor = function (name, fc) {
    logger.deprecate('i18next.addPostProcessor() can be replaced by i18next.use({ type: \'postProcessor\', name: \'name\', process: fc })');
    i18n.use({
      type: 'postProcessor',
      name: name,
      process: fc
    });
  };
}
// CONCATENATED MODULE: ../node_modules/cashier-payments-method-component/node_modules/i18next/dist/es/Translator.js
var Translator__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function Translator__defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function Translator__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Translator__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Translator__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : Translator__defaults(subClass, superClass); }







var Translator_Translator = function (_EventEmitter) {
  Translator__inherits(Translator, _EventEmitter);

  function Translator(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Translator__classCallCheck(this, Translator);

    var _this = Translator__possibleConstructorReturn(this, _EventEmitter.call(this));

    utils_copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector'], services, _this);

    _this.options = options;
    _this.logger = logger.create('translator');
    return _this;
  }

  Translator.prototype.changeLanguage = function changeLanguage(lng) {
    if (lng) this.language = lng;
  };

  Translator.prototype.exists = function exists(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { interpolation: {} };

    if (this.options.compatibilityAPI === 'v1') {
      options = convertTOptions(options);
    }

    return this.resolve(key, options) !== undefined;
  };

  Translator.prototype.extractFromKey = function extractFromKey(key, options) {
    var nsSeparator = options.nsSeparator || this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';
    var keySeparator = options.keySeparator || this.options.keySeparator || '.';

    var namespaces = options.ns || this.options.defaultNS;
    if (nsSeparator && key.indexOf(nsSeparator) > -1) {
      var parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    if (typeof namespaces === 'string') namespaces = [namespaces];

    return {
      key: key,
      namespaces: namespaces
    };
  };

  Translator.prototype.translate = function translate(keys) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
      /* eslint prefer-rest-params: 0 */
      options = this.options.overloadTranslationOptionHandler(arguments);
    } else if (this.options.compatibilityAPI === 'v1') {
      options = convertTOptions(options);
    }

    // non valid keys handling
    if (keys === undefined || keys === null || keys === '') return '';
    if (typeof keys === 'number') keys = String(keys);
    if (typeof keys === 'string') keys = [keys];

    // separators
    var keySeparator = options.keySeparator || this.options.keySeparator || '.';

    // get namespace(s)

    var _extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
        key = _extractFromKey.key,
        namespaces = _extractFromKey.namespaces;

    var namespace = namespaces[namespaces.length - 1];

    // return key on CIMode
    var lng = options.lng || this.language;
    var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng && lng.toLowerCase() === 'cimode') {
      if (appendNamespaceToCIMode) {
        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
        return namespace + nsSeparator + key;
      }

      return key;
    }

    // resolve from store
    var res = this.resolve(keys, options);

    var resType = Object.prototype.toString.apply(res);
    var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;

    // object
    if (res && typeof res !== 'string' && noObject.indexOf(resType) < 0 && !(joinArrays && resType === '[object Array]')) {
      if (!options.returnObjects && !this.options.returnObjects) {
        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(key, res, options) : 'key \'' + key + ' (' + this.language + ')\' returned an object instead of string.';
      }

      // if we got a separator we loop over children - else we just return object as is
      // as having it set to false means no hierarchy so no lookup for nested values
      if (options.keySeparator || this.options.keySeparator) {
        var copy = resType === '[object Array]' ? [] : {}; // apply child translation on a copy

        /* eslint no-restricted-syntax: 0 */
        for (var m in res) {
          if (Object.prototype.hasOwnProperty.call(res, m)) {
            copy[m] = this.translate('' + key + keySeparator + m, Translator__extends({}, options, { joinArrays: false, ns: namespaces }));
          }
        }
        res = copy;
      }
    } else if (joinArrays && resType === '[object Array]') {
      // array special treatment
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, key, options);
    } else {
      // string, empty or null
      var usedDefault = false;
      var usedKey = false;

      // fallback value
      if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
        usedDefault = true;
        res = options.defaultValue;
      }
      if (!this.isValidLookup(res)) {
        usedKey = true;
        res = key;
      }

      // save missing
      if (usedKey || usedDefault) {
        this.logger.log('missingKey', lng, namespace, key, res);

        var lngs = [];
        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
          for (var i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === 'all') {
          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
        } else {
          lngs.push(options.lng || this.language);
        }

        if (this.options.saveMissing) {
          if (this.options.missingKeyHandler) {
            this.options.missingKeyHandler(lngs, namespace, key, res);
          } else if (this.backendConnector && this.backendConnector.saveMissing) {
            this.backendConnector.saveMissing(lngs, namespace, key, res);
          }
        }

        this.emit('missingKey', lngs, namespace, key, res);
      }

      // extend
      res = this.extendTranslation(res, key, options);

      // append namespace if still key
      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = namespace + ':' + key;

      // parseMissingKeyHandler
      if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
    }

    // return
    return res;
  };

  Translator.prototype.extendTranslation = function extendTranslation(res, key, options) {
    var _this2 = this;

    if (options.interpolation) this.interpolator.init(Translator__extends({}, options, { interpolation: Translator__extends({}, this.options.interpolation, options.interpolation) }));

    // interpolate
    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
    if (this.options.interpolation.defaultVariables) data = Translator__extends({}, this.options.interpolation.defaultVariables, data);
    res = this.interpolator.interpolate(res, data, options.lng || this.language);

    // nesting
    if (options.nest !== false) res = this.interpolator.nest(res, function () {
      return _this2.translate.apply(_this2, arguments);
    }, options);

    if (options.interpolation) this.interpolator.reset();

    // post process
    var postProcess = options.postProcess || this.options.postProcess;
    var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

    if (res !== undefined && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
      res = postProcessor.handle(postProcessorNames, res, key, options, this);
    }

    return res;
  };

  Translator.prototype.resolve = function resolve(keys) {
    var _this3 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var found = void 0;

    if (typeof keys === 'string') keys = [keys];

    // forEach possible key
    keys.forEach(function (k) {
      if (_this3.isValidLookup(found)) return;

      var extracted = _this3.extractFromKey(k, options);
      var key = extracted.key;
      var namespaces = extracted.namespaces;
      if (_this3.options.fallbackNS) namespaces = namespaces.concat(_this3.options.fallbackNS);

      var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
      var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';

      var codes = options.lngs ? options.lngs : _this3.languageUtils.toResolveHierarchy(options.lng || _this3.language);

      namespaces.forEach(function (ns) {
        if (_this3.isValidLookup(found)) return;

        codes.forEach(function (code) {
          if (_this3.isValidLookup(found)) return;

          var finalKey = key;
          var finalKeys = [finalKey];

          var pluralSuffix = void 0;
          if (needsPluralHandling) pluralSuffix = _this3.pluralResolver.getSuffix(code, options.count);

          // fallback for plural if context not found
          if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);

          // get key for context if needed
          if (needsContextHandling) finalKeys.push(finalKey += '' + _this3.options.contextSeparator + options.context);

          // get key for plural if needed
          if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);

          // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only
          var possibleKey = void 0;
          /* eslint no-cond-assign: 0 */
          while (possibleKey = finalKeys.pop()) {
            if (!_this3.isValidLookup(found)) {
              found = _this3.getResource(code, ns, possibleKey, options);
            }
          }
        });
      });
    });

    return found;
  };

  Translator.prototype.isValidLookup = function isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  };

  Translator.prototype.getResource = function getResource(code, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    return this.resourceStore.getResource(code, ns, key, options);
  };

  return Translator;
}(es_EventEmitter);

/* harmony default export */ var es_Translator = (Translator_Translator);
// CONCATENATED MODULE: ../node_modules/cashier-payments-method-component/node_modules/i18next/dist/es/LanguageUtils.js
function LanguageUtils__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtils_LanguageUtil = function () {
  function LanguageUtil(options) {
    LanguageUtils__classCallCheck(this, LanguageUtil);

    this.options = options;

    this.whitelist = this.options.whitelist || false;
    this.logger = logger.create('languageUtils');
  }

  LanguageUtil.prototype.getScriptPartFromCode = function getScriptPartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return null;

    var p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    return this.formatLanguageCode(p.join('-'));
  };

  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return code;

    var p = code.split('-');
    return this.formatLanguageCode(p[0]);
  };

  LanguageUtil.prototype.formatLanguageCode = function formatLanguageCode(code) {
    // http://www.iana.org/assignments/language-tags/language-tags.xhtml
    if (typeof code === 'string' && code.indexOf('-') > -1) {
      var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
      var p = code.split('-');

      if (this.options.lowerCaseLng) {
        p = p.map(function (part) {
          return part.toLowerCase();
        });
      } else if (p.length === 2) {
        p[0] = p[0].toLowerCase();
        p[1] = p[1].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      } else if (p.length === 3) {
        p[0] = p[0].toLowerCase();

        // if lenght 2 guess it's a country
        if (p[1].length === 2) p[1] = p[1].toUpperCase();
        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
      }

      return p.join('-');
    }

    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  };

  LanguageUtil.prototype.isWhitelisted = function isWhitelisted(code) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
  };

  LanguageUtil.prototype.getFallbackCodes = function getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;

    if (!code) return fallbacks.default || [];

    // asume we have an object defining fallbacks
    var found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks.default;

    return found || [];
  };

  LanguageUtil.prototype.toResolveHierarchy = function toResolveHierarchy(code, fallbackCode) {
    var _this = this;

    var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);

    var codes = [];
    var addCode = function addCode(c) {
      if (!c) return;
      if (_this.isWhitelisted(c)) {
        codes.push(c);
      } else {
        _this.logger.warn('rejecting non-whitelisted language code: ' + c);
      }
    };

    if (typeof code === 'string' && code.indexOf('-') > -1) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (typeof code === 'string') {
      addCode(this.formatLanguageCode(code));
    }

    fallbackCodes.forEach(function (fc) {
      if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
    });

    return codes;
  };

  return LanguageUtil;
}();

/* harmony default export */ var LanguageUtils = (LanguageUtils_LanguageUtil);
// CONCATENATED MODULE: ../node_modules/cashier-payments-method-component/node_modules/i18next/dist/es/PluralResolver.js
function PluralResolver__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// definition http://translate.sourceforge.net/wiki/l10n/pluralforms
/* eslint-disable */
var sets = [{ lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'tg', 'ti', 'tr', 'uz', 'wa'], nr: [1, 2], fc: 1 }, { lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'es_ar', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'he', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt', 'pt_br', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'], nr: [1, 2], fc: 2 }, { lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'], nr: [1], fc: 3 }, { lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'], nr: [1, 2, 5], fc: 4 }, { lngs: ['ar'], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ['cs', 'sk'], nr: [1, 2, 5], fc: 6 }, { lngs: ['csb', 'pl'], nr: [1, 2, 5], fc: 7 }, { lngs: ['cy'], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ['fr'], nr: [1, 2], fc: 9 }, { lngs: ['ga'], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ['gd'], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ['is'], nr: [1, 2], fc: 12 }, { lngs: ['jv'], nr: [0, 1], fc: 13 }, { lngs: ['kw'], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ['lt'], nr: [1, 2, 10], fc: 15 }, { lngs: ['lv'], nr: [1, 2, 0], fc: 16 }, { lngs: ['mk'], nr: [1, 2], fc: 17 }, { lngs: ['mnk'], nr: [0, 1, 2], fc: 18 }, { lngs: ['mt'], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ['or'], nr: [2, 1], fc: 2 }, { lngs: ['ro'], nr: [1, 2, 20], fc: 20 }, { lngs: ['sl'], nr: [5, 1, 2, 3], fc: 21 }];

var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  }
};
/* eslint-enable */

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver_PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    PluralResolver__classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;

    this.logger = logger.create('pluralResolver');

    this.rules = createRules();
  }

  PluralResolver.prototype.addRule = function addRule(lng, obj) {
    this.rules[lng] = obj;
  };

  PluralResolver.prototype.getRule = function getRule(code) {
    return this.rules[this.languageUtils.getLanguagePartFromCode(code)];
  };

  PluralResolver.prototype.needsPlural = function needsPlural(code) {
    var rule = this.getRule(code);

    return rule && rule.numbers.length > 1;
  };

  PluralResolver.prototype.getSuffix = function getSuffix(code, count) {
    var _this = this;

    var rule = this.getRule(code);

    if (rule) {
      if (rule.numbers.length === 1) return ''; // only singular

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      // special treatment for lngs only having singular and plural
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this.options.prepend && suffix.toString() ? _this.options.prepend + suffix.toString() : suffix.toString();
      };

      // COMPATIBILITY JSON
      // v1
      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return '_plural_' + suffix.toString();
        return returnSuffix();
      } else if ( /* v2 */this.options.compatibilityJSON === 'v2' || rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      } else if ( /* v3 - gettext index */rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }

    this.logger.warn('no plural rule found for: ' + code);
    return '';
  };

  return PluralResolver;
}();

/* harmony default export */ var es_PluralResolver = (PluralResolver_PluralResolver);
// CONCATENATED MODULE: ../node_modules/cashier-payments-method-component/node_modules/i18next/dist/es/Interpolator.js
var Interpolator__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function Interpolator__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Interpolator_Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    Interpolator__classCallCheck(this, Interpolator);

    this.logger = logger.create('interpolator');

    this.init(options, true);
  }

  /* eslint no-param-reassign: 0 */


  Interpolator.prototype.init = function init() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var reset = arguments[1];

    if (reset) {
      this.options = options;
      this.format = options.interpolation && options.interpolation.format || function (value) {
        return value;
      };
      this.escape = options.interpolation && options.interpolation.escape || utils_escape;
    }
    if (!options.interpolation) options.interpolation = { escapeValue: true };

    var iOpts = options.interpolation;

    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;

    this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
    this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';

    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';

    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';

    this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
    this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');

    // the regexp
    this.resetRegExp();
  };

  Interpolator.prototype.reset = function reset() {
    if (this.options) this.init(this.options);
  };

  Interpolator.prototype.resetRegExp = function resetRegExp() {
    // the regexp
    var regexpStr = this.prefix + '(.+?)' + this.suffix;
    this.regexp = new RegExp(regexpStr, 'g');

    var regexpUnescapeStr = '' + this.prefix + this.unescapePrefix + '(.+?)' + this.unescapeSuffix + this.suffix;
    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');

    var nestingRegexpStr = this.nestingPrefix + '(.+?)' + this.nestingSuffix;
    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
  };

  Interpolator.prototype.interpolate = function interpolate(str, data, lng) {
    var _this = this;

    var match = void 0;
    var value = void 0;

    function regexSafe(val) {
      return val.replace(/\$/g, '$$$$');
    }

    var handleFormat = function handleFormat(key) {
      if (key.indexOf(_this.formatSeparator) < 0) return getPath(data, key);

      var p = key.split(_this.formatSeparator);
      var k = p.shift().trim();
      var f = p.join(_this.formatSeparator).trim();

      return _this.format(getPath(data, k), f, lng);
    };

    this.resetRegExp();

    // unescape if has unescapePrefix/Suffix
    /* eslint no-cond-assign: 0 */
    while (match = this.regexpUnescape.exec(str)) {
      value = handleFormat(match[1].trim());
      str = str.replace(match[0], value);
      this.regexpUnescape.lastIndex = 0;
    }

    // regular escape on demand
    while (match = this.regexp.exec(str)) {
      value = handleFormat(match[1].trim());
      if (typeof value !== 'string') value = makeString(value);
      if (!value) {
        this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
        value = '';
      }
      value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  };

  Interpolator.prototype.nest = function nest(str, fc) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var match = void 0;
    var value = void 0;

    var clonedOptions = Interpolator__extends({}, options);
    clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup

    // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"
    function handleHasOptions(key) {
      if (key.indexOf(',') < 0) return key;

      var p = key.split(',');
      key = p.shift();
      var optionsString = p.join(',');
      optionsString = this.interpolate(optionsString, clonedOptions);
      optionsString = optionsString.replace(/'/g, '"');

      try {
        clonedOptions = JSON.parse(optionsString);
      } catch (e) {
        this.logger.error('failed parsing options string in nesting for key ' + key, e);
      }

      return key;
    }

    // regular escape on demand
    while (match = this.nestingRegexp.exec(str)) {
      value = fc(handleHasOptions.call(this, match[1].trim()), clonedOptions);

      // is only the nesting key (key1 = '$(key2)') return the value without stringify
      if (value && match[0] === str && typeof value !== 'string') return value;

      // no string to include or empty
      if (typeof value !== 'string') value = makeString(value);
      if (!value) {
        this.logger.warn('missed to resolve ' + match[1] + ' for nesting ' + str);
        value = '';
      }
      // Nested keys should not be escaped by default #854
      // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  };

  return Interpolator;
}();

/* harmony default export */ var es_Interpolator = (Interpolator_Interpolator);
// CONCATENATED MODULE: ../node_modules/cashier-payments-method-component/node_modules/i18next/dist/es/BackendConnector.js
var BackendConnector__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function BackendConnector__defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function BackendConnector__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BackendConnector__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function BackendConnector__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : BackendConnector__defaults(subClass, superClass); }





function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var BackendConnector_Connector = function (_EventEmitter) {
  BackendConnector__inherits(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    BackendConnector__classCallCheck(this, Connector);

    var _this = BackendConnector__possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.options = options;
    _this.logger = logger.create('backendConnector');

    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }

  Connector.prototype.queueLoad = function queueLoad(languages, namespaces, callback) {
    var _this2 = this;

    // find what needs to be loaded
    var toLoad = [];
    var pending = [];
    var toLoadLanguages = [];
    var toLoadNamespaces = [];

    languages.forEach(function (lng) {
      var hasAllNamespaces = true;

      namespaces.forEach(function (ns) {
        var name = lng + '|' + ns;

        if (_this2.store.hasResourceBundle(lng, ns)) {
          _this2.state[name] = 2; // loaded
        } else if (_this2.state[name] < 0) {
          // nothing to do for err
        } else if (_this2.state[name] === 1) {
          if (pending.indexOf(name) < 0) pending.push(name);
        } else {
          _this2.state[name] = 1; // pending

          hasAllNamespaces = false;

          if (pending.indexOf(name) < 0) pending.push(name);
          if (toLoad.indexOf(name) < 0) toLoad.push(name);
          if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
        }
      });

      if (!hasAllNamespaces) toLoadLanguages.push(lng);
    });

    if (toLoad.length || pending.length) {
      this.queue.push({
        pending: pending,
        loaded: {},
        errors: [],
        callback: callback
      });
    }

    return {
      toLoad: toLoad,
      pending: pending,
      toLoadLanguages: toLoadLanguages,
      toLoadNamespaces: toLoadNamespaces
    };
  };

  Connector.prototype.loaded = function loaded(name, err, data) {
    var _this3 = this;

    var _name$split = name.split('|'),
        _name$split2 = _slicedToArray(_name$split, 2),
        lng = _name$split2[0],
        ns = _name$split2[1];

    if (err) this.emit('failedLoading', lng, ns, err);

    if (data) {
      this.store.addResourceBundle(lng, ns, data);
    }

    // set loaded
    this.state[name] = err ? -1 : 2;

    // callback if ready
    this.queue.forEach(function (q) {
      pushPath(q.loaded, [lng], ns);
      remove(q.pending, name);

      if (err) q.errors.push(err);

      if (q.pending.length === 0 && !q.done) {
        _this3.emit('loaded', q.loaded);
        /* eslint no-param-reassign: 0 */
        q.done = true;
        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    });

    // remove done load requests
    this.queue = this.queue.filter(function (q) {
      return !q.done;
    });
  };

  Connector.prototype.read = function read(lng, ns, fcName) {
    var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    var _this4 = this;

    var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
    var callback = arguments[5];

    if (!lng.length) return callback(null, {}); // noting to load

    return this.backend[fcName](lng, ns, function (err, data) {
      if (err && data /* = retryFlag */ && tried < 5) {
        setTimeout(function () {
          _this4.read.call(_this4, lng, ns, fcName, tried + 1, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    });
  };

  /* eslint consistent-return: 0 */


  Connector.prototype.load = function load(languages, namespaces, callback) {
    var _this5 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }
    var options = BackendConnector__extends({}, this.backend.options, this.options.backend);

    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    var toLoad = this.queueLoad(languages, namespaces, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now
      return null; // pendings will trigger callback
    }

    // load with multi-load
    if (options.allowMultiLoading && this.backend.readMulti) {
      this.read(toLoad.toLoadLanguages, toLoad.toLoadNamespaces, 'readMulti', null, null, function (err, data) {
        if (err) _this5.logger.warn('loading namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading failed', err);
        if (!err && data) _this5.logger.log('successfully loaded namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading', data);

        toLoad.toLoad.forEach(function (name) {
          var _name$split3 = name.split('|'),
              _name$split4 = _slicedToArray(_name$split3, 2),
              l = _name$split4[0],
              n = _name$split4[1];

          var bundle = getPath(data, [l, n]);
          if (bundle) {
            _this5.loaded(name, err, bundle);
          } else {
            var error = 'loading namespace ' + n + ' for language ' + l + ' via multiloading failed';
            _this5.loaded(name, error);
            _this5.logger.error(error);
          }
        });
      });
    } else {
      toLoad.toLoad.forEach(function (name) {
        _this5.loadOne(name);
      });
    }
  };

  Connector.prototype.reload = function reload(languages, namespaces) {
    var _this6 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
    }
    var options = BackendConnector__extends({}, this.backend.options, this.options.backend);

    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    // load with multi-load
    if (options.allowMultiLoading && this.backend.readMulti) {
      this.read(languages, namespaces, 'readMulti', null, null, function (err, data) {
        if (err) _this6.logger.warn('reloading namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading failed', err);
        if (!err && data) _this6.logger.log('successfully reloaded namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading', data);

        languages.forEach(function (l) {
          namespaces.forEach(function (n) {
            var bundle = getPath(data, [l, n]);
            if (bundle) {
              _this6.loaded(l + '|' + n, err, bundle);
            } else {
              var error = 'reloading namespace ' + n + ' for language ' + l + ' via multiloading failed';
              _this6.loaded(l + '|' + n, error);
              _this6.logger.error(error);
            }
          });
        });
      });
    } else {
      languages.forEach(function (l) {
        namespaces.forEach(function (n) {
          _this6.loadOne(l + '|' + n, 're');
        });
      });
    }
  };

  Connector.prototype.loadOne = function loadOne(name) {
    var _this7 = this;

    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var _name$split5 = name.split('|'),
        _name$split6 = _slicedToArray(_name$split5, 2),
        lng = _name$split6[0],
        ns = _name$split6[1];

    this.read(lng, ns, 'read', null, null, function (err, data) {
      if (err) _this7.logger.warn(prefix + 'loading namespace ' + ns + ' for language ' + lng + ' failed', err);
      if (!err && data) _this7.logger.log(prefix + 'loaded namespace ' + ns + ' for language ' + lng, data);

      _this7.loaded(name, err, data);
    });
  };

  Connector.prototype.saveMissing = function saveMissing(languages, namespace, key, fallbackValue) {
    if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue);

    // write to store to avoid resending
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  };

  return Connector;
}(es_EventEmitter);

/* harmony default export */ var BackendConnector = (BackendConnector_Connector);
// CONCATENATED MODULE: ../node_modules/cashier-payments-method-component/node_modules/i18next/dist/es/CacheConnector.js
var CacheConnector__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function CacheConnector__defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function CacheConnector__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CacheConnector__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function CacheConnector__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : CacheConnector__defaults(subClass, superClass); }




var CacheConnector_Connector = function (_EventEmitter) {
  CacheConnector__inherits(Connector, _EventEmitter);

  function Connector(cache, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    CacheConnector__classCallCheck(this, Connector);

    var _this = CacheConnector__possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.cache = cache;
    _this.store = store;
    _this.services = services;
    _this.options = options;
    _this.logger = logger.create('cacheConnector');

    if (_this.cache && _this.cache.init) _this.cache.init(services, options.cache, options);
    return _this;
  }

  /* eslint consistent-return: 0 */


  Connector.prototype.load = function load(languages, namespaces, callback) {
    var _this2 = this;

    if (!this.cache) return callback && callback();
    var options = CacheConnector__extends({}, this.cache.options, this.options.cache);

    var loadLngs = typeof languages === 'string' ? this.services.languageUtils.toResolveHierarchy(languages) : languages;

    if (options.enabled) {
      this.cache.load(loadLngs, function (err, data) {
        if (err) _this2.logger.error('loading languages ' + loadLngs.join(', ') + ' from cache failed', err);
        if (data) {
          /* eslint no-restricted-syntax: 0 */
          for (var l in data) {
            if (Object.prototype.hasOwnProperty.call(data, l)) {
              for (var n in data[l]) {
                if (Object.prototype.hasOwnProperty.call(data[l], n)) {
                  if (n !== 'i18nStamp') {
                    var bundle = data[l][n];
                    if (bundle) _this2.store.addResourceBundle(l, n, bundle);
                  }
                }
              }
            }
          }
        }
        if (callback) callback();
      });
    } else if (callback) {
      callback();
    }
  };

  Connector.prototype.save = function save() {
    if (this.cache && this.options.cache && this.options.cache.enabled) this.cache.save(this.store.data);
  };

  return Connector;
}(es_EventEmitter);

/* harmony default export */ var CacheConnector = (CacheConnector_Connector);
// CONCATENATED MODULE: ../node_modules/cashier-payments-method-component/node_modules/i18next/dist/es/defaults.js

function get() {
  return {
    debug: false,
    initImmediate: true,

    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false, // string or array of namespaces

    whitelist: false, // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all', // | currentOnly | languageOnly
    preload: false, // array with preload languages

    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',

    saveMissing: false, // enable to send missing values
    saveMissingTo: 'fallback', // 'current' || 'all'
    missingKeyHandler: false, // function(lng, ns, key, fallbackValue) -> override if prefer on handling

    postProcess: false, // string or array of postProcessor names
    returnNull: true, // allows null value as valid translation
    returnEmptyString: true, // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false, // or string to join array
    returnedObjectHandler: function returnedObjectHandler() {}, // function(key, value, options) triggered if key returns object but returnObjects is set to false
    parseMissingKeyHandler: false, // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      return { defaultValue: args[1] };
    },

    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',

      nestingPrefix: '$t(',
      nestingSuffix: ')',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',
      defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
    }
  };
}

/* eslint no-param-reassign: 0 */
function transformOptions(options) {
  // create namespace object if namespace is passed in as string
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  // extend whitelist with cimode
  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) options.whitelist.push('cimode');

  return options;
}
// CONCATENATED MODULE: ../node_modules/cashier-payments-method-component/node_modules/i18next/dist/es/i18next.js
var i18next__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function i18next__defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function i18next__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function i18next__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function i18next__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : i18next__defaults(subClass, superClass); }















function noop() {}

var i18next_I18n = function (_EventEmitter) {
  i18next__inherits(I18n, _EventEmitter);

  function I18n() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    i18next__classCallCheck(this, I18n);

    var _this = i18next__possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = logger;
    _this.modules = { external: [] };

    if (callback && !_this.isInitialized && !options.isClone) {
      var _ret;

      // https://github.com/i18next/i18next/issues/879
      if (!_this.options.initImmediate) return _ret = _this.init(options, callback), i18next__possibleConstructorReturn(_this, _ret);
      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }

  I18n.prototype.init = function init(options, callback) {
    var _this2 = this;

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!options) options = {};

    if (options.compatibilityAPI === 'v1') {
      this.options = i18next__extends({}, get(), transformOptions(convertAPIOptions(options)), {});
    } else if (options.compatibilityJSON === 'v1') {
      this.options = i18next__extends({}, get(), transformOptions(convertJSONOptions(options)), {});
    } else {
      this.options = i18next__extends({}, get(), this.options, transformOptions(options));
    }
    this.format = this.options.interpolation.format;
    if (!callback) callback = noop;

    function createClassOnDemand(ClassOrObject) {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    }

    // init services
    if (!this.options.isClone) {
      if (this.modules.logger) {
        logger.init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        logger.init(null, this.options);
      }

      var lu = new LanguageUtils(this.options);
      this.store = new es_ResourceStore(this.options.resources, this.options);

      var s = this.services;
      s.logger = logger;
      s.resourceStore = this.store;
      s.resourceStore.on('added removed', function (lng, ns) {
        s.cacheConnector.save();
      });
      s.languageUtils = lu;
      s.pluralResolver = new es_PluralResolver(lu, { prepend: this.options.pluralSeparator, compatibilityJSON: this.options.compatibilityJSON, simplifyPluralSuffix: this.options.simplifyPluralSuffix });
      s.interpolator = new es_Interpolator(this.options);

      s.backendConnector = new BackendConnector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.backendConnector.on('*', function (event) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      s.backendConnector.on('loaded', function (loaded) {
        s.cacheConnector.save();
      });

      s.cacheConnector = new CacheConnector(createClassOnDemand(this.modules.cache), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.cacheConnector.on('*', function (event) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        s.languageDetector.init(s, this.options.detection, this.options);
      }

      this.translator = new es_Translator(this.services, this.options);
      // pipe events from translator
      this.translator.on('*', function (event) {
        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      this.modules.external.forEach(function (m) {
        if (m.init) m.init(_this2);
      });
    }

    // append api
    var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle'];
    storeApi.forEach(function (fcName) {
      _this2[fcName] = function () {
        var _store;

        return (_store = _this2.store)[fcName].apply(_store, arguments);
      };
    });

    // COMPATIBILITY: remove this
    if (this.options.compatibilityAPI === 'v1') appendBackwardsAPI(this);

    var load = function load() {
      _this2.changeLanguage(_this2.options.lng, function (err, t) {
        _this2.isInitialized = true;
        _this2.logger.log('initialized', _this2.options);
        _this2.emit('initialized', _this2.options);

        callback(err, t);
      });
    };

    if (this.options.resources || !this.options.initImmediate) {
      load();
    } else {
      setTimeout(load, 0);
    }

    return this;
  };

  /* eslint consistent-return: 0 */


  I18n.prototype.loadResources = function loadResources() {
    var _this3 = this;

    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

    if (!this.options.resources) {
      if (this.language && this.language.toLowerCase() === 'cimode') return callback(); // avoid loading resources for cimode

      var toLoad = [];

      var append = function append(lng) {
        if (!lng) return;
        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };

      if (!this.language) {
        // at least load fallbacks in this case
        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach(function (l) {
          return append(l);
        });
      } else {
        append(this.language);
      }

      if (this.options.preload) {
        this.options.preload.forEach(function (l) {
          return append(l);
        });
      }

      this.services.cacheConnector.load(toLoad, this.options.ns, function () {
        _this3.services.backendConnector.load(toLoad, _this3.options.ns, callback);
      });
    } else {
      callback(null);
    }
  };

  I18n.prototype.reloadResources = function reloadResources(lngs, ns) {
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    this.services.backendConnector.reload(lngs, ns);
  };

  I18n.prototype.use = function use(module) {
    if (module.type === 'backend') {
      this.modules.backend = module;
    }

    if (module.type === 'cache') {
      this.modules.cache = module;
    }

    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }

    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }

    if (module.type === 'postProcessor') {
      postProcessor.addPostProcessor(module);
    }

    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }

    return this;
  };

  I18n.prototype.changeLanguage = function changeLanguage(lng, callback) {
    var _this4 = this;

    var done = function done(err, l) {
      if (l) {
        _this4.emit('languageChanged', l);
        _this4.logger.log('languageChanged', l);
      }

      if (callback) callback(err, function () {
        return _this4.t.apply(_this4, arguments);
      });
    };

    var setLng = function setLng(l) {
      if (l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);

        _this4.translator.changeLanguage(l);

        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
      }

      _this4.loadResources(function (err) {
        done(err, l);
      });
    };

    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      this.services.languageDetector.detect(setLng);
    } else {
      setLng(lng);
    }
  };

  I18n.prototype.getFixedT = function getFixedT(lng, ns) {
    var _this5 = this;

    var fixedT = function fixedT(key) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var options = i18next__extends({}, opts);
      options.lng = options.lng || fixedT.lng;
      options.lngs = options.lngs || fixedT.lngs;
      options.ns = options.ns || fixedT.ns;
      return _this5.t(key, options);
    };
    if (typeof lng === 'string') {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }
    fixedT.ns = ns;
    return fixedT;
  };

  I18n.prototype.t = function t() {
    var _translator;

    return this.translator && (_translator = this.translator).translate.apply(_translator, arguments);
  };

  I18n.prototype.exists = function exists() {
    var _translator2;

    return this.translator && (_translator2 = this.translator).exists.apply(_translator2, arguments);
  };

  I18n.prototype.setDefaultNamespace = function setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  };

  I18n.prototype.loadNamespaces = function loadNamespaces(ns, callback) {
    var _this6 = this;

    if (!this.options.ns) return callback && callback();
    if (typeof ns === 'string') ns = [ns];

    ns.forEach(function (n) {
      if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
    });

    this.loadResources(callback);
  };

  I18n.prototype.loadLanguages = function loadLanguages(lngs, callback) {
    if (typeof lngs === 'string') lngs = [lngs];
    var preloaded = this.options.preload || [];

    var newLngs = lngs.filter(function (lng) {
      return preloaded.indexOf(lng) < 0;
    });
    // Exit early if all given languages are already preloaded
    if (!newLngs.length) return callback();

    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(callback);
  };

  I18n.prototype.dir = function dir(lng) {
    if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
    if (!lng) return 'rtl';

    var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];

    return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
  };

  /* eslint class-methods-use-this: 0 */


  I18n.prototype.createInstance = function createInstance() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    return new I18n(options, callback);
  };

  I18n.prototype.cloneInstance = function cloneInstance() {
    var _this7 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

    var mergedOptions = i18next__extends({}, this.options, options, { isClone: true });
    var clone = new I18n(mergedOptions, callback);
    var membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(function (m) {
      clone[m] = _this7[m];
    });
    clone.translator = new es_Translator(clone.services, clone.options);
    clone.translator.on('*', function (event) {
      for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      clone.emit.apply(clone, [event].concat(args));
    });
    clone.init(mergedOptions, callback);

    return clone;
  };

  return I18n;
}(es_EventEmitter);

/* harmony default export */ var i18next = (new i18next_I18n());
// CONCATENATED MODULE: ../node_modules/cashier-payments-method-component/node_modules/i18next/dist/es/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeLanguage", function() { return changeLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneInstance", function() { return es_cloneInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createInstance", function() { return createInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dir", function() { return dir; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exists", function() { return es_exists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFixedT", function() { return getFixedT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return es_init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadLanguages", function() { return loadLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadNamespaces", function() { return loadNamespaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadResources", function() { return loadResources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "off", function() { return off; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "on", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDefaultNamespace", function() { return setDefaultNamespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return t; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "use", function() { return es_use; });


/* harmony default export */ var es = __webpack_exports__["default"] = (i18next);

var changeLanguage = i18next.changeLanguage.bind(i18next);
var es_cloneInstance = i18next.cloneInstance.bind(i18next);
var createInstance = i18next.createInstance.bind(i18next);
var dir = i18next.dir.bind(i18next);
var es_exists = i18next.exists.bind(i18next);
var getFixedT = i18next.getFixedT.bind(i18next);
var es_init = i18next.init.bind(i18next);
var loadLanguages = i18next.loadLanguages.bind(i18next);
var loadNamespaces = i18next.loadNamespaces.bind(i18next);
var loadResources = i18next.loadResources.bind(i18next);
var off = i18next.off.bind(i18next);
var on = i18next.on.bind(i18next);
var setDefaultNamespace = i18next.setDefaultNamespace.bind(i18next);
var t = i18next.t.bind(i18next);
var es_use = i18next.use.bind(i18next);

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(157).default;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(158);

var utils = _interopRequireWildcard(_utils);

var _ajax = __webpack_require__(159);

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getDefaults() {
  return {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    addPath: 'locales/add/{{lng}}/{{ns}}',
    allowMultiLoading: false,
    parse: JSON.parse,
    crossDomain: false,
    ajax: _ajax2.default
  };
}

var Backend = function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Backend);

    this.init(services, options);

    this.type = 'backend';
  }

  _createClass(Backend, [{
    key: 'init',
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.services = services;
      this.options = utils.defaults(options, this.options || {}, getDefaults());
    }
  }, {
    key: 'readMulti',
    value: function readMulti(languages, namespaces, callback) {
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath(languages, namespaces);
      }

      var url = this.services.interpolator.interpolate(loadPath, { lng: languages.join('+'), ns: namespaces.join('+') });

      this.loadUrl(url, callback);
    }
  }, {
    key: 'read',
    value: function read(language, namespace, callback) {
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath([language], [namespace]);
      }

      var url = this.services.interpolator.interpolate(loadPath, { lng: language, ns: namespace });

      this.loadUrl(url, callback);
    }
  }, {
    key: 'loadUrl',
    value: function loadUrl(url, callback) {
      var _this = this;

      this.options.ajax(url, this.options, function (data, xhr) {
        if (xhr.status >= 500 && xhr.status < 600) return callback('failed loading ' + url, true /* retry */);
        if (xhr.status >= 400 && xhr.status < 500) return callback('failed loading ' + url, false /* no retry */);

        var ret = void 0,
            err = void 0;
        try {
          ret = _this.options.parse(data, url);
        } catch (e) {
          err = 'failed parsing ' + url + ' to json';
        }
        if (err) return callback(err, false);
        callback(null, ret);
      });
    }
  }, {
    key: 'create',
    value: function create(languages, namespace, key, fallbackValue) {
      var _this2 = this;

      if (typeof languages === 'string') languages = [languages];

      var payload = {};
      payload[key] = fallbackValue || '';

      languages.forEach(function (lng) {
        var url = _this2.services.interpolator.interpolate(_this2.options.addPath, { lng: lng, ns: namespace });

        _this2.options.ajax(url, _this2.options, function (data, xhr) {
          //const statusCode = xhr.status.toString();
          // TODO: if statusCode === 4xx do log
        }, payload);
      });
    }
  }]);

  return Backend;
}();

Backend.type = 'backend';

exports.default = Backend;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaults = defaults;
exports.extend = extend;
var arr = [];
var each = arr.forEach;
var slice = arr.slice;

function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

function extend(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function addQueryString(url, params) {
  if (params && (typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
    var queryString = '',
        e = encodeURIComponent;

    // Must encode data
    for (var paramName in params) {
      queryString += '&' + e(paramName) + '=' + e(params[paramName]);
    }

    if (!queryString) {
      return url;
    }

    url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
  }

  return url;
}

// https://gist.github.com/Xeoncross/7663273
function ajax(url, options, callback, data, cache) {

  if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
    if (!cache) {
      data['_t'] = new Date();
    }
    // URL encoded form data must be in querystring format
    data = addQueryString('', data).slice(1);
  }

  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }

  try {
    var x;
    if (XMLHttpRequest) {
      x = new XMLHttpRequest();
    } else {
      x = new ActiveXObject('MSXML2.XMLHTTP.3.0');
    }
    x.open(data ? 'POST' : 'GET', url, 1);
    if (!options.crossDomain) {
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    }
    x.withCredentials = !!options.withCredentials;
    if (data) {
      x.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    }
    if (x.overrideMimeType) {
      x.overrideMimeType("application/json");
    }
    var h = options.customHeaders;
    if (h) {
      for (var i in h) {
        x.setRequestHeader(i, h[i]);
      }
    }
    x.onreadystatechange = function () {
      x.readyState > 3 && callback && callback(x.responseText, x);
    };
    x.send(data);
  } catch (e) {
    console && console.log(e);
  }
}

exports.default = ajax;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./messages_ar.json": 161,
	"./messages_bg.json": 162,
	"./messages_cs.json": 163,
	"./messages_da.json": 164,
	"./messages_de.json": 165,
	"./messages_el.json": 166,
	"./messages_en.json": 167,
	"./messages_es.json": 168,
	"./messages_fi.json": 169,
	"./messages_fr.json": 170,
	"./messages_he.json": 171,
	"./messages_hi.json": 172,
	"./messages_hu.json": 173,
	"./messages_id.json": 174,
	"./messages_it.json": 175,
	"./messages_ja.json": 176,
	"./messages_ko.json": 177,
	"./messages_ms.json": 178,
	"./messages_nl.json": 179,
	"./messages_no.json": 180,
	"./messages_pl.json": 181,
	"./messages_pt.json": 182,
	"./messages_ro.json": 183,
	"./messages_ru.json": 184,
	"./messages_sv.json": 185,
	"./messages_th.json": 186,
	"./messages_tl.json": 187,
	"./messages_tr.json": 188,
	"./messages_zh.json": 189,
	"./messages_zu.json": 190
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 160;

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"الرقم البريدي","firstName.input.label":"الاسم الأول","phone.input.error":"يُرجى إدخال رقم هاتف سارٍ","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"الدفع نقدًا","form.submit":"التأكيد والدفع","address.input.error":"يُرجى إدخال عنوان صحيح","countryCode.input.label":"البلد","settings.offlineTitleOption3":"الدفع نقدًا","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"الدفع نقدًا","zipCode.input.error":"يُرجى إدخال رمز بريدي سارٍ","payments.wallet.description":"عند النقر فوق \"{{payButtonLabel}}\"، ستتم إعادة توجيهك إلى {{paymentMethodLabel}} حيث يمكنك إنهاء عملية الشراء في أمان.","settings.offlineTitleOptionDefaultInstruction":"تعليمات الدفع من دون الاتصال الإنترنت","phone.input.label":"رقم الهاتف","street.input.label":"Street Name","button.pay.placeOrder":"ضع طلبًا","payments.offline.defaultInstructionText":"سنتصل بك في غضون الساعات الأربع والعشرين القادمة لتسوية عملية الدفع؛ وحتى ذلك الحين، يمكنك أن تقرر ما إذا كنت تفضّل معاملةً بنكية أو شيكًا!<br /><br />سنتحدث إليك قريبًا، ونتمنى لك يومًا عظيمًا!","cc.installments.singlePayment":"الدفع مرة واحدة","street.input.error":"Please enter a valid street name","email.input.error":"يُرجى إدخال بريد إلكتروني سارٍ","button.pay.buyNow":"اشترِ الآن","wallet.pay.with":"الدفع باستخدام","city.input.label":"المدينة","address.input.label":"العنوان","email.input.label":"البريد الإلكتروني","city.input.error":"يُرجى إدخال مدينة صحيحة","cc.load.error":"مزوّد خدمة الدفع غير متاح في الوقت الحالي. يُرجى تحديد مزود آخر أو التواصل مع صاحب موقع الويب.","firstName.input.error":"يُرجى إدخال اسم أول صحيح","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"يُرجى إدخال اسم أخير صحيح","state.input.error":"يُرجى إدخال ولاية صحيحة","countryCode.input.error":"يُرجى إدخال بلد صحيح","houseNumber.input.label":"House Number","cc.installments.title":"الأقساط","state.input.label":"حالة","lastName.input.label":"الاسم الأخير"}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"Пощенски код","firstName.input.label":"Собствено име","phone.input.error":"Моля, въведете валиден телефонен номер","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Платете офлайн","form.submit":"Потвърдете и платете","address.input.error":"Моля, въведете валиден адрес","countryCode.input.label":"Държава","settings.offlineTitleOption3":"Офлайн плащане","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Плащане в брой","zipCode.input.error":"Моля, въведете валиден пощенски код","payments.wallet.description":"Когато натиснете \\\"{{payButtonLabel}}\\\", ще бъдете пренасочени към {{paymentMethodLabel}} където можете да завършите покупката си сигурно.","settings.offlineTitleOptionDefaultInstruction":"Инструкция за офлайн плащане","phone.input.label":"Телефон","street.input.label":"Street Name","button.pay.placeOrder":"Направете поръчка","payments.offline.defaultInstructionText":"Ще ви се обадим през следващите 24 часа, за да одобрим плащането, дотогава можете да решите дали предпочитате банкова транзакция или чек!<br/><br/>До скоро, приятен ден!","cc.installments.singlePayment":"Еднократно плащане","street.input.error":"Please enter a valid street name","email.input.error":"Моля, въведете валиден имейл","button.pay.buyNow":"Купете сега","wallet.pay.with":"Платете с","city.input.label":"Град","address.input.label":"Адрес","email.input.label":"Имейл","city.input.error":"Моля. въведете валиден град","cc.load.error":"В момента този платежен метод не е наличен. Моля, изберете друг или се свържете със собственика на уебсайта.","firstName.input.error":"Моля, въведете валидно име","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Моля, въведете валидна фамилия","state.input.error":"Моля, въведете валиден щат","countryCode.input.error":"Моля, въведете валидна държава","houseNumber.input.label":"House Number","cc.installments.title":"Вноски","state.input.label":"Щат","lastName.input.label":"Фамилия"}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"PSČ","firstName.input.label":"Jméno","phone.input.error":"Zadejte prosím platné telefonní číslo","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Zaplatit offline","form.submit":"Potvrdit a zaplatit","address.input.error":"Zadejte prosím platnou adresu","countryCode.input.label":"Země","settings.offlineTitleOption3":"Offline platba","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Platba v hotovosti","zipCode.input.error":"Zadejte platné PSČ","payments.wallet.description":"Když kliknete na tlačítko „{{payButtonLabel}}“, budete přesměrováni na {{paymentMethodLabel}}, kde můžete bezpečně dokončit platbu.","settings.offlineTitleOptionDefaultInstruction":"Instrukce pro offline platbu","phone.input.label":"Telefonní číslo","street.input.label":"Street Name","button.pay.placeOrder":"ODESLAT OBJEDNÁVKU","payments.offline.defaultInstructionText":"Během následujících 24 hodin vám zavoláme pro dokončení platby. Do té doby se můžete rozhodnout, zda chcete platit bankovním převodem nebo použít šek!<br/><br/>Brzy na slyšenou. Přejeme hezký den!","cc.installments.singlePayment":"Jednorázová platba","street.input.error":"Please enter a valid street name","email.input.error":"Zadejte, prosím, platný e-mail","button.pay.buyNow":"Koupit nyní","wallet.pay.with":"Platit přes","city.input.label":"Město","address.input.label":"Adresa","email.input.label":"E-mail","city.input.error":"Zadejte prosím platné město","cc.load.error":"Tento způsob platby není momentálně dostupný. Vyberte prosím jiný nebo kontaktujte majitele stránek.","firstName.input.error":"Zadejte prosím platné jméno","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Zadejte prosím platné příjmení","state.input.error":"Zadejte prosím platný stát","countryCode.input.error":"Zadejte prosím platnou zemi","houseNumber.input.label":"House Number","cc.installments.title":"Splátky","state.input.label":"Stát/provincie","lastName.input.label":"Příjmení"}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"Postnummer","firstName.input.label":"Fornavn","phone.input.error":"Indtast venligst et gyldigt telefonnummer","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Betal offline","form.submit":"Bekræft og betal","address.input.error":"Venligst indtast en gyldig adresse","countryCode.input.label":"Land","settings.offlineTitleOption3":"Offlinebetaling","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Kontant","zipCode.input.error":"Indtast venligst et gyldigt postnummer","payments.wallet.description":"Når du klikker på \"{{payButtonLabel}}\", bliver du omdirigeret til {{paymentMethodLabel}}. Her kan du fuldføre betalingen sikkert.","settings.offlineTitleOptionDefaultInstruction":"Instruktioner til offlinebetaling","phone.input.label":"Telefonnummer","street.input.label":"Street Name","button.pay.placeOrder":"Afgiv ordre","payments.offline.defaultInstructionText":"Vi ringer til dig indenfor de næste 24 timer for at udligne betalingen. Indtil den tid, kan du bestemme, om du foretrækker betaling via banktransaktion eller check!<br/><br/>Vi tales ved. Med venlig hilsen!","cc.installments.singlePayment":"En betaling","street.input.error":"Please enter a valid street name","email.input.error":"Indtast venligst en gyldig e-mail","button.pay.buyNow":"Køb nu","wallet.pay.with":"Betal med","city.input.label":"By","address.input.label":"Adresse","email.input.label":"E-mail","city.input.error":"Indtast venligst en gyldig by","cc.load.error":"Denne betalingsudbyder er ikke tilgængelig i øjeblikket. Vælg venligst en anden, eller kontakt hjemmesidens ejer.","firstName.input.error":"Indtast venligst et gyldigt fornavn","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Indtast venligst et gyldigt efternavn","state.input.error":"Indtast venligst et gyldigt område","countryCode.input.error":"Indtast venligst et gyldigt land","houseNumber.input.label":"House Number","cc.installments.title":"Rater","state.input.label":"Land","lastName.input.label":"Efternavn"}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"PLZ","firstName.input.label":"Vorname","phone.input.error":"Bitte gebe eine gültige Telefonnummer ein","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Offline zahlen","form.submit":"Bestätigen und Kostenpflichtig bestellen","address.input.error":"Bitte geben Sie eine gültige Adresse ein","countryCode.input.label":"Land","settings.offlineTitleOption3":"Offline-Zahlung","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Vorkasse","zipCode.input.error":"Bitte geben Sie eine gültige Postleitzahl ein","payments.wallet.description":"Wenn Sie auf \"{{payButtonLabel}}\" klicken, werden Sie zu {{paymentMethodLabel}} weitergeleitet, wo Sie Ihren Einkauf sicher abschließen können.","settings.offlineTitleOptionDefaultInstruction":"Anleitung für Offline-Zahlungen","phone.input.label":"Telefonnummer","street.input.label":"Street Name","button.pay.placeOrder":"Kostenpflichtig bestellen","payments.offline.defaultInstructionText":"Wir rufen Sie innerhalb von 24 Std. an, um die Zahlung zu begleichen. Bis dahin können Sie entscheiden, ob Sie eine Banküberweisung oder einen Scheck als Zahlungsmittel bevorzugen!<br/><br/>Bis bald und einen schönen Tag!","cc.installments.singlePayment":"Einmalige Zahlung","street.input.error":"Please enter a valid street name","email.input.error":"Bitte geben Sie eine gültige E-Mail-Adresse ein","button.pay.buyNow":"Jetzt kaufen","wallet.pay.with":"Bezahlen mit","city.input.label":"Stadt","address.input.label":"Adresse","email.input.label":"E-Mail-Adresse","city.input.error":"Bitte geben Sie eine gültigen Stadt ein","cc.load.error":"Dieser Zahlungsmethode ist zur Zeit nicht verfügbar. Bitte wählen Sie eine andere oder kontaktieren Sie den Website-Eigentümer.","firstName.input.error":"Bitte geben Sie einen gültigen Vornamen ein","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Bitte geben Sie einen gültigen Nachnamen ein","state.input.error":"Bitte geben Sie ein gültiges Bundesland ein","countryCode.input.error":"Bitte geben Sie ein gültiges Land ein","houseNumber.input.label":"House Number","cc.installments.title":"Ratenzahlungen","state.input.label":"Bundesstaat","lastName.input.label":"Nachname"}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"Ταχυδρομικός Κώδικας","firstName.input.label":"Όνομα","phone.input.error":"Παρακαλούμε πληκτρολογήστε έναν έγκυρο αριθμό τηλεφώνου","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Πληρωμή εκτός διαδικτύου","form.submit":"Επιβεβαίωση και πληρωμή","address.input.error":"Παρακαλούμε πληκτρολογήστε μια έγκυρη διεύθυνση","countryCode.input.label":"Χώρα","settings.offlineTitleOption3":"Πληρωμή εκτός διαδικτύου","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Πληρωμή με μετρητά","zipCode.input.error":"Παρακαλούμε πληκτρολογήστε έναν έγκυρο ταχυδρομικό κώδικα","payments.wallet.description":"Όταν πατήσετε \\\"{{payButtonLabel}}\\\" θα μεταφερθείτε στο {{paymentMethodLabel}} όπου μπορείτε να ολοκληρώσετε την αγορά σας με ασφάλεια.","settings.offlineTitleOptionDefaultInstruction":"Οδηγίες πληρωμής εκτός διαδικτύου","phone.input.label":"Αριθμός τηλεφώνου","street.input.label":"Street Name","button.pay.placeOrder":"ΔΩΣΤΕ ΤΗΝ ΠΑΡΑΓΓΕΛΙΑ","payments.offline.defaultInstructionText":"Θα σας καλέσουμε στις επόμενες 24 ώρες για να κανονίσουμε την πληρωμή, μέχρι τότε μπορείτε να αποφασίσετε εάν προτιμάτε μια τραπεζική συναλλαγή ή επιταγή!<br/><br/>Θα τα πούμε σύντομα, καλή σας μέρα!","cc.installments.singlePayment":"Εφάπαξ Πληρωμή","street.input.error":"Please enter a valid street name","email.input.error":"Παρακαλούμε πληκτρολογήστε ένα έγκυρο email","button.pay.buyNow":"Αγορά τώρα","wallet.pay.with":"Πληρωμή με","city.input.label":"Πόλη","address.input.label":"Διεύθυνση","email.input.label":"Ε-mail","city.input.error":"Παρακαλούμε πληκτρολογήστε μια έγκυρη πόλη","cc.load.error":"Αυτός ο τρόπος πληρωμής δεν είναι διαθέσιμος αυτή τη στιγμή. Παρακαλούμε επιλέξτε διαφορετικό τρόπο πληρωμής ή επικοινωνήστε με τον κάτοχο του ιστοτόπου.","firstName.input.error":"Παρακαλούμε πληκτρολογήστε ένα έγκυρο όνομα","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Παρακαλούμε πληκτρολογήστε ένα έγκυρο όνομα","state.input.error":"Παρακαλούμε πληκτρολογήστε μια έγκυρη πολιτεία","countryCode.input.error":"Παρακαλούμε πληκτρολογήστε μα έγκυρη χώρα","houseNumber.input.label":"House Number","cc.installments.title":"Δόσεις","state.input.label":"Πολιτεία","lastName.input.label":"Επώνυμο"}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports = {"form.submit":"Confirm and Pay","settings.offlineTitleOptionDefault":"Pay Offline","settings.offlineTitleOption3":"Offline Payment","settings.offlineTitleOption2":"Cash Payment","settings.offlineTitleOptionDefaultInstruction":"Pay Offline Instruction","payments.offline.defaultInstructionText":"We’ll call you in the next 24 hours to settle the payment, until then you can decide if you prefer a bank transaction or a check!<br/><br/>Talk to you soon, have a great day!","cc.installments.singlePayment":"Single Payment","wallet.pay.with":"Pay with","cc.load.error":"This payment method is not available at the moment. Please select a different one or contact the website owner.","cc.installments.title":"Installments","button.pay.placeOrder":"Place Order","button.pay.buyNow":"Buy Now","payments.wallet.description":"When you hit \"{{payButtonLabel}}\" you will be redirected to {{paymentMethodLabel}} where you can complete your purchase securely.","email.input.label":"Email","email.input.error":"Please enter a valid email","firstName.input.label":"First Name","firstName.input.error":"Please enter a valid first name","lastName.input.label":"Last Name","lastName.input.error":"Please enter a valid last name","address.input.label":"Address","address.input.error":"Please enter a valid address","city.input.label":"City","city.input.error":"Please enter a valid city","countryCode.input.label":"Country","countryCode.input.error":"Please enter a valid country","state.input.label":"State","state.input.error":"Please enter a valid state","zipCode.input.label":"Zip / Postal Code","zipCode.input.error":"Please enter a valid zip / postal code","holderId.input.label":"CPF / CPFJ","holderId.input.error":"Please enter a valid CPF/ CPFJ","street.input.label":"Street Name","street.input.error":"Please enter a valid street name","houseNumber.input.label":"House Number","houseNumber.input.error":"Please enter a valid house number","phone.input.label":"Phone Number","phone.input.error":"Please enter a valid phone number"}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"Código postal","firstName.input.label":"Nombre","phone.input.error":"Por favor, ingresa un número de teléfono válido","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Pagar offline","form.submit":"Confirmar y pagar","address.input.error":"Por favor, ingresa una dirección válida","countryCode.input.label":"País","settings.offlineTitleOption3":"Pago Offline","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Pago en efectivo","zipCode.input.error":"Por favor ingresa un código postal válido","payments.wallet.description":"Al hacer clic en {{payButtonLabel}} serás redirigido a {{paymentMethodLabel}} donde puedes completar tu compra de manera segura.","settings.offlineTitleOptionDefaultInstruction":"Instrucciones para pagar offline","phone.input.label":"Número telefónico","street.input.label":"Street Name","button.pay.placeOrder":"Realizar pedido","payments.offline.defaultInstructionText":"Te llamaremos en las próximas 24 horas para concretar el pago, hasta entonces puedes decidir si prefieres una transacción bancaria o un cheque. <br/><br/>Te llamaremos pronto, que tengas un buen día.","cc.installments.singlePayment":"Pago único","street.input.error":"Please enter a valid street name","email.input.error":"Por favor ingresa un email válido","button.pay.buyNow":"Comprar Ahora","wallet.pay.with":"Pagar con","city.input.label":"Ciudad","address.input.label":"Dirección","email.input.label":"Email","city.input.error":"Por favor ingresa una ciudad válida","cc.load.error":"Este método de pago no está disponible en este momento. Por favor, selecciona uno diferente o contacta al propietario del sitio.","firstName.input.error":"Por favor, ingresa un primer nombre válido","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Por favor ingresa un apellido válido","state.input.error":"Por favor ingresa un estado válido","countryCode.input.error":"Por favor ingresa un país válido","houseNumber.input.label":"House Number","cc.installments.title":"Plazos","state.input.label":"Estado","lastName.input.label":"Apellido"}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"Postinumero","firstName.input.label":"Etunimi","phone.input.error":"Anna voimassa oleva puhelinnumero","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Maksa offline-tilassa","form.submit":"Vahvista ja maksa","address.input.error":"Anna oikea osoite","countryCode.input.label":"Maa","settings.offlineTitleOption3":"Offline-maksu","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Käteismaksu","zipCode.input.error":"Anna oikea postinumero","payments.wallet.description":"Kun klikkaat \\\"{{payButtonLabel}}\\\", sinut ohjataan {{paymentMethodLabel}} jossa voit suorittaa ostoksesi turvallisesti.","settings.offlineTitleOptionDefaultInstruction":"Offline-maksuohjeet","phone.input.label":"Puhelinnumero","street.input.label":"Street Name","button.pay.placeOrder":"Tee tilaus","payments.offline.defaultInstructionText":"Soitamme sinulle 24 tunnin kuluessa maksun suorittamista varten. Sinulla on siihen asti aikaa päättää, haluatko maksaa pankkitilin kautta vai laskulla!<br/><br/>Kuullaan pian, hyvää päivän jatkoa!","cc.installments.singlePayment":"Kertamaksu","street.input.error":"Please enter a valid street name","email.input.error":"Anna voimassa oleva sähköpostiosoite","button.pay.buyNow":"Osta nyt","wallet.pay.with":"Maksa","city.input.label":"Kaupunki","address.input.label":"Osoite","email.input.label":"Sähköposti","city.input.error":"Anna oikea kaupunki","cc.load.error":"Tämä maksutapa ei ole juuri nyt käytettävissä. Ole hyvä ja valitse toinen maksutapa tai ota yhteyttä sivuston omistajaan.","firstName.input.error":"Anna oikea etunimi","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Anna oikea sukunimi","state.input.error":"Anna oikea osavaltio","countryCode.input.error":"Anna oikea maa","houseNumber.input.label":"House Number","cc.installments.title":"Maksuerät","state.input.label":"Osavaltio","lastName.input.label":"Sukunimi"}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"Code Postal","firstName.input.label":"Prénom","phone.input.error":"Veuillez saisir un numéro de téléphone valide","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Payer hors-ligne","form.submit":"Confirmer et payer","address.input.error":"Veuillez saisir une adresse valide","countryCode.input.label":"État","settings.offlineTitleOption3":"Paiement hors-ligne","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Paiement en espèces","zipCode.input.error":"Veuillez saisir un code postal valide","payments.wallet.description":"En cliquant sur \"{{payButtonLabel}}\" vous serez redirigé vers {{paymentMethodLabel}}. Vous pourrez compléter votre paiement en toute sécurité.","settings.offlineTitleOptionDefaultInstruction":"Instructions paiement hors ligne","phone.input.label":"Numéro de téléphone","street.input.label":"Street Name","button.pay.placeOrder":"Commandez","payments.offline.defaultInstructionText":"Nous vous appellerons dans les 24 heures pour régler le paiement. En attendant, décidez si vous préférez payer par virement bancaire ou par chèque !<br/><br/>À bientôt, et bonne journée !","cc.installments.singlePayment":"Paiement unique","street.input.error":"Please enter a valid street name","email.input.error":"Veuillez saisir un e-mail valide","button.pay.buyNow":"Acheter Maintenant","wallet.pay.with":"Payer avec","city.input.label":"Ville","address.input.label":"Adresse","email.input.label":"E-mail","city.input.error":"Veuillez saisir une ville valide","cc.load.error":"Ce moyen de paiement n'est pas disponible pour le moment. Veuillez choisir un autre moyen de paiement ou contactez le propriétaire du site.","firstName.input.error":"Veuillez saisir un prénom valide","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Veuillez saisir un nom valide","state.input.error":"Veuillez saisir un état valide","countryCode.input.error":"Veuillez saisir un pays valide","houseNumber.input.label":"House Number","cc.installments.title":"Mensualités","state.input.label":"État","lastName.input.label":"Nom de famille"}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"מיקוד","firstName.input.label":"שם פרטי","phone.input.error":"אנא הזן מספר טלפון תקף","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"שלם באופן לא-מקוון","form.submit":"אשר ושלם","address.input.error":"אנא הזן כתובת חוקית","countryCode.input.label":"מדינה","settings.offlineTitleOption3":"תשלום לא-מקוון","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"תשלום במזומן","zipCode.input.error":"אנא הזן מיקוד חוקי","payments.wallet.description":"כשתלחץ על \\\"{{payButtonLabel}}\\\", תופנה אל {{paymentMethodLabel}} היכן שתוכל להשלים את רכישתך באופן מאובטח.","settings.offlineTitleOptionDefaultInstruction":"הוראות לתשלום לא-מקוון","phone.input.label":"מספר טלפון","street.input.label":"Street Name","button.pay.placeOrder":"בצע הזמנה","payments.offline.defaultInstructionText":"נתקשר אליך במהלך 24 השעות הקרובות כדי להסדיר את התשלום, ועד אז תוכל להחליט אם אתה מעדיף לשלם באמצעות העברה בנקאית או באמצעות המחאה <br/><br/>נהיה בקשר בקרוב, שיהיה לך יום מעולה!","cc.installments.singlePayment":"תשלום אחד","street.input.error":"Please enter a valid street name","email.input.error":"אנא הזן כתובת דוא\"ל תקינה","button.pay.buyNow":"קנה עכשיו","wallet.pay.with":"שלם באמצעות","city.input.label":"עיר","address.input.label":"כתובת","email.input.label":"כתובת אימייל ","city.input.error":"אנא הזן שם עיר חוקי","cc.load.error":"שיטת תשלום זו אינה זמינה כרגע. אנא בחר שיטה אחרת או צור קשר עם בעל האתר.","firstName.input.error":"אנא הזן שם פרטי חוקי","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"אנא הזן שם משפחה חוקי","state.input.error":"אנא הזן שם מדינה חוקי","countryCode.input.error":"אנא הזן שם מדינה חוקי","houseNumber.input.label":"House Number","cc.installments.title":"תשלומים","state.input.label":"מדינה","lastName.input.label":"שם משפחה"}

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"ज़िप/डाक कोड","firstName.input.label":"प्रथम नाम","phone.input.error":"एक वैध फ़ोन नंबर प्रविष्ट करें","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"ऑफलाइन भुगतान करें","form.submit":"पुष्टि करें और भुगतान करें","address.input.error":"कृपया मान्य पता प्रविष्ट करें","countryCode.input.label":"देश","settings.offlineTitleOption3":"ऑफलाइन भुगतान","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"नकद भुगतान","zipCode.input.error":"कृपया मान्य ज़िप / डाक कोड प्रविष्ट करें","payments.wallet.description":"जब आप \"{{payButtonLabel}}\" को दबाते हैं तब आपको {{paymentMethodLabel}} पर रीडायरेक्ट कर दिया जाएगा जहाँ सुरक्षित रूप से आप अपनी खरीद पूरी कर सकते हैं।","settings.offlineTitleOptionDefaultInstruction":"ऑफलाइन भुगतान करने के निर्देश","phone.input.label":"फोन नंबर","street.input.label":"Street Name","button.pay.placeOrder":"ऑर्डर प्लेस करें","payments.offline.defaultInstructionText":"भुगतान का निपटारा करने के लिए हम अगले 24 घंटों में आपको कॉल करेंगे, तब तक आप निर्णय लें कि आपको बैंक लेनदेन पसंद है या चेक!<br/><br/>शीघ्र ही आप से बात करेंगे, आपका दिन शुभ हो!","cc.installments.singlePayment":"एकल भुगतान","street.input.error":"Please enter a valid street name","email.input.error":"कृपया एक मान्य ईमेल प्रविष्ट करें","button.pay.buyNow":"अभी खरीदें","wallet.pay.with":"के साथ भुगतान करें","city.input.label":"शहर","address.input.label":"पता","email.input.label":"ईमेल","city.input.error":"कृपया मान्य शहर प्रविष्ट करें","cc.load.error":"यह भुगतान प्रदाता फिलहाल उपलब्ध नहीं है। कृपया किसी अन्य भुगतान प्रदाता का चयन करें या वेबसाइट के मालिक से संपर्क करें।","firstName.input.error":"कृपया मान्य प्रथम नाम प्रविष्ट करें","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"कृपया मान्य अंतिम नाम प्रविष्ट करें","state.input.error":"कृपया मान्य राज्य प्रविष्ट करें","countryCode.input.error":"कृपया कोई वैध देश प्रविष्ट करें","houseNumber.input.label":"House Number","cc.installments.title":"किश्तें","state.input.label":"राज्य","lastName.input.label":"अंतिम नाम"}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"Postai irányítószám","firstName.input.label":"Utónév","phone.input.error":"Adj meg egy érvényes telefonszámot","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Fizetés offline módon","form.submit":"Jóváhagyás és fizetés","address.input.error":"Adj meg egy érvényes címet","countryCode.input.label":"Ország","settings.offlineTitleOption3":"Offline fizetés","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Készpénzes fizetés","zipCode.input.error":"Adj meg egy érvényes postai irányítószámot","payments.wallet.description":"Miután megnyomtad a \\\"{{payButtonLabel}}\\\" gombot, átirányítunk ide {{paymentMethodLabel}} ahol biztonságosan be tudod fejezni a fizetést.","settings.offlineTitleOptionDefaultInstruction":"Hagyományos (nem online) fizetés menete","phone.input.label":"Telefonszám","street.input.label":"Street Name","button.pay.placeOrder":"Rendelés feladása","payments.offline.defaultInstructionText":"A következő 24 órában telefonon felhívunk a fizetés véglegesítéséhez. Addig is döntsd el, hogy banki átutalással vagy csekkel fizetsz!<br/><br/>Szép napot kívánunk, a viszonthallásra!","cc.installments.singlePayment":"Egyszeri fizetés","street.input.error":"Please enter a valid street name","email.input.error":"Adj meg egy érvényes e-mail címet","button.pay.buyNow":"Vásárlás most!","wallet.pay.with":"Fizetési mód:","city.input.label":"Település","address.input.label":"Cím","email.input.label":"E-mail","city.input.error":"Adj meg egy érvényes települést","cc.load.error":"Ez a fizetési mód jelenleg nem érhető el. Válassz egy másik fizetési módot, vagy vedd fel a kapcsolatot a honlap tulajdonosával!","firstName.input.error":"Adj meg egy érvényes utónevet","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Adj meg egy érvényes családnevet","state.input.error":"Adj meg egy érvényes közigazgatási egységet (állam, megye stb.)","countryCode.input.error":"Adj meg egy érvényes országot","houseNumber.input.label":"House Number","cc.installments.title":"Részletfizetések","state.input.label":"Állam","lastName.input.label":"Családnév"}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"Kode Pos","firstName.input.label":"Nama Depan","phone.input.error":"Masukkan nomor telepon yang valid","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Bayar Offline","form.submit":"Tegaskan dan Bayar","address.input.error":"Masukkan alamat yang absah","countryCode.input.label":"Negara","settings.offlineTitleOption3":"Pembayaran Online","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Pembayaran Tunai","zipCode.input.error":"Masukkan kode zip / kode pos yang absah","payments.wallet.description":"Saat Anda menekan \\\"{{payButtonLabel}}\\\" Anda akan diarahkan ke {{paymentMethodLabel}} tempat Anda dapat menyelesaikan pembelian Anda dengan aman.","settings.offlineTitleOptionDefaultInstruction":"Petunjuk Pembayaran Offline","phone.input.label":"Nomor Telepon","street.input.label":"Street Name","button.pay.placeOrder":"Pesan","payments.offline.defaultInstructionText":"Kami akan menghubungi Anda dalam 24 jam mendatang untuk menyelesaikan pembayaran, sebelum itu, Anda dapat memilih apakah akan menerima transaksi bank atau cek!<br/><br/>Sampai nanti, semoga hari Anda menyenangkan!","cc.installments.singlePayment":"Pembayaran Tunggal","street.input.error":"Please enter a valid street name","email.input.error":"Masukkan email yang valid","button.pay.buyNow":"Beli Sekarang","wallet.pay.with":"Bayar dengan","city.input.label":"Kota","address.input.label":"Alamat","email.input.label":"Email","city.input.error":"Masukkan kota yang absah","cc.load.error":"Metode pembayaran ini tidak tersedia saat ini. Mohon pilih metode berbeda atau hubungi pemilik situs.","firstName.input.error":"Masukkan nama depan yang absah","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Masukkan nama belakang yang absah","state.input.error":"Masukkan negara bagian yang absah","countryCode.input.error":"Masukkan negara yang absah","houseNumber.input.label":"House Number","cc.installments.title":"Cicilan","state.input.label":"Negara Bagian","lastName.input.label":"Nama Belakang"}

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"Cap","firstName.input.label":"Nome","phone.input.error":"Inserisci un valido numero di tel.","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Paga offline","form.submit":"Conferma e paga","address.input.error":"Inserisci un indirizzo valido","countryCode.input.label":"Paese","settings.offlineTitleOption3":"Pagamento offline","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Pagamento in contanti","zipCode.input.error":"Inserisci un codice postale","payments.wallet.description":"Quando clicchi su \\\"{{payButtonLabel}}\\\" verrai reindirizzato a {{paymentMethodLabel}} dove potrai completare il tuo acquisto in modo sicuro.","settings.offlineTitleOptionDefaultInstruction":"Istruzioni per pagamento offline","phone.input.label":"Numero di telefono","street.input.label":"Street Name","button.pay.placeOrder":"EFFETTUA ORDINE","payments.offline.defaultInstructionText":"Ti contatteremo entro le prossime 24 ore per accordare il pagamento, nel frattempo puoi decidere se pagare tramite bonifico o assegno bancario!<br/><br/>Nell'attesa, ti auguriamo una buona giornata!","cc.installments.singlePayment":"Pagamento singolo","street.input.error":"Please enter a valid street name","email.input.error":"Inserisci un indirizzo email valido","button.pay.buyNow":"Acquista ora","wallet.pay.with":"Paga con","city.input.label":"Città","address.input.label":"Indirizzo","email.input.label":"Email","city.input.error":"Inserisci una città","cc.load.error":"Questo metodo di pagamento non è al momento disponibile. Selezionane un altro o contatta il proprietario del sito.","firstName.input.error":"Inserisci un nome","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Inserisci un cognome","state.input.error":"Inserisci uno stato","countryCode.input.error":"Inserisci un paese","houseNumber.input.label":"House Number","cc.installments.title":"Rate","state.input.label":"Stato","lastName.input.label":"Cognome"}

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"郵便番号","firstName.input.label":"姓","phone.input.error":"有効な電話番号を入力してください","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"オフラインでのお支払い","form.submit":"支払う","address.input.error":"有効なアドレスを入力してください","countryCode.input.label":"国","settings.offlineTitleOption3":"オフライン決済","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"代金引換","zipCode.input.error":"有効な郵便番号を入力してください","payments.wallet.description":"お支払い情報の入力が完了し「{{payButtonLabel}}」をクリックすると、{{paymentMethodLabel}} の決済手続きページにリダイレクトされます。","settings.offlineTitleOptionDefaultInstruction":"オフライン決済方法","phone.input.label":"電話番号","street.input.label":"Street Name","button.pay.placeOrder":"オーダーを送信","payments.offline.defaultInstructionText":"1営業日以内に決済に関する内容を電話でご連絡いたします。決済は銀行振込または小切手で行うことができます。ご連絡まで少々お待ち下さい。","cc.installments.singlePayment":"一括払い","street.input.error":"Please enter a valid street name","email.input.error":"有効なメールアドレスを入力してください","button.pay.buyNow":"購入する","wallet.pay.with":"お支払い方法：","city.input.label":"市区町村","address.input.label":"住所","email.input.label":"メールアドレス","city.input.error":"有効な市町村名を入力してください","cc.load.error":"この決済方法は現在利用いただけません。別の決済方法をご利用になるか、サイト管理者にご連絡ください。","firstName.input.error":"有効な名前を入力してください","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"有効な名字を入力してください","state.input.error":"有効な都道府県名を入力してください","countryCode.input.error":"有効な国名を入力してください","houseNumber.input.label":"House Number","cc.installments.title":"分割払い","state.input.label":"都道府県","lastName.input.label":"名"}

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"우편번호","firstName.input.label":"이름","phone.input.error":"유효한 전화번호를 입력하세요.","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"오프라인 결제","form.submit":"금액확인 및 결제","address.input.error":"올바른 주소를 입력하세요.","countryCode.input.label":"국가","settings.offlineTitleOption3":"오프라인 결제","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"현금결제","zipCode.input.error":"유효한 우편번호를 입력하세요.","payments.wallet.description":"\"{{payButtonLabel}}\" 클릭 시 안전하게 결제를 완료할 수 있는 {{paymentMethodLabel}} 페이지로 이동합니다.","settings.offlineTitleOptionDefaultInstruction":"오프라인 결제 지침","phone.input.label":"전화번호","street.input.label":"Street Name","button.pay.placeOrder":"주문","payments.offline.defaultInstructionText":"결제 완료를 위해 24시간 내에 연락드리도록 하겠습니다. <br />연락 전까지 결제 시 사용될 은행 계좌이체 또는 수표 정보를<br /> 미리 준비해주시면 감사하겠습니다.","cc.installments.singlePayment":"일시불로 지불","street.input.error":"Please enter a valid street name","email.input.error":"유효한 이메일 주소를 입력하세요.","button.pay.buyNow":"선택","wallet.pay.with":"결제방법:","city.input.label":"시/군/구를 입력하세요.","address.input.label":"주소","email.input.label":"이메일을 입력하세요.","city.input.error":"유효한 도시를 입력하세요.","cc.load.error":"일시적으로 해당 결제업체 서비스를 제공할 수 없습니다. 다른 결제방법을 선택하거나 해당 업체 사이트로 문의해주세요.","firstName.input.error":"유효한 이름을 입력하세요.","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"유효한 성을 입력하세요.","state.input.error":"유효한 지역을 입력하세요.","countryCode.input.error":"유효한 국가를 입력하세요.","houseNumber.input.label":"House Number","cc.installments.title":"할부","state.input.label":"주","lastName.input.label":"성"}

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"Poskod","firstName.input.label":"Nama Pertama","phone.input.error":"Sila masukkan nombor telefon yang sah","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Bayar Luar Talian","form.submit":"Sahkan dan Bayar","address.input.error":"Sila masukkan alamat yang sah","countryCode.input.label":"Negara","settings.offlineTitleOption3":"Pembayaran Luar Talian","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Pembayaran Tunai","zipCode.input.error":"Sila masukkan poskod yang sah","payments.wallet.description":"Apabila anda tekan \\\"{{payButtonLabel}}\\\" anda akan dibawa ke {{paymentMethodLabel}} di mana anda boleh melengkapkan pembelian anda dengan selamat.","settings.offlineTitleOptionDefaultInstruction":"Arahan Pembayaran Luar Talian","phone.input.label":"Nombor Telefon","street.input.label":"Street Name","button.pay.placeOrder":"Membuat Pesanan","payments.offline.defaultInstructionText":"Kami akan menghubungi anda dalam tempoh 24 jam untuk menyelesaikan pembayaran, sementara itu anda boleh menentukan jika anda lebih suka transaksi bank atau cek!<br/><br/>Anda akan dihubungi sebentar nanti, salam hormat!","cc.installments.singlePayment":"Pembayaran Tunggal","street.input.error":"Please enter a valid street name","email.input.error":"Sila masukkan e-mel yang sah","button.pay.buyNow":"Beli Sekarang","wallet.pay.with":"Bayar dengan","city.input.label":"Bandar","address.input.label":"Alamat","email.input.label":"E-mel","city.input.error":"Sila masukkan bandar yang sah","cc.load.error":"Kaedah pembayaran ini tidak tersedia pada masa ini. Sila pilih kaedah yang lain atau hubungi pemilik laman web.","firstName.input.error":"Sila masukkan nama pertama yang sah","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Sila masukkan nama bapa yang sah","state.input.error":"Sila masukkan negeri yang sah","countryCode.input.error":"Sila masukkan negara yang sah","houseNumber.input.label":"House Number","cc.installments.title":"Ansuran","state.input.label":"Negeri","lastName.input.label":"Nama Akhir"}

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"Postcode","firstName.input.label":"Voornaam","phone.input.error":"Vul een geldig telefoonnummer in","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Offline betalen","form.submit":"Bevestigen en betalen","address.input.error":"Vul een geldig adres in","countryCode.input.label":"Land","settings.offlineTitleOption3":"Offline betalen","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Contante betaling","zipCode.input.error":"Vul een geldige postcode in","payments.wallet.description":"Als u op \"{{payButtonLabel}}\" klikt wordt u doorgestuurd naar {{paymentMethodLabel}} waar u uw aankoop veilig kunt afronden.","settings.offlineTitleOptionDefaultInstruction":"Instructie voor offline betalen","phone.input.label":"Telefoonnummer","street.input.label":"Street Name","button.pay.placeOrder":"Bestelling plaatsen","payments.offline.defaultInstructionText":"We bellen u in de komende 24 uur om de betalingen af te ronden. U kunt tot dan kiezen voor bankoverschrijving of cheque.<br/><br/>Fijne dag!","cc.installments.singlePayment":"Alles ineens","street.input.error":"Please enter a valid street name","email.input.error":"Vul een geldig e-mailadres in","button.pay.buyNow":"Nu kopen","wallet.pay.with":"Betaal met","city.input.label":"Stad","address.input.label":"Adres","email.input.label":"E-mailadres","city.input.error":"Vul een geldige stad in","cc.load.error":"Deze betaalmethode is momenteel niet beschikbaar. Kies een andere betaalmethode of neem contact op met de eigenaar van de website.","firstName.input.error":"Vul een geldige voornaam in","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Vul een geldige achternaam in","state.input.error":"Vul een geldige staat in","countryCode.input.error":"Vul een geldig land in","houseNumber.input.label":"House Number","cc.installments.title":"Afbetalingen","state.input.label":"Staat","lastName.input.label":"Achternaam"}

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"Postnummer","firstName.input.label":"Fornavn","phone.input.error":"Vennligst oppgi et gyldig telefonnummer","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Betal offline","form.submit":"Bekreft og betal","address.input.error":"Angi en gyldig adresse","countryCode.input.label":"Land","settings.offlineTitleOption3":"Betaling offline","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Betal kontant","zipCode.input.error":"Vennligst oppgi et gyldig postnummer","payments.wallet.description":"Når du klikker på \"{{payButtonLabel}}\" vil du bli omdirigert til {{paymentMethodLabel}} hvor du kan fullføre kjøpet sikkert.","settings.offlineTitleOptionDefaultInstruction":"Instruksjoner for betaling offline","phone.input.label":"Telefon","street.input.label":"Street Name","button.pay.placeOrder":"Gjennomfør ordre","payments.offline.defaultInstructionText":"Vi ringer deg i løpet av de neste 24 timene angående betaling, og inntil da kan du bestemme om du ønsker en banktransaksjon eller en sjekk!<br/><br/>Vi snakkes snart, ha en flott dag!","cc.installments.singlePayment":"En enkelt betaling","street.input.error":"Please enter a valid street name","email.input.error":"Angi en gyldig e-postadresse","button.pay.buyNow":"Kjøp nå","wallet.pay.with":"Betal med","city.input.label":"By","address.input.label":"Adresse","email.input.label":"E-post","city.input.error":"Vennligst oppgi en gyldig by","cc.load.error":"Betalingsleverandøren er ikke tilgjengelig for øyeblikket. Velg en annen eller kontakt eieren av nettstedet.","firstName.input.error":"Vennligst oppgi et gyldig fornavn","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Vennligst oppgi et gyldig etternavn","state.input.error":"Vennligst oppgi et gyldig fylke","countryCode.input.error":"Vennligst oppgi et gyldig land","houseNumber.input.label":"House Number","cc.installments.title":"Avdrag","state.input.label":"Stat","lastName.input.label":"Etternavn"}

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"Kod pocztowy","firstName.input.label":"Imię","phone.input.error":"Wprowadź prawidłowy numer telefonu","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Zapłać poza siecią","form.submit":"Potwierdź i zapłać","address.input.error":"Wprowadź poprawny adres","countryCode.input.label":"Kraj","settings.offlineTitleOption3":"Płatności poza siecią","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Płatność Gotówką","zipCode.input.error":"Wprowadź prawidłowy kod pocztowy","payments.wallet.description":"Po kliknięciu \"{{payButtonLabel}}\" zostaniesz przekierowany do {{paymentMethodLabel}}, gdzie możesz bezpiecznie dokonać zakupu.","settings.offlineTitleOptionDefaultInstruction":"Instrukcje płatności poza siecią","phone.input.label":"Numer telefonu","street.input.label":"Street Name","button.pay.placeOrder":"Złóż zamówienie","payments.offline.defaultInstructionText":"Zadzwonimy do Ciebie w ciągu 24 godzin, aby sfinalizować płatność. Do tego czasu możesz zdecydować, czy wolisz transakcję bankową, czy czek!<br/><br/>Do usłyszenia, miłego dnia!","cc.installments.singlePayment":"Jednorazowa Opłata","street.input.error":"Please enter a valid street name","email.input.error":"Wpisz poprawny e-mail","button.pay.buyNow":"Kup Teraz","wallet.pay.with":"Zapłać przez","city.input.label":"Miasto","address.input.label":"Adres","email.input.label":"Email","city.input.error":"Wprowadź poprawną miejscowość","cc.load.error":"Ta metoda płatności nie jest obecnie dostępna. Wybierz inną metodę lub skontaktuj się z właścicielem.","firstName.input.error":"Wprowadź poprawne imię","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Wprowadź poprawne nazwisko","state.input.error":"Wprowadź poprawny region","countryCode.input.error":"Wprowadź poprawny kraj","houseNumber.input.label":"House Number","cc.installments.title":"Raty","state.input.label":"Region","lastName.input.label":"Nazwisko"}

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"Código postal (CEP)","firstName.input.label":"Nome","phone.input.error":"Por favor, insira um telefone válido","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Pagar offline","form.submit":"Confirme e pague","address.input.error":"Por favor adicione um endereço válido","countryCode.input.label":"País","settings.offlineTitleOption3":"Pagamento offline","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Pagamento em dinheiro","zipCode.input.error":"Por favor, insira um código postal válido","payments.wallet.description":"Ao clicar em \"{{payButtonLabel}}\" você será redirecionado ao {{paymentMethodLabel}} para poder completar sua compra com segurança.","settings.offlineTitleOptionDefaultInstruction":"Instruções para pagamento offline","phone.input.label":"Telefone","street.input.label":"Street Name","button.pay.placeOrder":"Fazer Seu Pedido","payments.offline.defaultInstructionText":"Entraremos em contato nas próximas 24 horas para efetuar o pagamento, até então você pode decidir se prefere uma transferência bancária ou um cheque!<br/><br/>A gente se fala em breve, tenha um ótimo dia!","cc.installments.singlePayment":"À vista","street.input.error":"Please enter a valid street name","email.input.error":"Por favor, insira um email válido","button.pay.buyNow":"Compre Já","wallet.pay.with":"Pagar com","city.input.label":"Cidade","address.input.label":"Endereço","email.input.label":"Email","city.input.error":"Por favor, insira uma cidade válida","cc.load.error":"Este método de pagamento não está disponível no momento. Por favor, selecione um diferente ou entre em contato com o próprietário do site.","firstName.input.error":"Por favor, insira um nome válido","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Por favor, insira um sobrenome válido","state.input.error":"Por favor, insira um estado válido","countryCode.input.error":"Por favor, insira um país válido","houseNumber.input.label":"House Number","cc.installments.title":"Parcelas","state.input.label":"Estado","lastName.input.label":"Sobrenome"}

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"Cod poștal","firstName.input.label":"Prenume","phone.input.error":"Introdu un număr de telefon valid","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Plătește offline","form.submit":"Confirmă și plătește","address.input.error":"Introdu o adresă validă","countryCode.input.label":"Țara","settings.offlineTitleOption3":"Plată offline","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Plată în numerar","zipCode.input.error":"Introdu un cod poștal/zip valid","payments.wallet.description":"Când apeși pe \\\"{{{payButtonLabel}}\\\" vei fi redirecționat(ă) la {{paymentMethodLabel}} unde poți finaliza achiziția în deplină siguranță.","settings.offlineTitleOptionDefaultInstruction":"Instrucțiuni pentru plată offline","phone.input.label":"Număr de telefon","street.input.label":"Street Name","button.pay.placeOrder":"Trimite comanda","payments.offline.defaultInstructionText":"Te vom suna în următoarele 24 de ore pentru a finaliza plata, până atunci puteți decide dacă preferați să plătiți printr-o tranzacție bancară sau prin cec!<br/><br/>Pe curând și o zi frumoasă în continuare!","cc.installments.singlePayment":"O singură plată","street.input.error":"Please enter a valid street name","email.input.error":"Introdu o adresă de e-mail validă","button.pay.buyNow":"Cumpără acum","wallet.pay.with":"Plătește cu","city.input.label":"Localitate","address.input.label":"Adresă","email.input.label":"E-mail","city.input.error":"Introdu un oraș valid","cc.load.error":"Această metodă de plată nu este disponibilă pentru moment. Selectează altă metodă de plată sau contactează proprietarul site-ului.","firstName.input.error":"Introdu un prenume valid","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Introdu un nume valid","state.input.error":"Introdu un stat valid","countryCode.input.error":"Introdu o țară validă","houseNumber.input.label":"House Number","cc.installments.title":"Rate","state.input.label":"Stat","lastName.input.label":"Nume"}

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"Почтовый индекс","firstName.input.label":"Имя","phone.input.error":"Пожалуйста, укажите действующий номер телефона.","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Оплата офлайн","form.submit":"Подтвердить и оплатить","address.input.error":"Пожалуйста, введите правильный адрес","countryCode.input.label":"Страна","settings.offlineTitleOption3":"Офлайн-оплата","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Оплата наличными","zipCode.input.error":"Пожалуйста, укажите действительный почтовый индекс.","payments.wallet.description":"Когда вы нажмете «{{payButtonLabel}}», вы будете перенаправлены на сайт {{paymentMethodLabel}}, где сможете безопасно оплатить заказ.","settings.offlineTitleOptionDefaultInstruction":"Инструкции по оплате","phone.input.label":"Номер телефона","street.input.label":"Street Name","button.pay.placeOrder":"Разместить заказ","payments.offline.defaultInstructionText":"Мы позвоним в течение 24 часов, чтобы узнать, как вы предпочитаете оформить платеж: банковским переводом или чеком.<br/><br/>Хорошего дня!","cc.installments.singlePayment":"Единичный платеж","street.input.error":"Please enter a valid street name","email.input.error":"Пожалуйста, укажите действительную эл. почту.","button.pay.buyNow":"Купить","wallet.pay.with":"Оплата через","city.input.label":"Город","address.input.label":"Адрес","email.input.label":"Email","city.input.error":"Пожалуйста, укажите действительный город.","cc.load.error":"Способ оплаты временно недоступен. Пожалуйста, выберите другой способ оплаты или свяжитесь с владельцем сайта.","firstName.input.error":"Пожалуйста, укажите действительное имя.","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Пожалуйста, укажите действительную фамилию.","state.input.error":"Пожалуйста, укажите действительный регион.","countryCode.input.error":"Пожалуйста, укажите действительную страну.","houseNumber.input.label":"House Number","cc.installments.title":"Платежи","state.input.label":"Область / Регион","lastName.input.label":"Фамилия"}

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"Postnummer","firstName.input.label":"Förnamn","phone.input.error":"Ange ett giltigt telefonnummer","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Betala offline","form.submit":"Bekräfta och betala","address.input.error":"Skriv in en giltig adress","countryCode.input.label":"Land","settings.offlineTitleOption3":"Offline-betalning","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Kontant betalning","zipCode.input.error":"Vänligen ange ett giltigt postnummer","payments.wallet.description":"När du klickar på ”{{payButtonLabel}}” kommer du att omdirigeras till {{paymentMethodLabel}} där du säkert kan slutföra ditt köp.","settings.offlineTitleOptionDefaultInstruction":"Instruktioner för betalning offline","phone.input.label":"Telefonnummer","street.input.label":"Street Name","button.pay.placeOrder":"Beställ","payments.offline.defaultInstructionText":"Vi kommer att ringa dig inom de kommande 24 timmarna för att slutföra betalningen, fram tills dess kan du bestämma om du föredrar en banktransaktion eller check!<br/><br/>Vi hörs snart, ha en bra dag!","cc.installments.singlePayment":"Enskild betalning","street.input.error":"Please enter a valid street name","email.input.error":"Skriv in en giltig e-postadress","button.pay.buyNow":"Köp nu","wallet.pay.with":"Betala med","city.input.label":"Ort","address.input.label":"Adress","email.input.label":"E-post","city.input.error":"Ange en giltig stad","cc.load.error":"Denna betalningsleverantör är inte tillgänglig för tillfället. Vänligen välj en annan eller kontakta hemsidans ägare.","firstName.input.error":"Ange ett giltigt förnamn","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Ange ett giltigt efternamn","state.input.error":"Ange en giltig region","countryCode.input.error":"Ange ett giltigt land","houseNumber.input.label":"House Number","cc.installments.title":"Omgångar","state.input.label":"Län","lastName.input.label":"Efternamn"}

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"รหัสไปรษณีย์","firstName.input.label":"ชื่อ","phone.input.error":"กรุณากรอกเบอร์โทรศัพท์ที่ถูกต้อง","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"ชำระเงินออฟไลน์","form.submit":"ยืนยันและชำระเงิน","address.input.error":"กรุณากรอกที่อยู่ที่ถูกต้อง","countryCode.input.label":"ประเทศ","settings.offlineTitleOption3":"การชำระเงินออฟไลน์","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"ชำระด้วยเงินสด","zipCode.input.error":"กรุณากรอกรหัสไปรษณีย์ที่ถูกต้อง","payments.wallet.description":"เมื่อคุณกด \\\"{{payButtonLabel}}\\\" ระบบจะพาคุณไปที่ {{paymentMethodLabel}} ที่ที่คุณสามารถทำการซื้อได้อย่างปลอดภัย","settings.offlineTitleOptionDefaultInstruction":"คำอธิบายการชำระเงินออฟไลน์","phone.input.label":"เบอร์โทรศัพท์","street.input.label":"Street Name","button.pay.placeOrder":"สั่ง","payments.offline.defaultInstructionText":"เราจะโทรหาคุณภายในเวลา 24 ชั่วโมงเพื่อตกลงเรื่องการชำระเงิน คุณจึงมีเวลาเพียงพอเพื่อตัดสินใจว่าจะเลือกใช้การโอนเงินทางธนาคารหรือเช็คเงินสด<br/><br/>แล้วคุยกันครับ!","cc.installments.singlePayment":"ชำระเงินงวดเดียว","street.input.error":"Please enter a valid street name","email.input.error":"กรุณากรอกอีเมลที่ถูกต้อง","button.pay.buyNow":"ซื้อเลย","wallet.pay.with":"ชำระเงินด้วย","city.input.label":"เมือง/จังหวัด","address.input.label":"ที่อยู่","email.input.label":"อีเมล","city.input.error":"กรุณากรอกชื่อเมือง/จังหวัดที่ถูกต้อง","cc.load.error":"วิธีการชำระเงินนี้ไม่มีให้เลือกในขณะนี้ กรุณาเลือกวิธีอื่นหรือติดต่อเจ้าของเว็บไซต์","firstName.input.error":"กรุณากรอกชื่อที่ถูกต้อง","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"กรุณากรอกนามสกุลที่ถูกต้อง","state.input.error":"กรุณากรอกชื่อรัฐที่ถูกต้อง","countryCode.input.error":"กรุณากรอกชื่อประเทศที่ถูกต้อง","houseNumber.input.label":"House Number","cc.installments.title":"งวดผ่อนชำระ","state.input.label":"รัฐ","lastName.input.label":"นามสกุล"}

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"Zip / Postal Code","firstName.input.label":"Pangalan","phone.input.error":"Maglagay ng wastong numero ng telepono","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Magbayad Offline","form.submit":"Kumpirmahin at Magbayad","address.input.error":"Maglagay ng valid na address","countryCode.input.label":"Bansa","settings.offlineTitleOption3":"Offline na Pagbabayad","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Pagbabayad ng Cash","zipCode.input.error":"Maglagay ng valid na zip / postal code","payments.wallet.description":"Kapag pinipindot mo ang \\\"{{payButtonLabel}}\\\" mare-redirect ka sa {{paymentMethodLabel}} kung saan maaari mong tapusin ang iyong pagbabayad nang secure.","settings.offlineTitleOptionDefaultInstruction":"Tagubilin sa Offline na Pagbabayad","phone.input.label":"Numero ng Telepono","street.input.label":"Street Name","button.pay.placeOrder":"I-place ang Order","payments.offline.defaultInstructionText":"Tatawagan ka namin sa susunod na 24 oras upang asikasuhin ang bayad, hanggang sa oras na iyon, maaari kang magpasiya kung mas gusto mo ng transaksyon sa bangkoo sa pamamagitan ng check!<br/><br/>Mag-usap tayo sa susunod, ingat!","cc.installments.singlePayment":"Isahang Pagbabayad","street.input.error":"Please enter a valid street name","email.input.error":"Maglagay ng wastong email","button.pay.buyNow":"Bilhin Na","wallet.pay.with":"Magbayad gamit ang","city.input.label":"Lungsod","address.input.label":"Address","email.input.label":"Email","city.input.error":"Maglagay ng valid na lungsod","cc.load.error":"Hindi available ang paraan sa pagbabayad na ito sa ngayon. Pumili ng iba o makipag-ugnayan sa may-ari ng website.","firstName.input.error":"Maglagay ng valid na pangalan","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Maglagay ng valid na apelyido","state.input.error":"Maglagay ng valid na estado","countryCode.input.error":"Maglagay ng valid na bansa","houseNumber.input.label":"House Number","cc.installments.title":"Mga Installment","state.input.label":"Estado","lastName.input.label":"Apelyido"}

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"Zip/Posta Kodu","firstName.input.label":"Ad","phone.input.error":"Lütfen geçerli bir telefon numarası girin","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"Çevrimdışı Ödeme","form.submit":"Onayla ve Öde","address.input.error":"Lütfen geçerli bir adres girin","countryCode.input.label":"Ülke","settings.offlineTitleOption3":"Çevrimdışı Ödeme","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"Nakit Ödeme","zipCode.input.error":"Lütfen geçerli bir zip / posta kodu girin","payments.wallet.description":"\"{{payButtonLabel}}\" düğmesine tıkladığınızda buraya yönlendirileceksiniz {{paymentMethodLabel}}. Burada alışverişinizi güvenli bir şekilde tamamlayabilirsiniz.","settings.offlineTitleOptionDefaultInstruction":"Çevrimdışı Ödeme Talimatları","phone.input.label":"Telefon Numarası","street.input.label":"Street Name","button.pay.placeOrder":"Siparişi Tamamla","payments.offline.defaultInstructionText":"Ödeme işleminizi tamamlamak için 24 saat içerisinde sizi arayacağız. Bu zamana kadar banka transferi veya çekle ödeme yapmayı tercih edebilirsiniz.<br/><br/>İyi günler ve yakında konuşmak üzere!","cc.installments.singlePayment":"Tek Ödeme","street.input.error":"Please enter a valid street name","email.input.error":"Lütfen geçerli bir e-posta adresi girin","button.pay.buyNow":"Satın Al","wallet.pay.with":"Ödeme Yöntemi:","city.input.label":"Şehir","address.input.label":"Adres","email.input.label":"E-posta","city.input.error":"Lütfen geçerli bir şehir girin","cc.load.error":"Bu ödeme yöntemi şu anda kullanılamıyor. Lütfen farklı bir ödeme yöntemi seçin veya site sahibi ile iletişime geçin.","firstName.input.error":"Lütfen geçerli bir ad girin","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"Lütfen geçerli bir soyad girin","state.input.error":"Lütfen geçerli bir eyalet girin","countryCode.input.error":"Lütfen geçerli bir ülke girin","houseNumber.input.label":"House Number","cc.installments.title":"Taksitle","state.input.label":"Eyalet","lastName.input.label":"Soyad"}

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports = {"zipCode.input.label":"郵遞區號 / 郵政編碼","firstName.input.label":"名字","phone.input.error":"請輸入有效的電話號碼","houseNumber.input.error":"Please enter a valid house number","settings.offlineTitleOptionDefault":"離線支付","form.submit":"確認並付款","address.input.error":"請輸入有效的地址","countryCode.input.label":"國家","settings.offlineTitleOption3":"離線支付","holderId.input.label":"CPF / CPFJ","settings.offlineTitleOption2":"現金付款","zipCode.input.error":"請輸入有效的郵遞區號 / 郵政編碼","payments.wallet.description":"點選「{{payButtonLabel}}」時，您將被重新導向{{paymentMethodLabel}}，在這裡您可以安全完成購買。","settings.offlineTitleOptionDefaultInstruction":"離線支付說明","phone.input.label":"電話號碼","street.input.label":"Street Name","button.pay.placeOrder":"下達訂單","payments.offline.defaultInstructionText":"接下來的24小時內，我們會打電話與您結算付款，您可以等到那時候再決定要用銀行轉帳或支票！<br/><br/>將會盡快與您聯繫，祝您有美好的一天！","cc.installments.singlePayment":"單筆付款","street.input.error":"Please enter a valid street name","email.input.error":"請輸入有效的電子信箱","button.pay.buyNow":"立即購買","wallet.pay.with":"支付使用","city.input.label":"城市","address.input.label":"地址","email.input.label":"電子郵件","city.input.error":"請輸入有效的城市","cc.load.error":"此付款方式目前不可用。請選擇其他的供應商或連絡網站所有人。","firstName.input.error":"請輸入有效的名字","holderId.input.error":"Please enter a valid CPF/ CPFJ","lastName.input.error":"請輸入有效的姓氏","state.input.error":"請輸入有效的州名","countryCode.input.error":"請輸入有效的國家","houseNumber.input.label":"House Number","cc.installments.title":"分期","state.input.label":"州","lastName.input.label":"姓氏"}

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = {"button.pay.placeOrder":"Place Order","button.pay.buyNow":"Buy Now","payments.wallet.description":"When you hit \"{{payButtonLabel}}\" you will be redirected to {{paymentMethodLabel}} where you can complete your purchase securely.","settings.methods.paypal":"PayPal","wallet.pay.with":"Pay with","wallet.message.end":"to complete your purchase securely, and return here to complete your purchase.","form.submit":"Submit","settings.offlineTitleOptionDefault":"Pay Offline Instruction","settings.methods.creditCard":"Credit Card","payments.offline.defaultInstructionText":"We’ll call you in the next 24 hours to settle the payment, untill then you can decide if you prefer a bank transaction or a chek!<br/><br/>Talk to you soon, have a great day!","settings.methods.offline":"Pay Offline"}

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"installmentsTitle":"_3A9A7"};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Field_1 = __webpack_require__(193);
exports.default = Field_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var FormsStore_1 = __webpack_require__(37);
var CountryAutoComplete_1 = __webpack_require__(195);
var StateAutoComplete_1 = __webpack_require__(200);
var TextField_1 = __webpack_require__(203);
var validators = {
    default: function (value) { return Boolean(value); },
};
var Field = (function (_super) {
    __extends(Field, _super);
    function Field() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleFieldChange = function (_a) {
            var value = _a.value, name = _a.name, isValid = _a.isValid;
            FormsStore_1.default.setFieldData(name, { value: value, name: name, isValid: isValid }, _this.props.formName);
        };
        _this.getFieldValue = function (name) {
            var formData = _this.props.formData;
            return formData[name] || { isValid: false, touched: false, value: '' };
        };
        _this.isValid = function (value) { return validators.default(value); };
        return _this;
    }
    Field.prototype.renderFieldByType = function () {
        var data = this.props.data;
        var metadataProps = {
            name: data.name,
            required: data.required,
            errorMessage: data.errorMessage,
            label: data.label,
        };
        switch (data.type) {
            case 'countryCode': {
                return (React.createElement(CountryAutoComplete_1.default, __assign({ isValid: this.getFieldValue(data.name).isValid, touched: this.getFieldValue(data.name).touched, value: this.getFieldValue(data.name).value || '', validate: this.isValid, onChange: this.handleFieldChange }, metadataProps)));
            }
            case 'state': {
                return (React.createElement(StateAutoComplete_1.default, __assign({ isValid: this.getFieldValue(data.name).isValid, touched: this.getFieldValue(data.name).touched, value: this.getFieldValue(data.name).value || '', countryCode: this.getFieldValue('countryCode').value || '', validate: this.isValid, onChange: this.handleFieldChange }, metadataProps)));
            }
            default: {
                return (React.createElement(TextField_1.default, __assign({ isValid: this.getFieldValue(data.name).isValid, touched: this.getFieldValue(data.name).touched, value: this.getFieldValue(data.name).value || '', validate: this.isValid, onChange: this.handleFieldChange }, metadataProps)));
            }
        }
    };
    Field.prototype.render = function () {
        return (React.createElement("div", { "data-hook": "cashier-payments-method-field" }, this.renderFieldByType()));
    };
    return Field;
}(React.Component));
exports.default = Field;
//# sourceMappingURL=Field.js.map

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var FormsStore = (function () {
    function FormsStore() {
        var _this = this;
        this.state = {};
        this.subscribers = {};
        this.initForm = function (formName, initialForm) {
            if (initialForm === void 0) { initialForm = {}; }
            _this.state[formName] = __assign({}, initialForm);
            _this.subscribers[formName] = [];
        };
        this.subscribe = function (formName, listener) {
            if (_this.subscribers[formName]) {
                _this.subscribers[formName].push(listener);
            }
        };
        this.validate = function (formName) {
            if (!_this.state[formName]) {
                return true;
            }
            var form = _this.state[formName];
            if (Object.keys(form).length > 0) {
                Object.keys(form).forEach(function (key) {
                    form[key] = __assign({}, form[key], { touched: true });
                });
                _this.sendNotificationToSubscribers(formName);
                return !Object.keys(form).find(function (key) { return !form[key].isValid; });
            }
            return true;
        };
        this.getFormData = function (formName) {
            if (!_this.state[formName]) {
                console.error('Form', formName, 'is not inited');
            }
            return _this.state[formName] || {};
        };
        this.setFieldData = function (fieldName, fieldData, formName) {
            if (!_this.state[formName] || !_this.state[formName][fieldName]) {
                console.error('Form', formName, 'is not inited');
                return null;
            }
            var form = _this.state[formName];
            var currentField = form[fieldName];
            _this.state[formName] = __assign({}, form, (_a = {}, _a[fieldName] = __assign({}, currentField, fieldData, { touched: true }), _a));
            _this.sendNotificationToSubscribers(formName);
            var _a;
        };
        this.sendNotificationToSubscribers = function (formName) {
            var form = _this.state[formName];
            _this.subscribers[formName].forEach(function (subscriber) { return subscriber(form); });
        };
    }
    FormsStore.prototype.reset = function () {
        this.state = {};
        this.subscribers = {};
    };
    return FormsStore;
}());
exports.default = (new FormsStore());
//# sourceMappingURL=FormsStore.js.map

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CountryAutoComplete_1 = __webpack_require__(196);
exports.default = CountryAutoComplete_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var AutoComplete_1 = __webpack_require__(70);
var countryApiService_1 = __webpack_require__(199);
var CountryAutoComplete = (function (_super) {
    __extends(CountryAutoComplete, _super);
    function CountryAutoComplete(props) {
        var _this = _super.call(this, props) || this;
        AutoComplete_1.default.cachedItems[_this.props.name] = [];
        return _this;
    }
    CountryAutoComplete.prototype.render = function () {
        return (React.createElement("div", { "data-hook": "cashier-payments-method-countryAutoComplete-dropdown" },
            React.createElement(AutoComplete_1.default, __assign({ fetchItems: countryApiService_1.default.fetchCountries }, this.props))));
    };
    return CountryAutoComplete;
}(React.Component));
exports.default = CountryAutoComplete;
//# sourceMappingURL=CountryAutoComplete.js.map

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Loader_1 = __webpack_require__(69);
var Dropdown_1 = __webpack_require__(68);
var Translate_1 = __webpack_require__(35);
var s = __webpack_require__(198);
var getItemTranslation = function (items, itemCode) {
    var itemValue = items.find(function (item) { return item.value === itemCode; });
    return itemValue ? itemValue.label : itemCode;
};
var AutoComplete = (function (_super) {
    __extends(AutoComplete, _super);
    function AutoComplete(props) {
        var _this = _super.call(this, props) || this;
        _this.getAutocompleteCachedItems = function () { return AutoComplete.cachedItems[_this.props.name] || []; };
        _this.handleDefaultValueTranslation = function (items) {
            _this.setState({
                itemCode: getItemTranslation(items, _this.state.itemCode),
                items: (_this.getAutocompleteCachedItems()).filter(function (item) {
                    return item.label === getItemTranslation(items, _this.state.itemCode);
                }),
            });
        };
        _this.handleTextChange = function (e) {
            var items = (_this.getAutocompleteCachedItems()).filter(function (item) {
                var label = item.label.toLowerCase();
                var mask = e.target.value.toLowerCase();
                return item.value.indexOf(e.target.value) === 0 || label.indexOf(mask) === 0;
            });
            if (items.length === 1 && items[0].label === e.target.value) {
                _this.handleSelect(items[0]);
                /* istanbul ignore next */
                if (_this.dropdownNode) {
                    _this.dropdownNode.hideDropdownMenu();
                }
            }
            _this.setState({
                items: items,
                itemCode: e.target.value,
            });
        };
        _this.mapItemsToOptionsFormat = function (items) {
            return items.map(function (item) {
                return {
                    id: item.key,
                    value: item.key,
                    label: item.displayName,
                };
            });
        };
        _this.handleFocus = function () {
            if (!(_this.getAutocompleteCachedItems()).length) {
                _this.fetchItems();
            }
        };
        _this.fetchItems = function (callback) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                // TODO here instead of xhr we should use client for wix-metadata-service
                this.setState({ isLoadingOptions: true });
                if (!this.props.fetchItems) {
                    return [2 /*return*/, null];
                }
                this.props.fetchItems(this.props.locale)
                    .then(function (rawItems) {
                    var items = _this.mapItemsToOptionsFormat(rawItems);
                    AutoComplete.cachedItems[_this.props.name] = items;
                    _this.setState({
                        items: items,
                        isLoadingOptions: false,
                    });
                    if (callback) {
                        callback(items);
                    }
                })
                    .catch(function (e) { return console.error(e); });
                return [2 /*return*/];
            });
        }); };
        _this.isError = function () { return !_this.props.isValid && _this.props.touched; };
        _this.handleSelect = function (option) {
            _this.setState({
                itemCode: option.label,
            });
            if (_this.props.onChange) {
                _this.props.onChange({
                    value: option.id,
                    name: _this.props.name,
                    isValid: _this.props.validate(option.id),
                });
            }
        };
        _this.state = {
            itemCode: getItemTranslation(_this.getAutocompleteCachedItems(), _this.props.value || ''),
            isLoadingOptions: false,
            items: _this.getAutocompleteCachedItems().filter(function (item) {
                return item.label === getItemTranslation(_this.getAutocompleteCachedItems(), _this.props.value || '');
            }),
        };
        return _this;
    }
    AutoComplete.prototype.componentDidMount = function () {
        if (!this.getAutocompleteCachedItems().length) {
            if (this.state.itemCode && this.state.itemCode.length === 3) {
                this.fetchItems(this.handleDefaultValueTranslation);
            }
            else {
                this.fetchItems();
            }
        }
    };
    AutoComplete.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.name === 'state' && this.props.countryCode !== prevProps.countryCode) {
            this.fetchItems();
        }
    };
    AutoComplete.prototype.renderErrorMessage = function () {
        if (!this.isError() || !this.props.errorMessage) {
            return null;
        }
        return (React.createElement("label", { "data-hook": "cashier-payments-method-autoComplete-dropdown-error", className: s.errorLabel, htmlFor: name }, Translate_1.translate({ forKey: this.props.errorMessage })));
    };
    AutoComplete.prototype.render = function () {
        var _this = this;
        var _a = this.props, required = _a.required, value = _a.value, name = _a.name, label = _a.label;
        return (React.createElement("div", { className: s.root, "data-hook": "cashier-payments-method-AutoComplete-dropdown" },
            React.createElement("label", { className: s.label, htmlFor: name },
                required ? '* ' : '',
                Translate_1.translate({ forKey: label })),
            this.state.isLoadingOptions
                ? React.createElement("div", { className: s.loader },
                    React.createElement(Loader_1.default, { size: "small" }))
                : null,
            React.createElement(Dropdown_1.default, { ref: function (node) { return _this.dropdownNode = node; }, disabled: this.state.isLoadingOptions, isLoadingOptions: this.state.isLoadingOptions, autocompleteInputValue: this.state.itemCode, autocomplete: true, defaultOptionId: value, options: this.state.items, onSelect: this.handleSelect, onChange: this.handleTextChange, onFocus: this.handleFocus }),
            this.renderErrorMessage()));
    };
    AutoComplete.cachedItems = {};
    AutoComplete.defaultProps = {
        locale: 'en',
    };
    return AutoComplete;
}(React.Component));
exports.default = AutoComplete;
//# sourceMappingURL=AutoComplete.js.map

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_1Wg1s","loader":"_1fkQU","label":"_12ZbL","input":"NVGxv","errorInput":"_2aR5e","errorLabel":"-o-ke"};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* istanbul ignore next */
var fetchCountries = function (locale) {
    return new Promise(function (resolve, reject) {
        var HOST = 'https://cashier-services.wix.com/cashier-metadata';
        var xhr = new window.XMLHttpRequest();
        xhr.open('GET', HOST + "/api/v2/locales/countries?locale=" + locale, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onreadystatechange = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (xhr.readyState === 4 && xhr.status >= 200 && xhr.status < 400) {
                try {
                    var response = JSON.parse(xhr.responseText);
                    resolve(response.countries || []);
                }
                catch (e) {
                    reject(e);
                }
            }
            else if (xhr.readyState === 4 && xhr.status !== 200) {
                reject(new Error('Bad server status'));
            }
        };
        xhr.send();
    });
};
exports.default = {
    fetchCountries: fetchCountries,
};
//# sourceMappingURL=countryApiService.js.map

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StateAutoComplete_1 = __webpack_require__(201);
exports.default = StateAutoComplete_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var AutoComplete_1 = __webpack_require__(70);
var stateApiService_1 = __webpack_require__(202);
var StateAutoComplete = (function (_super) {
    __extends(StateAutoComplete, _super);
    function StateAutoComplete(props) {
        var _this = _super.call(this, props) || this;
        AutoComplete_1.default.cachedItems[_this.props.name] = [];
        return _this;
    }
    StateAutoComplete.prototype.render = function () {
        return (React.createElement("div", { "data-hook": "cashier-payments-method-stateAutoComplete-dropdown" },
            React.createElement(AutoComplete_1.default, __assign({ fetchItems: stateApiService_1.default.fetchStates.bind(this, this.props.countryCode) }, this.props))));
    };
    return StateAutoComplete;
}(React.Component));
exports.default = StateAutoComplete;
//# sourceMappingURL=StateAutoComplete.js.map

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* istanbul ignore next */
var fetchStates = function (countryCode, locale) {
    return new Promise(function (resolve, reject) {
        var HOST = 'https://cashier-services.wix.com/cashier-metadata';
        var xhr = new window.XMLHttpRequest();
        xhr.open('GET', HOST + "/api/v2/locales/states?countryCode=" + countryCode + "&locale=" + locale, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onreadystatechange = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (xhr.readyState === 4 && xhr.status >= 200 && xhr.status < 400) {
                try {
                    var response = JSON.parse(xhr.responseText);
                    resolve(response.states || []);
                }
                catch (e) {
                    reject(e);
                }
            }
            else if (xhr.readyState === 4 && xhr.status !== 200) {
                reject(new Error('Bad server status'));
            }
        };
        xhr.send();
    });
};
exports.default = {
    fetchStates: fetchStates,
};
//# sourceMappingURL=stateApiService.js.map

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TextField_1 = __webpack_require__(204);
exports.default = TextField_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var s = __webpack_require__(205);
var Translate_1 = __webpack_require__(13);
var TextField = (function (_super) {
    __extends(TextField, _super);
    function TextField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (e) {
            var node = e.target;
            _this.props.onChange({
                value: node.value,
                name: _this.props.name,
                isValid: _this.props.validate(node.value),
            });
        };
        _this.handleBlur = function () {
            // field become touched, for validation
            _this.props.onChange({
                value: _this.props.value,
                name: _this.props.name,
                isValid: _this.props.isValid,
            });
        };
        _this.isError = function () { return !_this.props.isValid && _this.props.touched; };
        return _this;
    }
    TextField.prototype.renderErrorMessage = function () {
        if (!this.isError() || !this.props.errorMessage) {
            return null;
        }
        return (React.createElement("label", { className: s.errorLabel, htmlFor: name }, Translate_1.translate({ forKey: this.props.errorMessage })));
    };
    TextField.prototype.render = function () {
        var _a = this.props, required = _a.required, value = _a.value, name = _a.name, label = _a.label;
        return (React.createElement("div", { className: s.root, "data-hook": "cashier-payments-method-field-textField" },
            React.createElement("label", { className: s.label, htmlFor: name },
                required ? '* ' : '',
                Translate_1.translate({ forKey: label })),
            React.createElement("input", { className: s.input + " " + (this.isError() ? s.errorInput : ''), id: name, name: name, required: required, "data-hook": "cashier-payments-method-field-textField-" + name, value: value, onChange: this.handleChange, onBlur: this.handleBlur }),
            this.renderErrorMessage()));
    };
    return TextField;
}(React.Component));
exports.default = TextField;
//# sourceMappingURL=TextField.js.map

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_1bE65","label":"VBhYS","input":"_24PSq","errorInput":"_1ndux","errorLabel":"_2v6vZ"};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var s = __webpack_require__(207);
var PaymentMethodLayout = (function (_super) {
    __extends(PaymentMethodLayout, _super);
    function PaymentMethodLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentMethodLayout.prototype.render = function () {
        return (React.createElement("div", { "data-hook": this.props.dataHook, className: s.root + " " + (this.props.noPadding ? s.noPadding : '') }, this.props.children));
    };
    PaymentMethodLayout.defaultProps = {
        dataHook: 'wcn-cashier-payments-method-layout',
    };
    return PaymentMethodLayout;
}(React.Component));
exports.default = PaymentMethodLayout;
//# sourceMappingURL=PaymentMethodLayout.js.map

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_3cjyW","noPadding":"_1Qs0S"};

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"creditCardPayment":"nia-e","installmentsWrap":"_3d9CL"};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Offline_1 = __webpack_require__(210);
exports.default = Offline_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var s = __webpack_require__(211);
var PaymentMethodLayout_1 = __webpack_require__(38);
var Translate_1 = __webpack_require__(13);
var Offline = (function (_super) {
    __extends(Offline, _super);
    function Offline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getText = function (info) {
            return (info && info.text) || Translate_1.translate({ forKey: 'payments.offline.defaultInstructionText' });
        };
        return _this;
    }
    Offline.prototype.render = function () {
        var info = this.props.info;
        var text = this.getText(info).trim();
        if (!text) {
            return null;
        }
        return (React.createElement(PaymentMethodLayout_1.default, { dataHook: "cashier-payments-method-offline" },
            React.createElement("span", { className: s.content, dangerouslySetInnerHTML: { __html: text } })));
    };
    return Offline;
}(React.Component));
exports.default = Offline;
//# sourceMappingURL=Offline.js.map

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"xRts_","content":"lCeRY"};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Wallet_1 = __webpack_require__(213);
exports.default = Wallet_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var s = __webpack_require__(214);
var PaymentMethodLayout_1 = __webpack_require__(38);
var Translate_1 = __webpack_require__(13);
var Wallet = (function (_super) {
    __extends(Wallet, _super);
    function Wallet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Wallet.prototype.render = function () {
        var _a = this.props, paymentMethodName = _a.paymentMethodName, paymentMethodLabel = _a.paymentMethodLabel, payButtonLabel = _a.payButtonLabel;
        return (React.createElement(PaymentMethodLayout_1.default, { dataHook: "cashier-payments-method-wallet-" + paymentMethodName },
            React.createElement("div", { className: s.title },
                React.createElement(Translate_1.default, { forKey: "wallet.pay.with" }),
                React.createElement("span", null, "\u00A0"),
                React.createElement("span", null, paymentMethodLabel)),
            React.createElement("br", null),
            React.createElement("span", { className: s.content }, Translate_1.translate({
                forKey: 'payments.wallet.description',
                overrides: { paymentMethodLabel: paymentMethodLabel, payButtonLabel: Translate_1.translate({ forKey: payButtonLabel }) },
            }))));
    };
    Wallet.defaultProps = {
        payButtonLabel: 'button.pay.placeOrder',
    };
    return Wallet;
}(React.Component));
exports.default = Wallet;
//# sourceMappingURL=Wallet.js.map

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"_2QYlO","content":"TrPc6"};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var s = __webpack_require__(216);
var Fields_1 = __webpack_require__(67);
var Loader_1 = __webpack_require__(12);
var PayButton_1 = __webpack_require__(72);
var FormsStore_1 = __webpack_require__(37);
var PaymentsStore_1 = __webpack_require__(73);
var mandatoryFieldsUIUtils_1 = __webpack_require__(221);
var wix_experiments_1 = __webpack_require__(74);
var MANDATORY_FIELDS_FORM = 'MANDATORY_FIELDS_FORM';
var PaymentDetails = (function (_super) {
    __extends(PaymentDetails, _super);
    function PaymentDetails() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isComponentMounted = false;
        _this.validateForm = FormsStore_1.default.validate.bind(null, MANDATORY_FIELDS_FORM);
        _this.state = {
            formData: {},
            mandatoryFields: [],
            isLoadingMandatoryFields: true,
            isMandatoryFieldsEnabled: false,
        };
        _this.loadMandatoryFields = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.state.isMandatoryFieldsEnabled) return [3 /*break*/, 2];
                        this.safeSetState({
                            isLoadingMandatoryFields: true,
                        });
                        return [4 /*yield*/, PaymentsStore_1.default.fetchMandatoryFields()];
                    case 1:
                        _a.sent();
                        this.safeSetState({
                            isLoadingMandatoryFields: false,
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        this.safeSetState({
                            isLoadingMandatoryFields: false,
                        });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.checkIsCountryChanged = function (formData) {
            var currentCountry = _this.state.formData.countryCode;
            var nextCountry = formData.countryCode;
            /* istanbul ignore next */
            if (currentCountry && nextCountry && currentCountry.value !== nextCountry.value) {
                _this.props.paymentsSDK.setCountry(nextCountry.value);
                _this.loadMandatoryFields();
            }
        };
        /**
         * Returns camel-cased variant of mandatory field name
         * @example holder_id => holderId
         * @example holder_id_whatever => holderIdWhatever
         * @example holder_ => holder
         * @param {string} value Any string value
         * @returns {string}
         */
        _this.camelCased = function (value) {
            /* istanbul ignore next */
            return value.replace(/_.?/g, _this.replaceWithCamelCase);
        };
        /* istanbul ignore next */
        _this.replaceWithCamelCase = function (part) {
            /* istanbul ignore next */
            return (part && part[1]) ? part[1].toUpperCase() : '';
        };
        _this.excludeProvidedMandatoryFields = function (mf) {
            var providedMandatoryFields = [];
            /* istanbul ignore next */
            if (_this.props.mandatoryFields) {
                /* istanbul ignore next */
                providedMandatoryFields = Object.keys(_this.props.mandatoryFields).map(function (mandatoryFieldName) {
                    return _this.camelCased(mandatoryFieldName);
                });
            }
            return providedMandatoryFields.indexOf(mf.name) < 0;
        };
        _this.safeSetState = function (state, callback) {
            if (_this.isComponentMounted) {
                _this.setState(state, callback);
            }
        };
        _this.updateSDKCurrentMandatoryFields = function () {
            var formData = _this.state.formData;
            var mandatoryFieldsNames = Object.keys(formData);
            // Update SDK mandatory fields with current values
            mandatoryFieldsNames.forEach(function (name) {
                try {
                    _this.props.paymentsSDK.setMandatoryField(name, { value: formData[name].value });
                }
                catch (e) {
                    /* this line will be reached only if something went wrong with sdk */
                    /* istanbul ignore next */
                    // Commented due to https://jira.wixpress.com/browse/WCN-1878
                    // console.info('Something went wrong, maybe sdk not inited', e);
                }
            });
        };
        _this.updateSDKWithProvidedMandatoryFields = function () {
            if (!_this.props.mandatoryFields) {
                return null;
            }
            // Update SDK mandatory fields with provided values
            Object.keys(_this.props.mandatoryFields).forEach(function (mfKey) {
                try {
                    _this.props.paymentsSDK.setMandatoryField(mfKey, { value: _this.props.mandatoryFields[mfKey] });
                }
                catch (e) {
                    /* this line will be reached only if something went wrong with sdk */
                    /* istanbul ignore next */
                    // Commented due to https://jira.wixpress.com/browse/WCN-1878
                    // console.info('Something went wrong, maybe sdk not inited', e);
                }
            });
        };
        _this.renderPaymentMethod = function () {
            if (_this.state.isLoadingMandatoryFields) {
                return React.createElement(Loader_1.default, null);
            }
            return (React.createElement("div", { className: s.fieldsGroup }, _this.renderMandatoryFields()));
        };
        _this.renderMandatoryFields = function () {
            /* istanbul ignore next */
            if (_this.props.isMethodCollapsed) {
                /* istanbul ignore next */
                return null;
            }
            var fields = mandatoryFieldsUIUtils_1.getFieldsWithColumns(_this.state.mandatoryFields.filter(_this.excludeProvidedMandatoryFields), _this.props.mandatoryFieldsGroups);
            return fields.map(function (field) {
                var className = s.field;
                if (field.column === 'left') {
                    className = s.fieldLeft;
                }
                else if (field.column === 'right') {
                    className = s.fieldRight;
                }
                return (React.createElement("div", { key: field.name, className: className },
                    React.createElement(Fields_1.Field, { data: field, formData: _this.state.formData, formName: MANDATORY_FIELDS_FORM })));
            });
        };
        _this.validate = function () {
            return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                var isMandatoryFieldsValid, isPaymentMethodValid, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isMandatoryFieldsValid = this.validateForm();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.props.paymentsSDK.validate(this.props.paymentMethod.paymentMethod)];
                        case 2:
                            isPaymentMethodValid = _a.sent();
                            resolve({
                                isValid: (isMandatoryFieldsValid && isPaymentMethodValid.isValid) || false,
                                /* istanbul ignore next */
                                invalidFields: /* istanbul ignore next */ isPaymentMethodValid.invalidFields || [],
                            });
                            return [3 /*break*/, 4];
                        case 3:
                            e_1 = _a.sent();
                            /* istanbul ignore next */
                            reject();
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); });
        };
        return _this;
    }
    PaymentDetails.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var experiments;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, PaymentsStore_1.default.initPayments({
                            locale: this.props.locale,
                            paymentsSDK: this.props.paymentsSDK,
                            orderId: this.props.orderId,
                            paymentMethod: this.props.paymentMethod,
                        })];
                    case 1:
                        _a.sent();
                        this.isComponentMounted = true;
                        if (!this.props.isMandatoryFieldsEnabled) return [3 /*break*/, 2];
                        this.safeSetState({
                            isMandatoryFieldsEnabled: this.props.isMandatoryFieldsEnabled,
                        });
                        return [3 /*break*/, 4];
                    case 2:
                        experiments = new wix_experiments_1.default({
                            baseUrl: 'https://www.wix.com',
                            scope: 'cashier',
                        });
                        /* istanbul ignore next */ return [4 /*yield*/, experiments.ready()];
                    case 3:
                        /* istanbul ignore next */ _a.sent();
                        /* istanbul ignore next */
                        this.safeSetState({
                            isMandatoryFieldsEnabled: experiments.enabled('specs.cashier.MandatoryFields'),
                        });
                        _a.label = 4;
                    case 4:
                        PaymentsStore_1.default.subscribe('mandatoryFields', function (mandatoryFields) {
                            _this.safeSetState({
                                mandatoryFields: mandatoryFields,
                            });
                        });
                        return [4 /*yield*/, this.loadMandatoryFields()];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentDetails.prototype.componentWillReceiveProps = function (nextProps) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.props.paymentMethod !== nextProps.paymentMethod)) return [3 /*break*/, 2];
                        PaymentsStore_1.default.setPaymentMethod({
                            paymentMethod: nextProps.paymentMethod,
                        });
                        return [4 /*yield*/, this.loadMandatoryFields()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (this.props.mandatoryFields !== nextProps.mandatoryFields && this.state.isMandatoryFieldsEnabled) {
                            this.updateSDKWithProvidedMandatoryFields();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentDetails.prototype.componentDidUpdate = function (prevProps, prevState) {
        /* istanbul ignore next */
        var prevCountryCode = prevState.formData.countryCode && prevState.formData.countryCode.value;
        var curCountryCode = this.state.formData &&
            this.state.formData.countryCode &&
            this.state.formData.countryCode.value;
        var isCountryChanged = prevCountryCode !== curCountryCode;
        if (this.state.isMandatoryFieldsEnabled && prevState.mandatoryFields.length !== this.state.mandatoryFields.length) {
            this.initMandatoryFieldForm();
        }
        if (isCountryChanged && this.props.onCountryChange) {
            this.props.onCountryChange(this.state.formData && this.state.formData.countryCode);
        }
    };
    PaymentDetails.prototype.componentWillUnmount = function () {
        this.isComponentMounted = false;
    };
    PaymentDetails.prototype.initMandatoryFieldForm = function () {
        var _this = this;
        var defaultFields = this.state.mandatoryFields.filter(this.excludeProvidedMandatoryFields).reduce(function (res, field) {
            // TODO need to refactor tests
            /* istanbul ignore next */
            return __assign({}, res, (_a = {}, _a[field.name] = {
                name: field.name,
                isValid: field.name === 'countryCode' && _this.props.countryCode ? true : false,
                value: field.name === 'countryCode' && _this.props.countryCode ? _this.props.countryCode : undefined,
            }, _a));
            var _a;
        }, {});
        FormsStore_1.default.reset();
        FormsStore_1.default.initForm(MANDATORY_FIELDS_FORM, defaultFields);
        this.updateSDKWithProvidedMandatoryFields();
        FormsStore_1.default.subscribe(MANDATORY_FIELDS_FORM, function (formData) {
            _this.checkIsCountryChanged(formData);
            _this.safeSetState({ formData: formData }, function () { return _this.updateSDKCurrentMandatoryFields(); });
        });
        this.safeSetState({
            formData: FormsStore_1.default.getFormData(MANDATORY_FIELDS_FORM),
        });
    };
    PaymentDetails.prototype.renderPaymentButton = function () {
        if (this.props.externalPayButton || !this.props.isMobileApplication) {
            return null;
        }
        return (React.createElement("div", { className: s.payButton },
            React.createElement(PayButton_1.default, { paymentsSDK: this.props.paymentsSDK, paymentMethod: this.props.paymentMethod, orderId: this.props.orderId })));
    };
    PaymentDetails.prototype.render = function () {
        return (React.createElement("div", { "data-hook": "cashier-payments-method-payment-details", className: s.root },
            this.renderPaymentMethod(),
            this.renderPaymentButton()));
    };
    PaymentDetails.defaultProps = {
        mandatoryFieldsGroups: [
            ['countryCode', 'state'],
            ['zipCode', 'phone'],
            ['street', 'houseNumber'],
        ],
        isMandatoryFieldsEnabled: false,
        isMethodCollapsed: false,
    };
    return PaymentDetails;
}(React.Component));
exports.default = PaymentDetails;
//# sourceMappingURL=PaymentDetails.js.map

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_3Nk3R","pay-button":"_178H3","payButton":"_178H3","fields-group":"_37nEj","fieldsGroup":"_37nEj","field":"_1LmFj","field-left":"_1u2rh","fieldLeft":"_1u2rh","field-right":"_2AXo2","fieldRight":"_2AXo2"};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var i18n_1 = __webpack_require__(36);
var FormsStore_1 = __webpack_require__(37);
var s = __webpack_require__(218);
var Loader_1 = __webpack_require__(12);
var Translate_1 = __webpack_require__(13);
var MANDATORY_FIELDS_FORM = 'MANDATORY_FIELDS_FORM';
// TODO we should move this to separate repo
var PAY_BAD_STATUSES = ['UNDEFINED', 'DECLINED', 'FAILED', 'BUYER_CANCELED', 'TIMEOUT'];
var PENDING_STATUSES = ['IN_PROCESS', 'INITIALIZATION'];
var PayButton = (function (_super) {
    __extends(PayButton, _super);
    function PayButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isComponentMounted = false;
        _this.state = {
            loading: true,
            disabled: false,
            error: false,
        };
        _this.safeSetState = function (state) {
            if (_this.isComponentMounted) {
                _this.setState(state);
            }
        };
        _this.logValidationStatus = function (isValid, validateResult) {
            var invalidFields = [];
            if (!isValid) {
                var formData_1 = FormsStore_1.default.getFormData(MANDATORY_FIELDS_FORM);
                invalidFields = Object.keys(formData_1)
                    .filter(function (field) { return !formData_1[field].isValid; });
                invalidFields.push.apply(invalidFields, validateResult.invalidFields || []);
            }
            _this.props.paymentsSDK.logMandatoryFieldsValidationStatus({
                invalidFields: invalidFields,
                status: isValid,
                paymentMethod: _this.props.paymentMethod.paymentMethod,
                paymentProvider: _this.props.paymentMethod.connectedProviderId,
                orderId: _this.props.orderId,
            });
        };
        _this.handlePay = function () { return __awaiter(_this, void 0, void 0, function () {
            var validateFormPromise, validateResult, isMandatoryFieldsValid, isValid, payResult, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        validateFormPromise = this.props.paymentsSDK.validate(this.props.paymentMethod.paymentMethod);
                        this.safeSetState({
                            loading: true,
                            disabled: true,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, validateFormPromise];
                    case 2:
                        validateResult = _a.sent();
                        isMandatoryFieldsValid = !this.props.withMandatoryFields || this.props.validateForm();
                        isValid = validateResult.isValid && isMandatoryFieldsValid;
                        this.logValidationStatus(isValid, validateResult);
                        if (!isValid) return [3 /*break*/, 4];
                        if (this.props.onPayStart) {
                            this.props.onPayStart(this.props.paymentMethod);
                        }
                        return [4 /*yield*/, this.props.paymentsSDK.pay(this.props.paymentMethod.paymentMethod)];
                    case 3:
                        payResult = _a.sent();
                        if (PAY_BAD_STATUSES.indexOf(payResult.status) !== -1) {
                            this.safeSetState({
                                loading: false,
                                disabled: false,
                                error: true,
                            });
                            throw new Error('Bad transaction');
                        }
                        else if (PENDING_STATUSES.indexOf(payResult.status) !== -1) {
                            this.safeSetState({
                                loading: true,
                                disabled: true,
                                error: false,
                            });
                        }
                        else {
                            this.safeSetState({
                                loading: false,
                                disabled: false,
                                error: false,
                            });
                        }
                        return [3 /*break*/, 5];
                    case 4: throw new Error('Invalid form');
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        e_1 = _a.sent();
                        this.safeSetState({
                            loading: false,
                            disabled: false,
                            error: true,
                        });
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    PayButton.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isComponentMounted = true;
                        return [4 /*yield*/, i18n_1.init({ locale: this.props.locale || 'en' })];
                    case 1:
                        _a.sent();
                        this.setState({ loading: false });
                        return [2 /*return*/];
                }
            });
        });
    };
    PayButton.prototype.componentWillUnmount = function () {
        this.isComponentMounted = false;
    };
    PayButton.prototype.renderButtonContent = function () {
        if (this.state.loading) {
            return React.createElement("span", { className: s.spinnerWrap },
                React.createElement(Loader_1.default, { size: "small" }));
        }
        return React.createElement(Translate_1.default, { forKey: this.props.text });
    };
    PayButton.prototype.render = function () {
        return (React.createElement("button", { disabled: this.state.disabled, "data-hook": "cashier-payments-method-pay-button", className: s.root, onClick: this.handlePay }, this.renderButtonContent()));
    };
    PayButton.defaultProps = {
        withMandatoryFields: true,
        text: 'form.submit',
        validateForm: FormsStore_1.default.validate.bind(null, MANDATORY_FIELDS_FORM),
    };
    return PayButton;
}(React.Component));
exports.default = PayButton;
//# sourceMappingURL=PayButton.js.map

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_2ynoY","spinnerWrap":"zJTUm"};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var i18n_1 = __webpack_require__(36);
var MANDATORY_FIELDS_META = __webpack_require__(220);
var Payments = (function () {
    function Payments() {
        var _this = this;
        this.inited = false;
        this.initInProgress = false;
        this.state = { mandatoryFields: [] };
        this.props = {};
        this.subscribers = {};
        this.initPayments = function (_a) {
            var paymentsSDK = _a.paymentsSDK, paymentMethod = _a.paymentMethod, orderId = _a.orderId, locale = _a.locale;
            return new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.isInited(paymentMethod.connectedProviderId)) {
                                return [2 /*return*/, resolve()];
                            }
                            this.cashierPayments = paymentsSDK;
                            this.subscribers.mandatoryFields = this.subscribers.mandatoryFields || [];
                            this.props = {
                                locale: locale,
                                paymentMethod: paymentMethod,
                                orderId: orderId,
                            };
                            this.initInProgress = true;
                            return [4 /*yield*/, i18n_1.init({ locale: this.props.locale || 'en' })];
                        case 1:
                            _a.sent();
                            this.inited = true;
                            this.initInProgress = false;
                            resolve();
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        this.setPaymentMethod = function (_a) {
            var paymentMethod = _a.paymentMethod;
            _this.props.paymentMethod = paymentMethod;
            _this.state.mandatoryFields = [];
        };
        this.subscribe = function (name, listener) {
            _this.subscribers[name].push(listener);
        };
        this.reset = function () { return _this.destroy(); };
        this.destroy = function () {
            _this.inited = false;
            _this.props = {};
            _this.cashierPayments = null;
            _this.state = { mandatoryFields: [] };
            _this.subscribers = {};
            _this.initInProgress = false;
            return Promise.resolve({ status: 'OK' });
        };
        this.isInited = function (connectedProviderId) {
            var currentConnectedProviderId = _this.props.paymentMethod && _this.props.paymentMethod.connectedProviderId;
            return (_this.inited || _this.initInProgress) && connectedProviderId === currentConnectedProviderId;
        };
        this.renderPaymentMethod = function (name, node) { return _this.cashierPayments.render(name, node); };
        this.getMandatoryFields = function () { return _this.state.mandatoryFields; };
        this.fetchMandatoryFields = function () { return __awaiter(_this, void 0, void 0, function () {
            var orderId, paymentMethod, result, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        orderId = this.props.orderId;
                        paymentMethod = this.props.paymentMethod.connectedProviderId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.cashierPayments.fetchMandatoryFields({ orderId: orderId, paymentMethod: paymentMethod })];
                    case 2:
                        result = _a.sent();
                        if (!result.mandatoryFields) {
                            // as server has bug with removing properties when array is empty, we need this fallback
                            result.mandatoryFields = [];
                        }
                        this.setData('mandatoryFields', this.sortMandatoryFields(this.decorateWithUIProps(result.mandatoryFields)));
                        return [2 /*return*/, result];
                    case 3:
                        e_1 = _a.sent();
                        this.setData('mandatoryFields', []);
                        // Commented due to https://jira.wixpress.com/browse/WCN-1878
                        // console.info('Error during fetching mandatory fields', e);
                        return [2 /*return*/, {
                                errorCode: 500,
                                translatedError: e_1.toString(),
                                status: 'FAILURE',
                            }];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.decorateWithUIProps = function (mandatoryFields) {
            return mandatoryFields
                .map(function (field) {
                // If we receive fieldName not 'state', but 'description.billingAddress.state'
                var lastPartOfFieldName = field.fieldName.split('.').pop();
                return MANDATORY_FIELDS_META[lastPartOfFieldName];
            })
                .filter(function (field) { return field; });
        };
        this.sortMandatoryFields = function (mandatoryFields) {
            mandatoryFields.sort(function (field1, field2) { return field2.priority - field1.priority; });
            return mandatoryFields;
        };
        this.setData = function (name, data) {
            _this.state[name] = data;
            _this.subscribers[name].forEach(function (listener) { return listener(data); });
        };
    }
    return Payments;
}());
exports.default = (new Payments());
//# sourceMappingURL=PaymentsStore.js.map

/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports = {"countryCode":{"type":"countryCode","name":"countryCode","label":"countryCode.input.label","required":true,"editable":true,"errorMessage":"countryCode.input.error","priority":40},"email":{"type":"text","name":"email","label":"email.input.label","required":true,"editable":true,"errorMessage":"email.input.error","priority":90},"firstName":{"type":"text","name":"firstName","label":"firstName.input.label","required":true,"editable":true,"errorMessage":"firstName.input.error","priority":80},"lastName":{"type":"text","name":"lastName","label":"lastName.input.label","required":true,"editable":true,"errorMessage":"lastName.input.error","priority":70},"address":{"type":"text","name":"address","label":"address.input.label","required":true,"editable":true,"errorMessage":"address.input.error","priority":60},"city":{"type":"text","name":"city","label":"city.input.label","required":true,"editable":true,"errorMessage":"city.input.error","priority":50},"state":{"type":"state","name":"state","label":"state.input.label","required":true,"editable":true,"errorMessage":"state.input.error","priority":30},"zipCode":{"type":"zipCode","name":"zipCode","label":"zipCode.input.label","required":true,"editable":true,"errorMessage":"zipCode.input.error","priority":20},"phone":{"type":"text","name":"phone","label":"phone.input.label","required":true,"editable":true,"errorMessage":"phone.input.error","priority":10},"fake":{"type":"text","name":"fake","label":"fake.input.label","required":true,"editable":true,"errorMessage":"fake.input.error","priority":250},"holder_id":{"type":"text","name":"holderId","label":"holderId.input.label","required":true,"editable":true,"errorMessage":"holderId.input.error","priority":150},"street":{"type":"text","name":"street","label":"street.input.label","required":true,"editable":true,"errorMessage":"street.input.error","priority":65},"houseNumber":{"type":"text","name":"houseNumber","label":"houseNumber.input.label","required":true,"editable":true,"errorMessage":"houseNumber.input.error","priority":65}}

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldsWithColumns = function (fields, groups) {
    if (fields.length <= 2) {
        // not enough fields
        return fields.map(function (field) { return Object.assign({}, field, { column: '' }); });
    }
    // collect all related(group) fields for each field
    var fieldsGroup = {};
    groups.forEach(function (group) {
        group.forEach(function (field) { return fieldsGroup[field] = group; });
    });
    var nextColumn = '';
    return fields.map(function (field, index) {
        var fieldGroup = fieldsGroup[field.name] || [];
        var nextField = fields[index + 1] || null;
        var column = nextColumn;
        if (nextColumn) {
            nextColumn = '';
        }
        else if (nextField && fieldGroup.indexOf(nextField.name) !== -1) {
            // next field exist and it from current field group, move current/next fields to left/right columns
            nextColumn = 'right';
            column = 'left';
        }
        return Object.assign({}, field, { column: column });
    });
};
//# sourceMappingURL=mandatoryFieldsUIUtils.js.map

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(75);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(224);
var $Object = __webpack_require__(4).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(7);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(9), 'Object', { defineProperty: __webpack_require__(14).f });


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(9) && !__webpack_require__(39)(function () {
  return Object.defineProperty(__webpack_require__(40)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(15);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(228);


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(229);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 229 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(77);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(232);
__webpack_require__(233);
__webpack_require__(243);
__webpack_require__(247);
__webpack_require__(258);
__webpack_require__(259);
module.exports = __webpack_require__(4).Promise;


/***/ }),
/* 232 */
/***/ (function(module, exports) {



/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(234)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(78)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(41);
var defined = __webpack_require__(42);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(8);


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(237);
var descriptor = __webpack_require__(76);
var setToStringTag = __webpack_require__(45);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(8)(IteratorPrototype, __webpack_require__(3)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(5);
var dPs = __webpack_require__(238);
var enumBugKeys = __webpack_require__(85);
var IE_PROTO = __webpack_require__(44)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(40)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(86).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(14);
var anObject = __webpack_require__(5);
var getKeys = __webpack_require__(80);

module.exports = __webpack_require__(9) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(20);
var toIObject = __webpack_require__(43);
var arrayIndexOf = __webpack_require__(240)(false);
var IE_PROTO = __webpack_require__(44)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(43);
var toLength = __webpack_require__(82);
var toAbsoluteIndex = __webpack_require__(241);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(41);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(20);
var toObject = __webpack_require__(87);
var IE_PROTO = __webpack_require__(44)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(244);
var global = __webpack_require__(2);
var hide = __webpack_require__(8);
var Iterators = __webpack_require__(16);
var TO_STRING_TAG = __webpack_require__(3)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(245);
var step = __webpack_require__(246);
var Iterators = __webpack_require__(16);
var toIObject = __webpack_require__(43);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(78)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(79);
var global = __webpack_require__(2);
var ctx = __webpack_require__(18);
var classof = __webpack_require__(88);
var $export = __webpack_require__(7);
var isObject = __webpack_require__(15);
var aFunction = __webpack_require__(19);
var anInstance = __webpack_require__(248);
var forOf = __webpack_require__(249);
var speciesConstructor = __webpack_require__(89);
var task = __webpack_require__(90).set;
var microtask = __webpack_require__(254)();
var newPromiseCapabilityModule = __webpack_require__(46);
var perform = __webpack_require__(91);
var promiseResolve = __webpack_require__(92);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(3)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(255)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(45)($Promise, PROMISE);
__webpack_require__(256)(PROMISE);
Wrapper = __webpack_require__(4)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(257)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(18);
var call = __webpack_require__(250);
var isArrayIter = __webpack_require__(251);
var anObject = __webpack_require__(5);
var toLength = __webpack_require__(82);
var getIterFn = __webpack_require__(252);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(5);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(16);
var ITERATOR = __webpack_require__(3)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(88);
var ITERATOR = __webpack_require__(3)('iterator');
var Iterators = __webpack_require__(16);
module.exports = __webpack_require__(4).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 253 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var macrotask = __webpack_require__(90).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(21)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(8);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var core = __webpack_require__(4);
var dP = __webpack_require__(14);
var DESCRIPTORS = __webpack_require__(9);
var SPECIES = __webpack_require__(3)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(3)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(7);
var core = __webpack_require__(4);
var global = __webpack_require__(2);
var speciesConstructor = __webpack_require__(89);
var promiseResolve = __webpack_require__(92);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(7);
var newPromiseCapability = __webpack_require__(46);
var perform = __webpack_require__(91);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(261);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(262), __esModule: true };

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(263);
module.exports = __webpack_require__(4).Object.assign;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(7);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(264) });


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(80);
var gOPS = __webpack_require__(265);
var pIE = __webpack_require__(266);
var toObject = __webpack_require__(87);
var IObject = __webpack_require__(81);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(39)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 265 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 266 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(75);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loaderWrap":"_1A2vL","paymentsWidget":"_2b2Bc","generalError":"_3L8XX","generalErrorContent":"scsR9","generalErrorText":"_2INEq","circleIcon":"_1xYp5","title":"_294ns","methodsList":"_2tYgy","methodsListItem":"_1JWBE","hide":"_1vUz3"};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var PaymentMethodItem_1 = __webpack_require__(271);
var CreditCardIcon_1 = __webpack_require__(93);
var PayPalIcon_1 = __webpack_require__(94);
var MercadoPagoIcon_1 = __webpack_require__(95);
var PagSeguroIcon_1 = __webpack_require__(96);
var YandexIcon_1 = __webpack_require__(97);
var IDealIcon_1 = __webpack_require__(278);
var SofortIcon_1 = __webpack_require__(280);
var AlipayIcon_1 = __webpack_require__(282);
var styles = __webpack_require__(284);
var PaymentMethodList = /** @class */ (function (_super) {
    __extends(PaymentMethodList, _super);
    function PaymentMethodList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.iconsMap = {
            creditCard: React.createElement(CreditCardIcon_1.default, null),
            payPal: React.createElement(PayPalIcon_1.default, null),
            mercadoPago: React.createElement(MercadoPagoIcon_1.default, null),
            pagSeguro: React.createElement(PagSeguroIcon_1.default, null),
            yandex: React.createElement(YandexIcon_1.default, null),
            iDeal: React.createElement(IDealIcon_1.default, null),
            sofort: React.createElement(SofortIcon_1.default, null),
            alipay: React.createElement(AlipayIcon_1.default, null)
        };
        _this.handleEnterKey = function (value, e) {
            var isActionKey = e.key === 'Enter' || e.key === ' ';
            if (isActionKey && _this.props.onPaymentMethodChanged) {
                _this.props.onPaymentMethodChanged(value);
            }
        };
        return _this;
    }
    PaymentMethodList.prototype.renderList = function () {
        var _this = this;
        return this.props.paymentMethods.map(function (method) {
            var selected = _this.props.selectedMethod === method.value;
            return (React.createElement("div", { className: styles.wrapper, key: method.value, role: "radiogroup", "data-hook": "payment-method-item-" + method.value, onKeyDown: _this.handleEnterKey.bind(_this, method.value) },
                React.createElement(PaymentMethodItem_1.default, { radioButtonClassName: _this.props.radioButtonClassName, label: method.label, icon: _this.iconsMap[method.value], paymentMethodId: method.value, isSelected: selected, onPaymentMethodChanged: _this.props.onPaymentMethodChanged }),
                method.value === _this.props.selectedMethod && _this.props.activePaymentComponentNode
                    ? React.createElement("div", { className: styles.paymentComponent }, _this.props.activePaymentComponentNode)
                    : null));
        });
    };
    PaymentMethodList.prototype.render = function () {
        return (React.createElement("fieldset", { className: styles.paymentMethodList, "data-hook": "wcn-payment-method-list" }, this.renderList()));
    };
    return PaymentMethodList;
}(React.Component));
exports.default = PaymentMethodList;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var s = __webpack_require__(272);
var classNames = __webpack_require__(11);
exports.default = (function (props) {
    var id = "wcn-payment-method-item-" + props.paymentMethodId;
    return (React.createElement("label", { className: s.paymentMethod, "data-hook": "wcn-payment-method-item", htmlFor: props.paymentMethodId, onClick: function (e) {
            if (e) {
                e.stopPropagation();
            }
            return props.onPaymentMethodChanged(props.paymentMethodId);
        } },
        React.createElement("div", { className: s.radioContainer },
            React.createElement("input", { className: classNames(s.paymentMethodInput, 'wixSdkHideFocus'), type: "radio", name: "paymentMethodSelection", id: props.paymentMethodId, value: props.paymentMethodId, checked: props.isSelected, onChange: function () {
                    // fix React error with checked prop without onChange handler
                    return void 0;
                }, "aria-describedby": "wcn-method-description-" + props.paymentMethodId, "data-hook": "wcn-payment-method-item-input-" + props.paymentMethodId }),
            React.createElement("i", { className: 'wixSdkShowFocus', role: "radio", "aria-checked": props.isSelected ? 'true' : 'false' }),
            props.label),
        React.createElement("div", { className: s.icon }, props.icon)));
});


/***/ }),
/* 272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"paymentMethod":"eqc_Q","radioContainer":"_3TT1x","paymentMethodInput":"_3k8yt","icon":"_2I7rV"};

/***/ }),
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"paypalLogo":"_3NnMt"};

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mercadoPagoLogo":"RIeow"};

/***/ }),
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"pagSeguroLogo":"eN4dF"};

/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"yandexLogo":"_22a5-"};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(279);
exports.default = (function (props) { return (React.createElement("div", { className: styles.logoContainer },
    React.createElement("img", { className: styles.logo, src: "https://www.wix.com/_partials/third-party/cashier-settings/methods-new/method-icon-ideal-new-corrected.svg", style: props.style }))); });


/***/ }),
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"logoContainer":"_1vCAa","logo":"_3HN73"};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(281);
exports.default = (function (props) { return (React.createElement("div", { className: styles.logoContainer },
    React.createElement("img", { className: styles.logo, src: "https://www.wix.com/_partials/third-party/cashier-settings/methods-new/method-icon-sofort-new-corrected.svg", style: props.style }))); });


/***/ }),
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"logoContainer":"_2BC7d","logo":"_2Xesy"};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(283);
exports.default = (function (props) { return (React.createElement("div", { className: styles.logoContainer },
    React.createElement("img", { className: styles.logo, src: "https://www.wix.com/_partials/third-party/cashier-settings/methods-new/method-icon-alipay-new-corrected.svg", style: props.style }))); });


/***/ }),
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"logoContainer":"_1wrH_","logo":"_2LD1D"};

/***/ }),
/* 284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"paymentMethodList":"_3hg9K","wrapper":"_15cbL","paymentComponent":"_1s5Cs"};

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moduleRegistry = __webpack_require__(22);

Object.defineProperty(exports, 'ModuleRegistry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_moduleRegistry).default;
  }
});

var _reactLazyComponent = __webpack_require__(349);

Object.defineProperty(exports, 'ReactLazyComponent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reactLazyComponent).default;
  }
});

var _angularLazyComponent = __webpack_require__(361);

Object.defineProperty(exports, 'AngularLazyComponent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_angularLazyComponent).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(287);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(47),
    castPath = __webpack_require__(52),
    isIndex = __webpack_require__(54),
    isObject = __webpack_require__(25),
    toKey = __webpack_require__(55);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(100),
    isMasked = __webpack_require__(291),
    isObject = __webpack_require__(25),
    toSource = __webpack_require__(293);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(49);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 290 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(292);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(24);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 293 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 294 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(17),
    isSymbol = __webpack_require__(53);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(297);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(298);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(299);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(300),
    mapCacheDelete = __webpack_require__(314),
    mapCacheGet = __webpack_require__(316),
    mapCacheHas = __webpack_require__(317),
    mapCacheSet = __webpack_require__(318);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(301),
    ListCache = __webpack_require__(307),
    Map = __webpack_require__(313);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(302),
    hashDelete = __webpack_require__(303),
    hashGet = __webpack_require__(304),
    hashHas = __webpack_require__(305),
    hashSet = __webpack_require__(306);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(27);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 303 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(27);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(27);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(27);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(308),
    listCacheDelete = __webpack_require__(309),
    listCacheGet = __webpack_require__(310),
    listCacheHas = __webpack_require__(311),
    listCacheSet = __webpack_require__(312);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 308 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(28);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(28);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(28);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(28);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(48),
    root = __webpack_require__(24);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(29);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 315 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(29);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(29);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(29);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(49),
    arrayMap = __webpack_require__(320),
    isArray = __webpack_require__(17),
    isSymbol = __webpack_require__(53);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 320 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var baseUnset = __webpack_require__(322);

/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */
function unset(object, path) {
  return object == null ? true : baseUnset(object, path);
}

module.exports = unset;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(52),
    last = __webpack_require__(323),
    parent = __webpack_require__(324),
    toKey = __webpack_require__(55);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 323 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(325),
    baseSlice = __webpack_require__(326);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(52),
    toKey = __webpack_require__(55);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 326 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(328),
    baseEach = __webpack_require__(329),
    castFunction = __webpack_require__(347),
    isArray = __webpack_require__(17);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 328 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(330),
    createBaseEach = __webpack_require__(346);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(331),
    keys = __webpack_require__(103);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(332);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 332 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(334),
    isArguments = __webpack_require__(335),
    isArray = __webpack_require__(17),
    isBuffer = __webpack_require__(337),
    isIndex = __webpack_require__(54),
    isTypedArray = __webpack_require__(339);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 334 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(336),
    isObjectLike = __webpack_require__(26);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(23),
    isObjectLike = __webpack_require__(26);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(24),
    stubFalse = __webpack_require__(338);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)(module)))

/***/ }),
/* 338 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(340),
    baseUnary = __webpack_require__(341),
    nodeUtil = __webpack_require__(342);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(23),
    isLength = __webpack_require__(104),
    isObjectLike = __webpack_require__(26);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 341 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(101);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)(module)))

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(105),
    nativeKeys = __webpack_require__(344);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(345);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 345 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(30);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(57);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(102);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moduleRegistry = __webpack_require__(22);

var _moduleRegistry2 = _interopRequireDefault(_moduleRegistry);

var _baseLazyComponent = __webpack_require__(106);

var _baseLazyComponent2 = _interopRequireDefault(_baseLazyComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactLazyComponent = function (_BaseLazyComponent) {
  _inherits(ReactLazyComponent, _BaseLazyComponent);

  function ReactLazyComponent(props, manifest) {
    _classCallCheck(this, ReactLazyComponent);

    var _this = _possibleConstructorReturn(this, (ReactLazyComponent.__proto__ || Object.getPrototypeOf(ReactLazyComponent)).call(this, props, manifest));

    _this.state = { component: null };
    return _this;
  }

  _createClass(ReactLazyComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.resourceLoader.then(function () {
        var component = _moduleRegistry2.default.component(_this2.manifest.component);
        _this2.setState({ component: component });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return this.state.component ? _react2.default.createElement(this.state.component, this.mergedProps) : null;
    }
  }]);

  return ReactLazyComponent;
}(_baseLazyComponent2.default);

exports.default = ReactLazyComponent;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(47),
    copyObject = __webpack_require__(351),
    createAssigner = __webpack_require__(352),
    isArrayLike = __webpack_require__(30),
    isPrototype = __webpack_require__(105),
    keys = __webpack_require__(103);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(47),
    baseAssignValue = __webpack_require__(98);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(353),
    isIterateeCall = __webpack_require__(360);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(57),
    overRest = __webpack_require__(354),
    setToString = __webpack_require__(356);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(355);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 355 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(357),
    shortOut = __webpack_require__(359);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(358),
    defineProperty = __webpack_require__(99),
    identity = __webpack_require__(57);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 358 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 359 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(51),
    isArrayLike = __webpack_require__(30),
    isIndex = __webpack_require__(54),
    isObject = __webpack_require__(25);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(63);

var _tagAppender = __webpack_require__(107);

var _moduleRegistry = __webpack_require__(22);

var _moduleRegistry2 = _interopRequireDefault(_moduleRegistry);

var _baseLazyComponent = __webpack_require__(106);

var _baseLazyComponent2 = _interopRequireDefault(_baseLazyComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddRouterContext = function (_React$Component) {
  _inherits(AddRouterContext, _React$Component);

  function AddRouterContext() {
    _classCallCheck(this, AddRouterContext);

    return _possibleConstructorReturn(this, (AddRouterContext.__proto__ || Object.getPrototypeOf(AddRouterContext)).apply(this, arguments));
  }

  _createClass(AddRouterContext, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { router: this.props.router };
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AddRouterContext;
}(_react2.default.Component);

AddRouterContext.childContextTypes = {
  router: _propTypes2.default.any
};
AddRouterContext.propTypes = {
  router: _propTypes2.default.any,
  children: _propTypes2.default.any
};

var AngularLazyComponent = function (_BaseLazyComponent) {
  _inherits(AngularLazyComponent, _BaseLazyComponent);

  function AngularLazyComponent() {
    _classCallCheck(this, AngularLazyComponent);

    return _possibleConstructorReturn(this, (AngularLazyComponent.__proto__ || Object.getPrototypeOf(AngularLazyComponent)).apply(this, arguments));
  }

  _createClass(AngularLazyComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      this.mounted = true;
      this.resourceLoader.then(function () {
        if (_this3.mounted) {
          var component = '<' + _this3.manifest.component + '></' + _this3.manifest.component + '>';
          _this3.$injector = angular.bootstrap(component, [_this3.manifest.module, ['$provide', '$compileProvider', function ($provide, $compileProvider) {
            $provide.factory('props', function () {
              return function () {
                return _this3.mergedProps;
              };
            });
            $compileProvider.directive('moduleRegistry', function () {
              return {
                scope: { component: '@', props: '<' },
                controller: ['$scope', '$element', function ($scope, $element) {
                  var Component = _moduleRegistry2.default.component($scope.component);
                  $scope.$watch(function () {
                    return $scope.props;
                  }, function () {
                    (0, _reactDom.render)(_react2.default.createElement(
                      AddRouterContext,
                      { router: _this3.props.router },
                      _react2.default.createElement(Component, $scope.props)
                    ), $element[0]);
                  }, true);
                  $scope.$on('$destroy', function () {
                    return (0, _reactDom.unmountComponentAtNode)($element[0]);
                  });
                  //super hack to prevent angular from preventing external route changes
                  $element.on('click', function (e) {
                    return e.preventDefault = function () {
                      return delete e.preventDefault;
                    };
                  });
                }]
              };
            });
            $compileProvider.directive('routerLink', function () {
              return {
                transclude: true,
                scope: { to: '@' },
                template: '<a ng-href="{{to}}" ng-click="handleClick($event)"><ng-transclude></ng-transclude></a>',
                controller: ['$scope', function ($scope) {
                  $scope.handleClick = function (event) {
                    if (event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) {
                      return;
                    } else {
                      _this3.props.router.push($scope.to);
                      event.preventDefault();
                    }
                  };
                }]
              };
            });
          }]]);
          _this3.node.appendChild(_this3.$injector.get('$rootElement')[0]);
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
      if (this.$injector) {
        this.$injector.get('$rootScope').$destroy();
        this.$injector = null;
      }
      if (this.manifest.unloadStylesOnDestroy !== false) {
        (0, _tagAppender.unloadStyles)(document, this.manifest.files);
      }
      _get(AngularLazyComponent.prototype.__proto__ || Object.getPrototypeOf(AngularLazyComponent.prototype), 'componentWillUnmount', this).call(this);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.$injector && !this.$injector.get('$rootScope').$$phase) {
        this.$injector.get('$rootScope').$digest();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement('div', { ref: function ref(node) {
          return _this4.node = node;
        } });
    }
  }]);

  return AngularLazyComponent;
}(_baseLazyComponent2.default);

AngularLazyComponent.propTypes = {
  router: _propTypes2.default.any
};

exports.default = AngularLazyComponent;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(363);
var PayPalIcon_1 = __webpack_require__(94);
var CreditCardIcon_1 = __webpack_require__(93);
var MercadoPagoIcon_1 = __webpack_require__(95);
var PagSeguroIcon_1 = __webpack_require__(96);
var YandexIcon_1 = __webpack_require__(97);
var OfflineIcon_1 = __webpack_require__(364);
var CreditCardTypeIcon_1 = __webpack_require__(366);
var iconHash = {
    maestro: React.createElement(CreditCardTypeIcon_1.default, { cardType: "maestro" }),
    dankort: React.createElement(CreditCardTypeIcon_1.default, { cardType: "dankort" }),
    visa: React.createElement(CreditCardTypeIcon_1.default, { cardType: "visa" }),
    mastercard: React.createElement(CreditCardTypeIcon_1.default, { cardType: "mastercard" }),
    amex: React.createElement(CreditCardTypeIcon_1.default, { cardType: "amex" }),
    americanExpress: React.createElement(CreditCardTypeIcon_1.default, { cardType: "amex" }),
    dinersclub: React.createElement(CreditCardTypeIcon_1.default, { cardType: "diners" }),
    discover: React.createElement(CreditCardTypeIcon_1.default, { cardType: "discover" }),
    discoverDiners: React.createElement(CreditCardTypeIcon_1.default, { cardType: "discover" }),
    unionpay: React.createElement(CreditCardTypeIcon_1.default, { cardType: "unionpay" }),
    creditCard: React.createElement(CreditCardIcon_1.default, null),
    payPal: React.createElement(PayPalIcon_1.default, null),
    mercadoPago: React.createElement(MercadoPagoIcon_1.default, null),
    pagSeguro: React.createElement(PagSeguroIcon_1.default, null),
    yandex: React.createElement(YandexIcon_1.default, null),
    offline: React.createElement(OfflineIcon_1.default, null),
    fakePaymentMethod: (React.createElement("img", { className: styles.icon, src: "https://www.wix.com/_partials/third-party/cashier-settings/methods/method-icon-fakePaymentMethod.svg" }))
};
exports.default = (function (props) {
    return (React.createElement("div", { className: styles.collapsedPayment, "data-hook": "wcn-collapsed-payment" },
        iconHash[props.iconName],
        React.createElement("div", { className: styles.text }, props.title)));
});


/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"collapsedPayment":"_2DoC_","text":"_2socL","icon":"_3rYJ5","payPal":"RVdAR"};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(365);
exports.default = (function (props) { return (React.createElement("img", { className: styles.offline, src: "https://www.wix.com/_partials/third-party/cashier-settings/methods-new/method-icon-offline-new.svg", style: props.style })); });


/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"offline":"_3aIRa"};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(367);
exports.default = (function (props) { return (React.createElement("div", null,
    React.createElement("img", { className: styles.creditCardTypeIcon, src: "https://www.wix.com/_partials/third-party/cashier-settings/images/" + props.cardType + ".svg" }))); });


/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"creditCardTypeIcon":"_2GZuV"};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var web_bi_logger_1 = __webpack_require__(369);
var BiLogger = /** @class */ (function () {
    function BiLogger() {
        var _this = this;
        this.init = function (_a) {
            var appId = _a.appId, appInstanceId = _a.appInstanceId, orderSnapshotId = _a.orderSnapshotId, visitorId = _a.visitorId, msid = _a.msid;
            _this.logger = web_bi_logger_1.default.factory({
                endpoint: 'cashier-ugc'
            }).setDefaults({
                src: 64,
                appId: appId,
                appInstanceId: appInstanceId,
                orderSnapshotId: orderSnapshotId,
                visitorId: visitorId,
                msid: msid,
                buyerComponent: 'react',
                ownerId: 'undefined',
                roles: ''
            }).logger();
        };
        this.log = function (_a) {
            var evid = _a.evid, rest = __rest(_a, ["evid"]);
            return _this.logger.log(__assign({ evid: evid }, rest));
        };
        this.creditCardLoaded = function (_a) {
            var duration = _a.duration, paymentCategory = _a.paymentCategory, paymentProvider = _a.paymentProvider, source = _a.source;
            // when credit card completly loaded and displayed in iframe
            var evid = 100;
            _this.log({ evid: evid, paymentCategory: paymentCategory, paymentProvider: paymentProvider, duration: duration, source: source });
        };
        this.submitOrder = function (_a) {
            var errorDesc = _a.errorDesc, paymentMethodType = _a.paymentMethodType, status = _a.status, paymentProvider = _a.paymentProvider;
            // when user clicked submit order, place order, tokenize?
            var evid = 104;
            _this.log({ evid: evid, errorDesc: errorDesc, paymentMethodType: paymentMethodType, status: Boolean(status), paymentProvider: paymentProvider });
        };
        this.buyerChoosedPaymentMethod = function (_a) {
            var paymentMethod = _a.paymentMethod;
            // when user choosed some payment method(click on radio button)
            var evid = 105;
            _this.log({ evid: evid, paymentMethod: paymentMethod });
        };
        this.buyerLoadStart = function (_a) {
            var duration = _a.duration;
            // when load of component started
            var evid = 125;
            _this.log({ evid: evid, duration: duration });
        };
        this.buyerLoadCompleted = function (_a) {
            var duration = _a.duration, status = _a.status;
            // when load of component started
            var evid = 126;
            _this.log({ evid: evid, duration: duration, status: Boolean(status) });
        };
        this.transactionStatus = function (_a) {
            var paymentMethodType = _a.paymentMethodType, paymentProvider = _a.paymentProvider, transactionId = _a.transactionId, transactionStatus = _a.transactionStatus;
            // when load of component started
            var evid = 103;
            _this.log({ evid: evid, paymentMethodType: paymentMethodType, paymentProvider: paymentProvider, transactionId: transactionId, transactionStatus: transactionStatus });
        };
    }
    return BiLogger;
}());
exports.default = (new BiLogger());


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biLoggerFactory = __webpack_require__(109);

var _biLoggerFactory2 = _interopRequireDefault(_biLoggerFactory);

var _env = __webpack_require__(31);

var _publishers = __webpack_require__(374);

var _browsingSession = __webpack_require__(377);

var browsingSession = _interopRequireWildcard(_browsingSession);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var publisher = void 0;

  if ((0, _env.isWebWorker)()) {
    publisher = _publishers.fetchPublisher;
  } else if (options.useBeacon) {
    publisher = _publishers.beaconPublisher;
  } else {
    publisher = _publishers.imagePublisher;
  }

  return publisher(options);
}

var _factory = function _factory(options) {
  return new _biLoggerFactory2.default().addPublisher(getPublisher(options));
};

var logger = {
  factory: function factory() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var trackSession = options.trackSession || typeof options.trackSession === 'undefined';

    if (trackSession) {
      browsingSession.track(_factory);
    }

    return _factory(options);
  },
  setHost: _env.setHost
};

exports.default = logger;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assert = __webpack_require__(110);

var _require = __webpack_require__(371),
    mapValues = _require.mapValues;

var promise = __webpack_require__(372);

var _require2 = __webpack_require__(373),
    log = _require2.log;

var BiLogger = function () {
  //TODO: validate args
  function BiLogger(options, context) {
    _classCallCheck(this, BiLogger);

    this._publishers = options.publishers;
    this._validators = options.validators || [];
    this._defaults = options.defaults;
    this._events = options.events || {};
    this._context = context;
    this._defaultValueTimeout = options.defaultValueTimeout || 5000;
    this._defaultContinueOnFail = options.defaultContinueOnFail || false;
  }

  _createClass(BiLogger, [{
    key: 'log',
    value: function log(eventOrKey, eventOrUndefined) {
      var _this = this;

      assert.defined(eventOrKey, 'Event object or event key must be provided.');
      var event = this._eventOrExtractFromEvents(eventOrKey, eventOrUndefined);

      return this._getDefaults().then(function (defaults) {
        var fullEvent = Object.assign({}, defaults, event);

        var validatorsResult = _this._validators.length === 0 ? true : _this._validators.some(function (validator) {
          return validator.match(fullEvent) && (validator.execute(fullEvent) || true);
        });

        if (!validatorsResult) {
          throw new Error('No validator accepted the event. Source: ' + fullEvent.src + ' Evid: ' + (fullEvent.evid || fullEvent.evtId));
        }

        return Promise.all(_this._publishers.map(function (publish) {
          var cloned = Object.assign({}, fullEvent);

          return Promise.resolve().then(function () {
            return publish(cloned, _this._context);
          }).catch(function (error) {
            if (error && error.message && error.stack) {
              error.message = 'Publisher \'' + publish.name + '\' failed with error: \'' + error.message + '\'';
            }

            return Promise.reject(error);
          });
        }));
      });
    }
  }, {
    key: '_eventOrExtractFromEvents',
    value: function _eventOrExtractFromEvents(eventOrKey, eventOrUndefined) {
      if (typeof eventOrKey !== 'string') {
        return eventOrKey;
      }
      var event = this._events[eventOrKey];
      if (!event) {
        throw new assert.AssertionError('Event with key \'' + eventOrKey + '\' not found in event map.');
      }

      if (eventOrUndefined) {
        return Object.assign({}, event, eventOrUndefined);
      } else {
        return event;
      }
    }
  }, {
    key: '_handleDefaultsError',
    value: function _handleDefaultsError(err) {
      if (this._defaultContinueOnFail) {
        log.error(err);
        return null;
      }
      return Promise.reject(err);
    }
  }, {
    key: '_getDefaults',
    value: function _getDefaults() {
      var _this2 = this;

      if (!this._defaults) {
        return Promise.resolve({});
      }

      var promises = mapValues(this._defaults, function (value, key) {
        if (typeof value === 'function') {
          try {
            value = value();
          } catch (err) {
            return _this2._handleDefaultsError(err);
          }
        }
        if (value && typeof value.then !== 'function') {
          return value;
        }
        return promise.timedPromise(value, {
          message: 'Cannot get default value \'' + key + ' for BI Event\'',
          timeout: _this2._defaultValueTimeout
        }).catch(function (err) {
          return _this2._handleDefaultsError(err);
        });
      });

      return promise.allAsObject(promises);
    }
  }]);

  return BiLogger;
}();

module.exports = BiLogger;
//# sourceMappingURL=bi-logger.js.map

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This callback type is called `requestCallback` and is displayed as a global symbol.
 *
 * @callback iterateeCallback
 * @param {*} Value
 * @param {string} Key
 * @param {object} Original object
 */
/**
 * Iterates over object values
 * @param {Object} collection
 * @param {iterateeCallback} iteratee
 * @return {Object} iterated object
 */
module.exports.mapValues = function (collection, iteratee) {
  if (!collection) {
    return {};
  }
  return Object.keys(collection).reduce(function (acc, key) {
    acc[key] = iteratee(collection[key], key, collection);
    return acc;
  }, {});
};
//# sourceMappingURL=collections.js.map

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * rejects original promise after specified timeout
 * @param {Promise<R>} promise Original promise
 * @param {string} [message] Additional message for timeout reject
 * @param {number} timeout Time for reject
 * @return {Promise<R>}
 */
module.exports.timedPromise = function (promise, _ref) {
  var message = _ref.message,
      timeout = _ref.timeout;

  var timeoutPromise = new Promise(function (resolve, reject) {
    setTimeout(reject, timeout, message ? 'Timeout: ' + message : 'Timeout');
  });
  return Promise.race([promise, timeoutPromise]);
};

/**
 * Works like Promise.all expect uses object insetead of array.
 * @param {Object} promiseObject
 * @return {Promise} Promise wiht original keys and resolved values
 */
module.exports.allAsObject = function (promiseObject) {
  var keys = Object.keys(promiseObject);
  return Promise.all(keys.map(function (key) {
    return promiseObject[key];
  })).then(function (resolved) {
    return resolved.reduce(function (acc, value, i) {
      acc[keys[i]] = value;
      return acc;
    }, {});
  });
};
//# sourceMappingURL=promise.js.map

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.log = {
  error: function error() {
    if (console && console.error) {
      var _console;

      (_console = console).error.apply(_console, arguments);
    }
  }
};
//# sourceMappingURL=log.js.map

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imagePublisher = imagePublisher;
exports.beaconPublisher = beaconPublisher;
exports.fetchPublisher = fetchPublisher;

var _utils = __webpack_require__(111);

var _transport = __webpack_require__(376);

function imagePublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function imagePublisher(params) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // eslint-disable-line func-names
    var url = (0, _utils.buildUrl)(options, params);
    return (0, _transport.pixel)(url, context.image);
  };
}

function beaconPublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function beaconPublisher(params) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // eslint-disable-line func-names
    var url = (0, _utils.buildUrl)(options, params);
    return (0, _transport.beacon)(url).catch(function () {
      return (0, _transport.pixel)(url, context.image);
    });
  };
}

function fetchPublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function fetchPublisher(params) {
    // eslint-disable-line func-names
    var url = (0, _utils.buildUrl)(options, params);
    return fetch(url, { credentials: 'include' }).then(function (response) {
      if (!response.ok) {
        throw Error(response.status);
      }
      return response;
    });
  };
}

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.now = now;
function now() {
  return typeof performance !== 'undefined' && performance && performance.now ? performance.now() : -1;
}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.beacon = beacon;
exports.pixel = pixel;

var _navigator = __webpack_require__(112);

function beacon(url) {
  return new Promise(function (resolve, reject) {
    return (0, _navigator.sendBeacon)(url) ? resolve(url) : reject(url);
  });
}

function pixel(url, image) {
  return new Promise(function (resolve, reject) {
    var biImage = image || new Image(0, 0);
    biImage.onload = resolve;
    biImage.onerror = reject;
    biImage.src = url;
  });
}

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.track = track;

var _utils = __webpack_require__(111);

var _navigator = __webpack_require__(112);

var _env = __webpack_require__(31);

var _screen = __webpack_require__(378);

var IS_TRACKING = '__isTrackingBiBrowsingSession__';
var ENDPOINT = 'p';
var SOURCE = 19;
var EVID = 3;

function shouldTrack() {
  return !(0, _env.isWebWorker)() && (0, _env.provideBrowsingContext)(function (window) {
    return !window[IS_TRACKING];
  });
}

function setIsTracking() {
  return (0, _env.provideBrowsingContext)(function (window) {
    return window[IS_TRACKING] = true;
  });
}

function getLogger(loggerFactory) {
  return loggerFactory({ endpoint: ENDPOINT, useBeacon: true }).setDefaults({ src: SOURCE, evid: EVID, vsi: (0, _utils.guid)() }).logger();
}

function trackBrowsingSession(loggerFactory) {
  var logger = getLogger(loggerFactory);
  var firstInSession = 1;

  (0, _navigator.listen)(function (fromUrl, toUrl) {
    var _provideBrowsingConte = (0, _env.provideBrowsingContext)(function (window) {
      return { sr: (0, _screen.getDesktopSize)(window), wr: (0, _screen.getWindowSize)(window) };
    }),
        sr = _provideBrowsingConte.sr,
        wr = _provideBrowsingConte.wr;

    logger.log({ from: fromUrl, to: toUrl, fis: firstInSession, sr: sr, wr: wr });
    firstInSession = 0;
  });
}

/**
 * Sends a page view event on initial load and on every page switch
 * BI event definition: http://bo.wix.com/bi-catalog-webapp/#/sources/19/events/3
 */
function track(loggerFactory) {
  if (shouldTrack()) {
    setIsTracking();
    trackBrowsingSession(loggerFactory);
  }
}

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDesktopSize = getDesktopSize;
exports.getWindowSize = getWindowSize;
function getDesktopSize(window) {
  var width = window.screen && window.screen.width || 0;
  var height = window.screen && window.screen.height || 0;

  return width + "x" + height;
}

function getWindowSize(window) {
  var width = 0;
  var height = 0;

  if (window.innerWidth) {
    width = window.innerWidth;
    height = window.innerHeight;
  } else if (window.document) {
    if (window.document.documentElement && window.document.documentElement.clientWidth) {
      width = window.document.documentElement.clientWidth;
      height = window.document.documentElement.clientHeight;
    } else if (window.document.body && window.document.body.clientWidth) {
      width = window.document.body.clientWidth;
      height = window.document.body.clientHeight;
    }
  }

  return width + "x" + height;
}

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.getVisibleFocusingElements = function () { return [].map.call(document.getElementsByName('paymentMethodSelection'), function (e) { return e; })
    .filter(function (element) { return window.getComputedStyle(element, null).display !== 'none' && element.offsetParent; }); };
exports.focusNextEl = function (target) {
    var focusingElements = exports.getVisibleFocusingElements();
    var currentElementIndex = focusingElements.indexOf(target);
    var nextElementIndex = currentElementIndex >= focusingElements.length - 1 ? 0 : currentElementIndex + 1;
    focusEl(focusingElements[nextElementIndex]);
};
exports.focusPrevEl = function (target) {
    var focusingElements = exports.getVisibleFocusingElements();
    var currentElementIndex = focusingElements.indexOf(target);
    var prevElementIndex = currentElementIndex <= 0 ?
        focusingElements.length - 1 :
        currentElementIndex - 1;
    focusEl(focusingElements[prevElementIndex]);
};
var focusEl = function (elementToFocus) {
    if (elementToFocus) {
        elementToFocus.focus();
        elementToFocus.click();
    }
};


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var classNames = __webpack_require__(11);
var styles = __webpack_require__(381);
var Translate_1 = __webpack_require__(113);
exports.default = (function (props) {
    return (React.createElement("div", { className: styles.terms, tabIndex: 0 },
        React.createElement("input", { id: "accept-terms", type: "checkbox", "data-hook": "wcn-wallet-payment-terms-input", onChange: props.handleTermsStatusChange, tabIndex: -1, ref: function (node) { return _this.node = node; } }),
        React.createElement("label", { htmlFor: "accept-terms" },
            React.createElement(Translate_1.default, { forKey: "terms.conditions.agree" }),
            " "),
        React.createElement("a", { className: classNames(styles.termsLink, !props.termsAndConditionsLink && styles.disabledLink), href: props.termsAndConditionsLink },
            React.createElement(Translate_1.default, { forKey: "terms.conditions" }))));
});


/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"submitWrapper":"_1bOTv","disabledLink":"_2O6bY","submit":"_2Rpwj","disabled":"qCU-b","paypalSubmit":"_1iMCn","termsLink":"_1DHpu","terms":"_1_yKp"};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var MethodFactory_1 = __webpack_require__(383);
var events_1 = __webpack_require__(415);
var axios_1 = __webpack_require__(59);
var i18n_1 = __webpack_require__(416);
var PaymentModule_1 = __webpack_require__(422);
var MandatoryFields_1 = __webpack_require__(423);
var interpolate_1 = __webpack_require__(58);
var paymentsApi_1 = __webpack_require__(32);
var biLogger_1 = __webpack_require__(119);
var config = __webpack_require__(61);
var defaults = {
    selector: 'body',
    query: {},
    type: 'BUYER',
    styles: {},
    walletPaymentInNewTab: false,
};
// This payment provider is not available at the moment. Please try again in a few minutes.
var DEFAULT_ERROR_CODE = 999;
var CashierPayments = /** @class */ (function () {
    function CashierPayments(resources) {
        var _this = this;
        this.modules = {};
        this.addMethod = function (methodId, props) {
            var _props = props || {};
            return _this.methodFactory.addMethod(methodId, __assign({ localizeError: _this.localizeError }, _this.props, _props, { paymentModule: _this.paymentModule }));
        };
        this.getPaymentMethodMetadata = function (methodId) {
            var foundMethod = _this.methodFactory.getMethod(methodId);
            if (foundMethod) {
                return __assign({ id: methodId }, foundMethod.getMetadata());
            }
            return Promise.reject({ code: 404 });
        };
        this.populateMethodFactory = function (data) {
            if (data && data.paymentMethods) {
                data.paymentMethods = data.paymentMethods.map(function (pm) {
                    return __assign({}, pm, { icon: i18n_1.translate("icons." + pm.paymentMethod), name: i18n_1.translate(pm.paymentMethod) });
                });
                data.paymentMethods.forEach(function (paymentMethod) {
                    var squareAppId = '';
                    if (paymentMethod && paymentMethod.paymentMethod === 'creditCard' && paymentMethod.additionalInfo) {
                        squareAppId = paymentMethod.additionalInfo.squareAppId;
                    }
                    var query = Object.assign({}, _this.props.query, {
                        providerId: paymentMethod.connectedProviderId,
                        squareAppId: squareAppId || ''
                    }, paymentMethod.additionalInfo || {}, !!paymentMethod.installments ? { creditCardMaxInstallments: paymentMethod.installments.maxInstallments } : {}, !!paymentMethod.installments ? { creditCardMinInstallments: paymentMethod.installments.minInstallments } : {}, !!paymentMethod.installments ? { isInstallmentsSupported: true } : {});
                    _this.addMethod(paymentMethod.paymentMethod, Object.assign({}, _this.props, { query: query, paymentModule: _this.paymentModule }));
                });
            }
            return data;
        };
        this.fetchPaymentMethods = function (host, settingsRequestUrl, countryCode3, noPopulate) {
            if (!host && _this.props && _this.props.host) {
                host = _this.props.host;
            }
            return _this.i18nPromise.then(function () {
                // example of real url
                // 'https://cashier-services.wix.com/_api/payment-services-web/payments/v2/orders/88889d4e-5233-47b7-b4f2-857b72f12813/payment-methods?country=ISR'
                var extraParams = [];
                if (countryCode3) {
                    extraParams.push("country=" + countryCode3);
                }
                if (_this.props.query && _this.props.query.amount) {
                    extraParams.push("amount=" + _this.props.query.amount);
                }
                var extraParamsString = extraParams.length ? ('?' + extraParams.join('&')) : '';
                return axios_1.default.get(host + ("" + settingsRequestUrl + extraParamsString)).then(function (response) {
                    if (noPopulate) {
                        return response.data;
                    }
                    var populatedData = _this.populateMethodFactory(response.data) || {};
                    var filteredMethods = (populatedData.paymentMethods || []).filter(function (method) { return method.paymentMethod !== 'squarePOS' && method.paymentMethod !== 'pos'; });
                    return __assign({}, populatedData, { paymentMethods: filteredMethods });
                });
            });
        };
        this.getSettingsRequestUrl = function (configuration) {
            var accountId = configuration.appId + ":" + configuration.appInstanceId;
            var baseUrl = !configuration.snapshotId ? config.paymentMethodsAccountApiUrl : config.paymentMethodsOrderApiUrl;
            return interpolate_1.default(baseUrl, { accountId: accountId, orderId: configuration.snapshotId });
        };
        this.fetchPaymentMethodSettings = function (paymentMethod, _a, host) {
            var appId = _a.appId, appInstanceId = _a.appInstanceId, orderId = _a.orderId;
            return new Promise(function (resolve, reject) {
                _this.resolveCountry(host).then(function (result) {
                    var country = result.country || '';
                    paymentsApi_1.default.fetchPaymentMethodSettings({ appId: appId, appInstanceId: appInstanceId, orderId: orderId, paymentMethod: paymentMethod, country: country }, host).then(function (data) {
                        resolve(__assign({}, data, { countryCode: result && result.country }));
                    }).catch(function (e) { return console.log(e) || reject({
                        status: 'FAILURE',
                        errorCode: '500',
                        translatedError: ''
                    }); });
                }).catch(function () { return reject({
                    status: 'FAILURE',
                    errorCode: '500',
                    translatedError: ''
                }); });
            });
        };
        this.fetchPaymentMethodsByConfiguration = function (configuration, country, host) {
            if (country === void 0) { country = ''; }
            if (host === void 0) { host = ''; }
            if (!host && _this.props && _this.props.host) {
                host = _this.props.host;
            }
            var noPopulate = true;
            return _this.fetchPaymentMethods(host, _this.getSettingsRequestUrl(configuration), country, noPopulate);
        };
        this.fetchSettings = function (configuration, host) {
            if (host === void 0) { host = ''; }
            if (!configuration.appInstanceId || !configuration.appId) {
                return null; //TODO: throw relevant missing params error here
            }
            if (!host && _this.props && _this.props.host) {
                host = _this.props.host;
            }
            var settingsRequestUrl = _this.getSettingsRequestUrl(configuration);
            return new Promise(function (resolve, reject) {
                _this.resolveCountry(host).then(function (result) {
                    _this.fetchPaymentMethods(host, settingsRequestUrl, result && result.country)
                        .then(function (data) { return resolve(__assign({}, data, { countryCode: result && result.country })); })
                        .catch(function () { return reject({
                        status: 'FAILURE',
                        errorCode: '500',
                        translatedError: ''
                    }); });
                }).catch(function () {
                    // TODO currently this needed for backcompability, to not broke production
                    _this.fetchPaymentMethods(host, settingsRequestUrl, '')
                        .then(function (data) { return resolve(data); })
                        .catch(function () { return reject({
                        status: 'FAILURE',
                        errorCode: '500',
                        translatedError: ''
                    }); });
                });
            });
        };
        this.setActivePaymentMethod = function (pmId) {
            _this.activePaymentMethod = pmId;
            if (_this.props.onPaymentMethodChanged) {
                _this.props.onPaymentMethodChanged(pmId, { type: 'PAYMENT_METHOD_CHANGED', pmId: pmId });
            }
        };
        this.init = function (configuration, linkToWindow) {
            if (configuration === void 0) { configuration = {}; }
            var type = configuration.type !== 'RAW' ? { selector: configuration.selector } : {};
            _this.props = __assign({}, defaults, configuration, type);
            _this.eventEmitter = new events_1.EventEmitter();
            _this.i18nPromise = new Promise(function (resolve) {
                _this.i18n = i18n_1.init(_this.props.query.locale || 'en', _this.resources, function () {
                    resolve();
                });
            });
            var _a = _this.props, appId = _a.appId, appInstanceId = _a.appInstanceId, snapshotId = _a.snapshotId, onMerchantSettingsFetch = _a.onMerchantSettingsFetch, msid = _a.msid, visitorId = _a.visitorId;
            _this.linkToWindow = linkToWindow;
            _this.methodFactory = new MethodFactory_1.default();
            _this.paymentModule = new PaymentModule_1.default(_this.localizeError, linkToWindow, _this.props, _this.eventEmitter);
            var shouldPrefetch = !configuration.noPrefetchOnInit;
            if (shouldPrefetch) {
                _this.tryAutoFetchSettings({ appId: appId, appInstanceId: appInstanceId, snapshotId: snapshotId, onMerchantSettingsFetch: onMerchantSettingsFetch });
            }
            _this.modules.mandatoryFields = new MandatoryFields_1.default();
            biLogger_1.default.init({
                type: _this.props.biType || 'web',
                appId: appId,
                appInstanceId: appInstanceId,
                visitorId: visitorId,
                msid: msid,
                orderSnapshotId: snapshotId,
                host: _this.props.biHost,
            });
            return true;
        };
        this.on = function (event, handler) {
            _this.eventEmitter.on(event, handler);
        };
        this.off = function (event, handler) {
            _this.eventEmitter.removeListener(event, handler);
        };
        this.tryAutoFetchSettings = function (_a) {
            var appId = _a.appId, appInstanceId = _a.appInstanceId, snapshotId = _a.snapshotId, onMerchantSettingsFetch = _a.onMerchantSettingsFetch;
            var handler = onMerchantSettingsFetch || (function () { return false; });
            var resultPromise = _this.fetchSettings({ appId: appId, appInstanceId: appInstanceId, snapshotId: snapshotId });
            resultPromise && resultPromise.then(function (res) {
                handler(null, res);
            }).catch(function (err) { return handler(err, {}); });
        };
        this.render = function (method, node) {
            if (!_this.methodFactory) {
                return Promise.reject({
                    status: 'FAILURE',
                    errorCode: 500,
                    translatedError: method + " not inited",
                    paymentMethod: method
                });
            }
            var foundMethod = _this.methodFactory.getMethod(method || _this.activePaymentMethod);
            if (foundMethod) {
                return foundMethod.render(node);
            }
        };
        this.setMandatoryField = function (name, field) { return _this.modules.mandatoryFields.setMandatoryField(name, field); };
        this.getMandatoryFieldsMap = function () { return _this.modules.mandatoryFields.getMandatoryFieldsMap(); };
        this.reload = function () {
            _this.remove();
            _this.init(_this.props, _this.linkToWindow);
            return true;
        };
        this.remove = function () {
            _this.methodFactory && _this.methodFactory.remove();
            return true;
        };
        this.submit = function (method) { return _this.pay(method); };
        this.expand = function (method) {
            var foundMethod = _this.methodFactory.getMethod(method || _this.activePaymentMethod);
            if (foundMethod && foundMethod.expand) {
                return foundMethod.expand(method || _this.activePaymentMethod);
            }
            return Promise.reject({ code: 404 });
        };
        this.collapse = function (method) {
            var foundMethod = _this.methodFactory.getMethod(method || _this.activePaymentMethod);
            if (foundMethod && foundMethod.collapse) {
                return foundMethod.collapse(method || _this.activePaymentMethod);
            }
            return Promise.reject({ code: 404 });
        };
        this.validate = function (method) {
            var foundMethod = _this.methodFactory.getMethod(method || _this.activePaymentMethod);
            if (foundMethod) {
                return foundMethod.validate(method || _this.activePaymentMethod);
            }
            return Promise.reject({ code: 404 });
        };
        this.launchPaymentPopup = function (method, _a) {
            var chargeResponse = (_a === void 0 ? { chargeResponse: {} } : _a).chargeResponse;
            return _this.paymentModule.launchPaymentPopup(method, { chargeResponse: chargeResponse });
        };
        this.cancelPaymentPopup = function (method) {
            return _this.paymentModule.cancelPaymentPopup();
        };
        this.continuePayment = function (method, _a) {
            var _b = _a === void 0 ? { chargeResponse: {}, inNewTab: false } : _a, chargeResponse = _b.chargeResponse, inNewTab = _b.inNewTab;
            return _this.paymentModule.continuePayment(method, { chargeResponse: chargeResponse, inNewTab: inNewTab });
        };
        this.getCreditCardPublicData = function () {
            var method = _this.methodFactory.getMethod('creditCard');
            if (method && method.getCreditCardPublicData) {
                return method.getCreditCardPublicData();
            }
        };
        this.tokenize = function (method) {
            var foundMethod = _this.methodFactory.getMethod(method || _this.activePaymentMethod);
            if (foundMethod && foundMethod.tokenize) {
                return foundMethod.tokenize(method || _this.activePaymentMethod);
            }
            return Promise.reject({ code: 404 });
        };
        this.setInstallments = function (method, installments) {
            var foundMethod = _this.methodFactory.getMethod(method || _this.activePaymentMethod);
            if (foundMethod && foundMethod.setInstallments) {
                foundMethod.setInstallments(installments || 1);
            }
        };
        this.localizeError = function (errorCode, locale) {
            return new Promise(function (resolve) {
                var defaultLocale = _this.props.query && _this.props.query.locale;
                var currentLocale = locale || defaultLocale || 'en';
                var isLanguageLoaded = _this.i18n && _this.i18n.store && _this.i18n.store.data && _this.i18n.store.data[currentLocale];
                if (!_this.i18n || !isLanguageLoaded) {
                    _this.i18nPromise = new Promise(function (i18nPromiseResolve) {
                        _this.i18n = i18n_1.init(currentLocale, null, function () { return setTimeout(function () {
                            i18nPromiseResolve();
                            resolve(i18n_1.errorCodeToMessage(errorCode, locale));
                        }); });
                    });
                }
                else {
                    return resolve(i18n_1.errorCodeToMessage(errorCode, currentLocale));
                }
            });
        };
        this.pay = function (method) {
            var foundMethod = _this.methodFactory.getMethod(method || _this.activePaymentMethod);
            if (foundMethod && foundMethod.pay) {
                return foundMethod.pay(method || _this.activePaymentMethod, _this.getMandatoryFieldsMap())
                    .catch(function (e) {
                    var error = typeof e !== 'object' || !e.errorCode ? { errorCode: 500 } : e;
                    if (_this.props.onError) {
                        _this.props.onError(method, {
                            type: 'PAYMENT_ERROR',
                            error: error
                        });
                    }
                    return error;
                });
            }
            return Promise.reject({ code: 404 });
        };
        this.saveCreditCard = function (creditCard, host) {
            if (host === void 0) { host = 'https://cashier.wix.com'; }
            return axios_1.default.post(host + config.creditCardsUrl, { creditCard: creditCard }).then(function (response) { return response.data; });
        };
        this.fetchSavedCreditCards = function (host) {
            if (host === void 0) { host = 'https://cashier.wix.com'; }
            return axios_1.default.get(host + config.creditCardsUrl).then(function (response) { return response.data; });
        };
        this.fetchSavedCreditCard = function (id, host) {
            if (host === void 0) { host = 'https://cashier.wix.com'; }
            return axios_1.default.get("" + host + config.creditCardsUrl + "/" + id).then(function (response) { return response.data; });
        };
        this.fetchMandatoryFields = function (fetchConfig, host) {
            if (host === void 0) { host = ''; }
            return __awaiter(_this, void 0, void 0, function () {
                var countryResponse, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!host && this.props && this.props.host) {
                                host = this.props.host;
                            }
                            countryResponse = {};
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.resolveCountry(host)];
                        case 2:
                            countryResponse = _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            e_1 = _a.sent();
                            console.error(e_1);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/, this.modules.mandatoryFields.fetchMandatoryFields(fetchConfig, countryResponse.country, host)];
                    }
                });
            });
        };
        this.logMandatoryFieldsValidationStatus = function (data) {
            biLogger_1.default.mandatoryFieldsValidation(data);
        };
        this.updateSavedCreditCard = function (creditCard, metaData, host) {
            if (metaData === void 0) { metaData = { fieldMask: '*' }; }
            if (host === void 0) { host = 'https://cashier.wix.com'; }
            return axios_1.default.patch("" + host + config.creditCardsUrl + "/" + creditCard.creditCardId, __assign({ creditCard: creditCard }, metaData)).then(function (response) { return response.data; });
        };
        this.deleteSavedCreditCard = function (creditCardId, host) {
            if (host === void 0) { host = 'https://cashier.wix.com'; }
            return axios_1.default.delete("" + host + config.creditCardsUrl + "/" + creditCardId).then(function (response) { return response.data; });
        };
        this.saveBillingAddress = function (creditCardId, billingAddress, host) {
            if (host === void 0) { host = ''; }
            return _this.updateSavedCreditCard({
                creditCardId: creditCardId,
                creditCard: { billingAddress: billingAddress }
            }, { fieldMask: 'creditCard.billingAddress.*' }, host);
        };
        this.updateSavedBillingAddress = function (creditCardId, billingAddress, host) {
            if (host === void 0) { host = ''; }
            return _this.updateSavedCreditCard({
                creditCardId: creditCardId,
                creditCard: { billingAddress: billingAddress }
            }, { fieldMask: 'creditCard.billingAddress.*' }, host);
        };
        this.makeCreditCardPrimary = function (creditCardId, host) {
            if (host === void 0) { host = ''; }
            return axios_1.default.post("" + host + config.creditCardsUrl + "/" + creditCardId + "/primary").then(function (response) { return response.data; });
        };
        this.charge = function (request, host) {
            if (host === void 0) { host = ''; }
            return new Promise(function (resolve, reject) { return paymentsApi_1.default
                .charge({ request: request, host: host || _this.props.host })
                .then(function (result) { return resolve(result); })
                .catch(_this.handleRequestError.bind(_this, { request: request, reject: reject })); });
        };
        this.handleRequestError = function (props, e) {
            var status = e && e.response && e.response.status;
            _this.localizeError(e.errorCode || DEFAULT_ERROR_CODE)
                .then(function (translatedError) { return props.reject({
                status: status >= 200 && status < 400 ? 'OK' : 'FAILURE',
                errorCode: status,
                paymentMethod: props.request.payment.details.paymentMethod,
                translatedError: translatedError
            }); });
        };
        this.initializePayment = function (method, host) {
            if (host === void 0) { host = ''; }
            var selectedMethod = method || _this.activePaymentMethod;
            var getDetailsId = function (resolve, reject, tokenData, installments) {
                if (installments === void 0) { installments = 1; }
                var paymentDetails = {
                    details: {
                        paymentMethod: selectedMethod,
                        installments: installments,
                        creditCardToken: {
                            token: tokenData.token
                        },
                        additionalData: {}
                    }
                };
                axios_1.default.post(host + config.paymentDetailsUrl, paymentDetails)
                    .then(function (result) { return resolve(result.data); })
                    .catch(function (e) {
                    var status = e && e.response && e.response.status;
                    reject({
                        status: status >= 200 && status < 400 ? 'OK' : 'FAILURE',
                        errorCode: status,
                        translatedError: '',
                        paymentMethod: method
                    });
                });
            };
            return (new Promise(function (resolve, reject) {
                var publicDataPromise = selectedMethod === 'creditCard' ? _this.getCreditCardPublicData() : Promise.resolve();
                publicDataPromise.then(function (publicData) {
                    _this.tokenize(selectedMethod).then(function (data) {
                        var installments = publicData && publicData.additionalInformation && publicData.additionalInformation.installments;
                        return getDetailsId(resolve, reject, data.token, installments || 1);
                    }).catch(function (e) {
                        if (selectedMethod === 'creditCard') {
                            if (e && e.errorCode) {
                                _this.localizeError(e.errorCode).then(function (errorMessage) {
                                    reject({ errorCode: e.errorCode, translatedError: errorMessage, paymentMethod: selectedMethod });
                                });
                            }
                            else {
                                reject(e);
                            }
                        }
                        else {
                            return getDetailsId(resolve, reject, '', 1);
                        }
                    });
                });
            }));
        };
        this.resolveCountry = function (host) {
            if (host === void 0) { host = ''; }
            return (new Promise(function (resolve, reject) {
                if (_this.props && _this.props.query && _this.props.query.country) {
                    return resolve({
                        status: 'OK',
                        errorCode: '',
                        translatedError: '',
                        country: _this.props.query.country
                    });
                }
                return axios_1.default.get(host + config.resolveCountryUrl).then(function (response) {
                    var countryCode = response.data && response.data.country;
                    resolve({
                        status: 'OK',
                        errorCode: '',
                        translatedError: '',
                        country: countryCode
                    });
                }).catch(function (e) { return reject({
                    status: 'FAILURE',
                    errorCode: '500',
                    translatedError: '',
                    country: ''
                }); });
            }));
        };
        this.setCountry = function (country) {
            if (_this.props && _this.props.query) {
                _this.props.query.country = country;
            }
            else if (_this.props && !_this.props.query) {
                _this.props.query = { country: country };
            }
        };
        this.fetchTokenForSavedCreditCard = function (_a, host) {
            var creditCardId = _a.creditCardId, accountId = _a.accountId, _b = _a.cvv, cvv = _b === void 0 ? null : _b;
            return axios_1.default.post(interpolate_1.default(host + config.tokenForSavedCard, { creditCardId: creditCardId }), { accountId: accountId, cvv: cvv }).then(function (response) { return response.data; });
        };
        this.isRTLLocale = function (locale) {
            if (locale === void 0) { locale = ''; }
            if (locale.length !== 2 && locale.length !== 3) {
                console.error('Locale should contain 2 or 3 letters');
            }
            var RTL_LOCALES = [
                'ar',
                'arc',
                'bcc',
                'bqi',
                'ckb',
                'dv',
                'fa',
                'glk',
                'he',
                'ku',
                'mzn',
                'pnb',
                'ps',
                'sd',
                'ug',
                'ur',
                'yi',
            ];
            return RTL_LOCALES.indexOf(locale.toLowerCase()) !== -1;
        };
        this.getOrder = function (orderId, host) {
            if (host === void 0) { host = ''; }
            if (!host && _this.props && _this.props.host) {
                host = _this.props.host;
            }
            return axios_1.default.get(interpolate_1.default(host + config.orderUrl, { orderId: orderId })).then(function (response) {
                var order = response.data && response.data.order;
                return order;
            });
        };
        this.resources = resources;
    }
    return CashierPayments;
}());
exports.default = CashierPayments;
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CreditCard_1 = __webpack_require__(384);
var Offline_1 = __webpack_require__(413);
var Wallets_1 = __webpack_require__(414);
var MethodFactory = /** @class */ (function () {
    function MethodFactory() {
        var _this = this;
        this.methods = {};
        this.methodDefs = function (methodId) {
            var refs = {
                creditCard: function (props) { return (new CreditCard_1.default({
                    paymentModule: props.paymentModule,
                    methodId: methodId,
                    localizeError: props.localizeError,
                    linkToIframe: props.creditCardFormUrl,
                    query: props.query,
                    orderId: props.query.orderId || props.snapshotId,
                    appId: props.appId,
                    appInstanceId: props.appInstanceId,
                    onError: props.onError,
                    onMessage: props.onMessage,
                    onPaymentStart: props.onPaymentStart,
                    onPaymentComplete: props.onPaymentComplete,
                    selector: props.selector,
                    type: props.type,
                    host: props.host
                })); },
                offline: function (props) { return (new Offline_1.default({
                    paymentModule: props.paymentModule,
                    methodId: methodId,
                    orderId: props.query.orderId || props.snapshotId,
                    onError: props.onError,
                    onMessage: props.onMessage,
                    onPaymentStart: props.onPaymentStart,
                    onPaymentComplete: props.onPaymentComplete,
                    host: props.host
                })); },
                wallet: function (props) { return (new Wallets_1.default({
                    paymentModule: props.paymentModule,
                    methodId: methodId,
                    orderId: props.query.orderId || props.snapshotId,
                    walletPaymentInNewTab: props.walletPaymentInNewTab,
                    onError: props.onError,
                    onMessage: props.onMessage,
                    onPaymentStart: props.onPaymentStart,
                    onPaymentComplete: props.onPaymentComplete,
                    host: props.host
                })); }
            };
            return refs[methodId] || refs.wallet;
        };
        this.addMethod = function (methodId, props) {
            var method = _this.methodDefs(methodId);
            var methodInstance = method(props);
            methodInstance.setup();
            _this.methods[methodId] = methodInstance;
            return methodInstance;
        };
        this.getMethod = function (methodId) { return _this.methods[methodId]; };
        this.getMethods = function () { return Object.keys(_this.methods).map(function (key) { return _this.methods[key]; }); };
        this.removeById = function (methodId) {
            if (_this.getMethod(methodId)) {
                _this.getMethod(methodId).remove();
                delete _this.methods[methodId];
            }
        };
        this.remove = function (methodId) {
            if (methodId) {
                _this.removeById(methodId);
            }
            else {
                Object.keys(_this.methods || {}).forEach(function (key) { return _this.removeById(key); });
            }
        };
    }
    return MethodFactory;
}());
exports.default = MethodFactory;
//# sourceMappingURL=MethodFactory.js.map

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var queryString = __webpack_require__(385);
var encoder_1 = __webpack_require__(388);
var postMessagesPubSub_1 = __webpack_require__(390);
var paymentsApi_1 = __webpack_require__(32);
var NO_INIT_MESSAGE = 'SDK not inited, use cashierPayments.init() firstly(or wait until init will be finished, if you already runned init())';
var defaultInternals = {
    allowedIframes: ['cashier-pci'],
    linkToIframe: 'https://cashier.wix.com/cashier-pci',
};
var CreditCard = /** @class */ (function () {
    function CreditCard(_a) {
        var appId = _a.appId, appInstanceId = _a.appInstanceId, host = _a.host, paymentModule = _a.paymentModule, localizeError = _a.localizeError, methodId = _a.methodId, orderId = _a.orderId, linkToWindow = _a.linkToWindow, selector = _a.selector, styles = _a.styles, query = _a.query, onMessage = _a.onMessage, onPaymentComplete = _a.onPaymentComplete, onPaymentStart = _a.onPaymentStart, onError = _a.onError, type = _a.type, linkToIframe = _a.linkToIframe;
        var _this = this;
        this.state = {
            loading: false,
            error: false
        };
        this.ccLoadTimer = null;
        this.installments = 1;
        this.listenToMessages = function () {
            _this.windowController.addEventListener('message', _this.handleMessageFromIframe, false);
        };
        this.handleIframeSizeUpdate = function (message) {
            _this.iframeNode.style.height = message.height ?
                message.height + 'px' :
                _this.iframeNode.style.height;
        };
        this.handleClientFormValidation = function (data) {
            if (_this.props.onMessage) {
                _this.props.onMessage('creditCard', { type: 'VALIDATION', isValid: Boolean(data.status === 'CLIENT_OK') });
            }
        };
        this.handleMessageFromIframe = function (event) {
            var data = event.data || { iframeName: '' };
            var iframeName = data.iframeName;
            if (defaultInternals.allowedIframes.indexOf(iframeName) !== -1) {
                var hashOfEvents = {
                    FORM_SIZE: _this.handleIframeSizeUpdate,
                    SIZE: _this.handleIframeSizeUpdate,
                    CLIENT_FORM_VALIDATION: _this.handleClientFormValidation,
                    SERVER_FORM_SUBMIT: function (message) {
                        var parsedResponse = message.message;
                        if (message.message && typeof message.message === 'string') {
                            try {
                                parsedResponse = JSON.parse(message.message);
                            }
                            catch (ex) {
                                parsedResponse = message.message;
                            }
                        }
                        if (parsedResponse && parsedResponse.paymentStatus && parsedResponse.paymentStatus.value === 'Pending3ds') {
                            var nextUrl = "https://cashier.wix.com/_api/payment-gateway-web/3ds?transactionKey=" + parsedResponse.transactionKey;
                            if (_this.windowController.top && _this.windowController.top.location) {
                                _this.windowController.top.location.replace(nextUrl);
                            }
                            else {
                                _this.windowController.location.replace(nextUrl);
                            }
                        }
                        else {
                            if (parsedResponse && parsedResponse.errorCode && _this.props.localizeError) {
                                _this.props.localizeError(parsedResponse.errorCode).then(function (errorMessage) {
                                    _this.props.onPaymentComplete && _this.props.onPaymentComplete('creditCard', __assign({}, message, { translatedError: errorMessage }));
                                });
                            }
                            else {
                                _this.props.onPaymentComplete && _this.props.onPaymentComplete('creditCard', message);
                            }
                        }
                    },
                    CLIENT_FORM_4_CARD_NUMBERS: function (message) { return _this.props.onMessage('creditCard', __assign({}, message, { message: "\u25CF\u25CF\u25CF\u25CF \u25CF\u25CF\u25CF\u25CF \u25CF\u25CF\u25CF\u25CF " + (message.cardNumber || '●●●●'), icon: message.cardType })); }
                };
                if (hashOfEvents[data.type]) {
                    hashOfEvents[data.type](data);
                }
                else {
                    if (data.type === 'PING' && data.status === 'INITED') {
                        _this.handleCCLoadFinished({ error: false });
                    }
                    if (_this.props.onMessage) {
                        _this.props.onMessage('creditCard', data);
                    }
                }
            }
        };
        this.sendCommand = function (command, mandatoryFields) {
            if (mandatoryFields === void 0) { mandatoryFields = {}; }
            if (_this.iframeNode && _this.iframeNode.contentWindow && _this.iframeNode.contentWindow.postMessage) {
                _this.iframeNode.contentWindow.postMessage({ type: command, payload: { mandatoryFields: mandatoryFields } }, '*');
            }
            else {
                console.error(NO_INIT_MESSAGE);
            }
        };
        this.handleCCLoadFinished = function (_a) {
            var error = _a.error;
            clearTimeout(_this.ccLoadTimer);
            _this.state.error = Boolean(error);
            _this.state.loading = false;
            if (error) {
                _this.ccLoadReject({
                    status: 'FAILURE',
                    errorCode: '',
                    translatedError: '',
                    paymentMethod: 'creditCard'
                });
            }
            else {
                _this.ccLoadResolve({
                    status: 'OK',
                    errorCode: '',
                    translatedError: '',
                    paymentMethod: 'creditCard'
                });
            }
        };
        this.handleCCLoadStarted = function (resolve, reject) {
            _this.ccLoadResolve = resolve;
            _this.ccLoadReject = reject;
            _this.state.error = false;
            _this.state.loading = true;
        };
        this.setup = function () {
            if (typeof document === 'undefined') {
                return false;
            }
            var queryFromCurrentURL = _this.windowController && _this.windowController.location && _this.windowController.location.search
                ? queryString.parse(_this.windowController.location.search)
                : {};
            var query = Object.assign({}, {
                appId: _this.props.appId,
                appInstanceId: _this.props.appInstanceId,
                orderId: _this.props.orderId,
                snapshotId: _this.props.orderId
            }, queryFromCurrentURL, _this.props.query);
            _this.queryStringForBuyer = encoder_1.encode(query);
            if (_this.props.selector && _this.props.type === 'BUYER') {
                _this.render(_this.props.selector);
            }
            return true;
        };
        this.render = function (element) {
            return new Promise(function (resolve, reject) {
                if (typeof document === 'undefined') {
                    return reject({
                        status: 'FAILURE',
                        errorCode: '',
                        translatedError: '',
                        paymentMethod: 'creditCard'
                    });
                }
                var node = typeof element === 'string' ? document.querySelector(element) : element;
                var iframe = document.createElement('iframe');
                var iframeLink = (_this.props.linkToIframe || defaultInternals.linkToIframe);
                var divider = iframeLink.indexOf('?') !== -1 ? '&' : '?';
                iframe.src = (_this.props.linkToIframe || defaultInternals.linkToIframe) + (divider + "query=") + _this.queryStringForBuyer;
                iframe.style.width = '100%';
                iframe.style.border = 'none';
                Object.assign(iframe.style, _this.props.styles);
                if (node && node.appendChild) {
                    node.appendChild(iframe);
                }
                else {
                    console.error("Parent element: " + element);
                }
                _this.handleCCLoadStarted(resolve, reject);
                if (_this.props.onMessage) {
                    _this.props.onMessage('creditCard', { type: 'LOAD_STARTED' });
                }
                iframe.onload = function (e) {
                    _this.waitForPingFromCC();
                    if (e.type === 'load' && _this.props.onMessage) {
                        _this.props.onMessage('creditCard', { type: 'LOAD_FINISHED' });
                    }
                };
                _this.iframeNode = iframe;
                _this.listenToMessages();
                return true;
            });
        };
        this.waitForPingFromCC = function () {
            if (!_this.state.loading) {
                return true;
            }
            var TIME_TO_LOAD_CC = 3000;
            _this.ccLoadTimer = setTimeout(function () {
                if (_this.state.loading) {
                    _this.handleCCLoadFinished({ error: true });
                }
            }, TIME_TO_LOAD_CC);
        };
        this.remove = function () {
            if (typeof document === 'undefined') {
                console.error(NO_INIT_MESSAGE);
                return false;
            }
            var parentNode = document.querySelector(_this.props.selector);
            if (parentNode && _this.iframeNode) {
                parentNode.removeChild(_this.iframeNode);
            }
            return true;
        };
        this.lastNumbersOfCard = function () { return postMessagesPubSub_1.emitMessage({
            type: 'getPublicData',
            scope: _this.iframeNode && _this.iframeNode.contentWindow
        }); };
        this.validate = function () {
            return (new Promise(function (resolve, reject) {
                var scope = _this.iframeNode && _this.iframeNode.contentWindow;
                postMessagesPubSub_1.emitMessage({
                    type: 'validate',
                    scope: scope
                })
                    .then(function (payload) {
                    var isValid = payload ? payload.isValid : false;
                    var invalidFields = payload ? payload.invalidFields || [] : [];
                    return resolve({
                        isValid: isValid,
                        invalidFields: invalidFields,
                    });
                })
                    .catch(function (err) { return reject(err); });
            }));
        };
        this.getCreditCardPublicData = function () { return postMessagesPubSub_1.emitMessage({
            type: 'getPublicData',
            scope: _this.iframeNode && _this.iframeNode.contentWindow
        }); };
        this.collapse = function () { return _this.lastNumbersOfCard(); };
        this.expand = function () { return Promise.resolve({ method: 'creditCard', type: 'EXPAND', status: 'expanded' }); };
        this.tokenize = function (mandatoryFields) {
            if (mandatoryFields === void 0) { mandatoryFields = {}; }
            return postMessagesPubSub_1.emitMessage({
                type: 'tokenize',
                payload: { mandatoryFields: mandatoryFields },
                scope: _this.iframeNode && _this.iframeNode.contentWindow,
            });
        };
        this.setInstallments = function (installments) {
            _this.installments = installments;
            return postMessagesPubSub_1.emitMessage({
                type: 'setInstallments',
                payload: { installments: installments },
                scope: _this.iframeNode && _this.iframeNode.contentWindow
            });
        };
        this.pay = function (method, mandatoryFields) {
            if (mandatoryFields === void 0) { mandatoryFields = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var tokenizeResponse, chargeRequest, chargeResponse;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.tokenize(mandatoryFields)];
                        case 1:
                            tokenizeResponse = _a.sent();
                            chargeRequest = {
                                host: this.props.host,
                                request: {
                                    orderId: this.props.orderId,
                                    payment: {
                                        details: {
                                            paymentMethod: method,
                                            installments: this.installments,
                                            creditCardToken: {
                                                token: tokenizeResponse.token.token
                                            }
                                        }
                                    }
                                }
                            };
                            return [4 /*yield*/, paymentsApi_1.default.charge(chargeRequest)];
                        case 2:
                            chargeResponse = _a.sent();
                            return [2 /*return*/, this.props.paymentModule.continuePayment(method, { chargeResponse: chargeResponse })];
                    }
                });
            });
        };
        this.getMetadata = function () {
            return {
                popupSupported: false,
            };
        };
        this.windowController = linkToWindow || window;
        this.props = {
            appId: appId,
            appInstanceId: appInstanceId,
            host: host,
            paymentModule: paymentModule,
            localizeError: localizeError,
            methodId: methodId,
            orderId: orderId,
            linkToIframe: linkToIframe,
            selector: selector,
            styles: styles,
            query: query,
            onMessage: onMessage,
            onPaymentComplete: onPaymentComplete,
            onPaymentStart: onPaymentStart,
            onError: onError,
            type: type
        };
    }
    return CreditCard;
}());
exports.default = CreditCard;
//# sourceMappingURL=CreditCard.js.map

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(386);
var objectAssign = __webpack_require__(387);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// import base64 from 'base-64';
var base64 = __webpack_require__(389);
exports.encode = function (obj) {
    if (typeof obj === 'object') {
        return base64.encode(JSON.stringify(obj));
    }
    return base64.encode(obj);
};
exports.decode = function (str) { return base64.decode(str); };
//# sourceMappingURL=encoder.js.map

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */
;(function(root) {

	// Detect free variables `exports`.
	var freeExports = typeof exports == 'object' && exports;

	// Detect free variable `module`.
	var freeModule = typeof module == 'object' && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code, and use
	// it as `root`.
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var InvalidCharacterError = function(message) {
		this.message = message;
	};
	InvalidCharacterError.prototype = new Error;
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';

	var error = function(message) {
		// Note: the error messages used throughout this file match those used by
		// the native `atob`/`btoa` implementation in Chromium.
		throw new InvalidCharacterError(message);
	};

	var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	// http://whatwg.org/html/common-microsyntaxes.html#space-character
	var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;

	// `decode` is designed to be fully compatible with `atob` as described in the
	// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
	// The optimized base64-decoding algorithm used is based on @atk’s excellent
	// implementation. https://gist.github.com/atk/1020396
	var decode = function(input) {
		input = String(input)
			.replace(REGEX_SPACE_CHARACTERS, '');
		var length = input.length;
		if (length % 4 == 0) {
			input = input.replace(/==?$/, '');
			length = input.length;
		}
		if (
			length % 4 == 1 ||
			// http://whatwg.org/C#alphanumeric-ascii-characters
			/[^+a-zA-Z0-9/]/.test(input)
		) {
			error(
				'Invalid character: the string to be decoded is not correctly encoded.'
			);
		}
		var bitCounter = 0;
		var bitStorage;
		var buffer;
		var output = '';
		var position = -1;
		while (++position < length) {
			buffer = TABLE.indexOf(input.charAt(position));
			bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
			// Unless this is the first of a group of 4 characters…
			if (bitCounter++ % 4) {
				// …convert the first 8 bits to a single ASCII character.
				output += String.fromCharCode(
					0xFF & bitStorage >> (-2 * bitCounter & 6)
				);
			}
		}
		return output;
	};

	// `encode` is designed to be fully compatible with `btoa` as described in the
	// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
	var encode = function(input) {
		input = String(input);
		if (/[^\0-\xFF]/.test(input)) {
			// Note: no need to special-case astral symbols here, as surrogates are
			// matched, and the input is supposed to only contain ASCII anyway.
			error(
				'The string to be encoded contains characters outside of the ' +
				'Latin1 range.'
			);
		}
		var padding = input.length % 3;
		var output = '';
		var position = -1;
		var a;
		var b;
		var c;
		var d;
		var buffer;
		// Make sure any padding is handled outside of the loop.
		var length = input.length - padding;

		while (++position < length) {
			// Read three bytes, i.e. 24 bits.
			a = input.charCodeAt(position) << 16;
			b = input.charCodeAt(++position) << 8;
			c = input.charCodeAt(++position);
			buffer = a + b + c;
			// Turn the 24 bits into four chunks of 6 bits each, and append the
			// matching character for each of them to the output.
			output += (
				TABLE.charAt(buffer >> 18 & 0x3F) +
				TABLE.charAt(buffer >> 12 & 0x3F) +
				TABLE.charAt(buffer >> 6 & 0x3F) +
				TABLE.charAt(buffer & 0x3F)
			);
		}

		if (padding == 2) {
			a = input.charCodeAt(position) << 8;
			b = input.charCodeAt(++position);
			buffer = a + b;
			output += (
				TABLE.charAt(buffer >> 10) +
				TABLE.charAt((buffer >> 4) & 0x3F) +
				TABLE.charAt((buffer << 2) & 0x3F) +
				'='
			);
		} else if (padding == 1) {
			buffer = input.charCodeAt(position);
			output += (
				TABLE.charAt(buffer >> 2) +
				TABLE.charAt((buffer << 4) & 0x3F) +
				'=='
			);
		}

		return output;
	};

	var base64 = {
		'encode': encode,
		'decode': decode,
		'version': '0.1.0'
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return base64;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = base64;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (var key in base64) {
				base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.base64 = base64;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)(module), __webpack_require__(50)))

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var uuid = __webpack_require__(391);
var WAIT_TIMEOUT = 5000;
exports.emitMessage = function (_a) {
    var type = _a.type, _b = _a.payload, payload = _b === void 0 ? {} : _b, _c = _a.scope, scope = _c === void 0 ? window : _c, origin = _a.origin;
    var eventId = type + "-" + uuid();
    var waitId = null;
    var request = { type: type, payload: payload, eventId: eventId };
    return (new Promise(function (resolve, reject) {
        var replyCallback = function (event) {
            if (event.data.eventId === eventId) {
                clearTimeout(waitId);
                if (event.data.error) {
                    reject(event.data.error);
                }
                else {
                    resolve(event.data.payload);
                }
                if (window.removeEventListener) {
                    window.removeEventListener('message', replyCallback);
                }
            }
        };
        waitId = setTimeout(function () {
            if (window.removeEventListener) {
                window.removeEventListener('message', replyCallback);
            }
            reject({ errorCode: 502 });
        }, WAIT_TIMEOUT);
        window.addEventListener('message', replyCallback);
        if (scope.postMessage) {
            scope.postMessage(request, origin || '*');
        }
    }));
};
//# sourceMappingURL=postMessagesPubSub.js.map

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(392);
var bytesToUuid = __webpack_require__(393);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 392 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && msCrypto.getRandomValues.bind(msCrypto));
if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 393 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var interpolate_1 = __webpack_require__(58);
var axios_1 = __webpack_require__(59);
var config = __webpack_require__(61);
var mapResponseToBeSameAsStores = function (data) {
    // TODO this mapping should be removed, after stores will response with same charge object
    if (!data.charge || !data.charge.state) {
        return data;
    }
    return {
        chargeId: data.charge.chargeId,
        failureDetails: data.charge.state.failureDetails && data.charge.state.failureDetails.failureCode,
        redirectUrl: data.charge.state.userRedirectUrl,
        transactionStatus: data.charge.state.transactionStatus && data.charge.state.transactionStatus.status
    };
};
/**
 * Class will contain pure API requests
 */
var ApiCalls = /** @class */ (function () {
    function ApiCalls() {
        this.charge = function (_a) {
            var request = _a.request, _b = _a.host, host = _b === void 0 ? '' : _b;
            var url = host + interpolate_1.default(config.orderChargesUrl, { orderId: request.orderId });
            return axios_1.default
                .post(url, request)
                .then(function (response) { return mapResponseToBeSameAsStores(response.data); });
        };
        this.fetchPaymentMethodSettings = function (_a, host) {
            var orderId = _a.orderId, appId = _a.appId, appInstanceId = _a.appInstanceId, paymentMethod = _a.paymentMethod, country = _a.country;
            if (host === void 0) { host = ''; }
            var paymentMethodUrlMask = orderId ? config.paymentMethodOrderApiUrl : config.paymentMethodAccountApiUrl;
            var url = interpolate_1.default(paymentMethodUrlMask, { orderId: orderId, appId: appId, appInstanceId: appInstanceId, paymentMethod: paymentMethod });
            return axios_1.default
                .get(host + url, { params: { country: country } })
                .then(function (response) { return response.data; });
        };
    }
    return ApiCalls;
}());
exports.default = new ApiCalls();
//# sourceMappingURL=apiCalls.js.map

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(114);
var Axios = __webpack_require__(396);
var defaults = __webpack_require__(60);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(118);
axios.CancelToken = __webpack_require__(411);
axios.isCancel = __webpack_require__(117);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(412);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(60);
var utils = __webpack_require__(1);
var InterceptorManager = __webpack_require__(406);
var dispatchRequest = __webpack_require__(407);
var isAbsoluteURL = __webpack_require__(409);
var combineURLs = __webpack_require__(410);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 397 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(116);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response
    ));
  }
};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 @ @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.response = response;
  return error;
};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(408);
var isCancel = __webpack_require__(117);
var defaults = __webpack_require__(60);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
};


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(118);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var paymentsApi_1 = __webpack_require__(32);
var Offline = /** @class */ (function () {
    function Offline(_a) {
        var paymentModule = _a.paymentModule, orderId = _a.orderId, onMessage = _a.onMessage, host = _a.host;
        var _this = this;
        this.setup = function () { return true; };
        this.remove = function () { return true; };
        this.render = function () { return Promise.resolve(true); };
        this.pay = function (method) { return __awaiter(_this, void 0, void 0, function () {
            var chargeRequest, chargeResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        chargeRequest = {
                            orderId: this.props.orderId,
                            payment: {
                                details: {
                                    paymentMethod: method,
                                    installments: 1,
                                    creditCardToken: {
                                        token: ''
                                    }
                                }
                            }
                        };
                        return [4 /*yield*/, paymentsApi_1.default.charge({ request: chargeRequest, host: this.props.host })];
                    case 1:
                        chargeResponse = _a.sent();
                        return [2 /*return*/, this.props.paymentModule.continuePayment(method, { chargeResponse: chargeResponse })];
                }
            });
        }); };
        this.validate = function () {
            if (_this.props.onMessage) {
                _this.props.onMessage('offline', { type: 'VALIDATION', isValid: true });
            }
            return Promise.resolve({ isValid: true });
        };
        this.collapse = function () { return Promise.resolve({ method: 'offline', type: 'COLLAPSE', status: 'collapsed' }); };
        this.expand = function () { return Promise.resolve({ method: 'offline', type: 'EXPAND', status: 'expanded' }); };
        this.getMetadata = function () {
            return {
                popupSupported: false,
            };
        };
        this.props = {
            orderId: orderId,
            host: host,
            onMessage: onMessage,
            paymentModule: paymentModule
        };
    }
    return Offline;
}());
exports.default = Offline;
//# sourceMappingURL=Offline.js.map

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var paymentsApi_1 = __webpack_require__(32);
var Wallets = /** @class */ (function () {
    function Wallets(_a) {
        var paymentModule = _a.paymentModule, methodId = _a.methodId, orderId = _a.orderId, onMessage = _a.onMessage, walletPaymentInNewTab = _a.walletPaymentInNewTab, host = _a.host;
        var _this = this;
        this.setup = function () { return true; };
        this.remove = function () { return true; };
        this.render = function () { return Promise.resolve(true); };
        this.pay = function (method) { return __awaiter(_this, void 0, void 0, function () {
            var inNewTab, chargeRequest, chargeResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        inNewTab = this.props.walletPaymentInNewTab;
                        if (inNewTab) {
                            // It should be sync in case of blocking async windows by browser
                            // `chargeResponse` param we will get by .charge() calling after opening empty window
                            this.props.paymentModule.launchPaymentPopup(method, { chargeResponse: {} });
                        }
                        chargeRequest = {
                            orderId: this.props.orderId,
                            payment: {
                                details: {
                                    paymentMethod: this.props.methodId,
                                    // Always `1` for wallets
                                    installments: 1,
                                    creditCardToken: {
                                        // Always empty for wallets
                                        token: ''
                                    }
                                }
                            }
                        };
                        return [4 /*yield*/, paymentsApi_1.default.charge({ request: chargeRequest, host: this.props.host })];
                    case 1:
                        chargeResponse = _a.sent();
                        return [2 /*return*/, this.props.paymentModule.continuePayment(method, { chargeResponse: chargeResponse, inNewTab: inNewTab })];
                }
            });
        }); };
        this.validate = function (walletId) {
            if (_this.props.onMessage) {
                _this.props.onMessage(walletId, { type: 'VALIDATION', isValid: true });
            }
            return Promise.resolve({ isValid: true });
        };
        this.collapse = function (walletId) { return Promise.resolve({ method: walletId, type: 'COLLAPSE', status: 'collapsed' }); };
        this.expand = function (walletId) { return Promise.resolve({ method: walletId, type: 'EXPAND', status: 'expanded' }); };
        this.getMetadata = function () {
            return {
                popupSupported: true,
            };
        };
        this.props = {
            paymentModule: paymentModule,
            host: host,
            methodId: methodId,
            orderId: orderId,
            walletPaymentInNewTab: walletPaymentInNewTab,
            onMessage: onMessage,
        };
    }
    return Wallets;
}());
exports.default = Wallets;
//# sourceMappingURL=Wallets.js.map

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var i18next = __webpack_require__(417);
var i18nextXHRBackend = __webpack_require__(418);
var BASE_URL = 'https://cashier-services.wix.com/cashier-metadata/api/v1/locales/cashier-payments-sdk';
var _init = null;
var i18nInstance = null;
if (false) {
    _init = function (lng, resources, onReady) {
        if (resources === void 0) { resources = {}; }
        i18nInstance = i18next.createInstance()
            .init({
            lng: lng,
            keySeparator: '$',
            fallbackLng: 'en',
            interpolation: {
                escapeValue: false
            },
            resources: {
                en: {
                    translation: require('./../../src/assets/locale/messages_en.json')
                }
            }
        }, function (err, t) {
            onReady && onReady(t);
        });
        return i18nInstance;
    };
}
else {
    _init = function (lng, resources, onReady) {
        if (resources === void 0) { resources = {}; }
        i18nInstance = i18next
            .createInstance()
            .use(i18nextXHRBackend)
            .init({
            lng: lng,
            keySeparator: '$',
            fallbackLng: 'en',
            interpolation: {
                escapeValue: false
            },
            backend: {
                loadPath: BASE_URL + "/{{lng}}",
                crossDomain: true
            }
        }, function (err, t) {
            onReady && onReady(t);
        });
        return i18nInstance;
    };
}
exports.init = _init;
exports.translate = function (key, data) {
    if (data === void 0) { data = {}; }
    return i18nInstance.t(key, data);
};
exports.errorCodeToMessage = function (code, locale, data) {
    if (locale === void 0) { locale = 'en'; }
    if (data === void 0) { data = {}; }
    var key = "payment_error_" + code;
    var message = i18nInstance.t(key, Object.assign({}, data, { lng: locale, fallbackLng: 'en' }));
    if (message && message !== key) {
        return message;
    }
    return '';
};
exports.default = i18nInstance;
//# sourceMappingURL=i18n.js.map

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ../node_modules/cashier-payments-sdk/node_modules/i18next/dist/es/logger.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var consoleLogger = {
  type: 'logger',

  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    var _console;

    /* eslint no-console: 0 */
    if (console && console[type]) (_console = console)[type].apply(_console, _toConsumableArray(args));
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  Logger.prototype.init = function init(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug;
  };

  Logger.prototype.setDebug = function setDebug(bool) {
    this.debug = bool;
  };

  Logger.prototype.log = function log() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return this.forward(args, 'log', '', true);
  };

  Logger.prototype.warn = function warn() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return this.forward(args, 'warn', '', true);
  };

  Logger.prototype.error = function error() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return this.forward(args, 'error', '');
  };

  Logger.prototype.deprecate = function deprecate() {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
  };

  Logger.prototype.forward = function forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return null;
    if (typeof args[0] === 'string') args[0] = '' + prefix + this.prefix + ' ' + args[0];
    return this.logger[lvl](args);
  };

  Logger.prototype.create = function create(moduleName) {
    return new Logger(this.logger, _extends({ prefix: this.prefix + ':' + moduleName + ':' }, this.options));
  };

  return Logger;
}();

/* harmony default export */ var logger = (new Logger());
// CONCATENATED MODULE: ../node_modules/cashier-payments-sdk/node_modules/i18next/dist/es/EventEmitter.js
function EventEmitter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventEmitter = function () {
  function EventEmitter() {
    EventEmitter__classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  EventEmitter.prototype.on = function on(events, listener) {
    var _this = this;

    events.split(' ').forEach(function (event) {
      _this.observers[event] = _this.observers[event] || [];
      _this.observers[event].push(listener);
    });
  };

  EventEmitter.prototype.off = function off(event, listener) {
    var _this2 = this;

    if (!this.observers[event]) {
      return;
    }

    this.observers[event].forEach(function () {
      if (!listener) {
        delete _this2.observers[event];
      } else {
        var index = _this2.observers[event].indexOf(listener);
        if (index > -1) {
          _this2.observers[event].splice(index, 1);
        }
      }
    });
  };

  EventEmitter.prototype.emit = function emit(event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (this.observers[event]) {
      var cloned = [].concat(this.observers[event]);
      cloned.forEach(function (observer) {
        observer.apply(undefined, args);
      });
    }

    if (this.observers['*']) {
      var _cloned = [].concat(this.observers['*']);
      _cloned.forEach(function (observer) {
        var _ref;

        observer.apply(observer, (_ref = [event]).concat.apply(_ref, args));
      });
    }
  };

  return EventEmitter;
}();

/* harmony default export */ var es_EventEmitter = (EventEmitter);
// CONCATENATED MODULE: ../node_modules/cashier-payments-sdk/node_modules/i18next/dist/es/utils.js
function makeString(object) {
  if (object == null) return '';
  /* eslint prefer-template: 0 */
  return '' + object;
}

function utils_copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};

    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}

function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}

function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}

function deepExtend(target, source, overwrite) {
  /* eslint no-restricted-syntax: 0 */
  for (var prop in source) {
    if (prop in target) {
      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }
  return target;
}

function regexEscape(str) {
  /* eslint no-useless-escape: 0 */
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

/* eslint-disable */
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': '&quot;',
  "'": '&#39;',
  "/": '&#x2F;'
};
/* eslint-enable */

function utils_escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
// CONCATENATED MODULE: ../node_modules/cashier-payments-sdk/node_modules/i18next/dist/es/ResourceStore.js
var ResourceStore__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function ResourceStore__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }




var ResourceStore_ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  function ResourceStore() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { ns: ['translation'], defaultNS: 'translation' };

    ResourceStore__classCallCheck(this, ResourceStore);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.data = data;
    _this.options = options;
    return _this;
  }

  ResourceStore.prototype.addNamespaces = function addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  };

  ResourceStore.prototype.removeNamespaces = function removeNamespaces(ns) {
    var index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  };

  ResourceStore.prototype.getResource = function getResource(lng, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var keySeparator = options.keySeparator || this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key && typeof key !== 'string') path = path.concat(key);
    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    }

    return getPath(this.data, path);
  };

  ResourceStore.prototype.addResource = function addResource(lng, ns, key, value) {
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { silent: false };

    var keySeparator = this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    setPath(this.data, path, value);

    if (!options.silent) this.emit('added', lng, ns, key, value);
  };

  ResourceStore.prototype.addResources = function addResources(lng, ns, resources) {
    /* eslint no-restricted-syntax: 0 */
    for (var m in resources) {
      if (typeof resources[m] === 'string') this.addResource(lng, ns, m, resources[m], { silent: true });
    }
    this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.addResourceBundle = function addResourceBundle(lng, ns, resources, deep, overwrite) {
    var path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    var pack = getPath(this.data, path) || {};

    if (deep) {
      deepExtend(pack, resources, overwrite);
    } else {
      pack = ResourceStore__extends({}, pack, resources);
    }

    setPath(this.data, path, pack);

    this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.removeResourceBundle = function removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);

    this.emit('removed', lng, ns);
  };

  ResourceStore.prototype.hasResourceBundle = function hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  };

  ResourceStore.prototype.getResourceBundle = function getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;

    // COMPATIBILITY: remove extend in v2.1.0
    if (this.options.compatibilityAPI === 'v1') return ResourceStore__extends({}, this.getResource(lng, ns));

    return this.getResource(lng, ns);
  };

  ResourceStore.prototype.toJSON = function toJSON() {
    return this.data;
  };

  return ResourceStore;
}(es_EventEmitter);

/* harmony default export */ var es_ResourceStore = (ResourceStore_ResourceStore);
// CONCATENATED MODULE: ../node_modules/cashier-payments-sdk/node_modules/i18next/dist/es/postProcessor.js
/* harmony default export */ var postProcessor = ({

  processors: {},

  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });

    return value;
  }
});
// CONCATENATED MODULE: ../node_modules/cashier-payments-sdk/node_modules/i18next/dist/es/compatibility/v1.js
/* eslint no-param-reassign: 0 */


function convertInterpolation(options) {

  options.interpolation = {
    unescapeSuffix: 'HTML'
  };

  options.interpolation.prefix = options.interpolationPrefix || '__';
  options.interpolation.suffix = options.interpolationSuffix || '__';
  options.interpolation.escapeValue = options.escapeInterpolation || false;

  options.interpolation.nestingPrefix = options.reusePrefix || '$t(';
  options.interpolation.nestingSuffix = options.reuseSuffix || ')';

  return options;
}

function convertAPIOptions(options) {
  if (options.resStore) options.resources = options.resStore;

  if (options.ns && options.ns.defaultNs) {
    options.defaultNS = options.ns.defaultNs;
    options.ns = options.ns.namespaces;
  } else {
    options.defaultNS = options.ns || 'translation';
  }

  if (options.fallbackToDefaultNS && options.defaultNS) options.fallbackNS = options.defaultNS;

  options.saveMissing = options.sendMissing;
  options.saveMissingTo = options.sendMissingTo || 'current';
  options.returnNull = !options.fallbackOnNull;
  options.returnEmptyString = !options.fallbackOnEmpty;
  options.returnObjects = options.returnObjectTrees;
  options.joinArrays = '\n';

  options.returnedObjectHandler = options.objectTreeKeyHandler;
  options.parseMissingKeyHandler = options.parseMissingKey;
  options.appendNamespaceToMissingKey = true;

  options.nsSeparator = options.nsseparator || ':';
  options.keySeparator = options.keyseparator || '.';

  if (options.shortcutFunction === 'sprintf') {
    options.overloadTranslationOptionHandler = function handle(args) {
      var values = [];

      for (var i = 1; i < args.length; i++) {
        values.push(args[i]);
      }

      return {
        postProcess: 'sprintf',
        sprintf: values
      };
    };
  }

  options.whitelist = options.lngWhitelist;
  options.preload = options.preload;
  if (options.load === 'current') options.load = 'currentOnly';
  if (options.load === 'unspecific') options.load = 'languageOnly';

  // backend
  options.backend = options.backend || {};
  options.backend.loadPath = options.resGetPath || 'locales/__lng__/__ns__.json';
  options.backend.addPath = options.resPostPath || 'locales/add/__lng__/__ns__';
  options.backend.allowMultiLoading = options.dynamicLoad;

  // cache
  options.cache = options.cache || {};
  options.cache.prefix = 'res_';
  options.cache.expirationTime = 7 * 24 * 60 * 60 * 1000;
  options.cache.enabled = options.useLocalStorage;

  options = convertInterpolation(options);
  if (options.defaultVariables) options.interpolation.defaultVariables = options.defaultVariables;

  // COMPATIBILITY: deprecation
  // if (options.getAsync === false) throw deprecation error

  return options;
}

function convertJSONOptions(options) {
  options = convertInterpolation(options);
  options.joinArrays = '\n';

  return options;
}

function convertTOptions(options) {
  if (options.interpolationPrefix || options.interpolationSuffix || options.escapeInterpolation !== undefined) {
    options = convertInterpolation(options);
  }

  options.nsSeparator = options.nsseparator;
  options.keySeparator = options.keyseparator;

  options.returnObjects = options.returnObjectTrees;

  return options;
}

function appendBackwardsAPI(i18n) {
  i18n.lng = function () {
    logger.deprecate('i18next.lng() can be replaced by i18next.language for detected language or i18next.languages for languages ordered by translation lookup.');
    return i18n.services.languageUtils.toResolveHierarchy(i18n.language)[0];
  };

  i18n.preload = function (lngs, cb) {
    logger.deprecate('i18next.preload() can be replaced with i18next.loadLanguages()');
    i18n.loadLanguages(lngs, cb);
  };

  i18n.setLng = function (lng, options, callback) {
    logger.deprecate('i18next.setLng() can be replaced with i18next.changeLanguage() or i18next.getFixedT() to get a translation function with fixed language or namespace.');
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!options) options = {};

    if (options.fixLng === true) {
      if (callback) return callback(null, i18n.getFixedT(lng));
    }

    return i18n.changeLanguage(lng, callback);
  };

  i18n.addPostProcessor = function (name, fc) {
    logger.deprecate('i18next.addPostProcessor() can be replaced by i18next.use({ type: \'postProcessor\', name: \'name\', process: fc })');
    i18n.use({
      type: 'postProcessor',
      name: name,
      process: fc
    });
  };
}
// CONCATENATED MODULE: ../node_modules/cashier-payments-sdk/node_modules/i18next/dist/es/Translator.js
var Translator__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function Translator__defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function Translator__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Translator__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Translator__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : Translator__defaults(subClass, superClass); }







var Translator_Translator = function (_EventEmitter) {
  Translator__inherits(Translator, _EventEmitter);

  function Translator(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Translator__classCallCheck(this, Translator);

    var _this = Translator__possibleConstructorReturn(this, _EventEmitter.call(this));

    utils_copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector'], services, _this);

    _this.options = options;
    _this.logger = logger.create('translator');
    return _this;
  }

  Translator.prototype.changeLanguage = function changeLanguage(lng) {
    if (lng) this.language = lng;
  };

  Translator.prototype.exists = function exists(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { interpolation: {} };

    if (this.options.compatibilityAPI === 'v1') {
      options = convertTOptions(options);
    }

    return this.resolve(key, options) !== undefined;
  };

  Translator.prototype.extractFromKey = function extractFromKey(key, options) {
    var nsSeparator = options.nsSeparator || this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';
    var keySeparator = options.keySeparator || this.options.keySeparator || '.';

    var namespaces = options.ns || this.options.defaultNS;
    if (nsSeparator && key.indexOf(nsSeparator) > -1) {
      var parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    if (typeof namespaces === 'string') namespaces = [namespaces];

    return {
      key: key,
      namespaces: namespaces
    };
  };

  Translator.prototype.translate = function translate(keys) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
      /* eslint prefer-rest-params: 0 */
      options = this.options.overloadTranslationOptionHandler(arguments);
    } else if (this.options.compatibilityAPI === 'v1') {
      options = convertTOptions(options);
    }

    // non valid keys handling
    if (keys === undefined || keys === null || keys === '') return '';
    if (typeof keys === 'number') keys = String(keys);
    if (typeof keys === 'string') keys = [keys];

    // separators
    var keySeparator = options.keySeparator || this.options.keySeparator || '.';

    // get namespace(s)

    var _extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
        key = _extractFromKey.key,
        namespaces = _extractFromKey.namespaces;

    var namespace = namespaces[namespaces.length - 1];

    // return key on CIMode
    var lng = options.lng || this.language;
    var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng && lng.toLowerCase() === 'cimode') {
      if (appendNamespaceToCIMode) {
        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
        return namespace + nsSeparator + key;
      }

      return key;
    }

    // resolve from store
    var res = this.resolve(keys, options);

    var resType = Object.prototype.toString.apply(res);
    var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;

    // object
    if (res && typeof res !== 'string' && noObject.indexOf(resType) < 0 && !(joinArrays && resType === '[object Array]')) {
      if (!options.returnObjects && !this.options.returnObjects) {
        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(key, res, options) : 'key \'' + key + ' (' + this.language + ')\' returned an object instead of string.';
      }

      // if we got a separator we loop over children - else we just return object as is
      // as having it set to false means no hierarchy so no lookup for nested values
      if (options.keySeparator || this.options.keySeparator) {
        var copy = resType === '[object Array]' ? [] : {}; // apply child translation on a copy

        /* eslint no-restricted-syntax: 0 */
        for (var m in res) {
          if (Object.prototype.hasOwnProperty.call(res, m)) {
            copy[m] = this.translate('' + key + keySeparator + m, Translator__extends({}, options, { joinArrays: false, ns: namespaces }));
          }
        }
        res = copy;
      }
    } else if (joinArrays && resType === '[object Array]') {
      // array special treatment
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, key, options);
    } else {
      // string, empty or null
      var usedDefault = false;
      var usedKey = false;

      // fallback value
      if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
        usedDefault = true;
        res = options.defaultValue;
      }
      if (!this.isValidLookup(res)) {
        usedKey = true;
        res = key;
      }

      // save missing
      if (usedKey || usedDefault) {
        this.logger.log('missingKey', lng, namespace, key, res);

        var lngs = [];
        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
          for (var i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === 'all') {
          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
        } else {
          lngs.push(options.lng || this.language);
        }

        if (this.options.saveMissing) {
          if (this.options.missingKeyHandler) {
            this.options.missingKeyHandler(lngs, namespace, key, res);
          } else if (this.backendConnector && this.backendConnector.saveMissing) {
            this.backendConnector.saveMissing(lngs, namespace, key, res);
          }
        }

        this.emit('missingKey', lngs, namespace, key, res);
      }

      // extend
      res = this.extendTranslation(res, key, options);

      // append namespace if still key
      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = namespace + ':' + key;

      // parseMissingKeyHandler
      if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
    }

    // return
    return res;
  };

  Translator.prototype.extendTranslation = function extendTranslation(res, key, options) {
    var _this2 = this;

    if (options.interpolation) this.interpolator.init(Translator__extends({}, options, { interpolation: Translator__extends({}, this.options.interpolation, options.interpolation) }));

    // interpolate
    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
    if (this.options.interpolation.defaultVariables) data = Translator__extends({}, this.options.interpolation.defaultVariables, data);
    res = this.interpolator.interpolate(res, data, options.lng || this.language);

    // nesting
    if (options.nest !== false) res = this.interpolator.nest(res, function () {
      return _this2.translate.apply(_this2, arguments);
    }, options);

    if (options.interpolation) this.interpolator.reset();

    // post process
    var postProcess = options.postProcess || this.options.postProcess;
    var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

    if (res !== undefined && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
      res = postProcessor.handle(postProcessorNames, res, key, options, this);
    }

    return res;
  };

  Translator.prototype.resolve = function resolve(keys) {
    var _this3 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var found = void 0;

    if (typeof keys === 'string') keys = [keys];

    // forEach possible key
    keys.forEach(function (k) {
      if (_this3.isValidLookup(found)) return;

      var extracted = _this3.extractFromKey(k, options);
      var key = extracted.key;
      var namespaces = extracted.namespaces;
      if (_this3.options.fallbackNS) namespaces = namespaces.concat(_this3.options.fallbackNS);

      var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
      var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';

      var codes = options.lngs ? options.lngs : _this3.languageUtils.toResolveHierarchy(options.lng || _this3.language);

      namespaces.forEach(function (ns) {
        if (_this3.isValidLookup(found)) return;

        codes.forEach(function (code) {
          if (_this3.isValidLookup(found)) return;

          var finalKey = key;
          var finalKeys = [finalKey];

          var pluralSuffix = void 0;
          if (needsPluralHandling) pluralSuffix = _this3.pluralResolver.getSuffix(code, options.count);

          // fallback for plural if context not found
          if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);

          // get key for context if needed
          if (needsContextHandling) finalKeys.push(finalKey += '' + _this3.options.contextSeparator + options.context);

          // get key for plural if needed
          if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);

          // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only
          var possibleKey = void 0;
          /* eslint no-cond-assign: 0 */
          while (possibleKey = finalKeys.pop()) {
            if (!_this3.isValidLookup(found)) {
              found = _this3.getResource(code, ns, possibleKey, options);
            }
          }
        });
      });
    });

    return found;
  };

  Translator.prototype.isValidLookup = function isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  };

  Translator.prototype.getResource = function getResource(code, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    return this.resourceStore.getResource(code, ns, key, options);
  };

  return Translator;
}(es_EventEmitter);

/* harmony default export */ var es_Translator = (Translator_Translator);
// CONCATENATED MODULE: ../node_modules/cashier-payments-sdk/node_modules/i18next/dist/es/LanguageUtils.js
function LanguageUtils__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtils_LanguageUtil = function () {
  function LanguageUtil(options) {
    LanguageUtils__classCallCheck(this, LanguageUtil);

    this.options = options;

    this.whitelist = this.options.whitelist || false;
    this.logger = logger.create('languageUtils');
  }

  LanguageUtil.prototype.getScriptPartFromCode = function getScriptPartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return null;

    var p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    return this.formatLanguageCode(p.join('-'));
  };

  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return code;

    var p = code.split('-');
    return this.formatLanguageCode(p[0]);
  };

  LanguageUtil.prototype.formatLanguageCode = function formatLanguageCode(code) {
    // http://www.iana.org/assignments/language-tags/language-tags.xhtml
    if (typeof code === 'string' && code.indexOf('-') > -1) {
      var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
      var p = code.split('-');

      if (this.options.lowerCaseLng) {
        p = p.map(function (part) {
          return part.toLowerCase();
        });
      } else if (p.length === 2) {
        p[0] = p[0].toLowerCase();
        p[1] = p[1].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      } else if (p.length === 3) {
        p[0] = p[0].toLowerCase();

        // if lenght 2 guess it's a country
        if (p[1].length === 2) p[1] = p[1].toUpperCase();
        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
      }

      return p.join('-');
    }

    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  };

  LanguageUtil.prototype.isWhitelisted = function isWhitelisted(code) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
  };

  LanguageUtil.prototype.getFallbackCodes = function getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;

    if (!code) return fallbacks.default || [];

    // asume we have an object defining fallbacks
    var found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks.default;

    return found || [];
  };

  LanguageUtil.prototype.toResolveHierarchy = function toResolveHierarchy(code, fallbackCode) {
    var _this = this;

    var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);

    var codes = [];
    var addCode = function addCode(c) {
      if (!c) return;
      if (_this.isWhitelisted(c)) {
        codes.push(c);
      } else {
        _this.logger.warn('rejecting non-whitelisted language code: ' + c);
      }
    };

    if (typeof code === 'string' && code.indexOf('-') > -1) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (typeof code === 'string') {
      addCode(this.formatLanguageCode(code));
    }

    fallbackCodes.forEach(function (fc) {
      if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
    });

    return codes;
  };

  return LanguageUtil;
}();

/* harmony default export */ var LanguageUtils = (LanguageUtils_LanguageUtil);
// CONCATENATED MODULE: ../node_modules/cashier-payments-sdk/node_modules/i18next/dist/es/PluralResolver.js
function PluralResolver__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// definition http://translate.sourceforge.net/wiki/l10n/pluralforms
/* eslint-disable */
var sets = [{ lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'tg', 'ti', 'tr', 'uz', 'wa'], nr: [1, 2], fc: 1 }, { lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'es_ar', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'he', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt', 'pt_br', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'], nr: [1, 2], fc: 2 }, { lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'], nr: [1], fc: 3 }, { lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'], nr: [1, 2, 5], fc: 4 }, { lngs: ['ar'], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ['cs', 'sk'], nr: [1, 2, 5], fc: 6 }, { lngs: ['csb', 'pl'], nr: [1, 2, 5], fc: 7 }, { lngs: ['cy'], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ['fr'], nr: [1, 2], fc: 9 }, { lngs: ['ga'], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ['gd'], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ['is'], nr: [1, 2], fc: 12 }, { lngs: ['jv'], nr: [0, 1], fc: 13 }, { lngs: ['kw'], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ['lt'], nr: [1, 2, 10], fc: 15 }, { lngs: ['lv'], nr: [1, 2, 0], fc: 16 }, { lngs: ['mk'], nr: [1, 2], fc: 17 }, { lngs: ['mnk'], nr: [0, 1, 2], fc: 18 }, { lngs: ['mt'], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ['or'], nr: [2, 1], fc: 2 }, { lngs: ['ro'], nr: [1, 2, 20], fc: 20 }, { lngs: ['sl'], nr: [5, 1, 2, 3], fc: 21 }];

var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  }
};
/* eslint-enable */

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver_PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    PluralResolver__classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;

    this.logger = logger.create('pluralResolver');

    this.rules = createRules();
  }

  PluralResolver.prototype.addRule = function addRule(lng, obj) {
    this.rules[lng] = obj;
  };

  PluralResolver.prototype.getRule = function getRule(code) {
    return this.rules[this.languageUtils.getLanguagePartFromCode(code)];
  };

  PluralResolver.prototype.needsPlural = function needsPlural(code) {
    var rule = this.getRule(code);

    return rule && rule.numbers.length > 1;
  };

  PluralResolver.prototype.getSuffix = function getSuffix(code, count) {
    var _this = this;

    var rule = this.getRule(code);

    if (rule) {
      if (rule.numbers.length === 1) return ''; // only singular

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      // special treatment for lngs only having singular and plural
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this.options.prepend && suffix.toString() ? _this.options.prepend + suffix.toString() : suffix.toString();
      };

      // COMPATIBILITY JSON
      // v1
      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return '_plural_' + suffix.toString();
        return returnSuffix();
      } else if ( /* v2 */this.options.compatibilityJSON === 'v2' || rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      } else if ( /* v3 - gettext index */rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }

    this.logger.warn('no plural rule found for: ' + code);
    return '';
  };

  return PluralResolver;
}();

/* harmony default export */ var es_PluralResolver = (PluralResolver_PluralResolver);
// CONCATENATED MODULE: ../node_modules/cashier-payments-sdk/node_modules/i18next/dist/es/Interpolator.js
var Interpolator__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function Interpolator__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Interpolator_Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    Interpolator__classCallCheck(this, Interpolator);

    this.logger = logger.create('interpolator');

    this.init(options, true);
  }

  /* eslint no-param-reassign: 0 */


  Interpolator.prototype.init = function init() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var reset = arguments[1];

    if (reset) {
      this.options = options;
      this.format = options.interpolation && options.interpolation.format || function (value) {
        return value;
      };
      this.escape = options.interpolation && options.interpolation.escape || utils_escape;
    }
    if (!options.interpolation) options.interpolation = { escapeValue: true };

    var iOpts = options.interpolation;

    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;

    this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
    this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';

    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';

    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';

    this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
    this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');

    // the regexp
    this.resetRegExp();
  };

  Interpolator.prototype.reset = function reset() {
    if (this.options) this.init(this.options);
  };

  Interpolator.prototype.resetRegExp = function resetRegExp() {
    // the regexp
    var regexpStr = this.prefix + '(.+?)' + this.suffix;
    this.regexp = new RegExp(regexpStr, 'g');

    var regexpUnescapeStr = '' + this.prefix + this.unescapePrefix + '(.+?)' + this.unescapeSuffix + this.suffix;
    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');

    var nestingRegexpStr = this.nestingPrefix + '(.+?)' + this.nestingSuffix;
    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
  };

  Interpolator.prototype.interpolate = function interpolate(str, data, lng) {
    var _this = this;

    var match = void 0;
    var value = void 0;

    function regexSafe(val) {
      return val.replace(/\$/g, '$$$$');
    }

    var handleFormat = function handleFormat(key) {
      if (key.indexOf(_this.formatSeparator) < 0) return getPath(data, key);

      var p = key.split(_this.formatSeparator);
      var k = p.shift().trim();
      var f = p.join(_this.formatSeparator).trim();

      return _this.format(getPath(data, k), f, lng);
    };

    this.resetRegExp();

    // unescape if has unescapePrefix/Suffix
    /* eslint no-cond-assign: 0 */
    while (match = this.regexpUnescape.exec(str)) {
      value = handleFormat(match[1].trim());
      str = str.replace(match[0], value);
      this.regexpUnescape.lastIndex = 0;
    }

    // regular escape on demand
    while (match = this.regexp.exec(str)) {
      value = handleFormat(match[1].trim());
      if (typeof value !== 'string') value = makeString(value);
      if (!value) {
        this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
        value = '';
      }
      value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  };

  Interpolator.prototype.nest = function nest(str, fc) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var match = void 0;
    var value = void 0;

    var clonedOptions = Interpolator__extends({}, options);
    clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup

    // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"
    function handleHasOptions(key) {
      if (key.indexOf(',') < 0) return key;

      var p = key.split(',');
      key = p.shift();
      var optionsString = p.join(',');
      optionsString = this.interpolate(optionsString, clonedOptions);
      optionsString = optionsString.replace(/'/g, '"');

      try {
        clonedOptions = JSON.parse(optionsString);
      } catch (e) {
        this.logger.error('failed parsing options string in nesting for key ' + key, e);
      }

      return key;
    }

    // regular escape on demand
    while (match = this.nestingRegexp.exec(str)) {
      value = fc(handleHasOptions.call(this, match[1].trim()), clonedOptions);

      // is only the nesting key (key1 = '$(key2)') return the value without stringify
      if (value && match[0] === str && typeof value !== 'string') return value;

      // no string to include or empty
      if (typeof value !== 'string') value = makeString(value);
      if (!value) {
        this.logger.warn('missed to resolve ' + match[1] + ' for nesting ' + str);
        value = '';
      }
      // Nested keys should not be escaped by default #854
      // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  };

  return Interpolator;
}();

/* harmony default export */ var es_Interpolator = (Interpolator_Interpolator);
// CONCATENATED MODULE: ../node_modules/cashier-payments-sdk/node_modules/i18next/dist/es/BackendConnector.js
var BackendConnector__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function BackendConnector__defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function BackendConnector__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BackendConnector__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function BackendConnector__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : BackendConnector__defaults(subClass, superClass); }





function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var BackendConnector_Connector = function (_EventEmitter) {
  BackendConnector__inherits(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    BackendConnector__classCallCheck(this, Connector);

    var _this = BackendConnector__possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.options = options;
    _this.logger = logger.create('backendConnector');

    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }

  Connector.prototype.queueLoad = function queueLoad(languages, namespaces, callback) {
    var _this2 = this;

    // find what needs to be loaded
    var toLoad = [];
    var pending = [];
    var toLoadLanguages = [];
    var toLoadNamespaces = [];

    languages.forEach(function (lng) {
      var hasAllNamespaces = true;

      namespaces.forEach(function (ns) {
        var name = lng + '|' + ns;

        if (_this2.store.hasResourceBundle(lng, ns)) {
          _this2.state[name] = 2; // loaded
        } else if (_this2.state[name] < 0) {
          // nothing to do for err
        } else if (_this2.state[name] === 1) {
          if (pending.indexOf(name) < 0) pending.push(name);
        } else {
          _this2.state[name] = 1; // pending

          hasAllNamespaces = false;

          if (pending.indexOf(name) < 0) pending.push(name);
          if (toLoad.indexOf(name) < 0) toLoad.push(name);
          if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
        }
      });

      if (!hasAllNamespaces) toLoadLanguages.push(lng);
    });

    if (toLoad.length || pending.length) {
      this.queue.push({
        pending: pending,
        loaded: {},
        errors: [],
        callback: callback
      });
    }

    return {
      toLoad: toLoad,
      pending: pending,
      toLoadLanguages: toLoadLanguages,
      toLoadNamespaces: toLoadNamespaces
    };
  };

  Connector.prototype.loaded = function loaded(name, err, data) {
    var _this3 = this;

    var _name$split = name.split('|'),
        _name$split2 = _slicedToArray(_name$split, 2),
        lng = _name$split2[0],
        ns = _name$split2[1];

    if (err) this.emit('failedLoading', lng, ns, err);

    if (data) {
      this.store.addResourceBundle(lng, ns, data);
    }

    // set loaded
    this.state[name] = err ? -1 : 2;

    // callback if ready
    this.queue.forEach(function (q) {
      pushPath(q.loaded, [lng], ns);
      remove(q.pending, name);

      if (err) q.errors.push(err);

      if (q.pending.length === 0 && !q.done) {
        _this3.emit('loaded', q.loaded);
        /* eslint no-param-reassign: 0 */
        q.done = true;
        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    });

    // remove done load requests
    this.queue = this.queue.filter(function (q) {
      return !q.done;
    });
  };

  Connector.prototype.read = function read(lng, ns, fcName) {
    var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    var _this4 = this;

    var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
    var callback = arguments[5];

    if (!lng.length) return callback(null, {}); // noting to load

    return this.backend[fcName](lng, ns, function (err, data) {
      if (err && data /* = retryFlag */ && tried < 5) {
        setTimeout(function () {
          _this4.read.call(_this4, lng, ns, fcName, tried + 1, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    });
  };

  /* eslint consistent-return: 0 */


  Connector.prototype.load = function load(languages, namespaces, callback) {
    var _this5 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }
    var options = BackendConnector__extends({}, this.backend.options, this.options.backend);

    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    var toLoad = this.queueLoad(languages, namespaces, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now
      return null; // pendings will trigger callback
    }

    // load with multi-load
    if (options.allowMultiLoading && this.backend.readMulti) {
      this.read(toLoad.toLoadLanguages, toLoad.toLoadNamespaces, 'readMulti', null, null, function (err, data) {
        if (err) _this5.logger.warn('loading namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading failed', err);
        if (!err && data) _this5.logger.log('successfully loaded namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading', data);

        toLoad.toLoad.forEach(function (name) {
          var _name$split3 = name.split('|'),
              _name$split4 = _slicedToArray(_name$split3, 2),
              l = _name$split4[0],
              n = _name$split4[1];

          var bundle = getPath(data, [l, n]);
          if (bundle) {
            _this5.loaded(name, err, bundle);
          } else {
            var error = 'loading namespace ' + n + ' for language ' + l + ' via multiloading failed';
            _this5.loaded(name, error);
            _this5.logger.error(error);
          }
        });
      });
    } else {
      toLoad.toLoad.forEach(function (name) {
        _this5.loadOne(name);
      });
    }
  };

  Connector.prototype.reload = function reload(languages, namespaces) {
    var _this6 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
    }
    var options = BackendConnector__extends({}, this.backend.options, this.options.backend);

    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    // load with multi-load
    if (options.allowMultiLoading && this.backend.readMulti) {
      this.read(languages, namespaces, 'readMulti', null, null, function (err, data) {
        if (err) _this6.logger.warn('reloading namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading failed', err);
        if (!err && data) _this6.logger.log('successfully reloaded namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading', data);

        languages.forEach(function (l) {
          namespaces.forEach(function (n) {
            var bundle = getPath(data, [l, n]);
            if (bundle) {
              _this6.loaded(l + '|' + n, err, bundle);
            } else {
              var error = 'reloading namespace ' + n + ' for language ' + l + ' via multiloading failed';
              _this6.loaded(l + '|' + n, error);
              _this6.logger.error(error);
            }
          });
        });
      });
    } else {
      languages.forEach(function (l) {
        namespaces.forEach(function (n) {
          _this6.loadOne(l + '|' + n, 're');
        });
      });
    }
  };

  Connector.prototype.loadOne = function loadOne(name) {
    var _this7 = this;

    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var _name$split5 = name.split('|'),
        _name$split6 = _slicedToArray(_name$split5, 2),
        lng = _name$split6[0],
        ns = _name$split6[1];

    this.read(lng, ns, 'read', null, null, function (err, data) {
      if (err) _this7.logger.warn(prefix + 'loading namespace ' + ns + ' for language ' + lng + ' failed', err);
      if (!err && data) _this7.logger.log(prefix + 'loaded namespace ' + ns + ' for language ' + lng, data);

      _this7.loaded(name, err, data);
    });
  };

  Connector.prototype.saveMissing = function saveMissing(languages, namespace, key, fallbackValue) {
    if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue);

    // write to store to avoid resending
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  };

  return Connector;
}(es_EventEmitter);

/* harmony default export */ var BackendConnector = (BackendConnector_Connector);
// CONCATENATED MODULE: ../node_modules/cashier-payments-sdk/node_modules/i18next/dist/es/CacheConnector.js
var CacheConnector__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function CacheConnector__defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function CacheConnector__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CacheConnector__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function CacheConnector__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : CacheConnector__defaults(subClass, superClass); }




var CacheConnector_Connector = function (_EventEmitter) {
  CacheConnector__inherits(Connector, _EventEmitter);

  function Connector(cache, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    CacheConnector__classCallCheck(this, Connector);

    var _this = CacheConnector__possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.cache = cache;
    _this.store = store;
    _this.services = services;
    _this.options = options;
    _this.logger = logger.create('cacheConnector');

    if (_this.cache && _this.cache.init) _this.cache.init(services, options.cache, options);
    return _this;
  }

  /* eslint consistent-return: 0 */


  Connector.prototype.load = function load(languages, namespaces, callback) {
    var _this2 = this;

    if (!this.cache) return callback && callback();
    var options = CacheConnector__extends({}, this.cache.options, this.options.cache);

    var loadLngs = typeof languages === 'string' ? this.services.languageUtils.toResolveHierarchy(languages) : languages;

    if (options.enabled) {
      this.cache.load(loadLngs, function (err, data) {
        if (err) _this2.logger.error('loading languages ' + loadLngs.join(', ') + ' from cache failed', err);
        if (data) {
          /* eslint no-restricted-syntax: 0 */
          for (var l in data) {
            if (Object.prototype.hasOwnProperty.call(data, l)) {
              for (var n in data[l]) {
                if (Object.prototype.hasOwnProperty.call(data[l], n)) {
                  if (n !== 'i18nStamp') {
                    var bundle = data[l][n];
                    if (bundle) _this2.store.addResourceBundle(l, n, bundle);
                  }
                }
              }
            }
          }
        }
        if (callback) callback();
      });
    } else if (callback) {
      callback();
    }
  };

  Connector.prototype.save = function save() {
    if (this.cache && this.options.cache && this.options.cache.enabled) this.cache.save(this.store.data);
  };

  return Connector;
}(es_EventEmitter);

/* harmony default export */ var CacheConnector = (CacheConnector_Connector);
// CONCATENATED MODULE: ../node_modules/cashier-payments-sdk/node_modules/i18next/dist/es/defaults.js

function get() {
  return {
    debug: false,
    initImmediate: true,

    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false, // string or array of namespaces

    whitelist: false, // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all', // | currentOnly | languageOnly
    preload: false, // array with preload languages

    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',

    saveMissing: false, // enable to send missing values
    saveMissingTo: 'fallback', // 'current' || 'all'
    missingKeyHandler: false, // function(lng, ns, key, fallbackValue) -> override if prefer on handling

    postProcess: false, // string or array of postProcessor names
    returnNull: true, // allows null value as valid translation
    returnEmptyString: true, // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false, // or string to join array
    returnedObjectHandler: function returnedObjectHandler() {}, // function(key, value, options) triggered if key returns object but returnObjects is set to false
    parseMissingKeyHandler: false, // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      return { defaultValue: args[1] };
    },

    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',

      nestingPrefix: '$t(',
      nestingSuffix: ')',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',
      defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
    }
  };
}

/* eslint no-param-reassign: 0 */
function transformOptions(options) {
  // create namespace object if namespace is passed in as string
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  // extend whitelist with cimode
  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) options.whitelist.push('cimode');

  return options;
}
// CONCATENATED MODULE: ../node_modules/cashier-payments-sdk/node_modules/i18next/dist/es/i18next.js
var i18next__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function i18next__defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function i18next__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function i18next__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function i18next__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : i18next__defaults(subClass, superClass); }















function noop() {}

var i18next_I18n = function (_EventEmitter) {
  i18next__inherits(I18n, _EventEmitter);

  function I18n() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    i18next__classCallCheck(this, I18n);

    var _this = i18next__possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = logger;
    _this.modules = { external: [] };

    if (callback && !_this.isInitialized && !options.isClone) {
      var _ret;

      // https://github.com/i18next/i18next/issues/879
      if (!_this.options.initImmediate) return _ret = _this.init(options, callback), i18next__possibleConstructorReturn(_this, _ret);
      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }

  I18n.prototype.init = function init(options, callback) {
    var _this2 = this;

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!options) options = {};

    if (options.compatibilityAPI === 'v1') {
      this.options = i18next__extends({}, get(), transformOptions(convertAPIOptions(options)), {});
    } else if (options.compatibilityJSON === 'v1') {
      this.options = i18next__extends({}, get(), transformOptions(convertJSONOptions(options)), {});
    } else {
      this.options = i18next__extends({}, get(), this.options, transformOptions(options));
    }
    this.format = this.options.interpolation.format;
    if (!callback) callback = noop;

    function createClassOnDemand(ClassOrObject) {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    }

    // init services
    if (!this.options.isClone) {
      if (this.modules.logger) {
        logger.init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        logger.init(null, this.options);
      }

      var lu = new LanguageUtils(this.options);
      this.store = new es_ResourceStore(this.options.resources, this.options);

      var s = this.services;
      s.logger = logger;
      s.resourceStore = this.store;
      s.resourceStore.on('added removed', function (lng, ns) {
        s.cacheConnector.save();
      });
      s.languageUtils = lu;
      s.pluralResolver = new es_PluralResolver(lu, { prepend: this.options.pluralSeparator, compatibilityJSON: this.options.compatibilityJSON, simplifyPluralSuffix: this.options.simplifyPluralSuffix });
      s.interpolator = new es_Interpolator(this.options);

      s.backendConnector = new BackendConnector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.backendConnector.on('*', function (event) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      s.backendConnector.on('loaded', function (loaded) {
        s.cacheConnector.save();
      });

      s.cacheConnector = new CacheConnector(createClassOnDemand(this.modules.cache), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.cacheConnector.on('*', function (event) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        s.languageDetector.init(s, this.options.detection, this.options);
      }

      this.translator = new es_Translator(this.services, this.options);
      // pipe events from translator
      this.translator.on('*', function (event) {
        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      this.modules.external.forEach(function (m) {
        if (m.init) m.init(_this2);
      });
    }

    // append api
    var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle'];
    storeApi.forEach(function (fcName) {
      _this2[fcName] = function () {
        var _store;

        return (_store = _this2.store)[fcName].apply(_store, arguments);
      };
    });

    // COMPATIBILITY: remove this
    if (this.options.compatibilityAPI === 'v1') appendBackwardsAPI(this);

    var load = function load() {
      _this2.changeLanguage(_this2.options.lng, function (err, t) {
        _this2.isInitialized = true;
        _this2.logger.log('initialized', _this2.options);
        _this2.emit('initialized', _this2.options);

        callback(err, t);
      });
    };

    if (this.options.resources || !this.options.initImmediate) {
      load();
    } else {
      setTimeout(load, 0);
    }

    return this;
  };

  /* eslint consistent-return: 0 */


  I18n.prototype.loadResources = function loadResources() {
    var _this3 = this;

    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

    if (!this.options.resources) {
      if (this.language && this.language.toLowerCase() === 'cimode') return callback(); // avoid loading resources for cimode

      var toLoad = [];

      var append = function append(lng) {
        if (!lng) return;
        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };

      if (!this.language) {
        // at least load fallbacks in this case
        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach(function (l) {
          return append(l);
        });
      } else {
        append(this.language);
      }

      if (this.options.preload) {
        this.options.preload.forEach(function (l) {
          return append(l);
        });
      }

      this.services.cacheConnector.load(toLoad, this.options.ns, function () {
        _this3.services.backendConnector.load(toLoad, _this3.options.ns, callback);
      });
    } else {
      callback(null);
    }
  };

  I18n.prototype.reloadResources = function reloadResources(lngs, ns) {
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    this.services.backendConnector.reload(lngs, ns);
  };

  I18n.prototype.use = function use(module) {
    if (module.type === 'backend') {
      this.modules.backend = module;
    }

    if (module.type === 'cache') {
      this.modules.cache = module;
    }

    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }

    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }

    if (module.type === 'postProcessor') {
      postProcessor.addPostProcessor(module);
    }

    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }

    return this;
  };

  I18n.prototype.changeLanguage = function changeLanguage(lng, callback) {
    var _this4 = this;

    var done = function done(err, l) {
      if (l) {
        _this4.emit('languageChanged', l);
        _this4.logger.log('languageChanged', l);
      }

      if (callback) callback(err, function () {
        return _this4.t.apply(_this4, arguments);
      });
    };

    var setLng = function setLng(l) {
      if (l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);

        _this4.translator.changeLanguage(l);

        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
      }

      _this4.loadResources(function (err) {
        done(err, l);
      });
    };

    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      this.services.languageDetector.detect(setLng);
    } else {
      setLng(lng);
    }
  };

  I18n.prototype.getFixedT = function getFixedT(lng, ns) {
    var _this5 = this;

    var fixedT = function fixedT(key) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var options = i18next__extends({}, opts);
      options.lng = options.lng || fixedT.lng;
      options.lngs = options.lngs || fixedT.lngs;
      options.ns = options.ns || fixedT.ns;
      return _this5.t(key, options);
    };
    if (typeof lng === 'string') {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }
    fixedT.ns = ns;
    return fixedT;
  };

  I18n.prototype.t = function t() {
    var _translator;

    return this.translator && (_translator = this.translator).translate.apply(_translator, arguments);
  };

  I18n.prototype.exists = function exists() {
    var _translator2;

    return this.translator && (_translator2 = this.translator).exists.apply(_translator2, arguments);
  };

  I18n.prototype.setDefaultNamespace = function setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  };

  I18n.prototype.loadNamespaces = function loadNamespaces(ns, callback) {
    var _this6 = this;

    if (!this.options.ns) return callback && callback();
    if (typeof ns === 'string') ns = [ns];

    ns.forEach(function (n) {
      if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
    });

    this.loadResources(callback);
  };

  I18n.prototype.loadLanguages = function loadLanguages(lngs, callback) {
    if (typeof lngs === 'string') lngs = [lngs];
    var preloaded = this.options.preload || [];

    var newLngs = lngs.filter(function (lng) {
      return preloaded.indexOf(lng) < 0;
    });
    // Exit early if all given languages are already preloaded
    if (!newLngs.length) return callback();

    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(callback);
  };

  I18n.prototype.dir = function dir(lng) {
    if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
    if (!lng) return 'rtl';

    var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];

    return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
  };

  /* eslint class-methods-use-this: 0 */


  I18n.prototype.createInstance = function createInstance() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    return new I18n(options, callback);
  };

  I18n.prototype.cloneInstance = function cloneInstance() {
    var _this7 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

    var mergedOptions = i18next__extends({}, this.options, options, { isClone: true });
    var clone = new I18n(mergedOptions, callback);
    var membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(function (m) {
      clone[m] = _this7[m];
    });
    clone.translator = new es_Translator(clone.services, clone.options);
    clone.translator.on('*', function (event) {
      for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      clone.emit.apply(clone, [event].concat(args));
    });
    clone.init(mergedOptions, callback);

    return clone;
  };

  return I18n;
}(es_EventEmitter);

/* harmony default export */ var i18next = (new i18next_I18n());
// CONCATENATED MODULE: ../node_modules/cashier-payments-sdk/node_modules/i18next/dist/es/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeLanguage", function() { return changeLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneInstance", function() { return es_cloneInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createInstance", function() { return createInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dir", function() { return dir; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exists", function() { return es_exists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFixedT", function() { return getFixedT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return es_init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadLanguages", function() { return loadLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadNamespaces", function() { return loadNamespaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadResources", function() { return loadResources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "off", function() { return off; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "on", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDefaultNamespace", function() { return setDefaultNamespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return t; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "use", function() { return es_use; });


/* harmony default export */ var es = __webpack_exports__["default"] = (i18next);

var changeLanguage = i18next.changeLanguage.bind(i18next);
var es_cloneInstance = i18next.cloneInstance.bind(i18next);
var createInstance = i18next.createInstance.bind(i18next);
var dir = i18next.dir.bind(i18next);
var es_exists = i18next.exists.bind(i18next);
var getFixedT = i18next.getFixedT.bind(i18next);
var es_init = i18next.init.bind(i18next);
var loadLanguages = i18next.loadLanguages.bind(i18next);
var loadNamespaces = i18next.loadNamespaces.bind(i18next);
var loadResources = i18next.loadResources.bind(i18next);
var off = i18next.off.bind(i18next);
var on = i18next.on.bind(i18next);
var setDefaultNamespace = i18next.setDefaultNamespace.bind(i18next);
var t = i18next.t.bind(i18next);
var es_use = i18next.use.bind(i18next);

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(419).default;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(420);

var utils = _interopRequireWildcard(_utils);

var _ajax = __webpack_require__(421);

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getDefaults() {
  return {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    addPath: '/locales/add/{{lng}}/{{ns}}',
    allowMultiLoading: false,
    parse: JSON.parse,
    crossDomain: false,
    ajax: _ajax2.default
  };
}

var Backend = function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Backend);

    this.init(services, options);

    this.type = 'backend';
  }

  _createClass(Backend, [{
    key: 'init',
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.services = services;
      this.options = utils.defaults(options, this.options || {}, getDefaults());
    }
  }, {
    key: 'readMulti',
    value: function readMulti(languages, namespaces, callback) {
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath(languages, namespaces);
      }

      var url = this.services.interpolator.interpolate(loadPath, { lng: languages.join('+'), ns: namespaces.join('+') });

      this.loadUrl(url, callback);
    }
  }, {
    key: 'read',
    value: function read(language, namespace, callback) {
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath([language], [namespace]);
      }

      var url = this.services.interpolator.interpolate(loadPath, { lng: language, ns: namespace });

      this.loadUrl(url, callback);
    }
  }, {
    key: 'loadUrl',
    value: function loadUrl(url, callback) {
      var _this = this;

      this.options.ajax(url, this.options, function (data, xhr) {
        if (xhr.status >= 500 && xhr.status < 600) return callback('failed loading ' + url, true /* retry */);
        if (xhr.status >= 400 && xhr.status < 500) return callback('failed loading ' + url, false /* no retry */);

        var ret = void 0,
            err = void 0;
        try {
          ret = _this.options.parse(data, url);
        } catch (e) {
          err = 'failed parsing ' + url + ' to json';
        }
        if (err) return callback(err, false);
        callback(null, ret);
      });
    }
  }, {
    key: 'create',
    value: function create(languages, namespace, key, fallbackValue) {
      var _this2 = this;

      if (typeof languages === 'string') languages = [languages];

      var payload = {};
      payload[key] = fallbackValue || '';

      languages.forEach(function (lng) {
        var url = _this2.services.interpolator.interpolate(_this2.options.addPath, { lng: lng, ns: namespace });

        _this2.options.ajax(url, _this2.options, function (data, xhr) {
          //const statusCode = xhr.status.toString();
          // TODO: if statusCode === 4xx do log
        }, payload);
      });
    }
  }]);

  return Backend;
}();

Backend.type = 'backend';

exports.default = Backend;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaults = defaults;
exports.extend = extend;
var arr = [];
var each = arr.forEach;
var slice = arr.slice;

function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

function extend(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function addQueryString(url, params) {
  if (params && (typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
    var queryString = '',
        e = encodeURIComponent;

    // Must encode data
    for (var paramName in params) {
      queryString += '&' + e(paramName) + '=' + e(params[paramName]);
    }

    if (!queryString) {
      return url;
    }

    url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
  }

  return url;
}

// https://gist.github.com/Xeoncross/7663273
function ajax(url, options, callback, data, cache) {

  if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
    if (!cache) {
      data['_t'] = new Date();
    }
    // URL encoded form data must be in querystring format
    data = addQueryString('', data).slice(1);
  }

  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }

  try {
    var x;
    if (XMLHttpRequest) {
      x = new XMLHttpRequest();
    } else {
      x = new ActiveXObject('MSXML2.XMLHTTP.3.0');
    }
    x.open(data ? 'POST' : 'GET', url, 1);
    if (!options.crossDomain) {
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    }
    x.withCredentials = !!options.withCredentials;
    if (data) {
      x.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    }
    if (x.overrideMimeType) {
      x.overrideMimeType("application/json");
    }
    var h = options.customHeaders;
    if (h) {
      for (var i in h) {
        x.setRequestHeader(i, h[i]);
      }
    }
    x.onreadystatechange = function () {
      x.readyState > 3 && callback && callback(x.responseText, x);
    };
    x.send(data);
  } catch (e) {
    console && console.log(e);
  }
}

exports.default = ajax;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_POPUP_OPEN = 'payment:popup:open';
exports.EVENT_POPUP_CLOSE = 'payment:popup:close';
var PaymentModule = /** @class */ (function () {
    function PaymentModule(localizeError, linkToWindow, props, eventEmitter) {
        var _this = this;
        this.popupInstance = null;
        this.emit = function (event) {
            if (_this.eventEmitter) {
                _this.eventEmitter.emit(event);
            }
            return _this;
        };
        this.openPaymentInNewTab = function (url, walletId, resolve, reject, chargeResponse) {
            if (_this.windowController.name) {
                console.error('window.name will be override with new name - mainwin');
            }
            _this.windowController.name = 'mainwin';
            _this.windowController.onWalletPaymentCompleted = _this.handlePaymentComplete.bind(_this, walletId, chargeResponse, resolve, reject);
            var height = 608;
            var width = 450;
            var top = typeof screen === 'object' ? screen.height / 2 - height / 2 : 0;
            var left = typeof screen === 'object' ? screen.availLeft + screen.width / 2 - width / 2 : 0;
            if (_this.popupInstance && _this.popupInstance.window && _this.popupInstance.location && _this.popupInstance.location.href) {
                _this.emit(exports.EVENT_POPUP_CLOSE);
                _this.popupInstance.location.href = url;
            }
            else {
                _this.popupInstance = _this.windowController.open(url, '_blank', "location=yes,height=" + height + ",width=" + width + ",scrollbars=yes,status=yes,top=" + top + ",left=" + left);
                var interval_1 = setInterval(function () {
                    if (!_this.popupInstance || _this.popupInstance.closed) {
                        _this.emit(exports.EVENT_POPUP_CLOSE);
                        clearInterval(interval_1);
                    }
                }, 100);
            }
            _this.emit(exports.EVENT_POPUP_OPEN);
        };
        this.openPaymentInCurrentTab = function (url, walletId, opener) {
            if (!_this.windowController || !_this.windowController.location && opener) {
                opener(url);
            }
            else if (_this.windowController.location || (_this.windowController.top && _this.windowController.top.location)) {
                if (_this.windowController.top && _this.windowController.top.location) {
                    _this.windowController.top.location.href = url;
                }
                else {
                    _this.windowController.location.href = url;
                }
            }
            else {
                console.error('No location provided');
            }
        };
        this.cancelPaymentPopup = function () {
            if (_this.popupInstance) {
                _this.popupInstance.close();
                _this.popupInstance = null;
            }
        };
        this.launchPaymentPopup = function (walletId, _a) {
            var chargeResponse = _a.chargeResponse;
            var redirectUrl = (chargeResponse && chargeResponse.redirectUrl) || 'about:blank';
            _this.openPaymentInNewTab(redirectUrl, walletId, null, null, chargeResponse);
        };
        this.continuePayment = function (method, _a) {
            var chargeResponse = _a.chargeResponse, inNewTab = _a.inNewTab;
            return (new Promise(function (resolve, reject) {
                if (_this.onPaymentStart) {
                    _this.onPaymentStart(method, { type: 'PAYMENT_START' });
                }
                var result = _this.preparePaymentCompleteResult(method, chargeResponse);
                if (['APPROVED', 'PENDING_MERCHANT', 'PENDING_BUYER', 'INITIALIZED', 'OFFLINE'].indexOf(chargeResponse.transactionStatus) !== -1) {
                    if (_this.onPaymentComplete) {
                        _this.onPaymentComplete(method, result);
                    }
                    resolve(result);
                }
                if (['IN_PROCESS', 'INITIALIZATION'].indexOf(chargeResponse.transactionStatus) !== -1) {
                    if (inNewTab) {
                        _this.openPaymentInNewTab(chargeResponse.redirectUrl, method, resolve, reject, chargeResponse);
                    }
                    else {
                        resolve(result);
                        _this.openPaymentInCurrentTab(chargeResponse.redirectUrl, method, _this.linkOpener);
                    }
                }
                if (['UNDEFINED', 'DECLINED', 'FAILED', 'BUYER_CANCELED', 'TIMEOUT'].indexOf(chargeResponse.transactionStatus) !== -1) {
                    _this.cancelPaymentPopup();
                    _this.localizeError(chargeResponse.failureDetails).then(function (translatedError) {
                        var rejectResult = __assign({}, result, { errorCode: chargeResponse.failureDetails, translatedError: translatedError });
                        if (_this.onPaymentComplete) {
                            _this.onPaymentComplete(method, rejectResult);
                        }
                        reject(rejectResult);
                    });
                }
            }));
        };
        this.eventEmitter = eventEmitter;
        this.windowController = linkToWindow || window;
        this.localizeError = localizeError;
        this.onPaymentComplete = props.onPaymentComplete;
        this.onPaymentStart = props.onPaymentStart;
        this.linkOpener = props.linkOpener;
    }
    PaymentModule.prototype.handlePaymentComplete = function (walletId, chargeResponse, resolve, reject, result) {
        if (result === void 0) { result = { status: '', errorCode: '' }; }
        this.popupInstance = null;
        var OK_STATUSES = ['APPROVED', 'PENDING_MERCHANT', 'PENDING_BUYER'];
        var paymentResult = this.preparePaymentCompleteResult(walletId, chargeResponse, result);
        if (resolve && OK_STATUSES.indexOf(result.status) !== -1) {
            resolve(paymentResult);
        }
        else if (reject && this.localizeError) {
            this.localizeError(result.errorCode).then(function (translatedError) {
                return reject(__assign({}, paymentResult, { translatedError: translatedError }));
            });
        }
        if (this.onPaymentComplete) {
            this.onPaymentComplete(walletId, paymentResult);
        }
    };
    PaymentModule.prototype.preparePaymentCompleteResult = function (method, chargeResponse, result) {
        if (result === void 0) { result = {}; }
        return __assign({ status: chargeResponse.transactionStatus, paymentMethod: method, errorCode: '', translatedError: '' }, chargeResponse.chargeId ? { chargeId: chargeResponse.chargeId } : {}, result);
    };
    return PaymentModule;
}());
exports.default = PaymentModule;
//# sourceMappingURL=PaymentModule.js.map

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MandatoryFields_1 = __webpack_require__(424);
exports.default = MandatoryFields_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __webpack_require__(59);
var biLogger_1 = __webpack_require__(119);
var interpolate_1 = __webpack_require__(58);
var configURLS = __webpack_require__(61);
var MandatoryFields = /** @class */ (function () {
    function MandatoryFields() {
        var _this = this;
        this.fields = {};
        this.setMandatoryField = function (name, field) {
            _this.fields[name] = field;
        };
        this.getMandatoryFieldsMap = function () {
            var result = {};
            // TODO: Change with implementation of https://jira.wixpress.com/browse/WCN-2070
            var addressDetailKey = 'addressDetails';
            var addressDetailsKeys = ['street', 'houseNumber'];
            Object.keys(_this.fields).forEach(function (key) {
                if (addressDetailsKeys.indexOf(key) > -1) {
                    if (!result[addressDetailKey]) {
                        result[addressDetailKey] = {};
                    }
                    result[addressDetailKey][key] = _this.fields[key].value;
                }
                else {
                    result[key] = _this.fields[key].value;
                }
            });
            return result;
        };
        this.fetchMandatoryFields = function (config, country, host) { return __awaiter(_this, void 0, void 0, function () {
            var endpoint, provider, data, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = this.getMandatoryFieldsEndpoint({ orderId: config.orderId, host: host });
                        provider = config.providerId || config.paymentMethod;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios_1.default.get(endpoint, { params: { country: country, provider: provider } })];
                    case 2:
                        data = (_a.sent()).data;
                        this.logMandatoryFieldsLoaded({
                            appId: config.appId,
                            appInstanceId: config.appInstanceId,
                            paymentMethod: config.paymentMethod,
                            orderId: config.orderId,
                        }, data);
                        return [2 /*return*/, data];
                    case 3:
                        e_1 = _a.sent();
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.logMandatoryFieldsLoaded = function (_a, data) {
            var orderId = _a.orderId, paymentMethod = _a.paymentMethod, appId = _a.appId, appInstanceId = _a.appInstanceId;
            var mandatoryFields = data.mandatoryFields || [];
            biLogger_1.default.mandatoryFieldsLoaded({
                orderId: orderId, appId: appId, appInstanceId: appInstanceId, paymentMethod: paymentMethod,
                mandatoryFieldsList: mandatoryFields.map(function (field) { return field.fieldName; }),
            });
        };
        this.getMandatoryFieldsEndpoint = function (_a) {
            var orderId = _a.orderId, host = _a.host;
            var url = orderId
                ? host + interpolate_1.default(configURLS.mandatoryFieldsUrl, { orderId: orderId })
                : host + configURLS.mandatoryFieldsProviderUrl;
            return url;
        };
    }
    return MandatoryFields;
}());
exports.default = MandatoryFields;
//# sourceMappingURL=MandatoryFields.js.map

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biLoggerFactory = __webpack_require__(109);

var _biLoggerFactory2 = _interopRequireDefault(_biLoggerFactory);

var _env = __webpack_require__(33);

var _publishers = __webpack_require__(426);

var _browsingSession = __webpack_require__(429);

var browsingSession = _interopRequireWildcard(_browsingSession);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var publisher = void 0;

  if ((0, _env.isWebWorker)()) {
    publisher = _publishers.fetchPublisher;
  } else if (options.useBeacon) {
    publisher = _publishers.beaconPublisher;
  } else {
    publisher = _publishers.imagePublisher;
  }

  return publisher(options);
}

var _factory = function _factory(options) {
  return new _biLoggerFactory2.default().addPublisher(getPublisher(options));
};

var logger = {
  factory: function factory() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var trackSession = options.trackSession || typeof options.trackSession === 'undefined';

    if (trackSession) {
      browsingSession.track(_factory);
    }

    return _factory(options);
  },
  setHost: _env.setHost
};

exports.default = logger;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imagePublisher = imagePublisher;
exports.beaconPublisher = beaconPublisher;
exports.fetchPublisher = fetchPublisher;

var _utils = __webpack_require__(120);

var _transport = __webpack_require__(428);

function imagePublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function imagePublisher(params) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // eslint-disable-line func-names
    var url = (0, _utils.buildUrl)(options, params);
    return (0, _transport.pixel)(url, context.image);
  };
}

function beaconPublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function beaconPublisher(params) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // eslint-disable-line func-names
    var url = (0, _utils.buildUrl)(options, params);
    return (0, _transport.beacon)(url).catch(function () {
      return (0, _transport.pixel)(url, context.image);
    });
  };
}

function fetchPublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function fetchPublisher(params) {
    // eslint-disable-line func-names
    var url = (0, _utils.buildUrl)(options, params);
    return fetch(url, { credentials: 'include' }).then(function (response) {
      if (!response.ok) {
        throw Error(response.status);
      }
      return response;
    });
  };
}

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.now = now;
function now() {
  return typeof performance !== 'undefined' && performance && performance.now ? performance.now() : -1;
}

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.beacon = beacon;
exports.pixel = pixel;

var _navigator = __webpack_require__(121);

function beacon(url) {
  return new Promise(function (resolve, reject) {
    return (0, _navigator.sendBeacon)(url) ? resolve(url) : reject(url);
  });
}

function pixel(url, image) {
  return new Promise(function (resolve, reject) {
    var biImage = image || new Image(0, 0);
    biImage.onload = resolve;
    biImage.onerror = reject;
    biImage.src = url;
  });
}

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.track = track;

var _utils = __webpack_require__(120);

var _navigator = __webpack_require__(121);

var _env = __webpack_require__(33);

var _screen = __webpack_require__(430);

var IS_TRACKING = '__isTrackingBiBrowsingSession__';
var ENDPOINT = 'p';
var SOURCE = 19;
var EVID = 3;

function shouldTrack() {
  return !(0, _env.isWebWorker)() && (0, _env.provideBrowsingContext)(function (window) {
    return !window[IS_TRACKING];
  });
}

function setIsTracking() {
  return (0, _env.provideBrowsingContext)(function (window) {
    return window[IS_TRACKING] = true;
  });
}

function getLogger(loggerFactory) {
  return loggerFactory({ endpoint: ENDPOINT, useBeacon: true }).setDefaults({ src: SOURCE, evid: EVID, vsi: (0, _utils.guid)() }).logger();
}

function trackBrowsingSession(loggerFactory) {
  var logger = getLogger(loggerFactory);
  var firstInSession = 1;

  (0, _navigator.listen)(function (fromUrl, toUrl) {
    var _provideBrowsingConte = (0, _env.provideBrowsingContext)(function (window) {
      return { sr: (0, _screen.getDesktopSize)(window), wr: (0, _screen.getWindowSize)(window) };
    }),
        sr = _provideBrowsingConte.sr,
        wr = _provideBrowsingConte.wr;

    logger.log({ from: fromUrl, to: toUrl, fis: firstInSession, sr: sr, wr: wr });
    firstInSession = 0;
  });
}

/**
 * Sends a page view event on initial load and on every page switch
 * BI event definition: http://bo.wix.com/bi-catalog-webapp/#/sources/19/events/3
 */
function track(loggerFactory) {
  if (shouldTrack()) {
    setIsTracking();
    trackBrowsingSession(loggerFactory);
  }
}

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDesktopSize = getDesktopSize;
exports.getWindowSize = getWindowSize;
function getDesktopSize(window) {
  var width = window.screen && window.screen.width || 0;
  var height = window.screen && window.screen.height || 0;

  return width + "x" + height;
}

function getWindowSize(window) {
  var width = 0;
  var height = 0;

  if (window.innerWidth) {
    width = window.innerWidth;
    height = window.innerHeight;
  } else if (window.document) {
    if (window.document.documentElement && window.document.documentElement.clientWidth) {
      width = window.document.documentElement.clientWidth;
      height = window.document.documentElement.clientHeight;
    } else if (window.document.body && window.document.body.clientWidth) {
      width = window.document.body.clientWidth;
      height = window.document.body.clientHeight;
    }
  }

  return width + "x" + height;
}

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var fedops_logger_1 = __webpack_require__(432);
var NAME = '';
var mocked = {
    appLoadStarted: function () { return ({}); },
    appLoaded: function () { return ({}); },
    interactionStarted: function (name) { return ({}); },
    interactionEnded: function (name) { return ({}); },
};
var Logger = /** @class */ (function () {
    function Logger() {
        var _this = this;
        this.interactionStarted = function (name) { return _this.fedopsLogger.interactionStarted(name); };
        this.interactionEnded = function (name) { return _this.fedopsLogger.interactionEnded(name); };
        this.appLoaded = function () { return _this.fedopsLogger.appLoaded(); };
        this.appLoadStarted = function () { return _this.fedopsLogger.appLoadStarted(); };
        this.fedopsLogger = fedops_logger_1.create(this.name, { baseUrl: null, isWidgetLogger: true }) || mocked;
        this.appLoadStarted();
    }
    return Logger;
}());
exports.default = Logger;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.create = create;

var _loggerBuilder = __webpack_require__(433);

var _loggerBuilder2 = _interopRequireDefault(_loggerBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a logger instance, initialized with application name.
 *
 * @param {String} appName application name (will be used as an application identifier in the monitoring tool, e.g. Grafana)
 * @param {Boolean} isWidgetLogger
 */
function create(appName) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$baseUrl = _ref.baseUrl,
        baseUrl = _ref$baseUrl === undefined ? null : _ref$baseUrl,
        _ref$appId = _ref.appId,
        appId = _ref$appId === undefined ? null : _ref$appId,
        _ref$isWidgetLogger = _ref.isWidgetLogger,
        isWidgetLogger = _ref$isWidgetLogger === undefined ? false : _ref$isWidgetLogger,
        _ref$errorHandlerTogg = _ref.errorHandlerToggle,
        errorHandlerToggle = _ref$errorHandlerTogg === undefined ? false : _ref$errorHandlerTogg,
        _ref$disableAutoLoadF = _ref.disableAutoLoadFinish,
        disableAutoLoadFinish = _ref$disableAutoLoadF === undefined ? false : _ref$disableAutoLoadF,
        _ref$swallowException = _ref.swallowExceptions,
        swallowExceptions = _ref$swallowException === undefined ? false : _ref$swallowException,
        _ref$interactionTimeo = _ref.interactionTimeout,
        interactionTimeout = _ref$interactionTimeo === undefined ? null : _ref$interactionTimeo,
        _ref$timeoutHook = _ref.timeoutHook,
        timeoutHook = _ref$timeoutHook === undefined ? null : _ref$timeoutHook,
        _ref$startHook = _ref.startHook,
        startHook = _ref$startHook === undefined ? null : _ref$startHook,
        _ref$endHook = _ref.endHook,
        endHook = _ref$endHook === undefined ? null : _ref$endHook,
        _ref$networkAnalysis = _ref.networkAnalysis,
        networkAnalysis = _ref$networkAnalysis === undefined ? false : _ref$networkAnalysis;

    var appVersion = typeof window !== 'undefined' ? "1.216.0-SNAPSHOT" : null;

    return new _loggerBuilder2.default().setAppName(appName).setAppVersion(appVersion).setBaseUrl(baseUrl).setAppId(appId).setErrorHandlerToggle(errorHandlerToggle).setSwallowExceptions(swallowExceptions).setWidgetLogger(isWidgetLogger).setInteractionTimeout(interactionTimeout).setTimeoutHook(timeoutHook).setStartHook(startHook).setEndHook(endHook).setDisableAutoLoadFinish(disableAutoLoadFinish).setNetworkAnalysis(networkAnalysis).build();
}

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.setFactory = setFactory;

var _tools = __webpack_require__(122);

var _tools2 = _interopRequireDefault(_tools);

var _storage = __webpack_require__(434);

var _storage2 = _interopRequireDefault(_storage);

var _reporter = __webpack_require__(435);

var _reporter2 = _interopRequireDefault(_reporter);

var _loggerInstance = __webpack_require__(437);

var _loggerInstance2 = _interopRequireDefault(_loggerInstance);

var _widgetLoggerInstance = __webpack_require__(444);

var _widgetLoggerInstance2 = _interopRequireDefault(_widgetLoggerInstance);

var _errorHandler = __webpack_require__(446);

var _errorHandler2 = _interopRequireDefault(_errorHandler);

var _conf = __webpack_require__(447);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getSessionId() {
  var res = typeof window !== 'undefined' && window.fedops && window.fedops.sessionId;
  res = res || _storage2.default.getItem(_conf.SESSION_ID_STORAGE_KEY);
  res = res || _tools2.default.generateGuid();

  _storage2.default.setItem(_conf.SESSION_ID_STORAGE_KEY, res);

  return res;
}

var ReporterFactory = _reporter2.default; // good for tests

function setFactory(factory) {
  ReporterFactory = factory;
}
/**
 * Builds a logger instance.
 */

var LoggerBuilder = function () {
  function LoggerBuilder() {
    _classCallCheck(this, LoggerBuilder);
  }

  _createClass(LoggerBuilder, [{
    key: 'setAppName',
    value: function setAppName(name) {
      this.appName = name;
      return this;
    }
  }, {
    key: 'setAppVersion',
    value: function setAppVersion(version) {
      this.appVersion = version;
      return this;
    }
  }, {
    key: 'setErrorHandlerToggle',
    value: function setErrorHandlerToggle(toggle) {
      this.errorHandlerToggle = toggle;
      return this;
    }
  }, {
    key: 'setSwallowExceptions',
    value: function setSwallowExceptions(swallow) {
      this.swallowExceptions = swallow;
      return this;
    }
  }, {
    key: 'setAppId',
    value: function setAppId(appId) {
      this.appId = appId;
      return this;
    }
  }, {
    key: 'setBaseUrl',
    value: function setBaseUrl(url) {
      this.baseUrl = url;
      return this;
    }
  }, {
    key: 'setWidgetLogger',
    value: function setWidgetLogger(isWidgetLogger) {
      this.isWidgetLogger = isWidgetLogger;
      return this;
    }
  }, {
    key: 'setInteractionTimeout',
    value: function setInteractionTimeout(interactionTimeout) {
      this.interactionTimeout = interactionTimeout;
      return this;
    }
  }, {
    key: 'setTimeoutHook',
    value: function setTimeoutHook(timeoutHook) {
      this.timeoutHook = timeoutHook;
      return this;
    }
  }, {
    key: 'setStartHook',
    value: function setStartHook(startHook) {
      this.startHook = startHook;
      return this;
    }
  }, {
    key: 'setEndHook',
    value: function setEndHook(endHook) {
      this.endHook = endHook;
      return this;
    }
  }, {
    key: 'setDisableAutoLoadFinish',
    value: function setDisableAutoLoadFinish(disableAutoLoadFinish) {
      this.disableAutoLoadFinish = disableAutoLoadFinish;
      return this;
    }
  }, {
    key: 'setNetworkAnalysis',
    value: function setNetworkAnalysis() {
      // TODO - remove this API once no usage across wix
      return this;
    }
  }, {
    key: 'build',
    value: function build() {
      if (!this.appName) {
        return null;
      }

      if (!this.appVersion) {
        this.appVersion = _conf.DEFAULT_APP_VERSION;
      }

      var reporter = new ReporterFactory(this.baseUrl || _conf.BI_BASE_URL);
      var errorHandlerToggle = this.errorHandlerToggle;
      var swallowExceptions = this.swallowExceptions;
      var interactionTimeout = this.interactionTimeout;
      var timeoutHook = this.timeoutHook;
      var startHook = this.startHook;
      var endHook = this.endHook;
      var disableAutoLoadFinish = this.disableAutoLoadFinish;

      if (errorHandlerToggle) {
        window.fedopsLoggerErrorHandler = window.fedopsLoggerErrorHandler || new _errorHandler2.default({ swallowExceptions: swallowExceptions });
      }

      var logger = null;

      if (this.isWidgetLogger) {
        logger = new _widgetLoggerInstance2.default(this.appName, this.appVersion, reporter, { sessionId: getSessionId(), errorHandlerToggle: errorHandlerToggle, swallowExceptions: swallowExceptions, disableAutoLoadFinish: disableAutoLoadFinish });
      } else {
        logger = new _loggerInstance2.default(this.appName, this.appVersion, reporter, { sessionId: getSessionId(), errorHandlerToggle: errorHandlerToggle, swallowExceptions: swallowExceptions, disableAutoLoadFinish: disableAutoLoadFinish, interactionTimeout: interactionTimeout, timeoutHook: timeoutHook, startHook: startHook, endHook: endHook });
      }

      return logger;
    }
  }]);

  return LoggerBuilder;
}();

exports.default = LoggerBuilder;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Local storage wrapper (for tests mainly)
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  getItem: function getItem(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {}
  },
  setItem: function setItem(key, value) {
    try {
      return window.localStorage.setItem(key, value);
    } catch (e) {}
  }
};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pixel = __webpack_require__(436);

var _pixel2 = _interopRequireDefault(_pixel);

var _tools = __webpack_require__(122);

var _tools2 = _interopRequireDefault(_tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Reporter = function () {
  function Reporter(baseUrl) {
    _classCallCheck(this, Reporter);

    this.baseUrl = baseUrl;
  }

  _createClass(Reporter, [{
    key: 'getBaseUrl',
    value: function getBaseUrl() {
      return this.baseUrl;
    }
  }, {
    key: 'report',
    value: function report(data) {
      if (!data) {
        return null;
      }

      return _pixel2.default.fetch(this.baseUrl + '?' + _tools2.default.mapToQuery(data));
    }
  }]);

  return Reporter;
}();

exports.default = Reporter;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Simple GET request wrapper (for tests mainly)
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  fetch: function fetch(url) {
    return new window.Image().src = url;
  }
};

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseLogger = __webpack_require__(123);

var _baseLogger2 = _interopRequireDefault(_baseLogger);

var _biLoadFinishItem = __webpack_require__(441);

var _biLoadFinishItem2 = _interopRequireDefault(_biLoadFinishItem);

var _durationItem = __webpack_require__(124);

var _durationItem2 = _interopRequireDefault(_durationItem);

var _biInteractionStartItem = __webpack_require__(442);

var _biInteractionStartItem2 = _interopRequireDefault(_biInteractionStartItem);

var _biInteractionEndItem = __webpack_require__(443);

var _biInteractionEndItem2 = _interopRequireDefault(_biInteractionEndItem);

var _biErrorItem = __webpack_require__(128);

var _biErrorItem2 = _interopRequireDefault(_biErrorItem);

var _performance = __webpack_require__(34);

var _performance2 = _interopRequireDefault(_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var callHook = function callHook(hook, hookArgs) {
  if (hook) {
    return hook(hookArgs);
  }
};

/**
 * Logs application load phases.
 *
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */

var LoggerInstance = function (_BaseLogger) {
  _inherits(LoggerInstance, _BaseLogger);

  function LoggerInstance(appName, appVersion, reporter, _ref) {
    var sessionId = _ref.sessionId,
        errorHandlerToggle = _ref.errorHandlerToggle,
        disableAutoLoadFinish = _ref.disableAutoLoadFinish,
        interactionTimeout = _ref.interactionTimeout,
        timeoutHook = _ref.timeoutHook,
        startHook = _ref.startHook,
        endHook = _ref.endHook;

    _classCallCheck(this, LoggerInstance);

    var _this = _possibleConstructorReturn(this, (LoggerInstance.__proto__ || Object.getPrototypeOf(LoggerInstance)).call(this, appName, appVersion, reporter, { sessionId: sessionId, errorHandlerToggle: errorHandlerToggle, disableAutoLoadFinish: disableAutoLoadFinish }));

    _this._outgoingInteractions = {};
    _this.interactionTimeout = interactionTimeout;
    _this.timeoutHook = timeoutHook;
    _this.startHook = startHook;
    _this.endHook = endHook;
    return _this;
  }

  /**
   * Final phase (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11)
   * Call this method when your application finishes loading and after all custom phases.
   */


  _createClass(LoggerInstance, [{
    key: 'appLoaded',
    value: function appLoaded() {
      if (this._appLoadedCalled) {
        return;
      }

      if (window && window.fedops && typeof window.fedops.clearLoadTimeout === 'function') {
        window.fedops.clearLoadTimeout();
      }

      var dataSource = this.dataSource.clone().addItem(new _biLoadFinishItem2.default(this.sessionId)).addItem(new _durationItem2.default(this.appName).setFirstRequestDuration());

      this._appLoadedCalled = true;
      _performance2.default.mark('[fedops] app-loaded');
      _performance2.default.measure('[fedops] app-loaded', 'navigationStart', '[fedops] app-loaded');
      this.reportNetworkAnalysis();
      return this._report(dataSource);
    }

    /**
     * Custom interaction start (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/15)
     *
     * @param {String} interactionName  interaction name
     */

  }, {
    key: 'interactionStarted',
    value: function interactionStarted(interactionName) {
      var _this2 = this;

      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          interactionTimeout = _ref2.interactionTimeout,
          startHook = _ref2.startHook,
          timeoutHook = _ref2.timeoutHook;

      _performance2.default.mark(interactionName + ' started');
      var scheduleTimeoutEvent = function scheduleTimeoutEvent() {
        if (interactionTimeout || _this2.interactionTimeout) {
          return setTimeout(function () {
            var dataSource = _this2.dataSource.clone().addItem({ interactionName: interactionName }).addItem({ errorType: 'timeout' }).addItem(new _biErrorItem2.default(_this2.sessionId));

            _this2._report(dataSource);
            callHook(timeoutHook || _this2.timeoutHook, { name: interactionName, timeout: interactionTimeout || _this2.interactionTimeout });
          }, interactionTimeout || _this2.interactionTimeout);
        }
      };
      var dataSource = this.dataSource.clone().addItem({ name: interactionName }).addItem(new _biInteractionStartItem2.default(this.sessionId));

      this._outgoingInteractions[interactionName] = {
        timestamp: _performance2.default.now(),
        timeout: interactionTimeout || this.interactionTimeout
      };
      this._report(dataSource);
      callHook(startHook || this.startHook, { name: interactionName });

      var timeoutId = scheduleTimeoutEvent();
      return {
        timeoutId: timeoutId
      };
    }

    /**
     * Custom interaction end (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/16)
     *
     * @param {String} interactionName  interaction name
     */

  }, {
    key: 'interactionEnded',
    value: function interactionEnded(interactionName) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          timeoutId = _ref3.timeoutId,
          endHook = _ref3.endHook;

      _performance2.default.mark(interactionName + ' ended');
      _performance2.default.measure(interactionName + ' duration', interactionName + ' started', interactionName + ' ended');

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      var duration = this._outgoingInteractions[interactionName] ? Math.floor(_performance2.default.now() - this._outgoingInteractions[interactionName].timestamp) : '';

      callHook(endHook || this.endHook, {
        name: interactionName,
        duration: duration,
        timeout: this._outgoingInteractions[interactionName] && this._outgoingInteractions[interactionName].timeout
      });

      var dataSource = this.dataSource.clone().addItem({ name: interactionName }).addItem({ duration: duration }).addItem(new _biInteractionEndItem2.default(this.sessionId));

      delete this._outgoingInteractions[interactionName];

      this._report(dataSource);
    }
  }, {
    key: 'isDisableAutoLoadFinish',
    value: function isDisableAutoLoadFinish() {
      return this._isDisableAutoLoadFinish();
    }
  }]);

  return LoggerInstance;
}(_baseLogger2.default);

// vim: set ts=2 sw=2 tw=80 et :


exports.default = LoggerInstance;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dataItem = __webpack_require__(62);

var _dataItem2 = _interopRequireDefault(_dataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Data accumulator
 */
var DataSource = function () {
  function DataSource() {
    var _this = this;

    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, DataSource);

    this.items = [];

    if (item) {
      (typeof item.length === 'undefined' ? [item] : item).forEach(function (item) {
        return _this.addItem(item);
      });
    }
  }

  /**
   * Creates a new DataSource instance and clones internal state.
   *
   * @returns {DataSource}
   */


  _createClass(DataSource, [{
    key: 'clone',
    value: function clone() {
      return new DataSource(this.items.slice());
    }

    /**
     * Adds a new item.
     *
     * @param {Object | DataItem} item
     *
     * @return {DataSource} self
     */

  }, {
    key: 'addItem',
    value: function addItem(item) {
      this.items.push(item instanceof _dataItem2.default ? item : new _dataItem2.default(item));

      return this;
    }

    /**
     * Merges all added items into one plain object.
     *
     * @returns {Object}
     */

  }, {
    key: 'mergeItems',
    value: function mergeItems() {
      var res = {};

      for (var i = 0; i < this.items.length; i++) {
        var item = this.items[i];

        if (!item.isActive()) {
          res = null;
          break;
        }

        var data = item.export();

        for (var key in data) {
          if (data.hasOwnProperty(key)) {
            // eslint-disable-line
            res[key] = data[key];
          }
        }
      }

      return res;
    }
  }]);

  return DataSource;
}();

exports.default = DataSource;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biBaseItem = __webpack_require__(6);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents the "load phase" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/13
 *
 * It should be used to monitor custom application load phases.
 */
var BiLoadPhaseDataItem = function (_BiBaseDataItem) {
  _inherits(BiLoadPhaseDataItem, _BiBaseDataItem);

  function BiLoadPhaseDataItem(sessionId) {
    _classCallCheck(this, BiLoadPhaseDataItem);

    return _possibleConstructorReturn(this, (BiLoadPhaseDataItem.__proto__ || Object.getPrototypeOf(BiLoadPhaseDataItem)).call(this, 13, sessionId));
  }

  return BiLoadPhaseDataItem;
}(_biBaseItem2.default);

exports.default = BiLoadPhaseDataItem;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _biBaseItem = __webpack_require__(6);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

var _location = __webpack_require__(127);

var _location2 = _interopRequireDefault(_location);

var _performance = __webpack_require__(34);

var _performance2 = _interopRequireDefault(_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RESOURCES_TYPES = {
  xmlhttprequest: {
    count: 'countXhr',
    unsupported: 'unsprtXhr',
    duration: 'timeXhr',
    total: 'sizeXhr',
    longest: 'longXhr',
    http2: 'h2Xhr'
  },
  script: {
    count: 'countJs',
    unsupported: 'unsprtJs',
    duration: 'timeJs',
    total: 'sizeJs',
    cached: 'cachedJs',
    http2: 'h2Js'
  },
  link: { // css
    count: 'countCss',
    unsupported: 'unsprtCss',
    duration: 'timeCss',
    total: 'sizeCss',
    cached: 'cachedCss',
    http2: 'h2Css'
  },
  img: {
    count: 'countImg',
    unsupported: 'unsprtImg',
    duration: 'timeImg',
    total: 'sizeImg',
    cached: 'cachedImages',
    http2: 'h2Images'
  }
};

var CUSTOM_VALIDATORS = {
  link: function link(resource) {
    return (/(.\.css$|.\.css?.)/g.test(resource.name)
    );
  }
};

var durationOf = function durationOf(item) {
  return item.responseEnd - item.startTime;
};

function filterResourcesByType(resources, type) {
  var validator = CUSTOM_VALIDATORS[type];
  return resources.filter(function (r) {
    return type === r.initiatorType && (validator ? validator(r) : true);
  });
}

function calculateTotalSizeOfResource(resources) {
  return resources.reduce(function (totalSize, resource) {
    return totalSize + resource.transferSize;
  }, 0);
}

function calculateResourceLoadLongestDuration(resources) {
  if (resources.length === 0) {
    return 0;
  }
  var longest = resources.reduce(function (acc, cur) {
    return durationOf(cur) >= durationOf(acc) ? cur : acc;
  });
  return durationOf(longest);
}

function calculateResourceLoadDuration(resources) {
  if (resources.length === 0) {
    return 0;
  }
  var loadStartStop = {
    startTime: Infinity,
    responseEnd: 0
  };
  resources.forEach(function (r) {
    if (loadStartStop.startTime > r.startTime) {
      loadStartStop.startTime = r.startTime;
    }
    if (loadStartStop.responseEnd < r.responseEnd) {
      loadStartStop.responseEnd = r.responseEnd;
    }
  });
  return loadStartStop.responseEnd - loadStartStop.startTime;
}

function calculatePercentageOfUnsupportedResources(resources) {
  var totalCount = resources.length;
  if (totalCount === 0) {
    return 0;
  }
  var unsupportedCount = resources.filter(isResourceUnsupported).length;
  return Math.round(unsupportedCount / totalCount * 100);
}

function calculateCachedResourcesPercentage(resources) {
  if (resources.length === 0) {
    return 0;
  }
  var cached = resources.filter(function (r) {
    return r.transferSize === 0;
  });
  return Math.round(cached.length / resources.length * 100);
}

function calculatePercentageOfHttp2(resources) {
  if (resources.length === 0) {
    return 0;
  }
  var supported = false;
  var res = Math.round(resources.filter(function (r) {
    supported = supported || 'nextHopProtocol' in r;
    return r.nextHopProtocol === 'h2';
  }).length / resources.length * 100);
  return supported ? res : NaN;
}

function isResourceRelevant(resource) {
  return !resource.name.match(/http(s)?:\/\/frog.wix.com\//);
}

function isResourceUnsupported(resource) {
  return isCORS(resource.name) && resource.transferSize === 0 && resource.requestStart === 0;
}

function isCORS(resourceName) {
  var host = _location2.default.getHost();
  return host && resourceName.indexOf(host) === -1;
}

function normalizeValues(analysis) {
  return Object.keys(analysis).reduce(function (result, key) {
    var n = parseInt(analysis[key]);
    if (!isNaN(n) && typeof n === 'number') {
      result[key] = n;
    }
    return result;
  }, {});
}

function countAllResourcesByType(resources) {
  var supportedResources = resources.filter(function (r) {
    return !isResourceUnsupported(r);
  });
  return Object.keys(RESOURCES_TYPES).reduce(function (result, currentType) {
    var allSameTypeResources = filterResourcesByType(resources, currentType);
    var supportedSameTypeResources = filterResourcesByType(supportedResources, currentType);
    var type = RESOURCES_TYPES[currentType];
    result[type.count] = supportedSameTypeResources.length;
    result[type.duration] = calculateResourceLoadDuration(supportedSameTypeResources);
    result[type.total] = calculateTotalSizeOfResource(supportedSameTypeResources);
    result[type.unsupported] = calculatePercentageOfUnsupportedResources(allSameTypeResources);
    result[type.http2] = calculatePercentageOfHttp2(allSameTypeResources);
    if (type.longest) {
      result[type.longest] = calculateResourceLoadLongestDuration(supportedSameTypeResources);
    }
    if (type.cached) {
      result[type.cached] = calculateCachedResourcesPercentage(supportedSameTypeResources);
    }
    return result;
  }, {});
}

function extractResourceMetrics(resource) {
  return {
    url: resource.name,
    downloadDuration: resource.responseEnd - resource.startTime,
    bytesTransferred: resource.transferSize,
    isHTTP2: resource.nextHopProtocol === 'h2'
  };
}

function getResourcesBreakdown(resources) {
  var resourcesPartition = resources.reduce(function (result, r) {
    if (isResourceUnsupported(r)) {
      result.unsupported.push(r);
    } else {
      result.supported.push(r);
    }
    return result;
  }, { supported: [], unsupported: [] });
  return Object.keys(RESOURCES_TYPES).reduce(function (result, currentType) {
    result[currentType] = {};
    result[currentType].supported = filterResourcesByType(resourcesPartition.supported, currentType).map(function (r) {
      return extractResourceMetrics(r);
    });
    result[currentType].unsupported = filterResourcesByType(resourcesPartition.unsupported, currentType).map(function (r) {
      return extractResourceMetrics(r);
    });
    return result;
  }, {});
}

var ResourceDataItem = function (_BiBaseDataItem) {
  _inherits(ResourceDataItem, _BiBaseDataItem);

  function ResourceDataItem(sessionId) {
    _classCallCheck(this, ResourceDataItem);

    return _possibleConstructorReturn(this, (ResourceDataItem.__proto__ || Object.getPrototypeOf(ResourceDataItem)).call(this, 18, sessionId));
  }

  _createClass(ResourceDataItem, [{
    key: 'performNetworkAnalysis',
    value: function performNetworkAnalysis(resources) {
      if (resources.length === 0) {
        return null;
      }
      var t0 = _performance2.default.now();
      var resourcesToHandle = resources.filter(isResourceRelevant);
      var analysis = countAllResourcesByType(resourcesToHandle);
      analysis.overhead = _performance2.default.now() - t0;
      var result = normalizeValues(analysis);
      if (console.debug && _location2.default.isFedopsDev()) {
        var resourcesBreakdown = getResourcesBreakdown(resourcesToHandle);
        console.debug('[fedops network analysis] [bytes analysis]\n' + JSON.stringify(result, null, 4));
        console.debug('[fedops network analysis] [resources breakdown]\n', resourcesBreakdown);
      }
      return result;
    }
  }]);

  return ResourceDataItem;
}(_biBaseItem2.default);

exports.default = ResourceDataItem;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biBaseItem = __webpack_require__(6);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */
var BiLoadFinishDataItem = function (_BiBaseDataItem) {
  _inherits(BiLoadFinishDataItem, _BiBaseDataItem);

  function BiLoadFinishDataItem(sessionId) {
    _classCallCheck(this, BiLoadFinishDataItem);

    return _possibleConstructorReturn(this, (BiLoadFinishDataItem.__proto__ || Object.getPrototypeOf(BiLoadFinishDataItem)).call(this, 11, sessionId));
  }

  return BiLoadFinishDataItem;
}(_biBaseItem2.default);

exports.default = BiLoadFinishDataItem;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERACTION_START_EVID = undefined;

var _biBaseItem = __webpack_require__(6);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INTERACTION_START_EVID = exports.INTERACTION_START_EVID = 15;
/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */

var BiInteractionStartDataItem = function (_BiBaseDataItem) {
  _inherits(BiInteractionStartDataItem, _BiBaseDataItem);

  function BiInteractionStartDataItem(sessionId) {
    _classCallCheck(this, BiInteractionStartDataItem);

    return _possibleConstructorReturn(this, (BiInteractionStartDataItem.__proto__ || Object.getPrototypeOf(BiInteractionStartDataItem)).call(this, INTERACTION_START_EVID, sessionId));
  }

  return BiInteractionStartDataItem;
}(_biBaseItem2.default);

exports.default = BiInteractionStartDataItem;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERACTION_END_EVID = undefined;

var _biBaseItem = __webpack_require__(6);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INTERACTION_END_EVID = exports.INTERACTION_END_EVID = 16;

/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */

var BiInteractionEndDataItem = function (_BiBaseDataItem) {
  _inherits(BiInteractionEndDataItem, _BiBaseDataItem);

  function BiInteractionEndDataItem(sessionId) {
    _classCallCheck(this, BiInteractionEndDataItem);

    return _possibleConstructorReturn(this, (BiInteractionEndDataItem.__proto__ || Object.getPrototypeOf(BiInteractionEndDataItem)).call(this, INTERACTION_END_EVID, sessionId));
  }

  return BiInteractionEndDataItem;
}(_biBaseItem2.default);

exports.default = BiInteractionEndDataItem;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseLogger = __webpack_require__(123);

var _baseLogger2 = _interopRequireDefault(_baseLogger);

var _biLoadStartItem = __webpack_require__(445);

var _biLoadStartItem2 = _interopRequireDefault(_biLoadStartItem);

var _time = __webpack_require__(125);

var _time2 = _interopRequireDefault(_time);

var _appData = __webpack_require__(126);

var _appData2 = _interopRequireDefault(_appData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Logs application load phases.
 *
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */
var WidgetLoggerInstance = function (_BaseLogger) {
  _inherits(WidgetLoggerInstance, _BaseLogger);

  function WidgetLoggerInstance(appName, appVersion, reporter, _ref) {
    var sessionId = _ref.sessionId,
        disableAutoLoadFinish = _ref.disableAutoLoadFinish;

    _classCallCheck(this, WidgetLoggerInstance);

    var _this = _possibleConstructorReturn(this, (WidgetLoggerInstance.__proto__ || Object.getPrototypeOf(WidgetLoggerInstance)).call(this, appName, appVersion, reporter, { sessionId: sessionId, disableAutoLoadFinish: disableAutoLoadFinish }));

    _appData2.default.init(_this.appName);
    return _this;
  }

  /**
   * Manual report for widget load start (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/14)
   * Call this method at the earliest point possible when your widget starts loading
   */


  _createClass(WidgetLoggerInstance, [{
    key: 'appLoadStarted',
    value: function appLoadStarted() {

      _time2.default.loadStarted(this.appName);

      var dataSource = this.dataSource.clone().addItem(new _biLoadStartItem2.default(this.sessionId));

      return this._report(dataSource);
    }
  }, {
    key: 'isDisableAutoLoadFinish',
    value: function isDisableAutoLoadFinish() {
      return this._isDisableAutoLoadFinish();
    }
  }]);

  return WidgetLoggerInstance;
}(_baseLogger2.default);

exports.default = WidgetLoggerInstance;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biBaseItem = __webpack_require__(6);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents the "load started" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/14
 *
 * It should be used to monitor the initial application load.
 */
var BiLoadStartDataItem = function (_BiBaseDataItem) {
  _inherits(BiLoadStartDataItem, _BiBaseDataItem);

  function BiLoadStartDataItem(sessionId) {
    _classCallCheck(this, BiLoadStartDataItem);

    return _possibleConstructorReturn(this, (BiLoadStartDataItem.__proto__ || Object.getPrototypeOf(BiLoadStartDataItem)).call(this, 14, sessionId));
  }

  return BiLoadStartDataItem;
}(_biBaseItem2.default);

exports.default = BiLoadStartDataItem;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*eslint-disable camelcase*/

var _window = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var ErrorHandler = function () {
  function ErrorHandler(_ref) {
    var swallowExceptions = _ref.swallowExceptions;

    _classCallCheck(this, ErrorHandler);

    this.swallowExceptions = swallowExceptions;
    this.listeners = {};

    //*************************************************************************
    // We are wrapping the browser's native methods with try/catch for several
    // reasons:
    //
    // 1. It provides us with a more elaborate stack trace.
    //    Currently we ignore the stack trace due to BI limitations, but it can
    //    be very useful for future support.
    //
    // 2. Makes it easier to classify the error types.
    //
    // 3. Some browsers don't support a global error handler.
    //*************************************************************************

    this.instrumentAjax();
    this.instrumentSetTimeout();
    this.instrumentSetInterval();
    this.instrumentAddEventListener();
    this.instrumentFetch();
    this.instrumentPromise();

    //Sometimes catches one of the instruments above? Need to verify...
    this.instrumentGloballyUnhandledError();
  }

  _createClass(ErrorHandler, [{
    key: 'subscribeListener',
    value: function subscribeListener(appName, cb) {
      this.listeners[appName] = cb;
    }
  }, {
    key: 'removeListener',
    value: function removeListener(appName) {
      delete this.listeners[appName];
    }
  }, {
    key: 'instrumentAjax',
    value: function instrumentAjax() {
      var self = this;

      if ('XMLHttpRequest' in _window) {
        var xhrproto = XMLHttpRequest.prototype;

        this._wrap(xhrproto, 'open', function (orig) {
          return function (method, url) {
            this.__fedops_xhr = {
              method: method,
              url: url,
              status_code: null
            };

            return orig.apply(this, arguments);
          };
        }, 'xhr');

        this._wrap(xhrproto, 'send', function (orig) {
          return function () {
            var xhr = this;

            function saveStatusCode() {
              if (xhr.readyState === 1 || xhr.readyState === 4) {
                try {
                  xhr.__fedops_xhr.status_code = xhr.status;
                } catch (e) {}

                if (self._isErrorStatusCode(xhr.__fedops_xhr.status_code)) {
                  self._reportError(xhr.__fedops_xhr, 'xhr', xhr.__fedops_xhr.status_code);
                }
              }
            }

            self._wrap(this, 'onload', function (orig) {
              return function () {
                orig && orig.apply(this, arguments);
              };
            }, 'xhr');

            self._wrap(this, 'onerror', function (orig) {
              return function () {
                orig && orig.apply(this, arguments);
              };
            }, 'xhr');

            self._wrap(this, 'onprogress', function (orig) {
              return function () {
                orig && orig.apply(this, arguments);
              };
            }, 'xhr');

            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
              self._wrap(xhr, 'onreadystatechange', function (orig) {
                return function () {
                  saveStatusCode();
                  return orig.apply(this, arguments);
                };
              });
            } else {
              xhr.onreadystatechange = saveStatusCode;
            }

            return orig.apply(this, arguments);
          };
        }, 'xhr');
      }
    }
  }, {
    key: 'instrumentSetTimeout',
    value: function instrumentSetTimeout() {
      var self = this;

      this._wrap(_window, 'setTimeout', function (globalSetTimeout) {
        return function (fn) {
          for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            rest[_key - 1] = arguments[_key];
          }

          return globalSetTimeout.call.apply(globalSetTimeout, [this, self._wrapCallback(fn, 'setTimeout')].concat(rest));
        };
      });
    }
  }, {
    key: 'instrumentSetInterval',
    value: function instrumentSetInterval() {
      var self = this;

      this._wrap(_window, 'setInterval', function (globalSetInterval) {
        return function (fn) {
          for (var _len2 = arguments.length, rest = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            rest[_key2 - 1] = arguments[_key2];
          }

          return globalSetInterval.call.apply(globalSetInterval, [this, self._wrapCallback(fn, 'setInterval')].concat(rest));
        };
      });
    }
  }, {
    key: 'instrumentAddEventListener',
    value: function instrumentAddEventListener() {
      var self = this;

      function instrumentEventTarget(name) {
        var origTarget = _window[name] && _window[name].prototype;

        if (origTarget && Object.prototype.hasOwnProperty.call(origTarget, 'addEventListener')) {
          self._wrap(origTarget, 'addEventListener', function (orig) {
            return function (eventName, fn, capture, secure) {
              var wrapped = self._wrapCallback(fn, 'addEventListener');

              if (fn) {
                fn.__fedopsWrapper__ = wrapped;
              }

              return orig.call(this, eventName, wrapped, capture, secure);
            };
          });

          self._wrap(origTarget, 'removeEventListener', function (orig) {
            return function (eventName, fn, capture, secure) {
              fn = fn && (fn.__fedopsWrapper__ || fn);
              return orig.call(this, eventName, fn, capture, secure);
            };
          });
        }
      }

      var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
      eventTargets.forEach(function (name) {
        return instrumentEventTarget(name);
      });
    }
  }, {
    key: 'instrumentRequestAnimationFrame',
    value: function instrumentRequestAnimationFrame() {}
  }, {
    key: 'instrumentFetch',
    value: function instrumentFetch() {
      var self = this;

      this._wrap(_window, 'fetch', function (globalFetch) {
        return function (url, fetchOptions) {
          return globalFetch.apply(this, arguments).then(function (response) {
            var statusCode = response.status;

            if (self._isErrorStatusCode(statusCode)) {
              var requestInfo = {
                url: url,
                method: fetchOptions ? fetchOptions.method : 'GET',
                status_code: statusCode
              };

              self._reportError(requestInfo, 'fetch', statusCode);
            }

            return response;
          });
        };
      });
    }
  }, {
    key: 'instrumentPromise',
    value: function instrumentPromise() {
      var self = this;

      _window.addEventListener('unhandledrejection', function (err) {
        self._reportError(err, 'promise');
      });
    }
  }, {
    key: 'instrumentGloballyUnhandledError',
    value: function instrumentGloballyUnhandledError() {
      var _this = this;

      _window.addEventListener('error', function (err) {
        _this._reportError(err, 'windowOnError');
      });
    }
  }, {
    key: 'instrumentHistory',
    value: function instrumentHistory() {}
  }, {
    key: '_wrap',
    value: function _wrap(obj, fnName, replaced, errorType) {
      var self = this;
      var orig = obj[fnName];
      var r = replaced(orig);

      var wrapped = function wrapped() {
        try {
          return r.apply(this, arguments);
        } catch (err) {
          self._reportError(err, errorType);

          if (!self.swallowExceptions) {
            throw err;
          }
        }
      };

      obj[fnName] = wrapped;
    }
  }, {
    key: '_wrapCallback',
    value: function _wrapCallback(fn, errorType) {
      var self = this;

      return function () {
        try {
          return fn.apply(this, arguments);
        } catch (err) {
          self._reportError(err, errorType);

          if (!self.swallowExceptions) {
            throw err;
          }
        }
      };
    }
  }, {
    key: '_reportError',
    value: function _reportError(err, errorType, errorInfo) {
      var self = this;

      var actualError = err && (err.error || err);

      if (!actualError.__fedopsHandledError__) {
        var appNames = Object.keys(this.listeners);

        appNames.forEach(function (appName) {
          self.listeners[appName](actualError, errorType, errorInfo);
        });

        actualError.__fedopsHandledError__ = true;
      }
    }
  }, {
    key: '_isErrorStatusCode',
    value: function _isErrorStatusCode(statusCode) {
      return statusCode >= 400 || statusCode === 0;
    }
  }]);

  return ErrorHandler;
}();

/*eslint-enable camelcase*/


exports.default = ErrorHandler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50)))

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BI_BASE_URL = exports.BI_BASE_URL = 'https://frog.wix.com/fed';
var SESSION_ID_STORAGE_KEY = exports.SESSION_ID_STORAGE_KEY = 'fedops.logger.sessionId';
var DEFAULT_APP_VERSION = exports.DEFAULT_APP_VERSION = '0.0.0';

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var VisibilityWrapper_1 = __webpack_require__(449);
exports.default = VisibilityWrapper_1.default;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var s = __webpack_require__(450);
var VisibilityWrapper = /** @class */ (function (_super) {
    __extends(VisibilityWrapper, _super);
    function VisibilityWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VisibilityWrapper.prototype.render = function () {
        var _a = this.props, visible = _a.visible, display = _a.display, children = _a.children;
        return (React.createElement("div", { className: visible ? '' : s.hide }, display ? children : null));
    };
    VisibilityWrapper.defaultProps = {
        display: true,
        visible: true
    };
    return VisibilityWrapper;
}(React.Component));
exports.default = VisibilityWrapper;


/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"hide":"km0Zk"};

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./messages_ar.json": 452,
	"./messages_bg.json": 453,
	"./messages_cs.json": 454,
	"./messages_da.json": 455,
	"./messages_de.json": 456,
	"./messages_el.json": 457,
	"./messages_en.json": 458,
	"./messages_es.json": 459,
	"./messages_fi.json": 460,
	"./messages_fr.json": 461,
	"./messages_he.json": 462,
	"./messages_hi.json": 463,
	"./messages_hu.json": 464,
	"./messages_id.json": 465,
	"./messages_it.json": 466,
	"./messages_ja.json": 467,
	"./messages_ko.json": 468,
	"./messages_ms.json": 469,
	"./messages_nl.json": 470,
	"./messages_no.json": 471,
	"./messages_pl.json": 472,
	"./messages_pt.json": 473,
	"./messages_ro.json": 474,
	"./messages_ru.json": 475,
	"./messages_sv.json": 476,
	"./messages_th.json": 477,
	"./messages_tl.json": 478,
	"./messages_tr.json": 479,
	"./messages_zh.json": 480,
	"./messages_zu.json": 481
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 451;

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"كان يوجد خطأ في معالجة بطاقتك الائتمانية. يُرجى مراجعة بياناتك، والمحاولة مجددًا.","wallet.message.end":"حيث يمكنك إنهاء عملية الشراء في أمان.","form.submit":"اشترِ الآن","settings.offlineTitleOptionDefault":"الدفع اليدوي","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"الدفع نقدًا","settings.offlineTitleOption2":"الدفع نقدًا","payments.wallet.genericDescription.end":"حيث يمكنك إنهاء عملية الشراء في أمان.","offline":"الدفع نقدًا","settings.offlineTitleOptionDefaultInstruction":"تعليمات الدفع من دون الاتصال الإنترنت","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"ستتم إعادة توجيهك إلى","form.submit.paypal":"متابعة الدفع باستخدام","payments.wallet.genericDescription.internal.start":"عند النقر فوق \"اشترِ الآن\"، ستتم إعادة توجيهك إلى","payments.offline.defaultInstructionText":"سنتصل بك في غضون الساعات الأربع والعشرين القادمة لتسوية عملية الدفع؛ وحتى ذلك الحين، يمكنك أن تقرر ما إذا كنت تفضّل معاملةً بنكية أو شيكًا!<br /><br />سنتحدث إليك قريبًا، ونتمنى لك يومًا عظيمًا!","terms.conditions.agree":"أوافق على","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"الدفع مرة واحدة","iDeal":"iDeal","terms.conditions":"الشروط والأحكام","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"حيث يمكنك إنهاء عملية الشراء في أمان.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"الدفع عن طريق {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"عند الضغط على \"وضع الطلب\"، ستتم إعادة توجيهك إلى","wallet.pay.with":"الدفع باستخدام","cc.load.error":"مزوّد خدمة الدفع غير متاح في الوقت الحالي. يُرجى تحديد مزود آخر أو التواصل مع صاحب موقع الويب.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"ياندكس","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"الأقساط","creditCard":"بطاقة الائتمان/الخصم","payPal":"باي بال"}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"Възникна грешка при обработката на кредитната ви карта. Прегледайте данните си и опитайте отново.","wallet.message.end":"където можете да завършите покупката си сигурно.","form.submit":"Купете сега","settings.offlineTitleOptionDefault":"Плащане на ръка","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Офлайн плащане","settings.offlineTitleOption2":"Плащане в брой","payments.wallet.genericDescription.end":"където можете да завършите покупката си сигурно.","offline":"Платете офлайн","settings.offlineTitleOptionDefaultInstruction":"Инструкция за офлайн плащане","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"Ще бъдете пренасочени към","form.submit.paypal":"Купете с","payments.wallet.genericDescription.internal.start":"Когато натиснете \"Купете сега\", ще бъдете пренасочени към","payments.offline.defaultInstructionText":"Ще ви се обадим през следващите 24 часа, за да одобрим плащането, дотогава можете да решите дали предпочитате банкова транзакция или чек!<br/><br/>До скоро, приятен ден!","terms.conditions.agree":"Съгласен съм с","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"Еднократно плащане","iDeal":"iDeal","terms.conditions":"Общи условия","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"където можете да завършите покупката си сигурно.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"Плащане с {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"Когато натиснете \"Направете поръчката\", ще бъдете пренасочени към","wallet.pay.with":"Платете с","cc.load.error":"В момента този платежен метод не е наличен. Моля, изберете друг или се свържете със собственика на уебсайта.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Вноски","creditCard":"Кредитна / Дебитна карта","payPal":"PayPal"}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"Došlo k chybě při zpracování vaší kreditní karty. Zkontrolujte své kontaktní údaje a zkuste to znovu.","wallet.message.end":", kde můžete bezpečně dokončit platbu.","form.submit":"Koupit","settings.offlineTitleOptionDefault":"Manuální platba","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Offline platba","settings.offlineTitleOption2":"Platba v hotovosti","payments.wallet.genericDescription.end":", kde můžete bezpečně dokončit platbu.","offline":"Zaplatit offline","settings.offlineTitleOptionDefaultInstruction":"Instrukce pro offline platbu","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"Budete přesměrováni na","form.submit.paypal":"Zaplatit přes","payments.wallet.genericDescription.internal.start":"Když kliknete na tlačítko „Koupit“, budete přesměrováni na","payments.offline.defaultInstructionText":"Během následujících 24 hodin vám zavoláme pro dokončení platby. Do té doby se můžete rozhodnout, zda chcete platit bankovním převodem nebo použít šek!<br/><br/>Brzy na slyšenou. Přejeme hezký den!","terms.conditions.agree":"Souhlasím s","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"Jednorázová platba","iDeal":"IDeal","terms.conditions":"Všeobecné obchodní podmínky","squarePOS":"Square","payments.wallet.genericDescription.internal.end":", kde můžete bezpečně dokončit platbu.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"Platit přes {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"Když kliknete na tlačítko „Odeslat objednávku“, budete přesměrováni na","wallet.pay.with":"Platit přes","cc.load.error":"Tento způsob platby není momentálně dostupný. Vyberte prosím jiný nebo kontaktujte majitele stránek.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Splátky","creditCard":"Kreditní/Debetní karta","payPal":"PayPal"}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"Der opstod en fejl under behandlingen af ​​dit kreditkort. Kontroller dine detaljer og prøv igen.","wallet.message.end":"Her kan du fulføre betalingen sikkert.","form.submit":"Køb nu","settings.offlineTitleOptionDefault":"Manuel betaling","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Offlinebetaling","settings.offlineTitleOption2":"Kontant","payments.wallet.genericDescription.end":"Her kan du fuldføre betalingen sikker.","offline":"Betal offline","settings.offlineTitleOptionDefaultInstruction":"Instruktioner til offlinebetaling","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"Du bliver omdirigeret til","form.submit.paypal":"Betal med","payments.wallet.genericDescription.internal.start":"Når du klikker på \"Køb nu\", bliver du omdirigeret til","payments.offline.defaultInstructionText":"Vi ringer til dig indenfor de næste 24 timer for at udligne betalingen. Indtil den tid, kan du bestemme, om du foretrækker betaling via banktransaktion eller check!<br/><br/>Vi tales ved. Med venlig hilsen!","terms.conditions.agree":"I accepterer","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"En betaling","iDeal":"IDeal","terms.conditions":"Vilkår & betingelser","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"Her kan du fulføre betalingen sikkert.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"Betaler via {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"Når du klikker på \"Afgiv ordre\", bliver du omdirigeret til","wallet.pay.with":"Betal med","cc.load.error":"Denne betalingsudbyder er ikke tilgængelig i øjeblikket. Vælg venligst en anden, eller kontakt hjemmesidens ejer.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Rater","creditCard":"Kreditkort/Debitkort","payPal":"PayPal"}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"Ein Fehler ist bei der Zahlungsabwicklung mit Ihrer Kreditkarte aufgetreten. Überprüfen Sie Ihre Angaben und versuchen Sie es erneut.","wallet.message.end":"– dort können Sie Ihren Einkauf sicher abschließen.","form.submit":"Jetzt kaufen","settings.offlineTitleOptionDefault":"Manuelle Zahlung","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Offline-Zahlung","settings.offlineTitleOption2":"Vorkasse","payments.wallet.genericDescription.end":"– dort können Sie Ihren Einkauf sicher abschließen.","offline":"Offline zahlen","settings.offlineTitleOptionDefaultInstruction":"Anleitung für Offline-Zahlungen","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"werden Sie weitergeleitet zu","form.submit.paypal":"Zur Kasse mit","payments.wallet.genericDescription.internal.start":"Wenn Sie auf „Kostenpflichtig bestellen” klicken, werden Sie weitergeleitet zu","payments.offline.defaultInstructionText":"Wir rufen Sie innerhalb von 24 Std. an, um die Zahlung zu begleichen. Bis dahin können Sie entscheiden, ob Sie eine Banküberweisung oder einen Scheck als Zahlungsmittel bevorzugen!<br/><br/>Bis bald und einen schönen Tag!","terms.conditions.agree":"Ich stimme den","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"Einmalige Zahlung","iDeal":"iDeal","terms.conditions":"Allgemeine Geschäftsbedingungen","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"– dort können Sie Ihren Einkauf sicher abschließen.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"Bezahlung mit {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"Wenn Sie auf „Kostenpflichtig bestellen” klicken, werden Sie weitergeleitet zu","wallet.pay.with":"Bezahlen mit","cc.load.error":"Dieser Zahlungsmethode ist zur Zeit nicht verfügbar. Bitte wählen Sie eine andere oder kontaktieren Sie den Website-Eigentümer.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Ratenzahlungen","creditCard":"Kredit- und Debitkarte","payPal":"PayPal"}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"Υπήρξε σφάλμα με την επεξεργασία της κάρτας σας. Διορθώστε τα στοιχεία σας και προσπαθήστε πάλι.","wallet.message.end":"όπου μπορείτε να ολοκληρώσετε την αγορά σας με ασφάλεια.","form.submit":"Αγορά τώρα","settings.offlineTitleOptionDefault":"Πληρωμή με μη αυτόματο τρόπο","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Πληρωμή εκτός διαδικτύου","settings.offlineTitleOption2":"Πληρωμή με μετρητά","payments.wallet.genericDescription.end":"όπου μπορείτε να ολοκληρώσετε την αγορά σας με ασφάλεια.","offline":"Πληρωμή εκτός διαδικτύου","settings.offlineTitleOptionDefaultInstruction":"Οδηγίες πληρωμής εκτός διαδικτύου","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"Θα γίνει ανακατεύθυνση στο","form.submit.paypal":"Ολοκλήρωση παραγγελίας με","payments.wallet.genericDescription.internal.start":"Όταν πατήσετε «Αγορά τώρα» θα μεταφερθείτε στο","payments.offline.defaultInstructionText":"Θα σας καλέσουμε στις επόμενες 24 ώρες για να κανονίσουμε την πληρωμή, μέχρι τότε μπορείτε να αποφασίσετε εάν προτιμάτε μια τραπεζική συναλλαγή ή επιταγή!<br/><br/>Θα τα πούμε σύντομα, καλή σας μέρα!","terms.conditions.agree":"Συμφωνώ με το","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"Εφάπαξ Πληρωμή","iDeal":"iDeal","terms.conditions":"Όροι & Προϋποθέσεις","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"where you can complete your purchase securely.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"Πληρωμή με {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"Όταν πατήσετε \"καταχώριση παραγγελίας\" θα γίνει ανακατεύθυνση στο","wallet.pay.with":"Πληρωμή με","cc.load.error":"Αυτός ο τρόπος πληρωμής δεν είναι διαθέσιμος αυτή τη στιγμή. Παρακαλούμε επιλέξτε διαφορετικό τρόπο πληρωμής ή επικοινωνήστε με τον κάτοχο του ιστοτόπου.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Δόσεις","creditCard":"Πιστωτική/Χρεωστική Κάρτα","payPal":"PayPal"}

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = {"payPal":"PayPal","creditCard":"Credit / Debit Card","offline":"Pay Offline","mercadoPago":"MercadoPago","fakePaymentMethod":"Fake Payment Method","yandex":"Yandex","pagSeguro":"PagSeguro","squarePOS":"Square","iDeal":"iDeal","sofort":"Sofort","alipay":"Alipay","settings.offlineTitleOption2":"Cash Payment","settings.offlineTitleOption3":"Offline Payment","settings.offlineTitleOptionDefault":"Manual Payment","settings.offlineTitleOptionDefaultInstruction":"Pay Offline Instruction","form.submit":"Buy Now","form.submit.paypal":"Checkout with","terms.conditions":"Terms & Conditions","wallet.message.start":"You will be redirected to","wallet.message.end":"where you can complete your purchase securely.","wallet.pay.with":"Pay with","terms.conditions.agree":"I agree to the","payments.offline.defaultInstructionText":"We’ll call you in the next 24 hours to settle the payment, until then you can decide if you prefer a bank transaction or a check!<br/><br/>Talk to you soon, have a great day!","payments.wallet.genericDescription.start":"When you hit \"Place Order\" you will be redirected to","payments.wallet.genericDescription.end":"where you can complete your purchase securely.","payments.wallet.genericDescription.internal.start":"When you hit \"Buy Now\" you will be redirected to","payments.wallet.genericDescription.internal.end":"where you can complete your purchase securely.","payment.submitError":"There was an error processing your credit card. Review your details and try again.","cc.load.error":"This payment method is not available at the moment. Please select a different one or contact the website owner.","cc.installments.singlePayment":"Single Payment","cc.installments.title":"Installments","payments.collapsedMode.label":"Paying with {{paymentMethodLabel}}","payments.steps.back":"Back","payments.steps.paymentMethod.label":"01. Payment Method","payments.steps.paymentDetails.label":"02. Payment Details","paymentComplete.label":"Thank You!","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","paymentComplete.returnButton.label":"Got It"}

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"Hubo un error al procesar tu tarjeta de crédito. Verifica tus datos y vuelve a intentarlo.","wallet.message.end":"donde puedes completar tu compra de manera segura.","form.submit":"Comprar Ahora","settings.offlineTitleOptionDefault":"Pago manual","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Pago Offline","settings.offlineTitleOption2":"Pago en efectivo","payments.wallet.genericDescription.end":"donde puedes completar tu compra de forma segura.","offline":"Pagar offline","settings.offlineTitleOptionDefaultInstruction":"Instrucciones para pagar offline","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"Serás redirigido a","form.submit.paypal":"Finalizar la compra con","payments.wallet.genericDescription.internal.start":"Cuando hagas clic en \"Comprar ahora\", serás redirigido a","payments.offline.defaultInstructionText":"Te llamaremos en las próximas 24 horas para concretar el pago, hasta entonces puedes decidir si prefieres una transacción bancaria o un cheque. <br/><br/>Te llamaremos pronto, que tengas un buen día.","terms.conditions.agree":"Estoy de acuerdo con la","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"Pago único","iDeal":"IDeal","terms.conditions":"Términos y Condiciones","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"donde puedes completar tu compra de forma segura.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"Pagando con {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"Cuando pulses \"Realizar pedido\", serás redirigido a","wallet.pay.with":"Pagar con","cc.load.error":"Este método de pago no está disponible en este momento. Por favor, selecciona uno diferente o contacta al propietario del sitio.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Plazos","creditCard":"Tarjeta de crédito/débito","payPal":"PayPal"}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"Virhe havaittu luottokortin käsittelyssä. Tarkista tietosi ja yritä uudelleen.","wallet.message.end":"jossa voit suorittaa ostoksesi turvallisesti.","form.submit":"Osta nyt","settings.offlineTitleOptionDefault":"Manuaalinen Maksutapa","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Offline-maksu","settings.offlineTitleOption2":"Käteismaksu","payments.wallet.genericDescription.end":"jossa voit suorittaa ostoksesi turvallisesti.","offline":"Maksa offline-tilassa","settings.offlineTitleOptionDefaultInstruction":"Offline-maksuohjeet","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"Sinut ohjataan","form.submit.paypal":"Maksa","payments.wallet.genericDescription.internal.start":"Kun klikkaat \"Osta nyt\", sinut ohjataan","payments.offline.defaultInstructionText":"Soitamme sinulle 24 tunnin kuluessa maksun suorittamista varten. Sinulla on siihen asti aikaa päättää, haluatko maksaa pankkitilin kautta vai laskulla!<br/><br/>Kuullaan pian, hyvää päivän jatkoa!","terms.conditions.agree":"Sitoudun","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"Kertamaksu","iDeal":"iDeal","terms.conditions":"Ehdot","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"jossa voit suorittaa ostoksesi turvallisesti.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"Maksutapa {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"Kun klikkaat \"Tee tilaus\", sinut ohjataan","wallet.pay.with":"Maksa","cc.load.error":"Tämä maksutapa ei ole juuri nyt käytettävissä. Ole hyvä ja valitse toinen maksutapa tai ota yhteyttä sivuston omistajaan.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Maksuerät","creditCard":"Luotto/pankkikortti","payPal":"PayPal"}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"Erreur de paiement par carte de crédit. Veuillez vérifier vos informations puis réessayez.","wallet.message.end":"d'où vous pourrez compléter votre paiement en toute sécurité.","form.submit":"Acheter","settings.offlineTitleOptionDefault":"Paiement manuel","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Paiement hors-ligne","settings.offlineTitleOption2":"Paiement en espèces","payments.wallet.genericDescription.end":"d'où vous pourrez compléter votre paiement en toute sécurité.","offline":"Payer hors-ligne","settings.offlineTitleOptionDefaultInstruction":"Instructions paiement hors ligne","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"Vous serez redirigé vers","form.submit.paypal":"Payer avec","payments.wallet.genericDescription.internal.start":"Lorsque vous cliquerez sur \"Acheter\", vous serez redirigé vers","payments.offline.defaultInstructionText":"Nous vous appellerons dans les 24 heures pour régler le paiement. En attendant, décidez si vous préférez payer par virement bancaire ou par chèque !<br/><br/>À bientôt, et bonne journée !","terms.conditions.agree":"J'accepte les","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"Paiement unique","iDeal":"IDeal","terms.conditions":"Termes et conditions","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"d'où vous pourrez compléter votre paiement en toute sécurité.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"Payer avec {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"Lorsque vous cliquez sur \"Commander\" vous serez redirigé vers","wallet.pay.with":"Payer avec","cc.load.error":"Ce moyen de paiement n'est pas disponible pour le moment. Veuillez choisir un autre moyen de paiement ou contactez le propriétaire du site.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Mensualités","creditCard":"Carte de crédit/débit","payPal":"PayPal"}

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"התרחשה תקלה בעת עיבוד כרטיס האשראי שלך. בדוק את הפרטים שהזנת ונסה שוב.","wallet.message.end":"היכן שתוכל להשלים את רכישתך באופן מאובטח.","form.submit":"קנה עכשיו","settings.offlineTitleOptionDefault":"תשלום ידני","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"תשלום לא-מקוון","settings.offlineTitleOption2":"תשלום במזומן","payments.wallet.genericDescription.end":"היכן שתוכל להשלים את רכישתך באופן מאובטח.","offline":"שלם באופן לא-מקוון","settings.offlineTitleOptionDefaultInstruction":"הוראות לתשלום לא-מקוון","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"תופנה אל","form.submit.paypal":"המשך לקופת תשלום באמצעות","payments.wallet.genericDescription.internal.start":"כשתלחץ על \"קנה עכשיו\", תופנה אל","payments.offline.defaultInstructionText":"נתקשר אליך במהלך 24 השעות הקרובות כדי להסדיר את התשלום, ועד אז תוכל להחליט אם אתה מעדיף לשלם באמצעות העברה בנקאית או באמצעות המחאה <br/><br/>נהיה בקשר בקרוב, שיהיה לך יום מעולה!","terms.conditions.agree":"אני מסכים ל","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"תשלום אחד","iDeal":"iDeal","terms.conditions":"תנאי שימוש","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"היכן שתוכל להשלים את רכישתך באופן מאובטח.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"תשלום באמצעות {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"כאשר תלחץ על \"בצע הזמנה\" תופנה אל","wallet.pay.with":"שלם באמצעות","cc.load.error":"שיטת תשלום זו אינה זמינה כרגע. אנא בחר שיטה אחרת או צור קשר עם בעל האתר.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"תשלומים","creditCard":"כרטיס אשראי/חיוב","payPal":"פייפאל"}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"अपने क्रेडिट कार्ड के प्रसंस्करण में कोई त्रुटि थी। अपने विवरण की समीक्षा करें और फिर कोशिश करें।","wallet.message.end":"जहाँ आप अपनी खरीद सुरक्षित रूप से पूरी कर सकते हैं।","form.submit":"अभी खरीदें","settings.offlineTitleOptionDefault":"मैन्युअल भुगतान","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"ऑफलाइन भुगतान","settings.offlineTitleOption2":"नकद भुगतान","payments.wallet.genericDescription.end":"जहाँ आप अपनी खरीद सुरक्षित रूप से पूरी कर सकते हैं।","offline":"ऑफलाइन भुगतान करें","settings.offlineTitleOptionDefaultInstruction":"ऑफलाइन भुगतान करने के निर्देश","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"आपको निम्न पर रीडायरेक्ट किया जाएगा","form.submit.paypal":"के साथ चेकआउट करें","payments.wallet.genericDescription.internal.start":"जब आप \"अभी खरीदें\" बटन पर क्लिक करते हैं तो आपको निम्न पर रीडायरेक्ट कर दिया जाता है","payments.offline.defaultInstructionText":"भुगतान का निपटारा करने के लिए हम अगले 24 घंटों में आपको कॉल करेंगे, तब तक आप निर्णय लें कि आपको बैंक लेनदेन पसंद है या चेक!<br/><br/>शीघ्र ही आप से बात करेंगे, आपका दिन शुभ हो!","terms.conditions.agree":"मैं निम्न से सहमत हूँ","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"एकल भुगतान","iDeal":"IDeal","terms.conditions":"नियम एवं शर्तें","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"जहाँ आप अपनी खरीद सुरक्षित रूप से पूरी कर सकते हैं।","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"{{paymentMethodLabel}} के साथ भुगतान कर रहे हैं","alipay":"Alipay","payments.wallet.genericDescription.start":"जब आप \"ऑर्डर करें\" पर क्लिक करते हैं तो आपको निम्न पर रीडायरेक्ट किया जाएगा","wallet.pay.with":"के साथ भुगतान करें","cc.load.error":"यह भुगतान प्रदाता फिलहाल उपलब्ध नहीं है। कृपया किसी अन्य भुगतान प्रदाता का चयन करें या वेबसाइट के मालिक से संपर्क करें।","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"किश्तें","creditCard":"क्रेडिट/डेबिट कार्ड","payPal":"PayPal"}

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"Hiba történt a bank- vagy hitelkártya ellenőrzésekor. Ellenőrizd az adatokat, és próbálkozz ismét!","wallet.message.end":"ahol biztonságosan be tudod fejezni a fizetést.","form.submit":"Vásárlás most!","settings.offlineTitleOptionDefault":"Hagyományos (kézi) fizetés","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Offline fizetés","settings.offlineTitleOption2":"Készpénzes fizetés","payments.wallet.genericDescription.end":"ahol biztonságosan be tudod fejezni a fizetést.","offline":"Fizetés offline módon","settings.offlineTitleOptionDefaultInstruction":"Hagyományos (nem online) fizetés menete","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"Átirányítunk ide:","form.submit.paypal":"Fizetés ezzel:","payments.wallet.genericDescription.internal.start":"Miután megnyomtad a „Vásárlás most!” gombot, átirányítunk ide:","payments.offline.defaultInstructionText":"A következő 24 órában telefonon felhívunk a fizetés véglegesítéséhez. Addig is döntsd el, hogy banki átutalással vagy csekkel fizetsz!<br/><br/>Szép napot kívánunk, a viszonthallásra!","terms.conditions.agree":"Elfogadom a(z)","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"Egyszeri fizetés","iDeal":"iDeal","terms.conditions":"Feltételek","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"ahol biztonságosan be tudod fejezni a fizetést.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"Fizetési mód: {{paymentMethodLabel}}","alipay":"AliPay","payments.wallet.genericDescription.start":"Miután megnyomtad a „Megrendelés” gombot, átirányítunk ide:","wallet.pay.with":"Fizetési mód:","cc.load.error":"Ez a fizetési mód jelenleg nem érhető el. Válassz egy másik fizetési módot, vagy vedd fel a kapcsolatot a honlap tulajdonosával!","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Részletfizetések","creditCard":"Hitel- vagy bankkártya","payPal":"PayPal"}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"Ada kesalahan saat memproses kartu kredit Anda. Periksa kembali data Anda dan coba lagi.","wallet.message.end":"tempat Anda dapat menyelesaikan pembelian Anda secara aman.","form.submit":"Beli Sekarang","settings.offlineTitleOptionDefault":"Pembayaran Manual","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Pembayaran Online","settings.offlineTitleOption2":"Pembayaran Tunai","payments.wallet.genericDescription.end":"tempat Anda dapat menyelesaikan pembelian Anda dengan aman.","offline":"Bayar Offline","settings.offlineTitleOptionDefaultInstruction":"Petunjuk Pembayaran Offline","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"Anda akan diarahkan ke","form.submit.paypal":"Bayar dengan","payments.wallet.genericDescription.internal.start":"Saat Anda mengklik \"Beli Sekarang\" Anda akan diarahkan ke","payments.offline.defaultInstructionText":"Kami akan menghubungi Anda dalam 24 jam mendatang untuk menyelesaikan pembayaran, sebelum itu, Anda dapat memilih apakah akan menerima transaksi bank atau cek!<br/><br/>Sampai nanti, semoga hari Anda menyenangkan!","terms.conditions.agree":"Saya setuju dengan","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"Pembayaran Tunggal","iDeal":"iDeal","terms.conditions":"Syarat & Ketentuan","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"tempat Anda dapat menyelesaikan pembelian Anda secara aman.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"Membayar dengan {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"Saat Anda menekan \"Tempatkan Pesanan\" Anda akan diarahkan ke","wallet.pay.with":"Bayar dengan","cc.load.error":"Metode pembayaran ini tidak tersedia saat ini. Mohon pilih metode berbeda atau hubungi pemilik situs.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Cicilan","creditCard":"Kartu Kredit/Debit","payPal":"PayPal"}

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"Si è verificato un errore durante l'elaborazione della carta di credito. Esamina i dettagli e riprova.","wallet.message.end":"dove potrai completare il tuo acquisto in modo sicuro.","form.submit":"Acquista ora","settings.offlineTitleOptionDefault":"Pagamento manuale","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Pagamento offline","settings.offlineTitleOption2":"Pagamento in contanti","payments.wallet.genericDescription.end":"dove potrai completare il tuo acquisto in modo sicuro","offline":"Paga offline","settings.offlineTitleOptionDefaultInstruction":"Istruzioni per pagamento offline","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"Verrai reindirizzato a","form.submit.paypal":"Esegui il checkout con","payments.wallet.genericDescription.internal.start":"Quando si clicca su \"Acquista ora\" si è reindirizzati a","payments.offline.defaultInstructionText":"Ti contatteremo entro le prossime 24 ore per accordare il pagamento, nel frattempo puoi decidere se pagare tramite bonifico o assegno bancario!<br/><br/>Nell'attesa, ti auguriamo una buona giornata!","terms.conditions.agree":"Accetto i","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"Pagamento singolo","iDeal":"IDeal","terms.conditions":"Termini e condizioni","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"dove potrai completare il tuo acquisto in modo sicuro","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"Paga con {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"Quando si clicca su \"Effettua l'ordine\" si è reindirizzati a","wallet.pay.with":"Paga con","cc.load.error":"Questo metodo di pagamento non è al momento disponibile. Selezionane un altro o contatta il proprietario del sito.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Rate","creditCard":"Carta di Credito/Debito","payPal":"PayPal"}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"クレジットカード決済にエラーが発生しました。 入力内容に間違いがないかご確認の上、もう一度お試しください。","wallet.message.end":"決済ページ","form.submit":"購入する","settings.offlineTitleOptionDefault":"銀行振込","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"オフライン決済","settings.offlineTitleOption2":"代金引換","payments.wallet.genericDescription.end":"決済ページ","offline":"オフラインでのお支払い","settings.offlineTitleOptionDefaultInstruction":"オフライン決済方法","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"自動的に","form.submit.paypal":"お支払いへ進む：","payments.wallet.genericDescription.internal.start":"「購入する」をクリックすると次にリダイレクトされます : ","payments.offline.defaultInstructionText":"1営業日以内に決済に関する内容を電話でご連絡いたします。決済は銀行振込または小切手で行うことができます。ご連絡まで少々お待ち下さい。","terms.conditions.agree":"次に同意します：","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"一括払い","iDeal":"IDeal","terms.conditions":"利用規約","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"決済ページ","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"{{paymentMethodLabel}} でお支払い","alipay":"Alipay","payments.wallet.genericDescription.start":"「購入する」をクリックすると次にリダイレクトされます : ","wallet.pay.with":"お支払い方法：","cc.load.error":"この決済方法は現在利用いただけません。別の決済方法をご利用になるか、サイト管理者にご連絡ください。","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"分割払い","creditCard":"クレジット / デビットカード","payPal":"PayPal"}

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"신용카드 결제 오류입니다. 입력정보 확인 후, 다시 시도하세요.","wallet.message.end":"으로 이동하여 안전하게 결제를 완료할 수 있습니다.","form.submit":"구매하기","settings.offlineTitleOptionDefault":"수동 결제","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"오프라인 결제","settings.offlineTitleOption2":"현금결제","payments.wallet.genericDescription.end":"으로 이동하여 안전하게 결제를 완료할 수 있습니다.","offline":"오프라인 결제","settings.offlineTitleOptionDefaultInstruction":"오프라인 결제 지침","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"다음으로 리디렉트됩니다:","form.submit.paypal":"온라인 결제는","payments.wallet.genericDescription.internal.start":"\"구매하기\"를 클릭하면","payments.offline.defaultInstructionText":"결제 완료를 위해 24시간 내에 연락드리도록 하겠습니다. <br />연락 전까지 결제 시 사용될 은행 계좌이체 또는 수표 정보를<br /> 미리 준비해주시면 감사하겠습니다.","terms.conditions.agree":"다음 사항에 동의합니다:","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"일시불로 지불","iDeal":"IDeal","terms.conditions":"이용약관","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"페이지로 이동하여 안전하게 결제를 완료할 수 있습니다.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"{{paymentMethodLabel}} 결제","alipay":"Alipay","payments.wallet.genericDescription.start":"\"주문\"을 클릭하면","wallet.pay.with":"결제방법:","cc.load.error":"일시적으로 해당 결제업체 서비스를 제공할 수 없습니다. 다른 결제방법을 선택하거나 해당 업체 사이트로 문의해주세요.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"할부","creditCard":"신용/직불카드","payPal":"PayPal"}

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"Terdapat ralat semasa memproses kad kredit anda. Semak butiran anda dan cuba lagi.","wallet.message.end":"di mana anda boleh melengkapkan pembelian anda dengan selamat.","form.submit":"Beli Sekarang","settings.offlineTitleOptionDefault":"Pembayaran Manual","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Pembayaran Luar Talian","settings.offlineTitleOption2":"Pembayaran Tunai","payments.wallet.genericDescription.end":"di mana anda boleh melengkapkan pembelian anda dengan selamat.","offline":"Bayar Luar Talian","settings.offlineTitleOptionDefaultInstruction":"Arahan Pembayaran Luar Talian","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"Anda akan dibawa ke","form.submit.paypal":"Semak keluar dengan","payments.wallet.genericDescription.internal.start":"Apabila anda tekan \"Beli Sekarang\" anda akan dibawa ke","payments.offline.defaultInstructionText":"Kami akan menghubungi anda dalam tempoh 24 jam untuk menyelesaikan pembayaran, sementara itu anda boleh menentukan jika anda lebih suka transaksi bank atau cek!<br/><br/>Anda akan dihubungi sebentar nanti, salam hormat!","terms.conditions.agree":"Saya bersetuju dengan","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"Pembayaran Tunggal","iDeal":"iDeal","terms.conditions":"Terma & Syarat","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"di mana anda boleh melengkapkan pembelian anda dengan selamat.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"Bayar dengan {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"Apabila anda tekan \"Buat Tempahan\" anda akan dibawa ke","wallet.pay.with":"Bayar dengan","cc.load.error":"Kaedah pembayaran ini tidak tersedia pada masa ini. Sila pilih kaedah yang lain atau hubungi pemilik laman web.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Ansuran","creditCard":"Kad Kredit / Debit","payPal":"PayPal"}

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"Er is iets fout gegaan bij het verwerken van uw creditcard. Controleer uw gegevens en probeer het opnieuw.","wallet.message.end":"waar u uw betaling veilig kunt afronden.","form.submit":"Nu kopen","settings.offlineTitleOptionDefault":"Handmatige betaling","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Offline betalen","settings.offlineTitleOption2":"Contante betaling","payments.wallet.genericDescription.end":"waar u uw betaling veilig kunt afronden.","offline":"Offline betalen","settings.offlineTitleOptionDefaultInstruction":"Instructie voor offline betalen","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"U wordt doorgestuurd naar","form.submit.paypal":"Afrekenen met","payments.wallet.genericDescription.internal.start":"Als u op 'Nu kopen' klikt, wordt u doorgestuurd naar","payments.offline.defaultInstructionText":"We bellen u in de komende 24 uur om de betalingen af te ronden. U kunt tot dan kiezen voor bankoverschrijving of cheque.<br/><br/>Fijne dag!","terms.conditions.agree":"Ik ga akkoord met de","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"Alles ineens","iDeal":"IDeal","terms.conditions":"Algemene voorwaarden","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"waar u uw betaling veilig kunt afronden.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"Betalen met {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"Als u op 'Bestelling plaatsen' klikt, wordt u doorgestuurd naar","wallet.pay.with":"Betaal met","cc.load.error":"Deze betaalmethode is momenteel niet beschikbaar. Kies een andere betaalmethode of neem contact op met de eigenaar van de website.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Afbetalingen","creditCard":"Creditcard/debetkaart","payPal":"PayPal"}

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"Det oppstod en feil under behandlingen av kredittkortet ditt. Sjekk dine detaljer og prøv igjen.","wallet.message.end":"hvor du kan fullføre kjøpet sikkert.","form.submit":"Kjøp nå","settings.offlineTitleOptionDefault":"Manuell betaling","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Betaling offline","settings.offlineTitleOption2":"Betal kontant","payments.wallet.genericDescription.end":"hvor du kan fullføre kjøpet sikkert.","offline":"Betal offline","settings.offlineTitleOptionDefaultInstruction":"Instruksjoner for betaling offline","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"Du vil bli omdirigert til","form.submit.paypal":"Betal med","payments.wallet.genericDescription.internal.start":"Når du klikker \"Kjøp nå\" vil du bli omdirigert til","payments.offline.defaultInstructionText":"Vi ringer deg i løpet av de neste 24 timene angående betaling, og inntil da kan du bestemme om du ønsker en banktransaksjon eller en sjekk!<br/><br/>Vi snakkes snart, ha en flott dag!","terms.conditions.agree":"Jeg godtar","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"En enkelt betaling","iDeal":"IDeal","terms.conditions":"Vilkår","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"hvor du kan fullføre kjøpet sikkert.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"Betaler med {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"Når du klikker \"Bestill\" vil du bli omdirigert til","wallet.pay.with":"Betal med","cc.load.error":"Betalingsleverandøren er ikke tilgjengelig for øyeblikket. Velg en annen eller kontakt eieren av nettstedet.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Avdrag","creditCard":"Kreditt/Bankkort","payPal":"PayPal"}

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"Wystąpił błąd podczas przetwarzania karty kredytowej. Przejrzyj informacje i spróbuj ponownie.","wallet.message.end":"gdzie możesz bezpiecznie sfinalizować zakup.","form.submit":"Kup Teraz","settings.offlineTitleOptionDefault":"Płatność Manualna","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Płatności poza siecią","settings.offlineTitleOption2":"Płatność Gotówką","payments.wallet.genericDescription.end":"gdzie możesz bezpiecznie sfinalizować zakup.","offline":"Zapłać poza siecią","settings.offlineTitleOptionDefaultInstruction":"Instrukcje płatności poza siecią","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"Zostaniesz przeniesiony do","form.submit.paypal":"Zapłać przez","payments.wallet.genericDescription.internal.start":"Gdy klikniesz \"Kup teraz\" zostaniesz przekierowany do","payments.offline.defaultInstructionText":"Zadzwonimy do Ciebie w ciągu 24 godzin, aby sfinalizować płatność. Do tego czasu możesz zdecydować, czy wolisz transakcję bankową, czy czek!<br/><br/>Do usłyszenia, miłego dnia!","terms.conditions.agree":"Zgadzam się na","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"Jednorazowa Opłata","iDeal":"IDeal","terms.conditions":"Regulamin sklepu","squarePOS":"Kwadrat","payments.wallet.genericDescription.internal.end":"gdzie możesz bezpiecznie sfinalizować zakup.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"Płatność via {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"Po kliknięciu \"Złóż zamówienie\" zostaniesz przekierowany do","wallet.pay.with":"Zapłać przez","cc.load.error":"Ta metoda płatności nie jest obecnie dostępna. Wybierz inną metodę lub skontaktuj się z właścicielem.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Raty","creditCard":"Karta debetowa/kredytowa","payPal":"PayPal"}

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"Houve um erro ao processar seu cartão de crédito. Verifique seus detalhes e tente novamente.","wallet.message.end":"para completar sua compra com segurança.","form.submit":"Compre Já","settings.offlineTitleOptionDefault":"Pagamento manual","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Pagamento offline","settings.offlineTitleOption2":"Pagamento em dinheiro","payments.wallet.genericDescription.end":"para completar sua compra com segurança.","offline":"Pagar offline","settings.offlineTitleOptionDefaultInstruction":"Instruções para pagamento offline","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"Você será redirecionado para","form.submit.paypal":"Finalizar compra com","payments.wallet.genericDescription.internal.start":"Ao clicar em \"Compre Já\" você será redirecionado para","payments.offline.defaultInstructionText":"Entraremos em contato nas próximas 24 horas para efetuar o pagamento, até então você pode decidir se prefere uma transferência bancária ou um cheque!<br/><br/>A gente se fala em breve, tenha um ótimo dia!","terms.conditions.agree":"Eu concordo com os","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"À vista","iDeal":"IDeal","terms.conditions":"Termos e Condições","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"para completar sua compra com segurança.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"Pagando com {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"Ao clicar em \"Fazer Pedido\" você será redirecionado para","wallet.pay.with":"Pagar com","cc.load.error":"Este método de pagamento não está disponível no momento. Por favor, selecione um diferente ou entre em contato com o próprietário do site.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Parcelas","creditCard":"Cartão de crédito","payPal":"PayPal"}

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"A apărut o eroare la procesarea cardului de credit. Verifică detaliile și încearcă din nou.","wallet.message.end":"unde poți finaliza achiziția în deplină sigiranță.","form.submit":"Cumpără acum","settings.offlineTitleOptionDefault":"Plată manuală","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Plată offline","settings.offlineTitleOption2":"Plată în numerar","payments.wallet.genericDescription.end":"unde poți finaliza achiziția în deplină siguranță.","offline":"Plătește offline","settings.offlineTitleOptionDefaultInstruction":"Instrucțiuni pentru plată offline","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"Vei fi redirecționat(ă) la","form.submit.paypal":"Finalizează comanda cu","payments.wallet.genericDescription.internal.start":"Când apeși pe „Cumpără acum” vei fi redirecționat(ă) la","payments.offline.defaultInstructionText":"Te vom suna în următoarele 24 de ore pentru a finaliza plata, până atunci puteți decide dacă preferați să plătiți printr-o tranzacție bancară sau prin cec!<br/><br/>Pe curând și o zi frumoasă în continuare!","terms.conditions.agree":"Sunt de acord","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"O singură plată","iDeal":"iDeal","terms.conditions":"Termeni și condiții","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"unde poți finaliza achiziția în deplină siguranță.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"Se plătește cu {{paymentMethodLabel}}","alipay":"AliPay","payments.wallet.genericDescription.start":"Când apeși pe „Trimite comanda” vei fi redirecționat(ă) la","wallet.pay.with":"Plătește cu","cc.load.error":"Această metodă de plată nu este disponibilă pentru moment. Selectează altă metodă de plată sau contactează proprietarul site-ului.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Rate","creditCard":"Carduri de credit/debit","payPal":"PayPal"}

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"Возникла ошибка при обработке кредитной карты. Проверьте указанные данные и попробуйте снова.","wallet.message.end":", где сможете безопасно оплатить заказ.","form.submit":"Купить сейчас","settings.offlineTitleOptionDefault":"Оплата в ручном режиме","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Офлайн-оплата","settings.offlineTitleOption2":"Оплата наличными","payments.wallet.genericDescription.end":", где сможете безопасно оплатить заказ.","offline":"Оплата офлайн","settings.offlineTitleOptionDefaultInstruction":"Инструкции по оплате","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"Мы перенаправим вас на сайт","form.submit.paypal":"Оформить через","payments.wallet.genericDescription.internal.start":"Когда вы нажмете «Купить», вы будете перенаправлены на сайт","payments.offline.defaultInstructionText":"Мы позвоним в течение 24 часов, чтобы узнать, как вы предпочитаете оформить платеж: банковским переводом или чеком.<br/><br/>Хорошего дня!","terms.conditions.agree":"Я принимаю","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"Единичный платеж","iDeal":"IDeal","terms.conditions":"правила и условия","squarePOS":"Square","payments.wallet.genericDescription.internal.end":", где сможете безопасно оплатить заказ.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"Оплата через {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"Когда вы нажмете «Разместить заказ», вы будете перенаправлены на сайт","wallet.pay.with":"Оплата через","cc.load.error":"Способ оплаты временно недоступен. Пожалуйста, выберите другой способ оплаты или свяжитесь с владельцем сайта.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Яндекс.Касса","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Платежи","creditCard":"Кредитная / дебетовая карта","payPal":"PayPal"}

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"Ett fel uppstod vid behandlingen av kreditkortet. Granska dina uppgifter och försök igen.","wallet.message.end":"där du kan avsluta ditt köp säkert.","form.submit":"Köp nu","settings.offlineTitleOptionDefault":"Manuell betalning","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Offline-betalning","settings.offlineTitleOption2":"Kontant betalning","payments.wallet.genericDescription.end":"där du kan slutföra ditt köp säkert.","offline":"Betala offline","settings.offlineTitleOptionDefaultInstruction":"Instruktioner för betalning offline","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"Du kommer att bli omdirigerad till","form.submit.paypal":"Betala med","payments.wallet.genericDescription.internal.start":"När du klickar på \"Köp nu\" blir du omdirigerad till","payments.offline.defaultInstructionText":"Vi kommer att ringa dig inom de kommande 24 timmarna för att slutföra betalningen, fram tills dess kan du bestämma om du föredrar en banktransaktion eller check!<br/><br/>Vi hörs snart, ha en bra dag!","terms.conditions.agree":"Jag godkänner att","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"Enskild betalning","iDeal":"IDeal","terms.conditions":"Villkor","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"där du kan slutföra ditt köp säkert.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"Betalar med {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"När du klickar på \"Beställ\" blir du omdirigerad till","wallet.pay.with":"Betala med","cc.load.error":"Denna betalningsleverantör är inte tillgänglig för tillfället. Vänligen välj en annan eller kontakta hemsidans ägare.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Omgångar","creditCard":"Kredit-/betalkort","payPal":"PayPal"}

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"เกิดข้อผิดพลาดในการประมวลบัตรเครดิตของคุณ กรุณาตรวจสอบรายละเอียดแล้วลองอีกครั้ง","wallet.message.end":"ที่ที่คุณสามารถทำการซื้อได้อย่างปลอดภัย","form.submit":"ซื้อเลย","settings.offlineTitleOptionDefault":"ชำระเงินด้วยตนเอง","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"การชำระเงินออฟไลน์","settings.offlineTitleOption2":"ชำระด้วยเงินสด","payments.wallet.genericDescription.end":"ที่ที่คุณสามารถทำการซื้อได้อย่างปลอดภัย","offline":"ชำระเงินออฟไลน์","settings.offlineTitleOptionDefaultInstruction":"คำอธิบายการชำระเงินออฟไลน์","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"ระบบจะพาคุณไปที่","form.submit.paypal":"ชำระเงินด้วย","payments.wallet.genericDescription.internal.start":"เมื่อคุณกด \"ซื้อเลยทันที\" ระบบจะพาคุณไปที่","payments.offline.defaultInstructionText":"เราจะโทรหาคุณภายในเวลา 24 ชั่วโมงเพื่อตกลงเรื่องการชำระเงิน คุณจึงมีเวลาเพียงพอเพื่อตัดสินใจว่าจะเลือกใช้การโอนเงินทางธนาคารหรือเช็คเงินสด<br/><br/>แล้วคุยกันครับ!","terms.conditions.agree":"ฉันเห็นพ้องกับ","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"ชำระเงินงวดเดียว","iDeal":"iDeal","terms.conditions":"ข้อกำหนดและเงื่อนไข","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"ที่ที่คุณสามารถทำการซื้อได้อย่างปลอดภัย","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"ชำระเงินด้วย {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"เมื่อคุณกด \"สั่งซื้อ\" ระบบจะพาคุณไปที่","wallet.pay.with":"ชำระเงินด้วย","cc.load.error":"วิธีการชำระเงินนี้ไม่มีให้เลือกในขณะนี้ กรุณาเลือกวิธีอื่นหรือติดต่อเจ้าของเว็บไซต์","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"งวดผ่อนชำระ","creditCard":"บัตรเครดิต / เดบิต","payPal":"PayPal"}

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"Nagka-error sa pagproseso ng iyong credit card. Suriin ang iyong mga detalye at subukang muli.","wallet.message.end":"kung saan mo matatapos ang iyong pagbili nang secure.","form.submit":"Bilhin Na","settings.offlineTitleOptionDefault":"Manual na Pagbabayad","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Offline na Pagbabayad","settings.offlineTitleOption2":"Pagbabayad ng Cash","payments.wallet.genericDescription.end":"kung saan maaari mong tapusin ang iyong pagbabayad nang secure.","offline":"Magbayad Offline","settings.offlineTitleOptionDefaultInstruction":"Tagubilin sa Offline na Pagbabayad","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"Mare-redirect ka sa","form.submit.paypal":"Mag-checkout gamit ang","payments.wallet.genericDescription.internal.start":"Kapag pinindot mo ang \"Bumili Na\" mare-redirect ka sa","payments.offline.defaultInstructionText":"Tatawagan ka namin sa susunod na 24 oras upang asikasuhin ang bayad, hanggang sa oras na iyon, maaari kang magpasiya kung mas gusto mo ng transaksyon sa bangkoo sa pamamagitan ng check!<br/><br/>Mag-usap tayo sa susunod, ingat!","terms.conditions.agree":"Sumasang-ayon ako sa","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"Isahang Pagbabayad","iDeal":"iDeal","terms.conditions":"Mga Tuntunin at Kundisyon","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"kung saan maaari mong tapusin ang iyong pagbabayad nang secure.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"Magbabayad gamit ang {{paymentMethodLabel}}","alipay":"Alipay","payments.wallet.genericDescription.start":"Kapag pinindot mo ang \"I-order\", mare-redirect ka sa","wallet.pay.with":"Magbayad gamit ang","cc.load.error":"Hindi available ang paraan sa pagbabayad na ito sa ngayon. Pumili ng iba o makipag-ugnayan sa may-ari ng website.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Mga Installment","creditCard":"Credit / Debit Card","payPal":"PayPal"}

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"Kredi kartınızla ödeme yaparken bir işlem hatası oluştu. Lütfen bilgilerinizi gözden geçirin ve tekrar deneyin.","wallet.message.end":"Burada alışverişinizi güvenli bir şekilde tamamlayabilirsiniz.","form.submit":"Satın Al","settings.offlineTitleOptionDefault":"Şahsen Ödeme","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"Çevrimdışı Ödeme","settings.offlineTitleOption2":"Nakit Ödeme","payments.wallet.genericDescription.end":"Burada alışverişinizi güvenli bir şekilde tamamlayabilirsiniz.","offline":"Çevrimdışı Ödeme","settings.offlineTitleOptionDefaultInstruction":"Çevrimdışı Ödeme Talimatları","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"Buraya yönlendirileceksiniz:","form.submit.paypal":"Ödemeye devam et","payments.wallet.genericDescription.internal.start":"\"Satın Al\" düğmesine tıkladığınızda buraya yönlendirileceksiniz:","payments.offline.defaultInstructionText":"Ödeme işleminizi tamamlamak için 24 saat içerisinde sizi arayacağız. Bu zamana kadar banka transferi veya çekle ödeme yapmayı tercih edebilirsiniz.<br/><br/>İyi günler ve yakında konuşmak üzere!","terms.conditions.agree":"Tüm","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"Tek Ödeme","iDeal":"IDeal","terms.conditions":"Şart ve Koşullar","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"Burada alışverişinizi güvenli bir şekilde tamamlayabilirsiniz.","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"{{paymentMethodLabel}} ile ödeniyor","alipay":"Alipay","payments.wallet.genericDescription.start":"\"Siparişi Ver\" düğmesine tıklarsanız buraya yönlendirileceksiniz:","wallet.pay.with":"Ödeme Yöntemi:","cc.load.error":"Bu ödeme yöntemi şu anda kullanılamıyor. Lütfen farklı bir ödeme yöntemi seçin veya site sahibi ile iletişime geçin.","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"Taksitle","creditCard":"Kredi / Banka Kartları","payPal":"PayPal"}

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports = {"payments.steps.paymentDetails.label":"02. Payment Details","payment.submitError":"在處理您的信用卡時發生了一個錯誤。請檢視您的詳細資料，然後再試一次。","wallet.message.end":"在這裡您可以安全完成購買。","form.submit":"立即購買","settings.offlineTitleOptionDefault":"手動付款","paymentComplete.transaction.id":"Transaction ID: #{{transactionId}}","settings.offlineTitleOption3":"離線支付","settings.offlineTitleOption2":"現金付款","payments.wallet.genericDescription.end":"在這裡您可以安全完成購買。","offline":"離線支付","settings.offlineTitleOptionDefaultInstruction":"離線支付說明","paymentComplete.transaction.pending":"Your payment of {{amount}} is being processed.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","wallet.message.start":"您將被重新導向至","form.submit.paypal":"結帳方式","payments.wallet.genericDescription.internal.start":"當您按下「立即購買」，您將被重新導向至","payments.offline.defaultInstructionText":"接下來的24小時內，我們會打電話與您結算付款，您可以等到那時候再決定要用銀行轉帳或支票！<br/><br/>將會盡快與您聯繫，祝您有美好的一天！","terms.conditions.agree":"我同意","payments.steps.paymentMethod.label":"01. Payment Method","cc.installments.singlePayment":"單筆付款","iDeal":"iDeal","terms.conditions":"條款與條件","squarePOS":"Square","payments.wallet.genericDescription.internal.end":"在這裡您可以安全完成購買。","paymentComplete.label":"Thank You!","payments.collapsedMode.label":"使用{{paymentMethodLabel}}付款","alipay":"Alipay","payments.wallet.genericDescription.start":"當您按下「下訂單」，您將被重新導向至","wallet.pay.with":"支付使用","cc.load.error":"此付款方式目前不可用。請選擇其他的供應商或連絡網站所有人。","sofort":"Sofort","paymentComplete.returnButton.label":"Got It","payments.steps.back":"Back","pagSeguro":"PagSeguro","yandex":"Yandex","fakePaymentMethod":"Fake Payment Method","mercadoPago":"MercadoPago","paymentComplete.transaction.success":"Your payment of {{amount}} was successfull.<br/>We will send a confirmation email shortly to <br/>{{customerEmail}}","cc.installments.title":"分期","creditCard":"信用卡/轉帳卡","payPal":"PayPal"}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = {"settings.methods.paypal":"PayPal","wallet.message.start":"You will be redirected to","form.submit.paypal":"Checkout with","wallet.pay.with":"Pay with","wallet.message.end":"to complete your purchase securely, and return here to complete your purchase.","form.submit":"Submit","settings.offlineTitleOptionDefault":"Pay Offline Instruction","settings.methods.creditCard":"Credit Card","payments.offline.defaultInstructionText":"We’ll call you in the next 24 hours to settle the payment, untill then you can decide if you prefer a bank transaction or a chek!<br/><br/>Talk to you soon, have a great day!","terms.conditions.agree":"I agree to","settings.methods.offline":"Pay Offline","terms.conditions":"Terms & Condition"}

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDE3IDE3Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZmlsbD0iIzEyMTIxMiIgZD0iTS0zMC0zMGg1MTB2NzhILTMweiIgb3BhY2l0eT0iLjA1Ii8+CiAgICAgICAgPGcgdHJhbnNmb3JtPSJyb3RhdGUoLTE4MCA4IDgpIj4KICAgICAgICAgICAgPGNpcmNsZSBjeD0iNy41IiBjeT0iNy41IiByPSI4IiBzdHJva2U9IiNFRjVCNTMiLz4KICAgICAgICAgICAgPHBhdGggZmlsbD0iI0YxNTM0NyIgZD0iTTcgN2gxdjRIN3oiLz4KICAgICAgICAgICAgPHBhdGggZmlsbD0iI0YwNUY1NSIgZD0iTTcgNGgxdjFIN3oiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(63);
var App_1 = __webpack_require__(484);
ReactDOM.render(React.createElement(App_1.default, null), document.getElementById('root'));


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var App_1 = __webpack_require__(485);
exports.default = App_1.default;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Loader_1 = __webpack_require__(64);
var CashierPaymentsWidget_1 = __webpack_require__(143);
var PaymentComplete_1 = __webpack_require__(486);
var src_1 = __webpack_require__(130);
var locationUtils_1 = __webpack_require__(129);
var communicationUtils_1 = __webpack_require__(488);
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isLoading: true,
            generalErrorMessage: '',
            order: null,
            paymentResult: null,
        };
        _this.params = {
            appId: '',
            appInstanceId: '',
            snapshotId: '',
            locale: 'en',
            visitorId: '',
            msid: '',
            cashierPCIUrl: undefined,
            walletExpressCheckoutAPIUrl: '/_api/payment-services-web/wallet/start?orderId={{orderId}}&paymentMethod={{paymentMethod}}',
            theme: 'default',
            showOnlyCurrentStep: undefined,
            host: null,
            showThankYouPage: undefined,
        };
        _this.setPaymentWidgetRef = function (ref) {
            _this.paymentWidget = ref;
        };
        _this.setRootNode = function (node) {
            _this.rootNode = node;
        };
        _this.addListenerForMessagesFromParent = function () {
            window.addEventListener('resize', _this.sendSizeNotification, false);
        };
        _this.removeListenerForMessagesFromParent = function () {
            window.removeEventListener('resize', _this.sendSizeNotification, false);
        };
        _this.sendSizeNotification = function () {
            // because of tons of integrations and a lot of async's based on post messages
            // sometimes is happening case when we getting here just before dom will be updated, as a result we send
            // old size instead of new one
            // TODO this could be solved in more beautifull way after refactoring to callbacks system WCN-881
            setTimeout(function () {
                communicationUtils_1.postMessage({
                    type: 'SIZE',
                    width: _this.rootNode && _this.rootNode.offsetWidth,
                    height: _this.rootNode && _this.rootNode.offsetHeight,
                });
            }, 0);
        };
        _this.handleError = function (method, data) {
            communicationUtils_1.postMessage({
                type: 'PAYMENT_ERROR',
                method: method,
                error: data && data.toString && data.toString()
            });
        };
        _this.handlePaymentResult = function (result) {
            _this.sendSizeNotification();
        };
        _this.handlePaymentMethodChanged = function (pmId) {
            _this.sendSizeNotification();
            // we require to be sure, that component re-rendred with correct size
            setTimeout(function () {
                _this.sendSizeNotification();
            }, 100);
        };
        _this.handlePaymentComplete = function (method, paymentResult) {
            communicationUtils_1.postMessage({
                type: 'PAYMENT_COMPLETE',
                method: method,
            });
            _this.setState({ paymentResult: paymentResult });
            _this.sendSizeNotification();
        };
        var href = window.location.href || '';
        Object.keys(_this.params).forEach(function (key) {
            var param = locationUtils_1.getParameterByName(key, href);
            _this.params[key] = param === null ? _this.params[key] : param;
        });
        _this.params.showOnlyCurrentStep = _this.params.showOnlyCurrentStep === 'true' || _this.params.theme === 'modal';
        _this.params.host = _this.params.host === null ? 'https://cashier-services.wix.com' : _this.params.host;
        _this.params.showThankYouPage = _this.params.showThankYouPage !== 'false';
        return _this;
    }
    App.prototype.componentDidMount = function () {
        var _this = this;
        src_1.default.getOrder(this.params.snapshotId, this.params.host).then(function (order) {
            _this.setState({ isLoading: false, order: order });
        }).catch(function (e) {
            _this.setState({
                generalErrorMessage: 'Sorry, but something went wrong!'
            });
        });
        this.addListenerForMessagesFromParent();
        this.sendSizeNotification();
    };
    App.prototype.componentWillUnmount = function () {
        this.removeListenerForMessagesFromParent();
    };
    App.prototype.handleReturn = function () {
        window.Wix.closeWindow();
    };
    App.prototype.render = function () {
        return (React.createElement("div", { ref: this.setRootNode, "data-hook": "wcn-payment-app" },
            this.renderLoading(),
            this.renderGeneralError(),
            this.renderPaymentWidget(),
            this.renderPaymentComplete()));
    };
    App.prototype.renderLoading = function () {
        if (!this.state.isLoading || this.state.generalErrorMessage) {
            return null;
        }
        return (React.createElement("div", { "data-hook": "wcn-spinner-main" },
            React.createElement(Loader_1.default, { size: "medium" })));
    };
    App.prototype.renderGeneralError = function () {
        var generalErrorMessage = this.state.generalErrorMessage;
        if (!generalErrorMessage) {
            return null;
        }
        return (React.createElement("div", { "data-hook": "wcn-general-error-message", role: "alert" },
            React.createElement("span", { title: generalErrorMessage }, generalErrorMessage)));
    };
    App.prototype.renderPaymentWidget = function () {
        if (this.state.isLoading || this.state.paymentResult) {
            return null;
        }
        var configuration = {
            appId: this.params.appId,
            appInstanceId: this.params.appInstanceId,
            snapshotId: this.params.snapshotId,
            locale: this.params.locale,
            visitorId: this.params.visitorId,
            msid: this.params.msid,
            cashierPCIUrl: this.params.cashierPCIUrl,
            walletExpressCheckoutAPIUrl: this.params.walletExpressCheckoutAPIUrl,
        };
        return (React.createElement(CashierPaymentsWidget_1.default, { host: this.params.host, configuration: configuration, theme: this.params.theme, showOnlyCurrentStep: this.params.showOnlyCurrentStep || this.params.theme === 'modal', ref: this.setPaymentWidgetRef, onError: this.handleError, paymentMethodChanged: this.handlePaymentMethodChanged, paymentResult: this.handlePaymentResult, onPaymentComplete: this.handlePaymentComplete }));
    };
    App.prototype.renderPaymentComplete = function () {
        if (this.state.isLoading || !this.state.paymentResult) {
            return null;
        }
        if (!this.params.showThankYouPage) {
            this.handleReturn();
            return null;
        }
        return (React.createElement(PaymentComplete_1.default, { order: this.state.order, paymentResult: this.state.paymentResult, locale: this.params.locale, onReturn: this.handleReturn }));
    };
    return App;
}(React.Component));
exports.default = App;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var i18next = __webpack_require__(65);
var currency_helper_1 = __webpack_require__(487);
var PaymentComplete = /** @class */ (function (_super) {
    __extends(PaymentComplete, _super);
    function PaymentComplete() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentComplete.prototype.render = function () {
        var _a = this.props, paymentResult = _a.paymentResult, order = _a.order, locale = _a.locale;
        var transactionId = paymentResult.chargeId;
        var amount = currency_helper_1.getFormattedPrice({
            locale: locale,
            price: order.description.amount,
            currency: order.description.currency
        });
        var customerEmail = 'your@email.com';
        var statusMessage = paymentResult.isPending ? 'paymentComplete.transaction.pending' : 'paymentComplete.transaction.success';
        return (React.createElement("div", { "data-hook": "wcn-payment-complete", style: { textAlign: 'center' } },
            React.createElement("h2", { "data-hook": "wcn-payment-complete-label" }, i18next.t('paymentComplete.label')),
            React.createElement("div", { "data-hook": "wcn-transaction-info" },
                React.createElement("span", { dangerouslySetInnerHTML: { __html: i18next.t(statusMessage, { amount: amount, customerEmail: customerEmail }) } }),
                React.createElement("br", null),
                i18next.t('paymentComplete.transaction.id', { transactionId: transactionId }),
                React.createElement("br", null),
                React.createElement("br", null)),
            this.props.onReturn ?
                React.createElement("button", { "data-hook": "wcn-return-button", onClick: this.props.onReturn }, i18next.t('paymentComplete.returnButton.label'))
                : null));
    };
    PaymentComplete.defaultProps = {
        onReturn: null,
    };
    return PaymentComplete;
}(React.Component));
exports.default = PaymentComplete;


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedPrice = function (_a) {
    var locale = _a.locale, price = _a.price, currency = _a.currency;
    var numberFormat = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
    return numberFormat.format(price);
};


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
function postMessage(message) {
    if (window.parent) {
        window.parent.postMessage(__assign({}, message, { iframeName: 'cashier-payments-widget' }), '*');
    }
}
exports.postMessage = postMessage;


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// app.bundle.min.js